
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree135"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree135"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jpaef", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $e2084958f4c8b842$export$ffb0004e005737fa, (v) => $e2084958f4c8b842$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $e2084958f4c8b842$export$34b9dba7ce09269b, (v) => $e2084958f4c8b842$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $e2084958f4c8b842$export$25062201e9e25d76, (v) => $e2084958f4c8b842$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e2084958f4c8b842$export$ffb0004e005737fa;
var $e2084958f4c8b842$export$34b9dba7ce09269b;
var $e2084958f4c8b842$export$25062201e9e25d76;
"use strict";
var $e2084958f4c8b842$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e2084958f4c8b842$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $e2084958f4c8b842$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $e2084958f4c8b842$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$e2084958f4c8b842$export$ffb0004e005737fa = $e2084958f4c8b842$var$REACT_FRAGMENT_TYPE;
$e2084958f4c8b842$export$34b9dba7ce09269b = $e2084958f4c8b842$var$jsxProd;
$e2084958f4c8b842$export$25062201e9e25d76 = $e2084958f4c8b842$var$jsxProd;

});

parcelRegister("9x51g", function(module, exports) {

$parcel$export(module.exports, "Children", () => $6f0b16db93ae96cf$export$dca3b0875bd9a954, (v) => $6f0b16db93ae96cf$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $6f0b16db93ae96cf$export$16fa2f45be04daa8, (v) => $6f0b16db93ae96cf$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $6f0b16db93ae96cf$export$ffb0004e005737fa, (v) => $6f0b16db93ae96cf$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $6f0b16db93ae96cf$export$e2c29f18771995cb, (v) => $6f0b16db93ae96cf$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $6f0b16db93ae96cf$export$221d75b3f55bb0bd, (v) => $6f0b16db93ae96cf$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $6f0b16db93ae96cf$export$5f8d39834fd61797, (v) => $6f0b16db93ae96cf$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6f0b16db93ae96cf$export$74bf444e3cd11ea5, (v) => $6f0b16db93ae96cf$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $6f0b16db93ae96cf$export$1ced07cd6b1985ce, (v) => $6f0b16db93ae96cf$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $6f0b16db93ae96cf$export$abd8e32b826d7ea7, (v) => $6f0b16db93ae96cf$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $6f0b16db93ae96cf$export$69a3209f1a06c04d, (v) => $6f0b16db93ae96cf$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $6f0b16db93ae96cf$export$e530037191fcd5d7, (v) => $6f0b16db93ae96cf$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $6f0b16db93ae96cf$export$fd42f52fd3ae1109, (v) => $6f0b16db93ae96cf$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $6f0b16db93ae96cf$export$c8a8987d4410bf2d, (v) => $6f0b16db93ae96cf$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $6f0b16db93ae96cf$export$7d1e3a5e95ceca43, (v) => $6f0b16db93ae96cf$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $6f0b16db93ae96cf$export$257a8862b851cb5b, (v) => $6f0b16db93ae96cf$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $6f0b16db93ae96cf$export$a8257692ac88316c, (v) => $6f0b16db93ae96cf$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $6f0b16db93ae96cf$export$488013bae63b21da, (v) => $6f0b16db93ae96cf$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $6f0b16db93ae96cf$export$7c73462e0d25e514, (v) => $6f0b16db93ae96cf$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $6f0b16db93ae96cf$export$7568632d0d33d16d, (v) => $6f0b16db93ae96cf$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $6f0b16db93ae96cf$export$f93f40ac0ca7e3a8, (v) => $6f0b16db93ae96cf$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $6f0b16db93ae96cf$export$1f96ae73734a86cc, (v) => $6f0b16db93ae96cf$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $6f0b16db93ae96cf$export$9a47ced3238df325, (v) => $6f0b16db93ae96cf$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $6f0b16db93ae96cf$export$35808ee640e87ca7, (v) => $6f0b16db93ae96cf$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $6f0b16db93ae96cf$export$fae74005e78b1a27, (v) => $6f0b16db93ae96cf$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $6f0b16db93ae96cf$export$dc8fbce3eb94dc1e, (v) => $6f0b16db93ae96cf$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $6f0b16db93ae96cf$export$6a7bc4e911dc01cf, (v) => $6f0b16db93ae96cf$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $6f0b16db93ae96cf$export$6d9c69b0de29b591, (v) => $6f0b16db93ae96cf$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $6f0b16db93ae96cf$export$f680877a34711e37, (v) => $6f0b16db93ae96cf$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $6f0b16db93ae96cf$export$d5a552a76deda3c2, (v) => $6f0b16db93ae96cf$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $6f0b16db93ae96cf$export$aaabe4eda9ed9969, (v) => $6f0b16db93ae96cf$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $6f0b16db93ae96cf$export$e5c5a5f917a5871c, (v) => $6f0b16db93ae96cf$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $6f0b16db93ae96cf$export$1538c33de8887b59, (v) => $6f0b16db93ae96cf$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $6f0b16db93ae96cf$export$fca7f784ae7a249a, (v) => $6f0b16db93ae96cf$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $6f0b16db93ae96cf$export$13e3392192263954, (v) => $6f0b16db93ae96cf$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $6f0b16db93ae96cf$export$b8f5890fc79d6aca, (v) => $6f0b16db93ae96cf$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $6f0b16db93ae96cf$export$60241385465d0a34, (v) => $6f0b16db93ae96cf$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $6f0b16db93ae96cf$export$306c0aa65ff9ec16, (v) => $6f0b16db93ae96cf$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $6f0b16db93ae96cf$export$7b286972b8d8ccbf, (v) => $6f0b16db93ae96cf$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $6f0b16db93ae96cf$export$83d89fbfd8236492, (v) => $6f0b16db93ae96cf$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6f0b16db93ae96cf$export$dca3b0875bd9a954;
var $6f0b16db93ae96cf$export$16fa2f45be04daa8;
var $6f0b16db93ae96cf$export$ffb0004e005737fa;
var $6f0b16db93ae96cf$export$e2c29f18771995cb;
var $6f0b16db93ae96cf$export$221d75b3f55bb0bd;
var $6f0b16db93ae96cf$export$5f8d39834fd61797;
var $6f0b16db93ae96cf$export$74bf444e3cd11ea5;
var $6f0b16db93ae96cf$export$1ced07cd6b1985ce;
var $6f0b16db93ae96cf$export$abd8e32b826d7ea7;
var $6f0b16db93ae96cf$export$69a3209f1a06c04d;
var $6f0b16db93ae96cf$export$e530037191fcd5d7;
var $6f0b16db93ae96cf$export$fd42f52fd3ae1109;
var $6f0b16db93ae96cf$export$c8a8987d4410bf2d;
var $6f0b16db93ae96cf$export$7d1e3a5e95ceca43;
var $6f0b16db93ae96cf$export$257a8862b851cb5b;
var $6f0b16db93ae96cf$export$a8257692ac88316c;
var $6f0b16db93ae96cf$export$488013bae63b21da;
var $6f0b16db93ae96cf$export$7c73462e0d25e514;
var $6f0b16db93ae96cf$export$7568632d0d33d16d;
var $6f0b16db93ae96cf$export$f93f40ac0ca7e3a8;
var $6f0b16db93ae96cf$export$1f96ae73734a86cc;
var $6f0b16db93ae96cf$export$9a47ced3238df325;
var $6f0b16db93ae96cf$export$35808ee640e87ca7;
var $6f0b16db93ae96cf$export$fae74005e78b1a27;
var $6f0b16db93ae96cf$export$dc8fbce3eb94dc1e;
var $6f0b16db93ae96cf$export$6a7bc4e911dc01cf;
var $6f0b16db93ae96cf$export$6d9c69b0de29b591;
var $6f0b16db93ae96cf$export$f680877a34711e37;
var $6f0b16db93ae96cf$export$d5a552a76deda3c2;
var $6f0b16db93ae96cf$export$aaabe4eda9ed9969;
var $6f0b16db93ae96cf$export$e5c5a5f917a5871c;
var $6f0b16db93ae96cf$export$1538c33de8887b59;
var $6f0b16db93ae96cf$export$fca7f784ae7a249a;
var $6f0b16db93ae96cf$export$13e3392192263954;
var $6f0b16db93ae96cf$export$b8f5890fc79d6aca;
var $6f0b16db93ae96cf$export$60241385465d0a34;
var $6f0b16db93ae96cf$export$306c0aa65ff9ec16;
var $6f0b16db93ae96cf$export$7b286972b8d8ccbf;
var $6f0b16db93ae96cf$export$83d89fbfd8236492;
"use strict";
var $6f0b16db93ae96cf$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $6f0b16db93ae96cf$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $6f0b16db93ae96cf$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $6f0b16db93ae96cf$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $6f0b16db93ae96cf$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $6f0b16db93ae96cf$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $6f0b16db93ae96cf$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $6f0b16db93ae96cf$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $6f0b16db93ae96cf$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $6f0b16db93ae96cf$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $6f0b16db93ae96cf$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $6f0b16db93ae96cf$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $6f0b16db93ae96cf$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $6f0b16db93ae96cf$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$6f0b16db93ae96cf$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $6f0b16db93ae96cf$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $6f0b16db93ae96cf$var$assign = Object.assign, $6f0b16db93ae96cf$var$emptyObject = {};
function $6f0b16db93ae96cf$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $6f0b16db93ae96cf$var$emptyObject;
    this.updater = updater || $6f0b16db93ae96cf$var$ReactNoopUpdateQueue;
}
$6f0b16db93ae96cf$var$Component.prototype.isReactComponent = {};
$6f0b16db93ae96cf$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$6f0b16db93ae96cf$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $6f0b16db93ae96cf$var$ComponentDummy() {}
$6f0b16db93ae96cf$var$ComponentDummy.prototype = $6f0b16db93ae96cf$var$Component.prototype;
function $6f0b16db93ae96cf$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $6f0b16db93ae96cf$var$emptyObject;
    this.updater = updater || $6f0b16db93ae96cf$var$ReactNoopUpdateQueue;
}
var $6f0b16db93ae96cf$var$pureComponentPrototype = $6f0b16db93ae96cf$var$PureComponent.prototype = new $6f0b16db93ae96cf$var$ComponentDummy();
$6f0b16db93ae96cf$var$pureComponentPrototype.constructor = $6f0b16db93ae96cf$var$PureComponent;
$6f0b16db93ae96cf$var$assign($6f0b16db93ae96cf$var$pureComponentPrototype, $6f0b16db93ae96cf$var$Component.prototype);
$6f0b16db93ae96cf$var$pureComponentPrototype.isPureReactComponent = !0;
var $6f0b16db93ae96cf$var$isArrayImpl = Array.isArray, $6f0b16db93ae96cf$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $6f0b16db93ae96cf$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $6f0b16db93ae96cf$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $6f0b16db93ae96cf$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $6f0b16db93ae96cf$var$cloneAndReplaceKey(oldElement, newKey) {
    return $6f0b16db93ae96cf$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $6f0b16db93ae96cf$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $6f0b16db93ae96cf$var$REACT_ELEMENT_TYPE;
}
function $6f0b16db93ae96cf$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $6f0b16db93ae96cf$var$userProvidedKeyEscapeRegex = /\/+/g;
function $6f0b16db93ae96cf$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $6f0b16db93ae96cf$var$escape("" + element.key) : index.toString(36);
}
function $6f0b16db93ae96cf$var$noop$1() {}
function $6f0b16db93ae96cf$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($6f0b16db93ae96cf$var$noop$1, $6f0b16db93ae96cf$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $6f0b16db93ae96cf$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $6f0b16db93ae96cf$var$REACT_ELEMENT_TYPE:
                case $6f0b16db93ae96cf$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $6f0b16db93ae96cf$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $6f0b16db93ae96cf$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $6f0b16db93ae96cf$var$getElementKey(children, 0) : nameSoFar, $6f0b16db93ae96cf$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($6f0b16db93ae96cf$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $6f0b16db93ae96cf$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($6f0b16db93ae96cf$var$isValidElement(callback) && (callback = $6f0b16db93ae96cf$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($6f0b16db93ae96cf$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($6f0b16db93ae96cf$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $6f0b16db93ae96cf$var$getElementKey(nameSoFar, i), invokeCallback += $6f0b16db93ae96cf$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $6f0b16db93ae96cf$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $6f0b16db93ae96cf$var$getElementKey(nameSoFar, i++), invokeCallback += $6f0b16db93ae96cf$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $6f0b16db93ae96cf$var$mapIntoArray($6f0b16db93ae96cf$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $6f0b16db93ae96cf$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $6f0b16db93ae96cf$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $6f0b16db93ae96cf$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $6f0b16db93ae96cf$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $6f0b16db93ae96cf$var$noop() {}
$6f0b16db93ae96cf$export$dca3b0875bd9a954 = {
    map: $6f0b16db93ae96cf$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $6f0b16db93ae96cf$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $6f0b16db93ae96cf$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $6f0b16db93ae96cf$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$6f0b16db93ae96cf$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$6f0b16db93ae96cf$export$16fa2f45be04daa8 = $6f0b16db93ae96cf$var$Component;
$6f0b16db93ae96cf$export$ffb0004e005737fa = $6f0b16db93ae96cf$var$REACT_FRAGMENT_TYPE;
$6f0b16db93ae96cf$export$e2c29f18771995cb = $6f0b16db93ae96cf$var$REACT_PROFILER_TYPE;
$6f0b16db93ae96cf$export$221d75b3f55bb0bd = $6f0b16db93ae96cf$var$PureComponent;
$6f0b16db93ae96cf$export$5f8d39834fd61797 = $6f0b16db93ae96cf$var$REACT_STRICT_MODE_TYPE;
$6f0b16db93ae96cf$export$74bf444e3cd11ea5 = $6f0b16db93ae96cf$var$REACT_SUSPENSE_TYPE;
$6f0b16db93ae96cf$export$1ced07cd6b1985ce = $6f0b16db93ae96cf$var$ReactSharedInternals;
$6f0b16db93ae96cf$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$6f0b16db93ae96cf$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$6f0b16db93ae96cf$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $6f0b16db93ae96cf$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$6f0b16db93ae96cf$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $6f0b16db93ae96cf$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$6f0b16db93ae96cf$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $6f0b16db93ae96cf$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $6f0b16db93ae96cf$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$6f0b16db93ae96cf$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$6f0b16db93ae96cf$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $6f0b16db93ae96cf$var$ReactElement(type, key, void 0, void 0, null, props);
};
$6f0b16db93ae96cf$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$6f0b16db93ae96cf$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $6f0b16db93ae96cf$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$6f0b16db93ae96cf$export$a8257692ac88316c = $6f0b16db93ae96cf$var$isValidElement;
$6f0b16db93ae96cf$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $6f0b16db93ae96cf$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $6f0b16db93ae96cf$var$lazyInitializer
    };
};
$6f0b16db93ae96cf$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $6f0b16db93ae96cf$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$6f0b16db93ae96cf$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $6f0b16db93ae96cf$var$ReactSharedInternals.T, currentTransition = {};
    $6f0b16db93ae96cf$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $6f0b16db93ae96cf$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($6f0b16db93ae96cf$var$noop, $6f0b16db93ae96cf$var$reportGlobalError);
    } catch (error) {
        $6f0b16db93ae96cf$var$reportGlobalError(error);
    } finally{
        $6f0b16db93ae96cf$var$ReactSharedInternals.T = prevTransition;
    }
};
$6f0b16db93ae96cf$export$f93f40ac0ca7e3a8 = function() {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useCacheRefresh();
};
$6f0b16db93ae96cf$export$1f96ae73734a86cc = function(usable) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.use(usable);
};
$6f0b16db93ae96cf$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$6f0b16db93ae96cf$export$35808ee640e87ca7 = function(callback, deps) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$6f0b16db93ae96cf$export$fae74005e78b1a27 = function(Context) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useContext(Context);
};
$6f0b16db93ae96cf$export$dc8fbce3eb94dc1e = function() {};
$6f0b16db93ae96cf$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$6f0b16db93ae96cf$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $6f0b16db93ae96cf$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$6f0b16db93ae96cf$export$f680877a34711e37 = function() {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useId();
};
$6f0b16db93ae96cf$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$6f0b16db93ae96cf$export$aaabe4eda9ed9969 = function(create, deps) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$6f0b16db93ae96cf$export$e5c5a5f917a5871c = function(create, deps) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$6f0b16db93ae96cf$export$1538c33de8887b59 = function(create, deps) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useMemo(create, deps);
};
$6f0b16db93ae96cf$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$6f0b16db93ae96cf$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$6f0b16db93ae96cf$export$b8f5890fc79d6aca = function(initialValue) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useRef(initialValue);
};
$6f0b16db93ae96cf$export$60241385465d0a34 = function(initialState) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useState(initialState);
};
$6f0b16db93ae96cf$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$6f0b16db93ae96cf$export$7b286972b8d8ccbf = function() {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useTransition();
};
$6f0b16db93ae96cf$export$83d89fbfd8236492 = "19.1.1";

});

parcelRegister("lnmxF", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $f8fd3b4e5f17ffb5$export$882461b6382ed46c, (v) => $f8fd3b4e5f17ffb5$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $f8fd3b4e5f17ffb5$export$757ceba2d55c277e, (v) => $f8fd3b4e5f17ffb5$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $f8fd3b4e5f17ffb5$export$83d89fbfd8236492, (v) => $f8fd3b4e5f17ffb5$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f8fd3b4e5f17ffb5$export$882461b6382ed46c;
var $f8fd3b4e5f17ffb5$export$757ceba2d55c277e;
var $f8fd3b4e5f17ffb5$export$83d89fbfd8236492;
"use strict";

var $hNfVH = parcelRequire("hNfVH");

var $dNU7X = parcelRequire("dNU7X");

var $boCrV = parcelRequire("boCrV");
function $f8fd3b4e5f17ffb5$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $f8fd3b4e5f17ffb5$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $f8fd3b4e5f17ffb5$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $f8fd3b4e5f17ffb5$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $f8fd3b4e5f17ffb5$var$assertIsMounted(fiber) {
    if ($f8fd3b4e5f17ffb5$var$getNearestMountedFiber(fiber) !== fiber) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(188));
}
function $f8fd3b4e5f17ffb5$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $f8fd3b4e5f17ffb5$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $f8fd3b4e5f17ffb5$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $f8fd3b4e5f17ffb5$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $f8fd3b4e5f17ffb5$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $f8fd3b4e5f17ffb5$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $f8fd3b4e5f17ffb5$var$assign = Object.assign, $f8fd3b4e5f17ffb5$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $f8fd3b4e5f17ffb5$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $f8fd3b4e5f17ffb5$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $f8fd3b4e5f17ffb5$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $f8fd3b4e5f17ffb5$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $f8fd3b4e5f17ffb5$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $f8fd3b4e5f17ffb5$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $f8fd3b4e5f17ffb5$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $f8fd3b4e5f17ffb5$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $f8fd3b4e5f17ffb5$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $f8fd3b4e5f17ffb5$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $f8fd3b4e5f17ffb5$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $f8fd3b4e5f17ffb5$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $f8fd3b4e5f17ffb5$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $f8fd3b4e5f17ffb5$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $f8fd3b4e5f17ffb5$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $f8fd3b4e5f17ffb5$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$f8fd3b4e5f17ffb5$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $f8fd3b4e5f17ffb5$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $f8fd3b4e5f17ffb5$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $f8fd3b4e5f17ffb5$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $f8fd3b4e5f17ffb5$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $f8fd3b4e5f17ffb5$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $f8fd3b4e5f17ffb5$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $f8fd3b4e5f17ffb5$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $f8fd3b4e5f17ffb5$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $f8fd3b4e5f17ffb5$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $f8fd3b4e5f17ffb5$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $f8fd3b4e5f17ffb5$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $f8fd3b4e5f17ffb5$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $f8fd3b4e5f17ffb5$var$getComponentNameFromType(type.type) || "Memo";
        case $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $f8fd3b4e5f17ffb5$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $f8fd3b4e5f17ffb5$var$isArrayImpl = Array.isArray, $f8fd3b4e5f17ffb5$var$ReactSharedInternals = $dNU7X.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals = $boCrV.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $f8fd3b4e5f17ffb5$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $f8fd3b4e5f17ffb5$var$valueStack = [], $f8fd3b4e5f17ffb5$var$index = -1;
function $f8fd3b4e5f17ffb5$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $f8fd3b4e5f17ffb5$var$pop(cursor) {
    0 > $f8fd3b4e5f17ffb5$var$index || (cursor.current = $f8fd3b4e5f17ffb5$var$valueStack[$f8fd3b4e5f17ffb5$var$index], $f8fd3b4e5f17ffb5$var$valueStack[$f8fd3b4e5f17ffb5$var$index] = null, $f8fd3b4e5f17ffb5$var$index--);
}
function $f8fd3b4e5f17ffb5$var$push(cursor, value) {
    $f8fd3b4e5f17ffb5$var$index++;
    $f8fd3b4e5f17ffb5$var$valueStack[$f8fd3b4e5f17ffb5$var$index] = cursor.current;
    cursor.current = value;
}
var $f8fd3b4e5f17ffb5$var$contextStackCursor = $f8fd3b4e5f17ffb5$var$createCursor(null), $f8fd3b4e5f17ffb5$var$contextFiberStackCursor = $f8fd3b4e5f17ffb5$var$createCursor(null), $f8fd3b4e5f17ffb5$var$rootInstanceStackCursor = $f8fd3b4e5f17ffb5$var$createCursor(null), $f8fd3b4e5f17ffb5$var$hostTransitionProviderCursor = $f8fd3b4e5f17ffb5$var$createCursor(null);
function $f8fd3b4e5f17ffb5$var$pushHostContainer(fiber, nextRootInstance) {
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$rootInstanceStackCursor, nextRootInstance);
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$contextFiberStackCursor, fiber);
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $f8fd3b4e5f17ffb5$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $f8fd3b4e5f17ffb5$var$getOwnHostContext(nextRootInstance), fiber = $f8fd3b4e5f17ffb5$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$contextStackCursor);
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$contextStackCursor, fiber);
}
function $f8fd3b4e5f17ffb5$var$popHostContainer() {
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$contextStackCursor);
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$contextFiberStackCursor);
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$rootInstanceStackCursor);
}
function $f8fd3b4e5f17ffb5$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$hostTransitionProviderCursor, fiber);
    var context = $f8fd3b4e5f17ffb5$var$contextStackCursor.current;
    var JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$contextFiberStackCursor, fiber), $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$contextStackCursor, JSCompiler_inline_result));
}
function $f8fd3b4e5f17ffb5$var$popHostContext(fiber) {
    $f8fd3b4e5f17ffb5$var$contextFiberStackCursor.current === fiber && ($f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$contextStackCursor), $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$contextFiberStackCursor));
    $f8fd3b4e5f17ffb5$var$hostTransitionProviderCursor.current === fiber && ($f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$hostTransitionProviderCursor), $f8fd3b4e5f17ffb5$var$HostTransitionContext._currentValue = $f8fd3b4e5f17ffb5$var$sharedNotPendingObject);
}
var $f8fd3b4e5f17ffb5$var$hasOwnProperty = Object.prototype.hasOwnProperty, $f8fd3b4e5f17ffb5$var$scheduleCallback$3 = $hNfVH.unstable_scheduleCallback, $f8fd3b4e5f17ffb5$var$cancelCallback$1 = $hNfVH.unstable_cancelCallback, $f8fd3b4e5f17ffb5$var$shouldYield = $hNfVH.unstable_shouldYield, $f8fd3b4e5f17ffb5$var$requestPaint = $hNfVH.unstable_requestPaint, $f8fd3b4e5f17ffb5$var$now = $hNfVH.unstable_now, $f8fd3b4e5f17ffb5$var$getCurrentPriorityLevel = $hNfVH.unstable_getCurrentPriorityLevel, $f8fd3b4e5f17ffb5$var$ImmediatePriority = $hNfVH.unstable_ImmediatePriority, $f8fd3b4e5f17ffb5$var$UserBlockingPriority = $hNfVH.unstable_UserBlockingPriority, $f8fd3b4e5f17ffb5$var$NormalPriority$1 = $hNfVH.unstable_NormalPriority, $f8fd3b4e5f17ffb5$var$LowPriority = $hNfVH.unstable_LowPriority, $f8fd3b4e5f17ffb5$var$IdlePriority = $hNfVH.unstable_IdlePriority, $f8fd3b4e5f17ffb5$var$log$1 = $hNfVH.log, $f8fd3b4e5f17ffb5$var$unstable_setDisableYieldValue = $hNfVH.unstable_setDisableYieldValue, $f8fd3b4e5f17ffb5$var$rendererID = null, $f8fd3b4e5f17ffb5$var$injectedHook = null;
function $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $f8fd3b4e5f17ffb5$var$log$1 && $f8fd3b4e5f17ffb5$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($f8fd3b4e5f17ffb5$var$injectedHook && "function" === typeof $f8fd3b4e5f17ffb5$var$injectedHook.setStrictMode) try {
        $f8fd3b4e5f17ffb5$var$injectedHook.setStrictMode($f8fd3b4e5f17ffb5$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $f8fd3b4e5f17ffb5$var$clz32 = Math.clz32 ? Math.clz32 : $f8fd3b4e5f17ffb5$var$clz32Fallback, $f8fd3b4e5f17ffb5$var$log = Math.log, $f8fd3b4e5f17ffb5$var$LN2 = Math.LN2;
function $f8fd3b4e5f17ffb5$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($f8fd3b4e5f17ffb5$var$log(x) / $f8fd3b4e5f17ffb5$var$LN2 | 0) | 0;
}
var $f8fd3b4e5f17ffb5$var$nextTransitionLane = 256, $f8fd3b4e5f17ffb5$var$nextRetryLane = 4194304;
function $f8fd3b4e5f17ffb5$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $f8fd3b4e5f17ffb5$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $f8fd3b4e5f17ffb5$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $f8fd3b4e5f17ffb5$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $f8fd3b4e5f17ffb5$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $f8fd3b4e5f17ffb5$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $f8fd3b4e5f17ffb5$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $f8fd3b4e5f17ffb5$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $f8fd3b4e5f17ffb5$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $f8fd3b4e5f17ffb5$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f8fd3b4e5f17ffb5$var$claimNextTransitionLane() {
    var lane = $f8fd3b4e5f17ffb5$var$nextTransitionLane;
    $f8fd3b4e5f17ffb5$var$nextTransitionLane <<= 1;
    0 === ($f8fd3b4e5f17ffb5$var$nextTransitionLane & 4194048) && ($f8fd3b4e5f17ffb5$var$nextTransitionLane = 256);
    return lane;
}
function $f8fd3b4e5f17ffb5$var$claimNextRetryLane() {
    var lane = $f8fd3b4e5f17ffb5$var$nextRetryLane;
    $f8fd3b4e5f17ffb5$var$nextRetryLane <<= 1;
    0 === ($f8fd3b4e5f17ffb5$var$nextRetryLane & 62914560) && ($f8fd3b4e5f17ffb5$var$nextRetryLane = 4194304);
    return lane;
}
function $f8fd3b4e5f17ffb5$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $f8fd3b4e5f17ffb5$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $f8fd3b4e5f17ffb5$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $f8fd3b4e5f17ffb5$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $f8fd3b4e5f17ffb5$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $f8fd3b4e5f17ffb5$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $f8fd3b4e5f17ffb5$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $f8fd3b4e5f17ffb5$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $f8fd3b4e5f17ffb5$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $f8fd3b4e5f17ffb5$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $f8fd3b4e5f17ffb5$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $f8fd3b4e5f17ffb5$var$resolveUpdatePriority() {
    var updatePriority = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $f8fd3b4e5f17ffb5$var$getEventPriority(updatePriority.type);
}
function $f8fd3b4e5f17ffb5$var$runWithPriority(priority, fn) {
    var previousPriority = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
    try {
        return $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $f8fd3b4e5f17ffb5$var$randomKey = Math.random().toString(36).slice(2), $f8fd3b4e5f17ffb5$var$internalInstanceKey = "__reactFiber$" + $f8fd3b4e5f17ffb5$var$randomKey, $f8fd3b4e5f17ffb5$var$internalPropsKey = "__reactProps$" + $f8fd3b4e5f17ffb5$var$randomKey, $f8fd3b4e5f17ffb5$var$internalContainerInstanceKey = "__reactContainer$" + $f8fd3b4e5f17ffb5$var$randomKey, $f8fd3b4e5f17ffb5$var$internalEventHandlersKey = "__reactEvents$" + $f8fd3b4e5f17ffb5$var$randomKey, $f8fd3b4e5f17ffb5$var$internalEventHandlerListenersKey = "__reactListeners$" + $f8fd3b4e5f17ffb5$var$randomKey, $f8fd3b4e5f17ffb5$var$internalEventHandlesSetKey = "__reactHandles$" + $f8fd3b4e5f17ffb5$var$randomKey, $f8fd3b4e5f17ffb5$var$internalRootNodeResourcesKey = "__reactResources$" + $f8fd3b4e5f17ffb5$var$randomKey, $f8fd3b4e5f17ffb5$var$internalHoistableMarker = "__reactMarker$" + $f8fd3b4e5f17ffb5$var$randomKey;
function $f8fd3b4e5f17ffb5$var$detachDeletedInstance(node) {
    delete node[$f8fd3b4e5f17ffb5$var$internalInstanceKey];
    delete node[$f8fd3b4e5f17ffb5$var$internalPropsKey];
    delete node[$f8fd3b4e5f17ffb5$var$internalEventHandlersKey];
    delete node[$f8fd3b4e5f17ffb5$var$internalEventHandlerListenersKey];
    delete node[$f8fd3b4e5f17ffb5$var$internalEventHandlesSetKey];
}
function $f8fd3b4e5f17ffb5$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$f8fd3b4e5f17ffb5$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$f8fd3b4e5f17ffb5$var$internalContainerInstanceKey] || parentNode[$f8fd3b4e5f17ffb5$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $f8fd3b4e5f17ffb5$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$f8fd3b4e5f17ffb5$var$internalInstanceKey]) return parentNode;
                targetNode = $f8fd3b4e5f17ffb5$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $f8fd3b4e5f17ffb5$var$getInstanceFromNode(node) {
    if (node = node[$f8fd3b4e5f17ffb5$var$internalInstanceKey] || node[$f8fd3b4e5f17ffb5$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $f8fd3b4e5f17ffb5$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(33));
}
function $f8fd3b4e5f17ffb5$var$getResourcesFromRoot(root) {
    var resources = root[$f8fd3b4e5f17ffb5$var$internalRootNodeResourcesKey];
    resources || (resources = root[$f8fd3b4e5f17ffb5$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(node) {
    node[$f8fd3b4e5f17ffb5$var$internalHoistableMarker] = !0;
}
var $f8fd3b4e5f17ffb5$var$allNativeEvents = new Set(), $f8fd3b4e5f17ffb5$var$registrationNameDependencies = {};
function $f8fd3b4e5f17ffb5$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $f8fd3b4e5f17ffb5$var$registerDirectEvent(registrationName, dependencies);
    $f8fd3b4e5f17ffb5$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $f8fd3b4e5f17ffb5$var$registerDirectEvent(registrationName, dependencies) {
    $f8fd3b4e5f17ffb5$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$f8fd3b4e5f17ffb5$var$allNativeEvents.add(dependencies[registrationName]);
}
var $f8fd3b4e5f17ffb5$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $f8fd3b4e5f17ffb5$var$illegalAttributeNameCache = {}, $f8fd3b4e5f17ffb5$var$validatedAttributeNameCache = {};
function $f8fd3b4e5f17ffb5$var$isAttributeNameSafe(attributeName) {
    if ($f8fd3b4e5f17ffb5$var$hasOwnProperty.call($f8fd3b4e5f17ffb5$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($f8fd3b4e5f17ffb5$var$hasOwnProperty.call($f8fd3b4e5f17ffb5$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($f8fd3b4e5f17ffb5$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $f8fd3b4e5f17ffb5$var$validatedAttributeNameCache[attributeName] = !0;
    $f8fd3b4e5f17ffb5$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $f8fd3b4e5f17ffb5$var$setValueForAttribute(node, name, value) {
    if ($f8fd3b4e5f17ffb5$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $f8fd3b4e5f17ffb5$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $f8fd3b4e5f17ffb5$var$prefix, $f8fd3b4e5f17ffb5$var$suffix;
function $f8fd3b4e5f17ffb5$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $f8fd3b4e5f17ffb5$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $f8fd3b4e5f17ffb5$var$prefix = match && match[1] || "";
        $f8fd3b4e5f17ffb5$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $f8fd3b4e5f17ffb5$var$prefix + name + $f8fd3b4e5f17ffb5$var$suffix;
}
var $f8fd3b4e5f17ffb5$var$reentry = !1;
function $f8fd3b4e5f17ffb5$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $f8fd3b4e5f17ffb5$var$reentry) return "";
    $f8fd3b4e5f17ffb5$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $f8fd3b4e5f17ffb5$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $f8fd3b4e5f17ffb5$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $f8fd3b4e5f17ffb5$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $f8fd3b4e5f17ffb5$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $f8fd3b4e5f17ffb5$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $f8fd3b4e5f17ffb5$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $f8fd3b4e5f17ffb5$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $f8fd3b4e5f17ffb5$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $f8fd3b4e5f17ffb5$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $f8fd3b4e5f17ffb5$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $f8fd3b4e5f17ffb5$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $f8fd3b4e5f17ffb5$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $f8fd3b4e5f17ffb5$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $f8fd3b4e5f17ffb5$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $f8fd3b4e5f17ffb5$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $f8fd3b4e5f17ffb5$var$trackValueOnNode(node) {
    var valueField = $f8fd3b4e5f17ffb5$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $f8fd3b4e5f17ffb5$var$track(node) {
    node._valueTracker || (node._valueTracker = $f8fd3b4e5f17ffb5$var$trackValueOnNode(node));
}
function $f8fd3b4e5f17ffb5$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $f8fd3b4e5f17ffb5$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $f8fd3b4e5f17ffb5$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $f8fd3b4e5f17ffb5$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $f8fd3b4e5f17ffb5$var$getToStringValue(value);
        } else element.value !== "" + $f8fd3b4e5f17ffb5$var$getToStringValue(value) && (element.value = "" + $f8fd3b4e5f17ffb5$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $f8fd3b4e5f17ffb5$var$setDefaultValue(element, type, $f8fd3b4e5f17ffb5$var$getToStringValue(value)) : null != defaultValue ? $f8fd3b4e5f17ffb5$var$setDefaultValue(element, type, $f8fd3b4e5f17ffb5$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $f8fd3b4e5f17ffb5$var$getToStringValue(name) : element.removeAttribute("name");
}
function $f8fd3b4e5f17ffb5$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $f8fd3b4e5f17ffb5$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $f8fd3b4e5f17ffb5$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $f8fd3b4e5f17ffb5$var$setDefaultValue(node, type, value) {
    "number" === type && $f8fd3b4e5f17ffb5$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $f8fd3b4e5f17ffb5$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $f8fd3b4e5f17ffb5$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $f8fd3b4e5f17ffb5$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $f8fd3b4e5f17ffb5$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $f8fd3b4e5f17ffb5$var$getToStringValue(defaultValue) : "";
}
function $f8fd3b4e5f17ffb5$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(92));
            if ($f8fd3b4e5f17ffb5$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $f8fd3b4e5f17ffb5$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $f8fd3b4e5f17ffb5$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $f8fd3b4e5f17ffb5$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $f8fd3b4e5f17ffb5$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $f8fd3b4e5f17ffb5$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $f8fd3b4e5f17ffb5$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $f8fd3b4e5f17ffb5$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $f8fd3b4e5f17ffb5$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $f8fd3b4e5f17ffb5$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f8fd3b4e5f17ffb5$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $f8fd3b4e5f17ffb5$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $f8fd3b4e5f17ffb5$var$sanitizeURL(url) {
    return $f8fd3b4e5f17ffb5$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $f8fd3b4e5f17ffb5$var$currentReplayingEvent = null;
function $f8fd3b4e5f17ffb5$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $f8fd3b4e5f17ffb5$var$restoreTarget = null, $f8fd3b4e5f17ffb5$var$restoreQueue = null;
function $f8fd3b4e5f17ffb5$var$restoreStateOfTarget(target) {
    var internalInstance = $f8fd3b4e5f17ffb5$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$f8fd3b4e5f17ffb5$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $f8fd3b4e5f17ffb5$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$f8fd3b4e5f17ffb5$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(90));
                            $f8fd3b4e5f17ffb5$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $f8fd3b4e5f17ffb5$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $f8fd3b4e5f17ffb5$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $f8fd3b4e5f17ffb5$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $f8fd3b4e5f17ffb5$var$isInsideEventHandler = !1;
function $f8fd3b4e5f17ffb5$var$batchedUpdates$1(fn, a, b) {
    if ($f8fd3b4e5f17ffb5$var$isInsideEventHandler) return fn(a, b);
    $f8fd3b4e5f17ffb5$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($f8fd3b4e5f17ffb5$var$isInsideEventHandler = !1, null !== $f8fd3b4e5f17ffb5$var$restoreTarget || null !== $f8fd3b4e5f17ffb5$var$restoreQueue) {
            if ($f8fd3b4e5f17ffb5$var$flushSyncWork$1(), $f8fd3b4e5f17ffb5$var$restoreTarget && (a = $f8fd3b4e5f17ffb5$var$restoreTarget, fn = $f8fd3b4e5f17ffb5$var$restoreQueue, $f8fd3b4e5f17ffb5$var$restoreQueue = $f8fd3b4e5f17ffb5$var$restoreTarget = null, $f8fd3b4e5f17ffb5$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$f8fd3b4e5f17ffb5$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $f8fd3b4e5f17ffb5$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$f8fd3b4e5f17ffb5$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $f8fd3b4e5f17ffb5$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f8fd3b4e5f17ffb5$var$passiveBrowserEventsSupported = !1;
if ($f8fd3b4e5f17ffb5$var$canUseDOM) try {
    var $f8fd3b4e5f17ffb5$var$options = {};
    Object.defineProperty($f8fd3b4e5f17ffb5$var$options, "passive", {
        get: function() {
            $f8fd3b4e5f17ffb5$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $f8fd3b4e5f17ffb5$var$options, $f8fd3b4e5f17ffb5$var$options);
    window.removeEventListener("test", $f8fd3b4e5f17ffb5$var$options, $f8fd3b4e5f17ffb5$var$options);
} catch (e) {
    $f8fd3b4e5f17ffb5$var$passiveBrowserEventsSupported = !1;
}
var $f8fd3b4e5f17ffb5$var$root = null, $f8fd3b4e5f17ffb5$var$startText = null, $f8fd3b4e5f17ffb5$var$fallbackText = null;
function $f8fd3b4e5f17ffb5$var$getData() {
    if ($f8fd3b4e5f17ffb5$var$fallbackText) return $f8fd3b4e5f17ffb5$var$fallbackText;
    var start, startValue = $f8fd3b4e5f17ffb5$var$startText, startLength = startValue.length, end, endValue = "value" in $f8fd3b4e5f17ffb5$var$root ? $f8fd3b4e5f17ffb5$var$root.value : $f8fd3b4e5f17ffb5$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $f8fd3b4e5f17ffb5$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $f8fd3b4e5f17ffb5$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $f8fd3b4e5f17ffb5$var$functionThatReturnsTrue() {
    return !0;
}
function $f8fd3b4e5f17ffb5$var$functionThatReturnsFalse() {
    return !1;
}
function $f8fd3b4e5f17ffb5$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $f8fd3b4e5f17ffb5$var$functionThatReturnsTrue : $f8fd3b4e5f17ffb5$var$functionThatReturnsFalse;
        this.isPropagationStopped = $f8fd3b4e5f17ffb5$var$functionThatReturnsFalse;
        return this;
    }
    $f8fd3b4e5f17ffb5$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $f8fd3b4e5f17ffb5$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $f8fd3b4e5f17ffb5$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $f8fd3b4e5f17ffb5$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $f8fd3b4e5f17ffb5$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f8fd3b4e5f17ffb5$var$SyntheticEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$EventInterface), $f8fd3b4e5f17ffb5$var$UIEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$EventInterface, {
    view: 0,
    detail: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticUIEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$UIEventInterface), $f8fd3b4e5f17ffb5$var$lastMovementX, $f8fd3b4e5f17ffb5$var$lastMovementY, $f8fd3b4e5f17ffb5$var$lastMouseEvent, $f8fd3b4e5f17ffb5$var$MouseEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f8fd3b4e5f17ffb5$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $f8fd3b4e5f17ffb5$var$lastMouseEvent && ($f8fd3b4e5f17ffb5$var$lastMouseEvent && "mousemove" === event.type ? ($f8fd3b4e5f17ffb5$var$lastMovementX = event.screenX - $f8fd3b4e5f17ffb5$var$lastMouseEvent.screenX, $f8fd3b4e5f17ffb5$var$lastMovementY = event.screenY - $f8fd3b4e5f17ffb5$var$lastMouseEvent.screenY) : $f8fd3b4e5f17ffb5$var$lastMovementY = $f8fd3b4e5f17ffb5$var$lastMovementX = 0, $f8fd3b4e5f17ffb5$var$lastMouseEvent = event);
        return $f8fd3b4e5f17ffb5$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $f8fd3b4e5f17ffb5$var$lastMovementY;
    }
}), $f8fd3b4e5f17ffb5$var$SyntheticMouseEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$MouseEventInterface), $f8fd3b4e5f17ffb5$var$DragEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$MouseEventInterface, {
    dataTransfer: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticDragEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$DragEventInterface), $f8fd3b4e5f17ffb5$var$FocusEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$UIEventInterface, {
    relatedTarget: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticFocusEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$FocusEventInterface), $f8fd3b4e5f17ffb5$var$AnimationEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticAnimationEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$AnimationEventInterface), $f8fd3b4e5f17ffb5$var$ClipboardEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $f8fd3b4e5f17ffb5$var$SyntheticClipboardEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$ClipboardEventInterface), $f8fd3b4e5f17ffb5$var$CompositionEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$EventInterface, {
    data: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticCompositionEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$CompositionEventInterface), $f8fd3b4e5f17ffb5$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f8fd3b4e5f17ffb5$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f8fd3b4e5f17ffb5$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f8fd3b4e5f17ffb5$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $f8fd3b4e5f17ffb5$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $f8fd3b4e5f17ffb5$var$getEventModifierState() {
    return $f8fd3b4e5f17ffb5$var$modifierStateGetter;
}
var $f8fd3b4e5f17ffb5$var$KeyboardEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $f8fd3b4e5f17ffb5$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $f8fd3b4e5f17ffb5$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $f8fd3b4e5f17ffb5$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f8fd3b4e5f17ffb5$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $f8fd3b4e5f17ffb5$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $f8fd3b4e5f17ffb5$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $f8fd3b4e5f17ffb5$var$SyntheticKeyboardEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$KeyboardEventInterface), $f8fd3b4e5f17ffb5$var$PointerEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticPointerEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$PointerEventInterface), $f8fd3b4e5f17ffb5$var$TouchEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f8fd3b4e5f17ffb5$var$getEventModifierState
}), $f8fd3b4e5f17ffb5$var$SyntheticTouchEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$TouchEventInterface), $f8fd3b4e5f17ffb5$var$TransitionEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticTransitionEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$TransitionEventInterface), $f8fd3b4e5f17ffb5$var$WheelEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticWheelEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$WheelEventInterface), $f8fd3b4e5f17ffb5$var$ToggleEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticToggleEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$ToggleEventInterface), $f8fd3b4e5f17ffb5$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $f8fd3b4e5f17ffb5$var$canUseCompositionEvent = $f8fd3b4e5f17ffb5$var$canUseDOM && "CompositionEvent" in window, $f8fd3b4e5f17ffb5$var$documentMode = null;
$f8fd3b4e5f17ffb5$var$canUseDOM && "documentMode" in document && ($f8fd3b4e5f17ffb5$var$documentMode = document.documentMode);
var $f8fd3b4e5f17ffb5$var$canUseTextInputEvent = $f8fd3b4e5f17ffb5$var$canUseDOM && "TextEvent" in window && !$f8fd3b4e5f17ffb5$var$documentMode, $f8fd3b4e5f17ffb5$var$useFallbackCompositionData = $f8fd3b4e5f17ffb5$var$canUseDOM && (!$f8fd3b4e5f17ffb5$var$canUseCompositionEvent || $f8fd3b4e5f17ffb5$var$documentMode && 8 < $f8fd3b4e5f17ffb5$var$documentMode && 11 >= $f8fd3b4e5f17ffb5$var$documentMode), $f8fd3b4e5f17ffb5$var$SPACEBAR_CHAR = String.fromCharCode(32), $f8fd3b4e5f17ffb5$var$hasSpaceKeypress = !1;
function $f8fd3b4e5f17ffb5$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $f8fd3b4e5f17ffb5$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f8fd3b4e5f17ffb5$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $f8fd3b4e5f17ffb5$var$isComposing = !1;
function $f8fd3b4e5f17ffb5$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $f8fd3b4e5f17ffb5$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $f8fd3b4e5f17ffb5$var$hasSpaceKeypress = !0;
            return $f8fd3b4e5f17ffb5$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $f8fd3b4e5f17ffb5$var$SPACEBAR_CHAR && $f8fd3b4e5f17ffb5$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $f8fd3b4e5f17ffb5$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($f8fd3b4e5f17ffb5$var$isComposing) return "compositionend" === domEventName || !$f8fd3b4e5f17ffb5$var$canUseCompositionEvent && $f8fd3b4e5f17ffb5$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $f8fd3b4e5f17ffb5$var$getData(), $f8fd3b4e5f17ffb5$var$fallbackText = $f8fd3b4e5f17ffb5$var$startText = $f8fd3b4e5f17ffb5$var$root = null, $f8fd3b4e5f17ffb5$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $f8fd3b4e5f17ffb5$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $f8fd3b4e5f17ffb5$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f8fd3b4e5f17ffb5$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$f8fd3b4e5f17ffb5$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $f8fd3b4e5f17ffb5$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $f8fd3b4e5f17ffb5$var$restoreTarget ? $f8fd3b4e5f17ffb5$var$restoreQueue ? $f8fd3b4e5f17ffb5$var$restoreQueue.push(target) : $f8fd3b4e5f17ffb5$var$restoreQueue = [
        target
    ] : $f8fd3b4e5f17ffb5$var$restoreTarget = target;
    inst = $f8fd3b4e5f17ffb5$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $f8fd3b4e5f17ffb5$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $f8fd3b4e5f17ffb5$var$activeElement$1 = null, $f8fd3b4e5f17ffb5$var$activeElementInst$1 = null;
function $f8fd3b4e5f17ffb5$var$runEventInBatch(dispatchQueue) {
    $f8fd3b4e5f17ffb5$var$processDispatchQueue(dispatchQueue, 0);
}
function $f8fd3b4e5f17ffb5$var$getInstIfValueChanged(targetInst) {
    var targetNode = $f8fd3b4e5f17ffb5$var$getNodeFromInstance(targetInst);
    if ($f8fd3b4e5f17ffb5$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $f8fd3b4e5f17ffb5$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $f8fd3b4e5f17ffb5$var$isInputEventSupported = !1;
if ($f8fd3b4e5f17ffb5$var$canUseDOM) {
    var $f8fd3b4e5f17ffb5$var$JSCompiler_inline_result$jscomp$282;
    if ($f8fd3b4e5f17ffb5$var$canUseDOM) {
        var $f8fd3b4e5f17ffb5$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$f8fd3b4e5f17ffb5$var$isSupported$jscomp$inline_417) {
            var $f8fd3b4e5f17ffb5$var$element$jscomp$inline_418 = document.createElement("div");
            $f8fd3b4e5f17ffb5$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $f8fd3b4e5f17ffb5$var$isSupported$jscomp$inline_417 = "function" === typeof $f8fd3b4e5f17ffb5$var$element$jscomp$inline_418.oninput;
        }
        $f8fd3b4e5f17ffb5$var$JSCompiler_inline_result$jscomp$282 = $f8fd3b4e5f17ffb5$var$isSupported$jscomp$inline_417;
    } else $f8fd3b4e5f17ffb5$var$JSCompiler_inline_result$jscomp$282 = !1;
    $f8fd3b4e5f17ffb5$var$isInputEventSupported = $f8fd3b4e5f17ffb5$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $f8fd3b4e5f17ffb5$var$stopWatchingForValueChange() {
    $f8fd3b4e5f17ffb5$var$activeElement$1 && ($f8fd3b4e5f17ffb5$var$activeElement$1.detachEvent("onpropertychange", $f8fd3b4e5f17ffb5$var$handlePropertyChange), $f8fd3b4e5f17ffb5$var$activeElementInst$1 = $f8fd3b4e5f17ffb5$var$activeElement$1 = null);
}
function $f8fd3b4e5f17ffb5$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $f8fd3b4e5f17ffb5$var$getInstIfValueChanged($f8fd3b4e5f17ffb5$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $f8fd3b4e5f17ffb5$var$createAndAccumulateChangeEvent(dispatchQueue, $f8fd3b4e5f17ffb5$var$activeElementInst$1, nativeEvent, $f8fd3b4e5f17ffb5$var$getEventTarget(nativeEvent));
        $f8fd3b4e5f17ffb5$var$batchedUpdates$1($f8fd3b4e5f17ffb5$var$runEventInBatch, dispatchQueue);
    }
}
function $f8fd3b4e5f17ffb5$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($f8fd3b4e5f17ffb5$var$stopWatchingForValueChange(), $f8fd3b4e5f17ffb5$var$activeElement$1 = target, $f8fd3b4e5f17ffb5$var$activeElementInst$1 = targetInst, $f8fd3b4e5f17ffb5$var$activeElement$1.attachEvent("onpropertychange", $f8fd3b4e5f17ffb5$var$handlePropertyChange)) : "focusout" === domEventName && $f8fd3b4e5f17ffb5$var$stopWatchingForValueChange();
}
function $f8fd3b4e5f17ffb5$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $f8fd3b4e5f17ffb5$var$getInstIfValueChanged($f8fd3b4e5f17ffb5$var$activeElementInst$1);
}
function $f8fd3b4e5f17ffb5$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $f8fd3b4e5f17ffb5$var$getInstIfValueChanged(targetInst);
}
function $f8fd3b4e5f17ffb5$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $f8fd3b4e5f17ffb5$var$getInstIfValueChanged(targetInst);
}
function $f8fd3b4e5f17ffb5$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $f8fd3b4e5f17ffb5$var$objectIs = "function" === typeof Object.is ? Object.is : $f8fd3b4e5f17ffb5$var$is;
function $f8fd3b4e5f17ffb5$var$shallowEqual(objA, objB) {
    if ($f8fd3b4e5f17ffb5$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$f8fd3b4e5f17ffb5$var$hasOwnProperty.call(objB, currentKey) || !$f8fd3b4e5f17ffb5$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $f8fd3b4e5f17ffb5$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $f8fd3b4e5f17ffb5$var$getNodeForCharacterOffset(root, offset) {
    var node = $f8fd3b4e5f17ffb5$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $f8fd3b4e5f17ffb5$var$getLeafNode(node);
    }
}
function $f8fd3b4e5f17ffb5$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $f8fd3b4e5f17ffb5$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $f8fd3b4e5f17ffb5$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $f8fd3b4e5f17ffb5$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $f8fd3b4e5f17ffb5$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $f8fd3b4e5f17ffb5$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $f8fd3b4e5f17ffb5$var$skipSelectionChangeEvent = $f8fd3b4e5f17ffb5$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $f8fd3b4e5f17ffb5$var$activeElement = null, $f8fd3b4e5f17ffb5$var$activeElementInst = null, $f8fd3b4e5f17ffb5$var$lastSelection = null, $f8fd3b4e5f17ffb5$var$mouseDown = !1;
function $f8fd3b4e5f17ffb5$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $f8fd3b4e5f17ffb5$var$mouseDown || null == $f8fd3b4e5f17ffb5$var$activeElement || $f8fd3b4e5f17ffb5$var$activeElement !== $f8fd3b4e5f17ffb5$var$getActiveElement(doc) || (doc = $f8fd3b4e5f17ffb5$var$activeElement, "selectionStart" in doc && $f8fd3b4e5f17ffb5$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $f8fd3b4e5f17ffb5$var$lastSelection && $f8fd3b4e5f17ffb5$var$shallowEqual($f8fd3b4e5f17ffb5$var$lastSelection, doc) || ($f8fd3b4e5f17ffb5$var$lastSelection = doc, doc = $f8fd3b4e5f17ffb5$var$accumulateTwoPhaseListeners($f8fd3b4e5f17ffb5$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $f8fd3b4e5f17ffb5$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $f8fd3b4e5f17ffb5$var$activeElement)));
}
function $f8fd3b4e5f17ffb5$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $f8fd3b4e5f17ffb5$var$vendorPrefixes = {
    animationend: $f8fd3b4e5f17ffb5$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $f8fd3b4e5f17ffb5$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $f8fd3b4e5f17ffb5$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $f8fd3b4e5f17ffb5$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $f8fd3b4e5f17ffb5$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $f8fd3b4e5f17ffb5$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $f8fd3b4e5f17ffb5$var$makePrefixMap("Transition", "TransitionEnd")
}, $f8fd3b4e5f17ffb5$var$prefixedEventNames = {}, $f8fd3b4e5f17ffb5$var$style = {};
$f8fd3b4e5f17ffb5$var$canUseDOM && ($f8fd3b4e5f17ffb5$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $f8fd3b4e5f17ffb5$var$vendorPrefixes.animationend.animation, delete $f8fd3b4e5f17ffb5$var$vendorPrefixes.animationiteration.animation, delete $f8fd3b4e5f17ffb5$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $f8fd3b4e5f17ffb5$var$vendorPrefixes.transitionend.transition);
function $f8fd3b4e5f17ffb5$var$getVendorPrefixedEventName(eventName) {
    if ($f8fd3b4e5f17ffb5$var$prefixedEventNames[eventName]) return $f8fd3b4e5f17ffb5$var$prefixedEventNames[eventName];
    if (!$f8fd3b4e5f17ffb5$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $f8fd3b4e5f17ffb5$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $f8fd3b4e5f17ffb5$var$style) return $f8fd3b4e5f17ffb5$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $f8fd3b4e5f17ffb5$var$ANIMATION_END = $f8fd3b4e5f17ffb5$var$getVendorPrefixedEventName("animationend"), $f8fd3b4e5f17ffb5$var$ANIMATION_ITERATION = $f8fd3b4e5f17ffb5$var$getVendorPrefixedEventName("animationiteration"), $f8fd3b4e5f17ffb5$var$ANIMATION_START = $f8fd3b4e5f17ffb5$var$getVendorPrefixedEventName("animationstart"), $f8fd3b4e5f17ffb5$var$TRANSITION_RUN = $f8fd3b4e5f17ffb5$var$getVendorPrefixedEventName("transitionrun"), $f8fd3b4e5f17ffb5$var$TRANSITION_START = $f8fd3b4e5f17ffb5$var$getVendorPrefixedEventName("transitionstart"), $f8fd3b4e5f17ffb5$var$TRANSITION_CANCEL = $f8fd3b4e5f17ffb5$var$getVendorPrefixedEventName("transitioncancel"), $f8fd3b4e5f17ffb5$var$TRANSITION_END = $f8fd3b4e5f17ffb5$var$getVendorPrefixedEventName("transitionend"), $f8fd3b4e5f17ffb5$var$topLevelEventsToReactNames = new Map(), $f8fd3b4e5f17ffb5$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$f8fd3b4e5f17ffb5$var$simpleEventPluginEvents.push("scrollEnd");
function $f8fd3b4e5f17ffb5$var$registerSimpleEvent(domEventName, reactName) {
    $f8fd3b4e5f17ffb5$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $f8fd3b4e5f17ffb5$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $f8fd3b4e5f17ffb5$var$CapturedStacks = new WeakMap();
function $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $f8fd3b4e5f17ffb5$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $f8fd3b4e5f17ffb5$var$getStackByFiberInDevAndProd(source)
        };
        $f8fd3b4e5f17ffb5$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $f8fd3b4e5f17ffb5$var$getStackByFiberInDevAndProd(source)
    };
}
var $f8fd3b4e5f17ffb5$var$concurrentQueues = [], $f8fd3b4e5f17ffb5$var$concurrentQueuesIndex = 0, $f8fd3b4e5f17ffb5$var$concurrentlyUpdatedLanes = 0;
function $f8fd3b4e5f17ffb5$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $f8fd3b4e5f17ffb5$var$concurrentQueuesIndex, i = $f8fd3b4e5f17ffb5$var$concurrentlyUpdatedLanes = $f8fd3b4e5f17ffb5$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $f8fd3b4e5f17ffb5$var$concurrentQueues[i];
        $f8fd3b4e5f17ffb5$var$concurrentQueues[i++] = null;
        var queue = $f8fd3b4e5f17ffb5$var$concurrentQueues[i];
        $f8fd3b4e5f17ffb5$var$concurrentQueues[i++] = null;
        var update = $f8fd3b4e5f17ffb5$var$concurrentQueues[i];
        $f8fd3b4e5f17ffb5$var$concurrentQueues[i++] = null;
        var lane = $f8fd3b4e5f17ffb5$var$concurrentQueues[i];
        $f8fd3b4e5f17ffb5$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $f8fd3b4e5f17ffb5$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $f8fd3b4e5f17ffb5$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $f8fd3b4e5f17ffb5$var$concurrentQueues[$f8fd3b4e5f17ffb5$var$concurrentQueuesIndex++] = fiber;
    $f8fd3b4e5f17ffb5$var$concurrentQueues[$f8fd3b4e5f17ffb5$var$concurrentQueuesIndex++] = queue;
    $f8fd3b4e5f17ffb5$var$concurrentQueues[$f8fd3b4e5f17ffb5$var$concurrentQueuesIndex++] = update;
    $f8fd3b4e5f17ffb5$var$concurrentQueues[$f8fd3b4e5f17ffb5$var$concurrentQueuesIndex++] = lane;
    $f8fd3b4e5f17ffb5$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $f8fd3b4e5f17ffb5$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $f8fd3b4e5f17ffb5$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $f8fd3b4e5f17ffb5$var$getRootForUpdatedFiber(fiber);
}
function $f8fd3b4e5f17ffb5$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $f8fd3b4e5f17ffb5$var$enqueueUpdate$1(fiber, null, null, lane);
    return $f8fd3b4e5f17ffb5$var$getRootForUpdatedFiber(fiber);
}
function $f8fd3b4e5f17ffb5$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $f8fd3b4e5f17ffb5$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $f8fd3b4e5f17ffb5$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $f8fd3b4e5f17ffb5$var$nestedUpdateCount) throw $f8fd3b4e5f17ffb5$var$nestedUpdateCount = 0, $f8fd3b4e5f17ffb5$var$rootWithNestedUpdates = null, Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $f8fd3b4e5f17ffb5$var$emptyContextObject = {};
function $f8fd3b4e5f17ffb5$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f8fd3b4e5f17ffb5$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $f8fd3b4e5f17ffb5$var$FiberNode(tag, pendingProps, key, mode);
}
function $f8fd3b4e5f17ffb5$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $f8fd3b4e5f17ffb5$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $f8fd3b4e5f17ffb5$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $f8fd3b4e5f17ffb5$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $f8fd3b4e5f17ffb5$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $f8fd3b4e5f17ffb5$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $f8fd3b4e5f17ffb5$var$isHostHoistableType(type, pendingProps, $f8fd3b4e5f17ffb5$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $f8fd3b4e5f17ffb5$var$REACT_ACTIVITY_TYPE:
            return type = $f8fd3b4e5f17ffb5$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $f8fd3b4e5f17ffb5$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $f8fd3b4e5f17ffb5$var$REACT_FRAGMENT_TYPE:
            return $f8fd3b4e5f17ffb5$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $f8fd3b4e5f17ffb5$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $f8fd3b4e5f17ffb5$var$REACT_PROFILER_TYPE:
            return type = $f8fd3b4e5f17ffb5$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $f8fd3b4e5f17ffb5$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $f8fd3b4e5f17ffb5$var$REACT_SUSPENSE_TYPE:
            return type = $f8fd3b4e5f17ffb5$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $f8fd3b4e5f17ffb5$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $f8fd3b4e5f17ffb5$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $f8fd3b4e5f17ffb5$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $f8fd3b4e5f17ffb5$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $f8fd3b4e5f17ffb5$var$REACT_PROVIDER_TYPE:
                case $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $f8fd3b4e5f17ffb5$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $f8fd3b4e5f17ffb5$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $f8fd3b4e5f17ffb5$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $f8fd3b4e5f17ffb5$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $f8fd3b4e5f17ffb5$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $f8fd3b4e5f17ffb5$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $f8fd3b4e5f17ffb5$var$createFiberFromText(content, mode, lanes) {
    content = $f8fd3b4e5f17ffb5$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $f8fd3b4e5f17ffb5$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $f8fd3b4e5f17ffb5$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $f8fd3b4e5f17ffb5$var$forkStack = [], $f8fd3b4e5f17ffb5$var$forkStackIndex = 0, $f8fd3b4e5f17ffb5$var$treeForkProvider = null, $f8fd3b4e5f17ffb5$var$treeForkCount = 0, $f8fd3b4e5f17ffb5$var$idStack = [], $f8fd3b4e5f17ffb5$var$idStackIndex = 0, $f8fd3b4e5f17ffb5$var$treeContextProvider = null, $f8fd3b4e5f17ffb5$var$treeContextId = 1, $f8fd3b4e5f17ffb5$var$treeContextOverflow = "";
function $f8fd3b4e5f17ffb5$var$pushTreeFork(workInProgress, totalChildren) {
    $f8fd3b4e5f17ffb5$var$forkStack[$f8fd3b4e5f17ffb5$var$forkStackIndex++] = $f8fd3b4e5f17ffb5$var$treeForkCount;
    $f8fd3b4e5f17ffb5$var$forkStack[$f8fd3b4e5f17ffb5$var$forkStackIndex++] = $f8fd3b4e5f17ffb5$var$treeForkProvider;
    $f8fd3b4e5f17ffb5$var$treeForkProvider = workInProgress;
    $f8fd3b4e5f17ffb5$var$treeForkCount = totalChildren;
}
function $f8fd3b4e5f17ffb5$var$pushTreeId(workInProgress, totalChildren, index) {
    $f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex++] = $f8fd3b4e5f17ffb5$var$treeContextId;
    $f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex++] = $f8fd3b4e5f17ffb5$var$treeContextOverflow;
    $f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex++] = $f8fd3b4e5f17ffb5$var$treeContextProvider;
    $f8fd3b4e5f17ffb5$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $f8fd3b4e5f17ffb5$var$treeContextId;
    workInProgress = $f8fd3b4e5f17ffb5$var$treeContextOverflow;
    var baseLength = 32 - $f8fd3b4e5f17ffb5$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $f8fd3b4e5f17ffb5$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $f8fd3b4e5f17ffb5$var$treeContextId = 1 << 32 - $f8fd3b4e5f17ffb5$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $f8fd3b4e5f17ffb5$var$treeContextOverflow = length + workInProgress;
    } else $f8fd3b4e5f17ffb5$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $f8fd3b4e5f17ffb5$var$treeContextOverflow = workInProgress;
}
function $f8fd3b4e5f17ffb5$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($f8fd3b4e5f17ffb5$var$pushTreeFork(workInProgress, 1), $f8fd3b4e5f17ffb5$var$pushTreeId(workInProgress, 1, 0));
}
function $f8fd3b4e5f17ffb5$var$popTreeContext(workInProgress) {
    for(; workInProgress === $f8fd3b4e5f17ffb5$var$treeForkProvider;)$f8fd3b4e5f17ffb5$var$treeForkProvider = $f8fd3b4e5f17ffb5$var$forkStack[--$f8fd3b4e5f17ffb5$var$forkStackIndex], $f8fd3b4e5f17ffb5$var$forkStack[$f8fd3b4e5f17ffb5$var$forkStackIndex] = null, $f8fd3b4e5f17ffb5$var$treeForkCount = $f8fd3b4e5f17ffb5$var$forkStack[--$f8fd3b4e5f17ffb5$var$forkStackIndex], $f8fd3b4e5f17ffb5$var$forkStack[$f8fd3b4e5f17ffb5$var$forkStackIndex] = null;
    for(; workInProgress === $f8fd3b4e5f17ffb5$var$treeContextProvider;)$f8fd3b4e5f17ffb5$var$treeContextProvider = $f8fd3b4e5f17ffb5$var$idStack[--$f8fd3b4e5f17ffb5$var$idStackIndex], $f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex] = null, $f8fd3b4e5f17ffb5$var$treeContextOverflow = $f8fd3b4e5f17ffb5$var$idStack[--$f8fd3b4e5f17ffb5$var$idStackIndex], $f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex] = null, $f8fd3b4e5f17ffb5$var$treeContextId = $f8fd3b4e5f17ffb5$var$idStack[--$f8fd3b4e5f17ffb5$var$idStackIndex], $f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex] = null;
}
var $f8fd3b4e5f17ffb5$var$hydrationParentFiber = null, $f8fd3b4e5f17ffb5$var$nextHydratableInstance = null, $f8fd3b4e5f17ffb5$var$isHydrating = !1, $f8fd3b4e5f17ffb5$var$hydrationErrors = null, $f8fd3b4e5f17ffb5$var$rootOrSingletonContext = !1, $f8fd3b4e5f17ffb5$var$HydrationMismatchException = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(519));
function $f8fd3b4e5f17ffb5$var$throwOnHydrationMismatch(fiber) {
    var error = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(418, ""));
    $f8fd3b4e5f17ffb5$var$queueHydrationError($f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(error, fiber));
    throw $f8fd3b4e5f17ffb5$var$HydrationMismatchException;
}
function $f8fd3b4e5f17ffb5$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = fiber;
    instance[$f8fd3b4e5f17ffb5$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("cancel", instance);
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $f8fd3b4e5f17ffb5$var$mediaEventTypes.length; type++)$f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent($f8fd3b4e5f17ffb5$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("error", instance);
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("invalid", instance);
            $f8fd3b4e5f17ffb5$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $f8fd3b4e5f17ffb5$var$track(instance);
            break;
        case "select":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("invalid", instance), $f8fd3b4e5f17ffb5$var$initTextarea(instance, props.value, props.defaultValue, props.children), $f8fd3b4e5f17ffb5$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $f8fd3b4e5f17ffb5$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("beforetoggle", instance), $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $f8fd3b4e5f17ffb5$var$noop$1), instance = !0) : instance = !1;
    instance || $f8fd3b4e5f17ffb5$var$throwOnHydrationMismatch(fiber);
}
function $f8fd3b4e5f17ffb5$var$popToNextHostParent(fiber) {
    for($f8fd3b4e5f17ffb5$var$hydrationParentFiber = fiber.return; $f8fd3b4e5f17ffb5$var$hydrationParentFiber;)switch($f8fd3b4e5f17ffb5$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $f8fd3b4e5f17ffb5$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $f8fd3b4e5f17ffb5$var$rootOrSingletonContext = !0;
            return;
        default:
            $f8fd3b4e5f17ffb5$var$hydrationParentFiber = $f8fd3b4e5f17ffb5$var$hydrationParentFiber.return;
    }
}
function $f8fd3b4e5f17ffb5$var$popHydrationState(fiber) {
    if (fiber !== $f8fd3b4e5f17ffb5$var$hydrationParentFiber) return !1;
    if (!$f8fd3b4e5f17ffb5$var$isHydrating) return $f8fd3b4e5f17ffb5$var$popToNextHostParent(fiber), $f8fd3b4e5f17ffb5$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $f8fd3b4e5f17ffb5$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $f8fd3b4e5f17ffb5$var$nextHydratableInstance && $f8fd3b4e5f17ffb5$var$throwOnHydrationMismatch(fiber);
    $f8fd3b4e5f17ffb5$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $f8fd3b4e5f17ffb5$var$nextHydratableInstance = $f8fd3b4e5f17ffb5$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $f8fd3b4e5f17ffb5$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $f8fd3b4e5f17ffb5$var$nextHydratableInstance, $f8fd3b4e5f17ffb5$var$isSingletonScope(fiber.type) ? (fiber = $f8fd3b4e5f17ffb5$var$previousHydratableOnEnteringScopedSingleton, $f8fd3b4e5f17ffb5$var$previousHydratableOnEnteringScopedSingleton = null, $f8fd3b4e5f17ffb5$var$nextHydratableInstance = fiber) : $f8fd3b4e5f17ffb5$var$nextHydratableInstance = tag) : $f8fd3b4e5f17ffb5$var$nextHydratableInstance = $f8fd3b4e5f17ffb5$var$hydrationParentFiber ? $f8fd3b4e5f17ffb5$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $f8fd3b4e5f17ffb5$var$resetHydrationState() {
    $f8fd3b4e5f17ffb5$var$nextHydratableInstance = $f8fd3b4e5f17ffb5$var$hydrationParentFiber = null;
    $f8fd3b4e5f17ffb5$var$isHydrating = !1;
}
function $f8fd3b4e5f17ffb5$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $f8fd3b4e5f17ffb5$var$hydrationErrors;
    null !== queuedErrors && (null === $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors ? $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors = queuedErrors : $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors.push.apply($f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors, queuedErrors), $f8fd3b4e5f17ffb5$var$hydrationErrors = null);
    return queuedErrors;
}
function $f8fd3b4e5f17ffb5$var$queueHydrationError(error) {
    null === $f8fd3b4e5f17ffb5$var$hydrationErrors ? $f8fd3b4e5f17ffb5$var$hydrationErrors = [
        error
    ] : $f8fd3b4e5f17ffb5$var$hydrationErrors.push(error);
}
var $f8fd3b4e5f17ffb5$var$valueCursor = $f8fd3b4e5f17ffb5$var$createCursor(null), $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber$1 = null, $f8fd3b4e5f17ffb5$var$lastContextDependency = null;
function $f8fd3b4e5f17ffb5$var$pushProvider(providerFiber, context, nextValue) {
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $f8fd3b4e5f17ffb5$var$popProvider(context) {
    context._currentValue = $f8fd3b4e5f17ffb5$var$valueCursor.current;
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$valueCursor);
}
function $f8fd3b4e5f17ffb5$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $f8fd3b4e5f17ffb5$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $f8fd3b4e5f17ffb5$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $f8fd3b4e5f17ffb5$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $f8fd3b4e5f17ffb5$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $f8fd3b4e5f17ffb5$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $f8fd3b4e5f17ffb5$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($f8fd3b4e5f17ffb5$var$HostTransitionContext) : current = [
                $f8fd3b4e5f17ffb5$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $f8fd3b4e5f17ffb5$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $f8fd3b4e5f17ffb5$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$f8fd3b4e5f17ffb5$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $f8fd3b4e5f17ffb5$var$prepareToReadContext(workInProgress) {
    $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber$1 = workInProgress;
    $f8fd3b4e5f17ffb5$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $f8fd3b4e5f17ffb5$var$readContext(context) {
    return $f8fd3b4e5f17ffb5$var$readContextForConsumer($f8fd3b4e5f17ffb5$var$currentlyRenderingFiber$1, context);
}
function $f8fd3b4e5f17ffb5$var$readContextDuringReconciliation(consumer, context) {
    null === $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber$1 && $f8fd3b4e5f17ffb5$var$prepareToReadContext(consumer);
    return $f8fd3b4e5f17ffb5$var$readContextForConsumer(consumer, context);
}
function $f8fd3b4e5f17ffb5$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $f8fd3b4e5f17ffb5$var$lastContextDependency) {
        if (null === consumer) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(308));
        $f8fd3b4e5f17ffb5$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $f8fd3b4e5f17ffb5$var$lastContextDependency = $f8fd3b4e5f17ffb5$var$lastContextDependency.next = context;
    return value;
}
var $f8fd3b4e5f17ffb5$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $f8fd3b4e5f17ffb5$var$scheduleCallback$2 = $hNfVH.unstable_scheduleCallback, $f8fd3b4e5f17ffb5$var$NormalPriority = $hNfVH.unstable_NormalPriority, $f8fd3b4e5f17ffb5$var$CacheContext = {
    $$typeof: $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $f8fd3b4e5f17ffb5$var$createCache() {
    return {
        controller: new $f8fd3b4e5f17ffb5$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $f8fd3b4e5f17ffb5$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $f8fd3b4e5f17ffb5$var$scheduleCallback$2($f8fd3b4e5f17ffb5$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $f8fd3b4e5f17ffb5$var$currentEntangledListeners = null, $f8fd3b4e5f17ffb5$var$currentEntangledPendingCount = 0, $f8fd3b4e5f17ffb5$var$currentEntangledLane = 0, $f8fd3b4e5f17ffb5$var$currentEntangledActionThenable = null;
function $f8fd3b4e5f17ffb5$var$entangleAsyncAction(transition, thenable) {
    if (null === $f8fd3b4e5f17ffb5$var$currentEntangledListeners) {
        var entangledListeners = $f8fd3b4e5f17ffb5$var$currentEntangledListeners = [];
        $f8fd3b4e5f17ffb5$var$currentEntangledPendingCount = 0;
        $f8fd3b4e5f17ffb5$var$currentEntangledLane = $f8fd3b4e5f17ffb5$var$requestTransitionLane();
        $f8fd3b4e5f17ffb5$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $f8fd3b4e5f17ffb5$var$currentEntangledPendingCount++;
    thenable.then($f8fd3b4e5f17ffb5$var$pingEngtangledActionScope, $f8fd3b4e5f17ffb5$var$pingEngtangledActionScope);
    return thenable;
}
function $f8fd3b4e5f17ffb5$var$pingEngtangledActionScope() {
    if (0 === --$f8fd3b4e5f17ffb5$var$currentEntangledPendingCount && null !== $f8fd3b4e5f17ffb5$var$currentEntangledListeners) {
        null !== $f8fd3b4e5f17ffb5$var$currentEntangledActionThenable && ($f8fd3b4e5f17ffb5$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $f8fd3b4e5f17ffb5$var$currentEntangledListeners;
        $f8fd3b4e5f17ffb5$var$currentEntangledListeners = null;
        $f8fd3b4e5f17ffb5$var$currentEntangledLane = 0;
        $f8fd3b4e5f17ffb5$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $f8fd3b4e5f17ffb5$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $f8fd3b4e5f17ffb5$var$prevOnStartTransitionFinish = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.S;
$f8fd3b4e5f17ffb5$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $f8fd3b4e5f17ffb5$var$entangleAsyncAction(transition, returnValue);
    null !== $f8fd3b4e5f17ffb5$var$prevOnStartTransitionFinish && $f8fd3b4e5f17ffb5$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $f8fd3b4e5f17ffb5$var$resumedCache = $f8fd3b4e5f17ffb5$var$createCursor(null);
function $f8fd3b4e5f17ffb5$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $f8fd3b4e5f17ffb5$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $f8fd3b4e5f17ffb5$var$workInProgressRoot.pooledCache;
}
function $f8fd3b4e5f17ffb5$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$resumedCache, $f8fd3b4e5f17ffb5$var$resumedCache.current) : $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$resumedCache, prevCachePool.pool);
}
function $f8fd3b4e5f17ffb5$var$getSuspendedCache() {
    var cacheFromPool = $f8fd3b4e5f17ffb5$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $f8fd3b4e5f17ffb5$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $f8fd3b4e5f17ffb5$var$SuspenseException = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(460)), $f8fd3b4e5f17ffb5$var$SuspenseyCommitException = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(474)), $f8fd3b4e5f17ffb5$var$SuspenseActionException = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(542)), $f8fd3b4e5f17ffb5$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $f8fd3b4e5f17ffb5$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $f8fd3b4e5f17ffb5$var$noop$3() {}
function $f8fd3b4e5f17ffb5$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($f8fd3b4e5f17ffb5$var$noop$3, $f8fd3b4e5f17ffb5$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $f8fd3b4e5f17ffb5$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($f8fd3b4e5f17ffb5$var$noop$3, $f8fd3b4e5f17ffb5$var$noop$3);
            else {
                thenableState = $f8fd3b4e5f17ffb5$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $f8fd3b4e5f17ffb5$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $f8fd3b4e5f17ffb5$var$suspendedThenable = thenable;
            throw $f8fd3b4e5f17ffb5$var$SuspenseException;
    }
}
var $f8fd3b4e5f17ffb5$var$suspendedThenable = null;
function $f8fd3b4e5f17ffb5$var$getSuspendedThenable() {
    if (null === $f8fd3b4e5f17ffb5$var$suspendedThenable) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(459));
    var thenable = $f8fd3b4e5f17ffb5$var$suspendedThenable;
    $f8fd3b4e5f17ffb5$var$suspendedThenable = null;
    return thenable;
}
function $f8fd3b4e5f17ffb5$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $f8fd3b4e5f17ffb5$var$SuspenseException || rejectedReason === $f8fd3b4e5f17ffb5$var$SuspenseActionException) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(483));
}
var $f8fd3b4e5f17ffb5$var$hasForceUpdate = !1;
function $f8fd3b4e5f17ffb5$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $f8fd3b4e5f17ffb5$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $f8fd3b4e5f17ffb5$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f8fd3b4e5f17ffb5$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($f8fd3b4e5f17ffb5$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $f8fd3b4e5f17ffb5$var$getRootForUpdatedFiber(fiber);
        $f8fd3b4e5f17ffb5$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $f8fd3b4e5f17ffb5$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $f8fd3b4e5f17ffb5$var$getRootForUpdatedFiber(fiber);
}
function $f8fd3b4e5f17ffb5$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $f8fd3b4e5f17ffb5$var$markRootEntangled(root, lane);
    }
}
function $f8fd3b4e5f17ffb5$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $f8fd3b4e5f17ffb5$var$didReadFromEntangledAsyncAction = !1;
function $f8fd3b4e5f17ffb5$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($f8fd3b4e5f17ffb5$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $f8fd3b4e5f17ffb5$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $f8fd3b4e5f17ffb5$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $f8fd3b4e5f17ffb5$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $f8fd3b4e5f17ffb5$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $f8fd3b4e5f17ffb5$var$currentEntangledLane && ($f8fd3b4e5f17ffb5$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $f8fd3b4e5f17ffb5$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $f8fd3b4e5f17ffb5$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $f8fd3b4e5f17ffb5$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $f8fd3b4e5f17ffb5$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$f8fd3b4e5f17ffb5$var$callCallback(callbacks[updateQueue], context);
}
var $f8fd3b4e5f17ffb5$var$currentTreeHiddenStackCursor = $f8fd3b4e5f17ffb5$var$createCursor(null), $f8fd3b4e5f17ffb5$var$prevEntangledRenderLanesCursor = $f8fd3b4e5f17ffb5$var$createCursor(0);
function $f8fd3b4e5f17ffb5$var$pushHiddenContext(fiber, context) {
    fiber = $f8fd3b4e5f17ffb5$var$entangledRenderLanes;
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$prevEntangledRenderLanesCursor, fiber);
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$currentTreeHiddenStackCursor, context);
    $f8fd3b4e5f17ffb5$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $f8fd3b4e5f17ffb5$var$reuseHiddenContextOnStack() {
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$prevEntangledRenderLanesCursor, $f8fd3b4e5f17ffb5$var$entangledRenderLanes);
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$currentTreeHiddenStackCursor, $f8fd3b4e5f17ffb5$var$currentTreeHiddenStackCursor.current);
}
function $f8fd3b4e5f17ffb5$var$popHiddenContext() {
    $f8fd3b4e5f17ffb5$var$entangledRenderLanes = $f8fd3b4e5f17ffb5$var$prevEntangledRenderLanesCursor.current;
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$currentTreeHiddenStackCursor);
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$prevEntangledRenderLanesCursor);
}
var $f8fd3b4e5f17ffb5$var$renderLanes = 0, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber = null, $f8fd3b4e5f17ffb5$var$currentHook = null, $f8fd3b4e5f17ffb5$var$workInProgressHook = null, $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdate = !1, $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $f8fd3b4e5f17ffb5$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $f8fd3b4e5f17ffb5$var$localIdCounter = 0, $f8fd3b4e5f17ffb5$var$thenableIndexCounter$1 = 0, $f8fd3b4e5f17ffb5$var$thenableState$1 = null, $f8fd3b4e5f17ffb5$var$globalClientIdCounter = 0;
function $f8fd3b4e5f17ffb5$var$throwInvalidHookError() {
    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(321));
}
function $f8fd3b4e5f17ffb5$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$f8fd3b4e5f17ffb5$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $f8fd3b4e5f17ffb5$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $f8fd3b4e5f17ffb5$var$renderLanes = nextRenderLanes;
    $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $f8fd3b4e5f17ffb5$var$HooksDispatcherOnMount : $f8fd3b4e5f17ffb5$var$HooksDispatcherOnUpdate;
    $f8fd3b4e5f17ffb5$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $f8fd3b4e5f17ffb5$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $f8fd3b4e5f17ffb5$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $f8fd3b4e5f17ffb5$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $f8fd3b4e5f17ffb5$var$finishRenderingHooks(current) {
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H = $f8fd3b4e5f17ffb5$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $f8fd3b4e5f17ffb5$var$currentHook && null !== $f8fd3b4e5f17ffb5$var$currentHook.next;
    $f8fd3b4e5f17ffb5$var$renderLanes = 0;
    $f8fd3b4e5f17ffb5$var$workInProgressHook = $f8fd3b4e5f17ffb5$var$currentHook = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber = null;
    $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdate = !1;
    $f8fd3b4e5f17ffb5$var$thenableIndexCounter$1 = 0;
    $f8fd3b4e5f17ffb5$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(300));
    null === current || $f8fd3b4e5f17ffb5$var$didReceiveUpdate || (current = current.dependencies, null !== current && $f8fd3b4e5f17ffb5$var$checkIfContextChanged(current) && ($f8fd3b4e5f17ffb5$var$didReceiveUpdate = !0));
}
function $f8fd3b4e5f17ffb5$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdateDuringThisPass && ($f8fd3b4e5f17ffb5$var$thenableState$1 = null);
        $f8fd3b4e5f17ffb5$var$thenableIndexCounter$1 = 0;
        $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $f8fd3b4e5f17ffb5$var$workInProgressHook = $f8fd3b4e5f17ffb5$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H = $f8fd3b4e5f17ffb5$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $f8fd3b4e5f17ffb5$var$TransitionAwareHostComponent() {
    var dispatcher = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $f8fd3b4e5f17ffb5$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $f8fd3b4e5f17ffb5$var$currentHook ? $f8fd3b4e5f17ffb5$var$currentHook.memoizedState : null) !== dispatcher && ($f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $f8fd3b4e5f17ffb5$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $f8fd3b4e5f17ffb5$var$localIdCounter;
    $f8fd3b4e5f17ffb5$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $f8fd3b4e5f17ffb5$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $f8fd3b4e5f17ffb5$var$resetHooksOnUnwind(workInProgress) {
    if ($f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdate = !1;
    }
    $f8fd3b4e5f17ffb5$var$renderLanes = 0;
    $f8fd3b4e5f17ffb5$var$workInProgressHook = $f8fd3b4e5f17ffb5$var$currentHook = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber = null;
    $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $f8fd3b4e5f17ffb5$var$thenableIndexCounter$1 = $f8fd3b4e5f17ffb5$var$localIdCounter = 0;
    $f8fd3b4e5f17ffb5$var$thenableState$1 = null;
}
function $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f8fd3b4e5f17ffb5$var$workInProgressHook ? $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.memoizedState = $f8fd3b4e5f17ffb5$var$workInProgressHook = hook : $f8fd3b4e5f17ffb5$var$workInProgressHook = $f8fd3b4e5f17ffb5$var$workInProgressHook.next = hook;
    return $f8fd3b4e5f17ffb5$var$workInProgressHook;
}
function $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook() {
    if (null === $f8fd3b4e5f17ffb5$var$currentHook) {
        var nextCurrentHook = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $f8fd3b4e5f17ffb5$var$currentHook.next;
    var nextWorkInProgressHook = null === $f8fd3b4e5f17ffb5$var$workInProgressHook ? $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.memoizedState : $f8fd3b4e5f17ffb5$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $f8fd3b4e5f17ffb5$var$workInProgressHook = nextWorkInProgressHook, $f8fd3b4e5f17ffb5$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.alternate) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(467));
            throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(310));
        }
        $f8fd3b4e5f17ffb5$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $f8fd3b4e5f17ffb5$var$currentHook.memoizedState,
            baseState: $f8fd3b4e5f17ffb5$var$currentHook.baseState,
            baseQueue: $f8fd3b4e5f17ffb5$var$currentHook.baseQueue,
            queue: $f8fd3b4e5f17ffb5$var$currentHook.queue,
            next: null
        };
        null === $f8fd3b4e5f17ffb5$var$workInProgressHook ? $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.memoizedState = $f8fd3b4e5f17ffb5$var$workInProgressHook = nextCurrentHook : $f8fd3b4e5f17ffb5$var$workInProgressHook = $f8fd3b4e5f17ffb5$var$workInProgressHook.next = nextCurrentHook;
    }
    return $f8fd3b4e5f17ffb5$var$workInProgressHook;
}
function $f8fd3b4e5f17ffb5$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $f8fd3b4e5f17ffb5$var$useThenable(thenable) {
    var index = $f8fd3b4e5f17ffb5$var$thenableIndexCounter$1;
    $f8fd3b4e5f17ffb5$var$thenableIndexCounter$1 += 1;
    null === $f8fd3b4e5f17ffb5$var$thenableState$1 && ($f8fd3b4e5f17ffb5$var$thenableState$1 = []);
    thenable = $f8fd3b4e5f17ffb5$var$trackUsedThenable($f8fd3b4e5f17ffb5$var$thenableState$1, thenable, index);
    index = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber;
    null === (null === $f8fd3b4e5f17ffb5$var$workInProgressHook ? index.memoizedState : $f8fd3b4e5f17ffb5$var$workInProgressHook.next) && (index = index.alternate, $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $f8fd3b4e5f17ffb5$var$HooksDispatcherOnMount : $f8fd3b4e5f17ffb5$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $f8fd3b4e5f17ffb5$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $f8fd3b4e5f17ffb5$var$useThenable(usable);
        if (usable.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE) return $f8fd3b4e5f17ffb5$var$readContext(usable);
    }
    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(438, String(usable)));
}
function $f8fd3b4e5f17ffb5$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $f8fd3b4e5f17ffb5$var$createFunctionComponentUpdateQueue(), $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $f8fd3b4e5f17ffb5$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $f8fd3b4e5f17ffb5$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $f8fd3b4e5f17ffb5$var$updateReducer(reducer) {
    var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
    return $f8fd3b4e5f17ffb5$var$updateReducerImpl(hook, $f8fd3b4e5f17ffb5$var$currentHook, reducer);
}
function $f8fd3b4e5f17ffb5$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($f8fd3b4e5f17ffb5$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $f8fd3b4e5f17ffb5$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($f8fd3b4e5f17ffb5$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $f8fd3b4e5f17ffb5$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.lanes |= revertLane, $f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $f8fd3b4e5f17ffb5$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.lanes |= updateLane, $f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$f8fd3b4e5f17ffb5$var$objectIs(pendingQueue, hook.memoizedState) && ($f8fd3b4e5f17ffb5$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $f8fd3b4e5f17ffb5$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $f8fd3b4e5f17ffb5$var$rerenderReducer(reducer) {
    var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $f8fd3b4e5f17ffb5$var$objectIs(newState, hook.memoizedState) || ($f8fd3b4e5f17ffb5$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $f8fd3b4e5f17ffb5$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $f8fd3b4e5f17ffb5$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$f8fd3b4e5f17ffb5$var$objectIs(($f8fd3b4e5f17ffb5$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $f8fd3b4e5f17ffb5$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $f8fd3b4e5f17ffb5$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $f8fd3b4e5f17ffb5$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $f8fd3b4e5f17ffb5$var$workInProgressHook && $f8fd3b4e5f17ffb5$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $f8fd3b4e5f17ffb5$var$pushSimpleEffect(9, $f8fd3b4e5f17ffb5$var$createEffectInstance(), $f8fd3b4e5f17ffb5$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $f8fd3b4e5f17ffb5$var$workInProgressRoot) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($f8fd3b4e5f17ffb5$var$renderLanes & 124) || $f8fd3b4e5f17ffb5$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $f8fd3b4e5f17ffb5$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $f8fd3b4e5f17ffb5$var$createFunctionComponentUpdateQueue(), $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $f8fd3b4e5f17ffb5$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $f8fd3b4e5f17ffb5$var$checkIfSnapshotChanged(inst) && $f8fd3b4e5f17ffb5$var$forceStoreRerender(fiber);
}
function $f8fd3b4e5f17ffb5$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $f8fd3b4e5f17ffb5$var$checkIfSnapshotChanged(inst) && $f8fd3b4e5f17ffb5$var$forceStoreRerender(fiber);
    });
}
function $f8fd3b4e5f17ffb5$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$f8fd3b4e5f17ffb5$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $f8fd3b4e5f17ffb5$var$forceStoreRerender(fiber) {
    var root = $f8fd3b4e5f17ffb5$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $f8fd3b4e5f17ffb5$var$mountStateImpl(initialState) {
    var hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($f8fd3b4e5f17ffb5$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f8fd3b4e5f17ffb5$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $f8fd3b4e5f17ffb5$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $f8fd3b4e5f17ffb5$var$updateReducerImpl(hook, $f8fd3b4e5f17ffb5$var$currentHook, "function" === typeof reducer ? reducer : $f8fd3b4e5f17ffb5$var$basicStateReducer);
}
function $f8fd3b4e5f17ffb5$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($f8fd3b4e5f17ffb5$var$isRenderPhaseUpdate(fiber)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $f8fd3b4e5f17ffb5$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $f8fd3b4e5f17ffb5$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T, currentTransition = {};
        $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $f8fd3b4e5f17ffb5$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $f8fd3b4e5f17ffb5$var$onActionError(actionQueue, node, error);
        } finally{
            $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $f8fd3b4e5f17ffb5$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $f8fd3b4e5f17ffb5$var$onActionError(actionQueue, node, error$38);
    }
}
function $f8fd3b4e5f17ffb5$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $f8fd3b4e5f17ffb5$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $f8fd3b4e5f17ffb5$var$onActionError(actionQueue, node, error);
    }) : $f8fd3b4e5f17ffb5$var$onActionSuccess(actionQueue, node, returnValue);
}
function $f8fd3b4e5f17ffb5$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $f8fd3b4e5f17ffb5$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $f8fd3b4e5f17ffb5$var$runActionStateAction(actionQueue, nextState)));
}
function $f8fd3b4e5f17ffb5$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $f8fd3b4e5f17ffb5$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $f8fd3b4e5f17ffb5$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $f8fd3b4e5f17ffb5$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $f8fd3b4e5f17ffb5$var$mountActionState(action, initialStateProp) {
    if ($f8fd3b4e5f17ffb5$var$isHydrating) {
        var ssrFormState = $f8fd3b4e5f17ffb5$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber;
                if ($f8fd3b4e5f17ffb5$var$isHydrating) {
                    if ($f8fd3b4e5f17ffb5$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $f8fd3b4e5f17ffb5$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $f8fd3b4e5f17ffb5$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $f8fd3b4e5f17ffb5$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $f8fd3b4e5f17ffb5$var$nextHydratableInstance = $f8fd3b4e5f17ffb5$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $f8fd3b4e5f17ffb5$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f8fd3b4e5f17ffb5$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $f8fd3b4e5f17ffb5$var$dispatchSetState.bind(null, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$mountStateImpl(!1);
    inRootOrSingleton = $f8fd3b4e5f17ffb5$var$dispatchOptimisticSetState.bind(null, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $f8fd3b4e5f17ffb5$var$dispatchActionState.bind(null, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $f8fd3b4e5f17ffb5$var$updateActionState(action) {
    var stateHook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
    return $f8fd3b4e5f17ffb5$var$updateActionStateImpl(stateHook, $f8fd3b4e5f17ffb5$var$currentHook, action);
}
function $f8fd3b4e5f17ffb5$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $f8fd3b4e5f17ffb5$var$updateReducerImpl(stateHook, currentStateHook, $f8fd3b4e5f17ffb5$var$actionStateReducer)[0];
    stateHook = $f8fd3b4e5f17ffb5$var$updateReducer($f8fd3b4e5f17ffb5$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $f8fd3b4e5f17ffb5$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $f8fd3b4e5f17ffb5$var$SuspenseException) throw $f8fd3b4e5f17ffb5$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.flags |= 2048, $f8fd3b4e5f17ffb5$var$pushSimpleEffect(9, $f8fd3b4e5f17ffb5$var$createEffectInstance(), $f8fd3b4e5f17ffb5$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $f8fd3b4e5f17ffb5$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $f8fd3b4e5f17ffb5$var$rerenderActionState(action) {
    var stateHook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook(), currentStateHook = $f8fd3b4e5f17ffb5$var$currentHook;
    if (null !== currentStateHook) return $f8fd3b4e5f17ffb5$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $f8fd3b4e5f17ffb5$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $f8fd3b4e5f17ffb5$var$createFunctionComponentUpdateQueue(), $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $f8fd3b4e5f17ffb5$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $f8fd3b4e5f17ffb5$var$updateRef() {
    return $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook().memoizedState;
}
function $f8fd3b4e5f17ffb5$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $f8fd3b4e5f17ffb5$var$pushSimpleEffect(1 | hookFlags, $f8fd3b4e5f17ffb5$var$createEffectInstance(), create, createDeps);
}
function $f8fd3b4e5f17ffb5$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $f8fd3b4e5f17ffb5$var$currentHook && null !== deps && $f8fd3b4e5f17ffb5$var$areHookInputsEqual(deps, $f8fd3b4e5f17ffb5$var$currentHook.memoizedState.deps) ? hook.memoizedState = $f8fd3b4e5f17ffb5$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $f8fd3b4e5f17ffb5$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $f8fd3b4e5f17ffb5$var$mountEffect(create, createDeps) {
    $f8fd3b4e5f17ffb5$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $f8fd3b4e5f17ffb5$var$updateEffect(create, createDeps) {
    $f8fd3b4e5f17ffb5$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $f8fd3b4e5f17ffb5$var$updateInsertionEffect(create, deps) {
    return $f8fd3b4e5f17ffb5$var$updateEffectImpl(4, 2, create, deps);
}
function $f8fd3b4e5f17ffb5$var$updateLayoutEffect(create, deps) {
    return $f8fd3b4e5f17ffb5$var$updateEffectImpl(4, 4, create, deps);
}
function $f8fd3b4e5f17ffb5$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $f8fd3b4e5f17ffb5$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $f8fd3b4e5f17ffb5$var$updateEffectImpl(4, 4, $f8fd3b4e5f17ffb5$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $f8fd3b4e5f17ffb5$var$mountDebugValue() {}
function $f8fd3b4e5f17ffb5$var$updateCallback(callback, deps) {
    var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $f8fd3b4e5f17ffb5$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $f8fd3b4e5f17ffb5$var$updateMemo(nextCreate, deps) {
    var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $f8fd3b4e5f17ffb5$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($f8fd3b4e5f17ffb5$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $f8fd3b4e5f17ffb5$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($f8fd3b4e5f17ffb5$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $f8fd3b4e5f17ffb5$var$requestDeferredLane();
    $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.lanes |= hook;
    $f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $f8fd3b4e5f17ffb5$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($f8fd3b4e5f17ffb5$var$objectIs(value, prevValue)) return value;
    if (null !== $f8fd3b4e5f17ffb5$var$currentTreeHiddenStackCursor.current) return hook = $f8fd3b4e5f17ffb5$var$mountDeferredValueImpl(hook, value, initialValue), $f8fd3b4e5f17ffb5$var$objectIs(hook, prevValue) || ($f8fd3b4e5f17ffb5$var$didReceiveUpdate = !0), hook;
    if (0 === ($f8fd3b4e5f17ffb5$var$renderLanes & 42)) return $f8fd3b4e5f17ffb5$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $f8fd3b4e5f17ffb5$var$requestDeferredLane();
    $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.lanes |= hook;
    $f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $f8fd3b4e5f17ffb5$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
    $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T, currentTransition = {};
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = currentTransition;
    $f8fd3b4e5f17ffb5$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $f8fd3b4e5f17ffb5$var$chainThenableValue(returnValue, finishedState);
            $f8fd3b4e5f17ffb5$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $f8fd3b4e5f17ffb5$var$requestUpdateLane(fiber));
        } else $f8fd3b4e5f17ffb5$var$dispatchSetStateInternal(fiber, queue, finishedState, $f8fd3b4e5f17ffb5$var$requestUpdateLane(fiber));
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $f8fd3b4e5f17ffb5$var$requestUpdateLane());
    } finally{
        $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = previousPriority, $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f8fd3b4e5f17ffb5$var$noop$2() {}
function $f8fd3b4e5f17ffb5$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(476));
    var queue = $f8fd3b4e5f17ffb5$var$ensureFormComponentIsStateful(formFiber).queue;
    $f8fd3b4e5f17ffb5$var$startTransition(formFiber, queue, pendingState, $f8fd3b4e5f17ffb5$var$sharedNotPendingObject, null === action ? $f8fd3b4e5f17ffb5$var$noop$2 : function() {
        $f8fd3b4e5f17ffb5$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $f8fd3b4e5f17ffb5$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $f8fd3b4e5f17ffb5$var$sharedNotPendingObject,
        baseState: $f8fd3b4e5f17ffb5$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $f8fd3b4e5f17ffb5$var$basicStateReducer,
            lastRenderedState: $f8fd3b4e5f17ffb5$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $f8fd3b4e5f17ffb5$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $f8fd3b4e5f17ffb5$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $f8fd3b4e5f17ffb5$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $f8fd3b4e5f17ffb5$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $f8fd3b4e5f17ffb5$var$requestUpdateLane());
}
function $f8fd3b4e5f17ffb5$var$useHostTransitionStatus() {
    return $f8fd3b4e5f17ffb5$var$readContext($f8fd3b4e5f17ffb5$var$HostTransitionContext);
}
function $f8fd3b4e5f17ffb5$var$updateId() {
    return $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook().memoizedState;
}
function $f8fd3b4e5f17ffb5$var$updateRefresh() {
    return $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook().memoizedState;
}
function $f8fd3b4e5f17ffb5$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $f8fd3b4e5f17ffb5$var$requestUpdateLane();
                fiber = $f8fd3b4e5f17ffb5$var$createUpdate(lane);
                var root$41 = $f8fd3b4e5f17ffb5$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(root$41, provider, lane), $f8fd3b4e5f17ffb5$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $f8fd3b4e5f17ffb5$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $f8fd3b4e5f17ffb5$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $f8fd3b4e5f17ffb5$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $f8fd3b4e5f17ffb5$var$isRenderPhaseUpdate(fiber) ? $f8fd3b4e5f17ffb5$var$enqueueRenderPhaseUpdate(queue, action) : (action = $f8fd3b4e5f17ffb5$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(action, fiber, lane), $f8fd3b4e5f17ffb5$var$entangleTransitionUpdate(action, queue, lane)));
}
function $f8fd3b4e5f17ffb5$var$dispatchSetState(fiber, queue, action) {
    var lane = $f8fd3b4e5f17ffb5$var$requestUpdateLane();
    $f8fd3b4e5f17ffb5$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $f8fd3b4e5f17ffb5$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f8fd3b4e5f17ffb5$var$isRenderPhaseUpdate(fiber)) $f8fd3b4e5f17ffb5$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($f8fd3b4e5f17ffb5$var$objectIs(eagerState, currentState)) return $f8fd3b4e5f17ffb5$var$enqueueUpdate$1(fiber, queue, update, 0), null === $f8fd3b4e5f17ffb5$var$workInProgressRoot && $f8fd3b4e5f17ffb5$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $f8fd3b4e5f17ffb5$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(action, fiber, lane), $f8fd3b4e5f17ffb5$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $f8fd3b4e5f17ffb5$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $f8fd3b4e5f17ffb5$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f8fd3b4e5f17ffb5$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $f8fd3b4e5f17ffb5$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $f8fd3b4e5f17ffb5$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber || null !== alternate && alternate === $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber;
}
function $f8fd3b4e5f17ffb5$var$enqueueRenderPhaseUpdate(queue, update) {
    $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdateDuringThisPass = $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $f8fd3b4e5f17ffb5$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $f8fd3b4e5f17ffb5$var$markRootEntangled(root, lane);
    }
}
var $f8fd3b4e5f17ffb5$var$ContextOnlyDispatcher = {
    readContext: $f8fd3b4e5f17ffb5$var$readContext,
    use: $f8fd3b4e5f17ffb5$var$use,
    useCallback: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useContext: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useEffect: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useImperativeHandle: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useLayoutEffect: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useInsertionEffect: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useMemo: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useReducer: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useRef: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useState: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useDebugValue: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useDeferredValue: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useTransition: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useSyncExternalStore: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useId: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useHostTransitionStatus: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useFormState: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useActionState: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useOptimistic: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useMemoCache: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useCacheRefresh: $f8fd3b4e5f17ffb5$var$throwInvalidHookError
}, $f8fd3b4e5f17ffb5$var$HooksDispatcherOnMount = {
    readContext: $f8fd3b4e5f17ffb5$var$readContext,
    use: $f8fd3b4e5f17ffb5$var$use,
    useCallback: function(callback, deps) {
        $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $f8fd3b4e5f17ffb5$var$readContext,
    useEffect: $f8fd3b4e5f17ffb5$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $f8fd3b4e5f17ffb5$var$mountEffectImpl(4194308, 4, $f8fd3b4e5f17ffb5$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $f8fd3b4e5f17ffb5$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $f8fd3b4e5f17ffb5$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($f8fd3b4e5f17ffb5$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($f8fd3b4e5f17ffb5$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $f8fd3b4e5f17ffb5$var$dispatchReducerAction.bind(null, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $f8fd3b4e5f17ffb5$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $f8fd3b4e5f17ffb5$var$dispatchSetState.bind(null, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $f8fd3b4e5f17ffb5$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
        return $f8fd3b4e5f17ffb5$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $f8fd3b4e5f17ffb5$var$mountStateImpl(!1);
        stateHook = $f8fd3b4e5f17ffb5$var$startTransition.bind(null, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
        if ($f8fd3b4e5f17ffb5$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $f8fd3b4e5f17ffb5$var$workInProgressRoot) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(349));
            0 !== ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & 124) || $f8fd3b4e5f17ffb5$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $f8fd3b4e5f17ffb5$var$mountEffect($f8fd3b4e5f17ffb5$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $f8fd3b4e5f17ffb5$var$pushSimpleEffect(9, $f8fd3b4e5f17ffb5$var$createEffectInstance(), $f8fd3b4e5f17ffb5$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook(), identifierPrefix = $f8fd3b4e5f17ffb5$var$workInProgressRoot.identifierPrefix;
        if ($f8fd3b4e5f17ffb5$var$isHydrating) {
            var JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$treeContextOverflow;
            var idWithLeadingBit = $f8fd3b4e5f17ffb5$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $f8fd3b4e5f17ffb5$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $f8fd3b4e5f17ffb5$var$useHostTransitionStatus,
    useFormState: $f8fd3b4e5f17ffb5$var$mountActionState,
    useActionState: $f8fd3b4e5f17ffb5$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $f8fd3b4e5f17ffb5$var$dispatchOptimisticSetState.bind(null, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $f8fd3b4e5f17ffb5$var$useMemoCache,
    useCacheRefresh: function() {
        return $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook().memoizedState = $f8fd3b4e5f17ffb5$var$refreshCache.bind(null, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber);
    }
}, $f8fd3b4e5f17ffb5$var$HooksDispatcherOnUpdate = {
    readContext: $f8fd3b4e5f17ffb5$var$readContext,
    use: $f8fd3b4e5f17ffb5$var$use,
    useCallback: $f8fd3b4e5f17ffb5$var$updateCallback,
    useContext: $f8fd3b4e5f17ffb5$var$readContext,
    useEffect: $f8fd3b4e5f17ffb5$var$updateEffect,
    useImperativeHandle: $f8fd3b4e5f17ffb5$var$updateImperativeHandle,
    useInsertionEffect: $f8fd3b4e5f17ffb5$var$updateInsertionEffect,
    useLayoutEffect: $f8fd3b4e5f17ffb5$var$updateLayoutEffect,
    useMemo: $f8fd3b4e5f17ffb5$var$updateMemo,
    useReducer: $f8fd3b4e5f17ffb5$var$updateReducer,
    useRef: $f8fd3b4e5f17ffb5$var$updateRef,
    useState: function() {
        return $f8fd3b4e5f17ffb5$var$updateReducer($f8fd3b4e5f17ffb5$var$basicStateReducer);
    },
    useDebugValue: $f8fd3b4e5f17ffb5$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
        return $f8fd3b4e5f17ffb5$var$updateDeferredValueImpl(hook, $f8fd3b4e5f17ffb5$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $f8fd3b4e5f17ffb5$var$updateReducer($f8fd3b4e5f17ffb5$var$basicStateReducer)[0], start = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $f8fd3b4e5f17ffb5$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $f8fd3b4e5f17ffb5$var$updateSyncExternalStore,
    useId: $f8fd3b4e5f17ffb5$var$updateId,
    useHostTransitionStatus: $f8fd3b4e5f17ffb5$var$useHostTransitionStatus,
    useFormState: $f8fd3b4e5f17ffb5$var$updateActionState,
    useActionState: $f8fd3b4e5f17ffb5$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
        return $f8fd3b4e5f17ffb5$var$updateOptimisticImpl(hook, $f8fd3b4e5f17ffb5$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $f8fd3b4e5f17ffb5$var$useMemoCache,
    useCacheRefresh: $f8fd3b4e5f17ffb5$var$updateRefresh
}, $f8fd3b4e5f17ffb5$var$HooksDispatcherOnRerender = {
    readContext: $f8fd3b4e5f17ffb5$var$readContext,
    use: $f8fd3b4e5f17ffb5$var$use,
    useCallback: $f8fd3b4e5f17ffb5$var$updateCallback,
    useContext: $f8fd3b4e5f17ffb5$var$readContext,
    useEffect: $f8fd3b4e5f17ffb5$var$updateEffect,
    useImperativeHandle: $f8fd3b4e5f17ffb5$var$updateImperativeHandle,
    useInsertionEffect: $f8fd3b4e5f17ffb5$var$updateInsertionEffect,
    useLayoutEffect: $f8fd3b4e5f17ffb5$var$updateLayoutEffect,
    useMemo: $f8fd3b4e5f17ffb5$var$updateMemo,
    useReducer: $f8fd3b4e5f17ffb5$var$rerenderReducer,
    useRef: $f8fd3b4e5f17ffb5$var$updateRef,
    useState: function() {
        return $f8fd3b4e5f17ffb5$var$rerenderReducer($f8fd3b4e5f17ffb5$var$basicStateReducer);
    },
    useDebugValue: $f8fd3b4e5f17ffb5$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
        return null === $f8fd3b4e5f17ffb5$var$currentHook ? $f8fd3b4e5f17ffb5$var$mountDeferredValueImpl(hook, value, initialValue) : $f8fd3b4e5f17ffb5$var$updateDeferredValueImpl(hook, $f8fd3b4e5f17ffb5$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $f8fd3b4e5f17ffb5$var$rerenderReducer($f8fd3b4e5f17ffb5$var$basicStateReducer)[0], start = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $f8fd3b4e5f17ffb5$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $f8fd3b4e5f17ffb5$var$updateSyncExternalStore,
    useId: $f8fd3b4e5f17ffb5$var$updateId,
    useHostTransitionStatus: $f8fd3b4e5f17ffb5$var$useHostTransitionStatus,
    useFormState: $f8fd3b4e5f17ffb5$var$rerenderActionState,
    useActionState: $f8fd3b4e5f17ffb5$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
        if (null !== $f8fd3b4e5f17ffb5$var$currentHook) return $f8fd3b4e5f17ffb5$var$updateOptimisticImpl(hook, $f8fd3b4e5f17ffb5$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $f8fd3b4e5f17ffb5$var$useMemoCache,
    useCacheRefresh: $f8fd3b4e5f17ffb5$var$updateRefresh
}, $f8fd3b4e5f17ffb5$var$thenableState = null, $f8fd3b4e5f17ffb5$var$thenableIndexCounter = 0;
function $f8fd3b4e5f17ffb5$var$unwrapThenable(thenable) {
    var index = $f8fd3b4e5f17ffb5$var$thenableIndexCounter;
    $f8fd3b4e5f17ffb5$var$thenableIndexCounter += 1;
    null === $f8fd3b4e5f17ffb5$var$thenableState && ($f8fd3b4e5f17ffb5$var$thenableState = []);
    return $f8fd3b4e5f17ffb5$var$trackUsedThenable($f8fd3b4e5f17ffb5$var$thenableState, thenable, index);
}
function $f8fd3b4e5f17ffb5$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $f8fd3b4e5f17ffb5$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $f8fd3b4e5f17ffb5$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $f8fd3b4e5f17ffb5$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $f8fd3b4e5f17ffb5$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $f8fd3b4e5f17ffb5$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $f8fd3b4e5f17ffb5$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE && $f8fd3b4e5f17ffb5$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $f8fd3b4e5f17ffb5$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $f8fd3b4e5f17ffb5$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $f8fd3b4e5f17ffb5$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $f8fd3b4e5f17ffb5$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $f8fd3b4e5f17ffb5$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $f8fd3b4e5f17ffb5$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f8fd3b4e5f17ffb5$var$REACT_ELEMENT_TYPE:
                    return lanes = $f8fd3b4e5f17ffb5$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $f8fd3b4e5f17ffb5$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $f8fd3b4e5f17ffb5$var$REACT_PORTAL_TYPE:
                    return newChild = $f8fd3b4e5f17ffb5$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($f8fd3b4e5f17ffb5$var$isArrayImpl(newChild) || $f8fd3b4e5f17ffb5$var$getIteratorFn(newChild)) return newChild = $f8fd3b4e5f17ffb5$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $f8fd3b4e5f17ffb5$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $f8fd3b4e5f17ffb5$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f8fd3b4e5f17ffb5$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f8fd3b4e5f17ffb5$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $f8fd3b4e5f17ffb5$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($f8fd3b4e5f17ffb5$var$isArrayImpl(newChild) || $f8fd3b4e5f17ffb5$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $f8fd3b4e5f17ffb5$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $f8fd3b4e5f17ffb5$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f8fd3b4e5f17ffb5$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f8fd3b4e5f17ffb5$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $f8fd3b4e5f17ffb5$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($f8fd3b4e5f17ffb5$var$isArrayImpl(newChild) || $f8fd3b4e5f17ffb5$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $f8fd3b4e5f17ffb5$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $f8fd3b4e5f17ffb5$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f8fd3b4e5f17ffb5$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $f8fd3b4e5f17ffb5$var$isHydrating && $f8fd3b4e5f17ffb5$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $f8fd3b4e5f17ffb5$var$isHydrating && $f8fd3b4e5f17ffb5$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $f8fd3b4e5f17ffb5$var$isHydrating && $f8fd3b4e5f17ffb5$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $f8fd3b4e5f17ffb5$var$isHydrating && $f8fd3b4e5f17ffb5$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $f8fd3b4e5f17ffb5$var$isHydrating && $f8fd3b4e5f17ffb5$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $f8fd3b4e5f17ffb5$var$isHydrating && $f8fd3b4e5f17ffb5$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $f8fd3b4e5f17ffb5$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f8fd3b4e5f17ffb5$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $f8fd3b4e5f17ffb5$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE && $f8fd3b4e5f17ffb5$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $f8fd3b4e5f17ffb5$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $f8fd3b4e5f17ffb5$var$REACT_FRAGMENT_TYPE ? (lanes = $f8fd3b4e5f17ffb5$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $f8fd3b4e5f17ffb5$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $f8fd3b4e5f17ffb5$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $f8fd3b4e5f17ffb5$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $f8fd3b4e5f17ffb5$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($f8fd3b4e5f17ffb5$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($f8fd3b4e5f17ffb5$var$getIteratorFn(newChild)) {
                key = $f8fd3b4e5f17ffb5$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $f8fd3b4e5f17ffb5$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $f8fd3b4e5f17ffb5$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f8fd3b4e5f17ffb5$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $f8fd3b4e5f17ffb5$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $f8fd3b4e5f17ffb5$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $f8fd3b4e5f17ffb5$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $f8fd3b4e5f17ffb5$var$SuspenseException || x === $f8fd3b4e5f17ffb5$var$SuspenseActionException) throw x;
            var fiber = $f8fd3b4e5f17ffb5$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $f8fd3b4e5f17ffb5$var$reconcileChildFibers = $f8fd3b4e5f17ffb5$var$createChildReconciler(!0), $f8fd3b4e5f17ffb5$var$mountChildFibers = $f8fd3b4e5f17ffb5$var$createChildReconciler(!1), $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor = $f8fd3b4e5f17ffb5$var$createCursor(null), $f8fd3b4e5f17ffb5$var$shellBoundary = null;
function $f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseStackCursor, $f8fd3b4e5f17ffb5$var$suspenseStackCursor.current & 1);
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor, handler);
    null === $f8fd3b4e5f17ffb5$var$shellBoundary && (null === current || null !== $f8fd3b4e5f17ffb5$var$currentTreeHiddenStackCursor.current ? $f8fd3b4e5f17ffb5$var$shellBoundary = handler : null !== current.memoizedState && ($f8fd3b4e5f17ffb5$var$shellBoundary = handler));
}
function $f8fd3b4e5f17ffb5$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseStackCursor, $f8fd3b4e5f17ffb5$var$suspenseStackCursor.current), $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor, fiber), null === $f8fd3b4e5f17ffb5$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($f8fd3b4e5f17ffb5$var$shellBoundary = fiber);
        }
    } else $f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack(fiber);
}
function $f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack() {
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseStackCursor, $f8fd3b4e5f17ffb5$var$suspenseStackCursor.current);
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor, $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor.current);
}
function $f8fd3b4e5f17ffb5$var$popSuspenseHandler(fiber) {
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor);
    $f8fd3b4e5f17ffb5$var$shellBoundary === fiber && ($f8fd3b4e5f17ffb5$var$shellBoundary = null);
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$suspenseStackCursor);
}
var $f8fd3b4e5f17ffb5$var$suspenseStackCursor = $f8fd3b4e5f17ffb5$var$createCursor(0);
function $f8fd3b4e5f17ffb5$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $f8fd3b4e5f17ffb5$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $f8fd3b4e5f17ffb5$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $f8fd3b4e5f17ffb5$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $f8fd3b4e5f17ffb5$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $f8fd3b4e5f17ffb5$var$requestUpdateLane(), update = $f8fd3b4e5f17ffb5$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $f8fd3b4e5f17ffb5$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(payload, inst, lane), $f8fd3b4e5f17ffb5$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $f8fd3b4e5f17ffb5$var$requestUpdateLane(), update = $f8fd3b4e5f17ffb5$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $f8fd3b4e5f17ffb5$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(payload, inst, lane), $f8fd3b4e5f17ffb5$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $f8fd3b4e5f17ffb5$var$requestUpdateLane(), update = $f8fd3b4e5f17ffb5$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $f8fd3b4e5f17ffb5$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(callback, inst, lane), $f8fd3b4e5f17ffb5$var$entangleTransitions(callback, inst, lane));
    }
};
function $f8fd3b4e5f17ffb5$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$f8fd3b4e5f17ffb5$var$shallowEqual(oldProps, newProps) || !$f8fd3b4e5f17ffb5$var$shallowEqual(oldState, newState) : !0;
}
function $f8fd3b4e5f17ffb5$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $f8fd3b4e5f17ffb5$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $f8fd3b4e5f17ffb5$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $f8fd3b4e5f17ffb5$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $f8fd3b4e5f17ffb5$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $f8fd3b4e5f17ffb5$var$defaultOnUncaughtError(error) {
    $f8fd3b4e5f17ffb5$var$reportGlobalError(error);
}
function $f8fd3b4e5f17ffb5$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $f8fd3b4e5f17ffb5$var$defaultOnRecoverableError(error) {
    $f8fd3b4e5f17ffb5$var$reportGlobalError(error);
}
function $f8fd3b4e5f17ffb5$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $f8fd3b4e5f17ffb5$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $f8fd3b4e5f17ffb5$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $f8fd3b4e5f17ffb5$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $f8fd3b4e5f17ffb5$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $f8fd3b4e5f17ffb5$var$createClassErrorUpdate(lane) {
    lane = $f8fd3b4e5f17ffb5$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $f8fd3b4e5f17ffb5$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $f8fd3b4e5f17ffb5$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $f8fd3b4e5f17ffb5$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed ? $f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $f8fd3b4e5f17ffb5$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $f8fd3b4e5f17ffb5$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $f8fd3b4e5f17ffb5$var$shellBoundary ? $f8fd3b4e5f17ffb5$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus && ($f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $f8fd3b4e5f17ffb5$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $f8fd3b4e5f17ffb5$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $f8fd3b4e5f17ffb5$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $f8fd3b4e5f17ffb5$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $f8fd3b4e5f17ffb5$var$attachPingListener(root, value, rootRenderLanes);
        $f8fd3b4e5f17ffb5$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($f8fd3b4e5f17ffb5$var$isHydrating) return returnFiber = $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $f8fd3b4e5f17ffb5$var$HydrationMismatchException && (root = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(422), {
        cause: value
    }), $f8fd3b4e5f17ffb5$var$queueHydrationError($f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $f8fd3b4e5f17ffb5$var$HydrationMismatchException && (returnFiber = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(423), {
        cause: value
    }), $f8fd3b4e5f17ffb5$var$queueHydrationError($f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $f8fd3b4e5f17ffb5$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $f8fd3b4e5f17ffb5$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus && ($f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $f8fd3b4e5f17ffb5$var$workInProgressRootConcurrentErrors ? $f8fd3b4e5f17ffb5$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $f8fd3b4e5f17ffb5$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus && ($f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $f8fd3b4e5f17ffb5$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $f8fd3b4e5f17ffb5$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed || !$f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $f8fd3b4e5f17ffb5$var$createClassErrorUpdate(rootRenderLanes), $f8fd3b4e5f17ffb5$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $f8fd3b4e5f17ffb5$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $f8fd3b4e5f17ffb5$var$SelectiveHydrationException = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(461)), $f8fd3b4e5f17ffb5$var$didReceiveUpdate = !1;
function $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $f8fd3b4e5f17ffb5$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $f8fd3b4e5f17ffb5$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $f8fd3b4e5f17ffb5$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $f8fd3b4e5f17ffb5$var$prepareToReadContext(workInProgress);
    nextProps = $f8fd3b4e5f17ffb5$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $f8fd3b4e5f17ffb5$var$checkDidRenderIdHook();
    if (null !== current && !$f8fd3b4e5f17ffb5$var$didReceiveUpdate) return $f8fd3b4e5f17ffb5$var$bailoutHooks(current, workInProgress, renderLanes), $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f8fd3b4e5f17ffb5$var$isHydrating && key && $f8fd3b4e5f17ffb5$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $f8fd3b4e5f17ffb5$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$f8fd3b4e5f17ffb5$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $f8fd3b4e5f17ffb5$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $f8fd3b4e5f17ffb5$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$f8fd3b4e5f17ffb5$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $f8fd3b4e5f17ffb5$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $f8fd3b4e5f17ffb5$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $f8fd3b4e5f17ffb5$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($f8fd3b4e5f17ffb5$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($f8fd3b4e5f17ffb5$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $f8fd3b4e5f17ffb5$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($f8fd3b4e5f17ffb5$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $f8fd3b4e5f17ffb5$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $f8fd3b4e5f17ffb5$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $f8fd3b4e5f17ffb5$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $f8fd3b4e5f17ffb5$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $f8fd3b4e5f17ffb5$var$pushHiddenContext(workInProgress, prevState) : $f8fd3b4e5f17ffb5$var$reuseHiddenContextOnStack(), $f8fd3b4e5f17ffb5$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $f8fd3b4e5f17ffb5$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($f8fd3b4e5f17ffb5$var$pushTransition(workInProgress, prevState.cachePool), $f8fd3b4e5f17ffb5$var$pushHiddenContext(workInProgress, prevState), $f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $f8fd3b4e5f17ffb5$var$pushTransition(workInProgress, null), $f8fd3b4e5f17ffb5$var$reuseHiddenContextOnStack(), $f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack(workInProgress));
    $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $f8fd3b4e5f17ffb5$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $f8fd3b4e5f17ffb5$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $f8fd3b4e5f17ffb5$var$pushTransition(workInProgress, null);
    $f8fd3b4e5f17ffb5$var$reuseHiddenContextOnStack();
    $f8fd3b4e5f17ffb5$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $f8fd3b4e5f17ffb5$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $f8fd3b4e5f17ffb5$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $f8fd3b4e5f17ffb5$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $f8fd3b4e5f17ffb5$var$prepareToReadContext(workInProgress);
    Component = $f8fd3b4e5f17ffb5$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $f8fd3b4e5f17ffb5$var$checkDidRenderIdHook();
    if (null !== current && !$f8fd3b4e5f17ffb5$var$didReceiveUpdate) return $f8fd3b4e5f17ffb5$var$bailoutHooks(current, workInProgress, renderLanes), $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f8fd3b4e5f17ffb5$var$isHydrating && nextProps && $f8fd3b4e5f17ffb5$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $f8fd3b4e5f17ffb5$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $f8fd3b4e5f17ffb5$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $f8fd3b4e5f17ffb5$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $f8fd3b4e5f17ffb5$var$finishRenderingHooks(current);
    Component = $f8fd3b4e5f17ffb5$var$checkDidRenderIdHook();
    if (null !== current && !$f8fd3b4e5f17ffb5$var$didReceiveUpdate) return $f8fd3b4e5f17ffb5$var$bailoutHooks(current, workInProgress, renderLanes), $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f8fd3b4e5f17ffb5$var$isHydrating && Component && $f8fd3b4e5f17ffb5$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $f8fd3b4e5f17ffb5$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $f8fd3b4e5f17ffb5$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $f8fd3b4e5f17ffb5$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $f8fd3b4e5f17ffb5$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $f8fd3b4e5f17ffb5$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $f8fd3b4e5f17ffb5$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $f8fd3b4e5f17ffb5$var$readContext(contextType) : $f8fd3b4e5f17ffb5$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($f8fd3b4e5f17ffb5$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $f8fd3b4e5f17ffb5$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $f8fd3b4e5f17ffb5$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $f8fd3b4e5f17ffb5$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $f8fd3b4e5f17ffb5$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $f8fd3b4e5f17ffb5$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $f8fd3b4e5f17ffb5$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $f8fd3b4e5f17ffb5$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $f8fd3b4e5f17ffb5$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $f8fd3b4e5f17ffb5$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $f8fd3b4e5f17ffb5$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $f8fd3b4e5f17ffb5$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($f8fd3b4e5f17ffb5$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $f8fd3b4e5f17ffb5$var$hasForceUpdate || $f8fd3b4e5f17ffb5$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $f8fd3b4e5f17ffb5$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $f8fd3b4e5f17ffb5$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $f8fd3b4e5f17ffb5$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $f8fd3b4e5f17ffb5$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $f8fd3b4e5f17ffb5$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $f8fd3b4e5f17ffb5$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $f8fd3b4e5f17ffb5$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $f8fd3b4e5f17ffb5$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $f8fd3b4e5f17ffb5$var$hasForceUpdate || null !== current && null !== current.dependencies && $f8fd3b4e5f17ffb5$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($f8fd3b4e5f17ffb5$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $f8fd3b4e5f17ffb5$var$hasForceUpdate || $f8fd3b4e5f17ffb5$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $f8fd3b4e5f17ffb5$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $f8fd3b4e5f17ffb5$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $f8fd3b4e5f17ffb5$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $f8fd3b4e5f17ffb5$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $f8fd3b4e5f17ffb5$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $f8fd3b4e5f17ffb5$var$resetHydrationState();
    workInProgress.flags |= 256;
    $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $f8fd3b4e5f17ffb5$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $f8fd3b4e5f17ffb5$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $f8fd3b4e5f17ffb5$var$getSuspendedCache()
    };
}
function $f8fd3b4e5f17ffb5$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane);
    return current;
}
function $f8fd3b4e5f17ffb5$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($f8fd3b4e5f17ffb5$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($f8fd3b4e5f17ffb5$var$isHydrating) {
            showFallback ? $f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($f8fd3b4e5f17ffb5$var$isHydrating) {
                var nextInstance = $f8fd3b4e5f17ffb5$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $f8fd3b4e5f17ffb5$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $f8fd3b4e5f17ffb5$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $f8fd3b4e5f17ffb5$var$treeContextProvider ? {
                            id: $f8fd3b4e5f17ffb5$var$treeContextId,
                            overflow: $f8fd3b4e5f17ffb5$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $f8fd3b4e5f17ffb5$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $f8fd3b4e5f17ffb5$var$hydrationParentFiber = workInProgress, $f8fd3b4e5f17ffb5$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $f8fd3b4e5f17ffb5$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $f8fd3b4e5f17ffb5$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $f8fd3b4e5f17ffb5$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $f8fd3b4e5f17ffb5$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $f8fd3b4e5f17ffb5$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $f8fd3b4e5f17ffb5$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $f8fd3b4e5f17ffb5$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f8fd3b4e5f17ffb5$var$SUSPENDED_MARKER, nextProps;
        $f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $f8fd3b4e5f17ffb5$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $f8fd3b4e5f17ffb5$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $f8fd3b4e5f17ffb5$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $f8fd3b4e5f17ffb5$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $f8fd3b4e5f17ffb5$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $f8fd3b4e5f17ffb5$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $f8fd3b4e5f17ffb5$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f8fd3b4e5f17ffb5$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(workInProgress), $f8fd3b4e5f17ffb5$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $f8fd3b4e5f17ffb5$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $f8fd3b4e5f17ffb5$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($f8fd3b4e5f17ffb5$var$didReceiveUpdate || $f8fd3b4e5f17ffb5$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $f8fd3b4e5f17ffb5$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $f8fd3b4e5f17ffb5$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $f8fd3b4e5f17ffb5$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $f8fd3b4e5f17ffb5$var$enqueueConcurrentRenderForLane(current, nextProps), $f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $f8fd3b4e5f17ffb5$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $f8fd3b4e5f17ffb5$var$renderDidSuspendDelayIfPossible();
            workInProgress = $f8fd3b4e5f17ffb5$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $f8fd3b4e5f17ffb5$var$nextHydratableInstance = $f8fd3b4e5f17ffb5$var$getNextHydratable(nextInstance.nextSibling), $f8fd3b4e5f17ffb5$var$hydrationParentFiber = workInProgress, $f8fd3b4e5f17ffb5$var$isHydrating = !0, $f8fd3b4e5f17ffb5$var$hydrationErrors = null, $f8fd3b4e5f17ffb5$var$rootOrSingletonContext = !1, null !== current && ($f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex++] = $f8fd3b4e5f17ffb5$var$treeContextId, $f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex++] = $f8fd3b4e5f17ffb5$var$treeContextOverflow, $f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex++] = $f8fd3b4e5f17ffb5$var$treeContextProvider, $f8fd3b4e5f17ffb5$var$treeContextId = current.id, $f8fd3b4e5f17ffb5$var$treeContextOverflow = current.overflow, $f8fd3b4e5f17ffb5$var$treeContextProvider = workInProgress), workInProgress = $f8fd3b4e5f17ffb5$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $f8fd3b4e5f17ffb5$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $f8fd3b4e5f17ffb5$var$createWorkInProgress(digest, showFallback) : (showFallback = $f8fd3b4e5f17ffb5$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $f8fd3b4e5f17ffb5$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $f8fd3b4e5f17ffb5$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $f8fd3b4e5f17ffb5$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $f8fd3b4e5f17ffb5$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f8fd3b4e5f17ffb5$var$SUSPENDED_MARKER, nextProps;
    $f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $f8fd3b4e5f17ffb5$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $f8fd3b4e5f17ffb5$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $f8fd3b4e5f17ffb5$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $f8fd3b4e5f17ffb5$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $f8fd3b4e5f17ffb5$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $f8fd3b4e5f17ffb5$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $f8fd3b4e5f17ffb5$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $f8fd3b4e5f17ffb5$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $f8fd3b4e5f17ffb5$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $f8fd3b4e5f17ffb5$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $f8fd3b4e5f17ffb5$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $f8fd3b4e5f17ffb5$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $f8fd3b4e5f17ffb5$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $f8fd3b4e5f17ffb5$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $f8fd3b4e5f17ffb5$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $f8fd3b4e5f17ffb5$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $f8fd3b4e5f17ffb5$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $f8fd3b4e5f17ffb5$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $f8fd3b4e5f17ffb5$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $f8fd3b4e5f17ffb5$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($f8fd3b4e5f17ffb5$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $f8fd3b4e5f17ffb5$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $f8fd3b4e5f17ffb5$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $f8fd3b4e5f17ffb5$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $f8fd3b4e5f17ffb5$var$checkIfContextChanged(current) ? !0 : !1;
}
function $f8fd3b4e5f17ffb5$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $f8fd3b4e5f17ffb5$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $f8fd3b4e5f17ffb5$var$pushProvider(workInProgress, $f8fd3b4e5f17ffb5$var$CacheContext, current.memoizedState.cache);
            $f8fd3b4e5f17ffb5$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $f8fd3b4e5f17ffb5$var$pushHostContext(workInProgress);
            break;
        case 4:
            $f8fd3b4e5f17ffb5$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $f8fd3b4e5f17ffb5$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $f8fd3b4e5f17ffb5$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($f8fd3b4e5f17ffb5$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $f8fd3b4e5f17ffb5$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseStackCursor, $f8fd3b4e5f17ffb5$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $f8fd3b4e5f17ffb5$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $f8fd3b4e5f17ffb5$var$pushProvider(workInProgress, $f8fd3b4e5f17ffb5$var$CacheContext, current.memoizedState.cache);
    }
    return $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $f8fd3b4e5f17ffb5$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $f8fd3b4e5f17ffb5$var$didReceiveUpdate = !0;
        else {
            if (!$f8fd3b4e5f17ffb5$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $f8fd3b4e5f17ffb5$var$didReceiveUpdate = !1, $f8fd3b4e5f17ffb5$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $f8fd3b4e5f17ffb5$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $f8fd3b4e5f17ffb5$var$didReceiveUpdate = !1, $f8fd3b4e5f17ffb5$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $f8fd3b4e5f17ffb5$var$pushTreeId(workInProgress, $f8fd3b4e5f17ffb5$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $f8fd3b4e5f17ffb5$var$shouldConstruct(lazyComponent) ? (current = $f8fd3b4e5f17ffb5$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $f8fd3b4e5f17ffb5$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $f8fd3b4e5f17ffb5$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $f8fd3b4e5f17ffb5$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $f8fd3b4e5f17ffb5$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $f8fd3b4e5f17ffb5$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $f8fd3b4e5f17ffb5$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $f8fd3b4e5f17ffb5$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $f8fd3b4e5f17ffb5$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $f8fd3b4e5f17ffb5$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $f8fd3b4e5f17ffb5$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $f8fd3b4e5f17ffb5$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $f8fd3b4e5f17ffb5$var$cloneUpdateQueue(current, workInProgress);
                $f8fd3b4e5f17ffb5$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $f8fd3b4e5f17ffb5$var$pushProvider(workInProgress, $f8fd3b4e5f17ffb5$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $f8fd3b4e5f17ffb5$var$propagateContextChanges(workInProgress, [
                    $f8fd3b4e5f17ffb5$var$CacheContext
                ], renderLanes, !0);
                $f8fd3b4e5f17ffb5$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $f8fd3b4e5f17ffb5$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(424)), workInProgress);
                        $f8fd3b4e5f17ffb5$var$queueHydrationError(init);
                        workInProgress = $f8fd3b4e5f17ffb5$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $f8fd3b4e5f17ffb5$var$nextHydratableInstance = $f8fd3b4e5f17ffb5$var$getNextHydratable(current.firstChild);
                        $f8fd3b4e5f17ffb5$var$hydrationParentFiber = workInProgress;
                        $f8fd3b4e5f17ffb5$var$isHydrating = !0;
                        $f8fd3b4e5f17ffb5$var$hydrationErrors = null;
                        $f8fd3b4e5f17ffb5$var$rootOrSingletonContext = !0;
                        renderLanes = $f8fd3b4e5f17ffb5$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $f8fd3b4e5f17ffb5$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $f8fd3b4e5f17ffb5$var$markRef(current, workInProgress), null === current ? (renderLanes = $f8fd3b4e5f17ffb5$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $f8fd3b4e5f17ffb5$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $f8fd3b4e5f17ffb5$var$getOwnerDocumentFromRootContainer($f8fd3b4e5f17ffb5$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = workInProgress, lazyComponent[$f8fd3b4e5f17ffb5$var$internalPropsKey] = current, $f8fd3b4e5f17ffb5$var$setInitialProperties(lazyComponent, renderLanes, current), $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $f8fd3b4e5f17ffb5$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $f8fd3b4e5f17ffb5$var$pushHostContext(workInProgress), null === current && $f8fd3b4e5f17ffb5$var$isHydrating && (lazyComponent = workInProgress.stateNode = $f8fd3b4e5f17ffb5$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $f8fd3b4e5f17ffb5$var$rootInstanceStackCursor.current), $f8fd3b4e5f17ffb5$var$hydrationParentFiber = workInProgress, $f8fd3b4e5f17ffb5$var$rootOrSingletonContext = !0, init = $f8fd3b4e5f17ffb5$var$nextHydratableInstance, $f8fd3b4e5f17ffb5$var$isSingletonScope(workInProgress.type) ? ($f8fd3b4e5f17ffb5$var$previousHydratableOnEnteringScopedSingleton = init, $f8fd3b4e5f17ffb5$var$nextHydratableInstance = $f8fd3b4e5f17ffb5$var$getNextHydratable(lazyComponent.firstChild)) : $f8fd3b4e5f17ffb5$var$nextHydratableInstance = init), $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $f8fd3b4e5f17ffb5$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $f8fd3b4e5f17ffb5$var$isHydrating) {
                if (init = lazyComponent = $f8fd3b4e5f17ffb5$var$nextHydratableInstance) lazyComponent = $f8fd3b4e5f17ffb5$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $f8fd3b4e5f17ffb5$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $f8fd3b4e5f17ffb5$var$hydrationParentFiber = workInProgress, $f8fd3b4e5f17ffb5$var$nextHydratableInstance = $f8fd3b4e5f17ffb5$var$getNextHydratable(lazyComponent.firstChild), $f8fd3b4e5f17ffb5$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $f8fd3b4e5f17ffb5$var$throwOnHydrationMismatch(workInProgress);
            }
            $f8fd3b4e5f17ffb5$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $f8fd3b4e5f17ffb5$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $f8fd3b4e5f17ffb5$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $f8fd3b4e5f17ffb5$var$renderWithHooks(current, workInProgress, $f8fd3b4e5f17ffb5$var$TransitionAwareHostComponent, null, null, renderLanes), $f8fd3b4e5f17ffb5$var$HostTransitionContext._currentValue = init);
            $f8fd3b4e5f17ffb5$var$markRef(current, workInProgress);
            $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $f8fd3b4e5f17ffb5$var$isHydrating) {
                if (current = renderLanes = $f8fd3b4e5f17ffb5$var$nextHydratableInstance) renderLanes = $f8fd3b4e5f17ffb5$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $f8fd3b4e5f17ffb5$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $f8fd3b4e5f17ffb5$var$hydrationParentFiber = workInProgress, $f8fd3b4e5f17ffb5$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $f8fd3b4e5f17ffb5$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $f8fd3b4e5f17ffb5$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $f8fd3b4e5f17ffb5$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $f8fd3b4e5f17ffb5$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $f8fd3b4e5f17ffb5$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $f8fd3b4e5f17ffb5$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $f8fd3b4e5f17ffb5$var$prepareToReadContext(workInProgress), init = $f8fd3b4e5f17ffb5$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $f8fd3b4e5f17ffb5$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $f8fd3b4e5f17ffb5$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $f8fd3b4e5f17ffb5$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $f8fd3b4e5f17ffb5$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $f8fd3b4e5f17ffb5$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $f8fd3b4e5f17ffb5$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $f8fd3b4e5f17ffb5$var$prepareToReadContext(workInProgress), lazyComponent = $f8fd3b4e5f17ffb5$var$readContext($f8fd3b4e5f17ffb5$var$CacheContext), null === current ? (init = $f8fd3b4e5f17ffb5$var$peekCacheFromPool(), null === init && (init = $f8fd3b4e5f17ffb5$var$workInProgressRoot, prevState = $f8fd3b4e5f17ffb5$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $f8fd3b4e5f17ffb5$var$initializeUpdateQueue(workInProgress), $f8fd3b4e5f17ffb5$var$pushProvider(workInProgress, $f8fd3b4e5f17ffb5$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($f8fd3b4e5f17ffb5$var$cloneUpdateQueue(current, workInProgress), $f8fd3b4e5f17ffb5$var$processUpdateQueue(workInProgress, null, null, renderLanes), $f8fd3b4e5f17ffb5$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $f8fd3b4e5f17ffb5$var$pushProvider(workInProgress, $f8fd3b4e5f17ffb5$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $f8fd3b4e5f17ffb5$var$pushProvider(workInProgress, $f8fd3b4e5f17ffb5$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $f8fd3b4e5f17ffb5$var$propagateContextChanges(workInProgress, [
                $f8fd3b4e5f17ffb5$var$CacheContext
            ], renderLanes, !0))), $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $f8fd3b4e5f17ffb5$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $f8fd3b4e5f17ffb5$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$f8fd3b4e5f17ffb5$var$preloadResource(resource)) {
        resource = $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & 4194048) === $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes ? null !== $f8fd3b4e5f17ffb5$var$shellBoundary : ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & 62914560) !== $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes && 0 === ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & 536870912) || resource !== $f8fd3b4e5f17ffb5$var$shellBoundary)) throw $f8fd3b4e5f17ffb5$var$suspendedThenable = $f8fd3b4e5f17ffb5$var$noopSuspenseyCommitThenable, $f8fd3b4e5f17ffb5$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $f8fd3b4e5f17ffb5$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $f8fd3b4e5f17ffb5$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $f8fd3b4e5f17ffb5$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $f8fd3b4e5f17ffb5$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$f8fd3b4e5f17ffb5$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $f8fd3b4e5f17ffb5$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $f8fd3b4e5f17ffb5$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $f8fd3b4e5f17ffb5$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), null;
        case 1:
            return $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $f8fd3b4e5f17ffb5$var$popProvider($f8fd3b4e5f17ffb5$var$CacheContext);
            $f8fd3b4e5f17ffb5$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $f8fd3b4e5f17ffb5$var$popHydrationState(workInProgress) ? $f8fd3b4e5f17ffb5$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $f8fd3b4e5f17ffb5$var$upgradeHydrationErrorsToRecoverable());
            $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($f8fd3b4e5f17ffb5$var$markUpdate(workInProgress), null !== renderLanes ? ($f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), $f8fd3b4e5f17ffb5$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($f8fd3b4e5f17ffb5$var$markUpdate(workInProgress), $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), $f8fd3b4e5f17ffb5$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $f8fd3b4e5f17ffb5$var$markUpdate(workInProgress), $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $f8fd3b4e5f17ffb5$var$popHostContext(workInProgress);
            renderLanes = $f8fd3b4e5f17ffb5$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f8fd3b4e5f17ffb5$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(166));
                    $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $f8fd3b4e5f17ffb5$var$contextStackCursor.current;
                $f8fd3b4e5f17ffb5$var$popHydrationState(workInProgress) ? $f8fd3b4e5f17ffb5$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $f8fd3b4e5f17ffb5$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $f8fd3b4e5f17ffb5$var$markUpdate(workInProgress));
            }
            $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $f8fd3b4e5f17ffb5$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f8fd3b4e5f17ffb5$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(166));
                    $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $f8fd3b4e5f17ffb5$var$contextStackCursor.current;
                if ($f8fd3b4e5f17ffb5$var$popHydrationState(workInProgress)) $f8fd3b4e5f17ffb5$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $f8fd3b4e5f17ffb5$var$getOwnerDocumentFromRootContainer($f8fd3b4e5f17ffb5$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = workInProgress;
                    current[$f8fd3b4e5f17ffb5$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($f8fd3b4e5f17ffb5$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $f8fd3b4e5f17ffb5$var$markUpdate(workInProgress);
                }
            }
            $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f8fd3b4e5f17ffb5$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(166));
                current = $f8fd3b4e5f17ffb5$var$rootInstanceStackCursor.current;
                if ($f8fd3b4e5f17ffb5$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $f8fd3b4e5f17ffb5$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $f8fd3b4e5f17ffb5$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $f8fd3b4e5f17ffb5$var$throwOnHydrationMismatch(workInProgress);
                } else current = $f8fd3b4e5f17ffb5$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $f8fd3b4e5f17ffb5$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(317));
                        type[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = workInProgress;
                    } else $f8fd3b4e5f17ffb5$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $f8fd3b4e5f17ffb5$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $f8fd3b4e5f17ffb5$var$popSuspenseHandler(workInProgress), workInProgress;
                    $f8fd3b4e5f17ffb5$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $f8fd3b4e5f17ffb5$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $f8fd3b4e5f17ffb5$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $f8fd3b4e5f17ffb5$var$popHostContainer(), null === current && $f8fd3b4e5f17ffb5$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), null;
        case 10:
            return $f8fd3b4e5f17ffb5$var$popProvider(workInProgress.type), $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), null;
        case 19:
            $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $f8fd3b4e5f17ffb5$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $f8fd3b4e5f17ffb5$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $f8fd3b4e5f17ffb5$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $f8fd3b4e5f17ffb5$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$f8fd3b4e5f17ffb5$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseStackCursor, $f8fd3b4e5f17ffb5$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $f8fd3b4e5f17ffb5$var$now() > $f8fd3b4e5f17ffb5$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $f8fd3b4e5f17ffb5$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $f8fd3b4e5f17ffb5$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $f8fd3b4e5f17ffb5$var$scheduleRetryEffect(workInProgress, current), $f8fd3b4e5f17ffb5$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$f8fd3b4e5f17ffb5$var$isHydrating) return $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), null;
                    } else 2 * $f8fd3b4e5f17ffb5$var$now() - type.renderingStartTime > $f8fd3b4e5f17ffb5$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $f8fd3b4e5f17ffb5$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $f8fd3b4e5f17ffb5$var$now(), workInProgress.sibling = null, current = $f8fd3b4e5f17ffb5$var$suspenseStackCursor.current, $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $f8fd3b4e5f17ffb5$var$popSuspenseHandler(workInProgress), $f8fd3b4e5f17ffb5$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $f8fd3b4e5f17ffb5$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $f8fd3b4e5f17ffb5$var$popProvider($f8fd3b4e5f17ffb5$var$CacheContext), $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $f8fd3b4e5f17ffb5$var$unwindWork(current, workInProgress) {
    $f8fd3b4e5f17ffb5$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $f8fd3b4e5f17ffb5$var$popProvider($f8fd3b4e5f17ffb5$var$CacheContext), $f8fd3b4e5f17ffb5$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $f8fd3b4e5f17ffb5$var$popHostContext(workInProgress), null;
        case 13:
            $f8fd3b4e5f17ffb5$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(340));
                $f8fd3b4e5f17ffb5$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$suspenseStackCursor), null;
        case 4:
            return $f8fd3b4e5f17ffb5$var$popHostContainer(), null;
        case 10:
            return $f8fd3b4e5f17ffb5$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $f8fd3b4e5f17ffb5$var$popSuspenseHandler(workInProgress), $f8fd3b4e5f17ffb5$var$popHiddenContext(), null !== current && $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $f8fd3b4e5f17ffb5$var$popProvider($f8fd3b4e5f17ffb5$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $f8fd3b4e5f17ffb5$var$unwindInterruptedWork(current, interruptedWork) {
    $f8fd3b4e5f17ffb5$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $f8fd3b4e5f17ffb5$var$popProvider($f8fd3b4e5f17ffb5$var$CacheContext);
            $f8fd3b4e5f17ffb5$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $f8fd3b4e5f17ffb5$var$popHostContext(interruptedWork);
            break;
        case 4:
            $f8fd3b4e5f17ffb5$var$popHostContainer();
            break;
        case 13:
            $f8fd3b4e5f17ffb5$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$suspenseStackCursor);
            break;
        case 10:
            $f8fd3b4e5f17ffb5$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $f8fd3b4e5f17ffb5$var$popSuspenseHandler(interruptedWork);
            $f8fd3b4e5f17ffb5$var$popHiddenContext();
            null !== current && $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$resumedCache);
            break;
        case 24:
            $f8fd3b4e5f17ffb5$var$popProvider($f8fd3b4e5f17ffb5$var$CacheContext);
    }
}
function $f8fd3b4e5f17ffb5$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f8fd3b4e5f17ffb5$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $f8fd3b4e5f17ffb5$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $f8fd3b4e5f17ffb5$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $f8fd3b4e5f17ffb5$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $f8fd3b4e5f17ffb5$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $f8fd3b4e5f17ffb5$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $f8fd3b4e5f17ffb5$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f8fd3b4e5f17ffb5$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $f8fd3b4e5f17ffb5$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$f8fd3b4e5f17ffb5$var$internalPropsKey] = newProps;
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f8fd3b4e5f17ffb5$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $f8fd3b4e5f17ffb5$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $f8fd3b4e5f17ffb5$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $f8fd3b4e5f17ffb5$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $f8fd3b4e5f17ffb5$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $f8fd3b4e5f17ffb5$var$noop$1));
    else if (4 !== tag && (27 === tag && $f8fd3b4e5f17ffb5$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $f8fd3b4e5f17ffb5$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $f8fd3b4e5f17ffb5$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $f8fd3b4e5f17ffb5$var$setInitialProperties(singleton, type, props);
        singleton[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = finishedWork;
        singleton[$f8fd3b4e5f17ffb5$var$internalPropsKey] = props;
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden = !1, $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden = !1, $f8fd3b4e5f17ffb5$var$needsFormReset = !1, $f8fd3b4e5f17ffb5$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $f8fd3b4e5f17ffb5$var$nextEffect = null;
function $f8fd3b4e5f17ffb5$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $f8fd3b4e5f17ffb5$var$eventsEnabled = $f8fd3b4e5f17ffb5$var$_enabled;
    root = $f8fd3b4e5f17ffb5$var$getActiveElementDeep(root);
    if ($f8fd3b4e5f17ffb5$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $f8fd3b4e5f17ffb5$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $f8fd3b4e5f17ffb5$var$_enabled = !1;
    for($f8fd3b4e5f17ffb5$var$nextEffect = firstChild; null !== $f8fd3b4e5f17ffb5$var$nextEffect;)if (firstChild = $f8fd3b4e5f17ffb5$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $f8fd3b4e5f17ffb5$var$nextEffect = root;
    else for(; null !== $f8fd3b4e5f17ffb5$var$nextEffect;){
        firstChild = $f8fd3b4e5f17ffb5$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $f8fd3b4e5f17ffb5$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $f8fd3b4e5f17ffb5$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $f8fd3b4e5f17ffb5$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $f8fd3b4e5f17ffb5$var$nextEffect = root;
            break;
        }
        $f8fd3b4e5f17ffb5$var$nextEffect = firstChild.return;
    }
}
function $f8fd3b4e5f17ffb5$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $f8fd3b4e5f17ffb5$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $f8fd3b4e5f17ffb5$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $f8fd3b4e5f17ffb5$var$commitClassCallbacks(finishedWork);
            flags & 512 && $f8fd3b4e5f17ffb5$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $f8fd3b4e5f17ffb5$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $f8fd3b4e5f17ffb5$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $f8fd3b4e5f17ffb5$var$commitHostMount(finishedWork);
            flags & 512 && $f8fd3b4e5f17ffb5$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $f8fd3b4e5f17ffb5$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $f8fd3b4e5f17ffb5$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $f8fd3b4e5f17ffb5$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden;
                prevProps = $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden;
                $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden = flags;
                ($f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden = prevProps;
                $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $f8fd3b4e5f17ffb5$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $f8fd3b4e5f17ffb5$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $f8fd3b4e5f17ffb5$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $f8fd3b4e5f17ffb5$var$hostParent = null, $f8fd3b4e5f17ffb5$var$hostParentIsContainer = !1;
function $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$f8fd3b4e5f17ffb5$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $f8fd3b4e5f17ffb5$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($f8fd3b4e5f17ffb5$var$injectedHook && "function" === typeof $f8fd3b4e5f17ffb5$var$injectedHook.onCommitFiberUnmount) try {
        $f8fd3b4e5f17ffb5$var$injectedHook.onCommitFiberUnmount($f8fd3b4e5f17ffb5$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || $f8fd3b4e5f17ffb5$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || $f8fd3b4e5f17ffb5$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $f8fd3b4e5f17ffb5$var$hostParent, prevHostParentIsContainer = $f8fd3b4e5f17ffb5$var$hostParentIsContainer;
            $f8fd3b4e5f17ffb5$var$isSingletonScope(deletedFiber.type) && ($f8fd3b4e5f17ffb5$var$hostParent = deletedFiber.stateNode, $f8fd3b4e5f17ffb5$var$hostParentIsContainer = !1);
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f8fd3b4e5f17ffb5$var$releaseSingletonInstance(deletedFiber.stateNode);
            $f8fd3b4e5f17ffb5$var$hostParent = prevHostParent;
            $f8fd3b4e5f17ffb5$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || $f8fd3b4e5f17ffb5$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $f8fd3b4e5f17ffb5$var$hostParent;
            prevHostParentIsContainer = $f8fd3b4e5f17ffb5$var$hostParentIsContainer;
            $f8fd3b4e5f17ffb5$var$hostParent = null;
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f8fd3b4e5f17ffb5$var$hostParent = prevHostParent;
            $f8fd3b4e5f17ffb5$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $f8fd3b4e5f17ffb5$var$hostParent) {
                if ($f8fd3b4e5f17ffb5$var$hostParentIsContainer) try {
                    (9 === $f8fd3b4e5f17ffb5$var$hostParent.nodeType ? $f8fd3b4e5f17ffb5$var$hostParent.body : "HTML" === $f8fd3b4e5f17ffb5$var$hostParent.nodeName ? $f8fd3b4e5f17ffb5$var$hostParent.ownerDocument.body : $f8fd3b4e5f17ffb5$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $f8fd3b4e5f17ffb5$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $f8fd3b4e5f17ffb5$var$hostParent && ($f8fd3b4e5f17ffb5$var$hostParentIsContainer ? (finishedRoot = $f8fd3b4e5f17ffb5$var$hostParent, $f8fd3b4e5f17ffb5$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $f8fd3b4e5f17ffb5$var$retryIfBlockedOn(finishedRoot)) : $f8fd3b4e5f17ffb5$var$clearSuspenseBoundary($f8fd3b4e5f17ffb5$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $f8fd3b4e5f17ffb5$var$hostParent;
            prevHostParentIsContainer = $f8fd3b4e5f17ffb5$var$hostParentIsContainer;
            $f8fd3b4e5f17ffb5$var$hostParent = deletedFiber.stateNode.containerInfo;
            $f8fd3b4e5f17ffb5$var$hostParentIsContainer = !0;
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f8fd3b4e5f17ffb5$var$hostParent = prevHostParent;
            $f8fd3b4e5f17ffb5$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || $f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || $f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || ($f8fd3b4e5f17ffb5$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $f8fd3b4e5f17ffb5$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden = (prevHostParent = $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $f8fd3b4e5f17ffb5$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $f8fd3b4e5f17ffb5$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f8fd3b4e5f17ffb5$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $f8fd3b4e5f17ffb5$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $f8fd3b4e5f17ffb5$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $f8fd3b4e5f17ffb5$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $f8fd3b4e5f17ffb5$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $f8fd3b4e5f17ffb5$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($f8fd3b4e5f17ffb5$var$isSingletonScope(parent.type)) {
                        $f8fd3b4e5f17ffb5$var$hostParent = parent.stateNode;
                        $f8fd3b4e5f17ffb5$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $f8fd3b4e5f17ffb5$var$hostParent = parent.stateNode;
                    $f8fd3b4e5f17ffb5$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $f8fd3b4e5f17ffb5$var$hostParent = parent.stateNode.containerInfo;
                    $f8fd3b4e5f17ffb5$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $f8fd3b4e5f17ffb5$var$hostParent) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(160));
        $f8fd3b4e5f17ffb5$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $f8fd3b4e5f17ffb5$var$hostParent = null;
        $f8fd3b4e5f17ffb5$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$f8fd3b4e5f17ffb5$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $f8fd3b4e5f17ffb5$var$currentHoistableRoot = null;
function $f8fd3b4e5f17ffb5$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $f8fd3b4e5f17ffb5$var$commitHookEffectListMount(3, finishedWork), $f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || null === current || $f8fd3b4e5f17ffb5$var$safelyDetachRef(current, current.return));
            flags & 64 && $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $f8fd3b4e5f17ffb5$var$currentHoistableRoot;
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || null === current || $f8fd3b4e5f17ffb5$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$f8fd3b4e5f17ffb5$var$internalHoistableMarker] || currentResource[$f8fd3b4e5f17ffb5$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $f8fd3b4e5f17ffb5$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = finishedWork;
                                        $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $f8fd3b4e5f17ffb5$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $f8fd3b4e5f17ffb5$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $f8fd3b4e5f17ffb5$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $f8fd3b4e5f17ffb5$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = finishedWork;
                                $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $f8fd3b4e5f17ffb5$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $f8fd3b4e5f17ffb5$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $f8fd3b4e5f17ffb5$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $f8fd3b4e5f17ffb5$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $f8fd3b4e5f17ffb5$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || null === current || $f8fd3b4e5f17ffb5$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $f8fd3b4e5f17ffb5$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || null === current || $f8fd3b4e5f17ffb5$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $f8fd3b4e5f17ffb5$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $f8fd3b4e5f17ffb5$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($f8fd3b4e5f17ffb5$var$needsFormReset = !0);
            break;
        case 6:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $f8fd3b4e5f17ffb5$var$tagCaches = null;
            hoistableRoot = $f8fd3b4e5f17ffb5$var$currentHoistableRoot;
            $f8fd3b4e5f17ffb5$var$currentHoistableRoot = $f8fd3b4e5f17ffb5$var$getHoistableRoot(root.containerInfo);
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$currentHoistableRoot = hoistableRoot;
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $f8fd3b4e5f17ffb5$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $f8fd3b4e5f17ffb5$var$needsFormReset && ($f8fd3b4e5f17ffb5$var$needsFormReset = !1, $f8fd3b4e5f17ffb5$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $f8fd3b4e5f17ffb5$var$currentHoistableRoot;
            $f8fd3b4e5f17ffb5$var$currentHoistableRoot = $f8fd3b4e5f17ffb5$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            $f8fd3b4e5f17ffb5$var$currentHoistableRoot = flags;
            break;
        case 12:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($f8fd3b4e5f17ffb5$var$globalMostRecentFallbackTime = $f8fd3b4e5f17ffb5$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $f8fd3b4e5f17ffb5$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden;
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden || $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $f8fd3b4e5f17ffb5$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $f8fd3b4e5f17ffb5$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork), $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
    }
}
function $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($f8fd3b4e5f17ffb5$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $f8fd3b4e5f17ffb5$var$getHostSibling(finishedWork);
                    $f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($f8fd3b4e5f17ffb5$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $f8fd3b4e5f17ffb5$var$getHostSibling(finishedWork);
                    $f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $f8fd3b4e5f17ffb5$var$getHostSibling(finishedWork);
                    $f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $f8fd3b4e5f17ffb5$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $f8fd3b4e5f17ffb5$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$f8fd3b4e5f17ffb5$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $f8fd3b4e5f17ffb5$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $f8fd3b4e5f17ffb5$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $f8fd3b4e5f17ffb5$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $f8fd3b4e5f17ffb5$var$safelyDetachRef(finishedWork, finishedWork.return);
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $f8fd3b4e5f17ffb5$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$f8fd3b4e5f17ffb5$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $f8fd3b4e5f17ffb5$var$commitClassCallbacks(finishedWork);
                $f8fd3b4e5f17ffb5$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $f8fd3b4e5f17ffb5$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $f8fd3b4e5f17ffb5$var$commitHostMount(finishedWork);
                $f8fd3b4e5f17ffb5$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $f8fd3b4e5f17ffb5$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $f8fd3b4e5f17ffb5$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f8fd3b4e5f17ffb5$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $f8fd3b4e5f17ffb5$var$releaseCache(previousCache));
}
function $f8fd3b4e5f17ffb5$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $f8fd3b4e5f17ffb5$var$releaseCache(current));
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$f8fd3b4e5f17ffb5$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $f8fd3b4e5f17ffb5$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $f8fd3b4e5f17ffb5$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $f8fd3b4e5f17ffb5$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $f8fd3b4e5f17ffb5$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $f8fd3b4e5f17ffb5$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $f8fd3b4e5f17ffb5$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $f8fd3b4e5f17ffb5$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $f8fd3b4e5f17ffb5$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $f8fd3b4e5f17ffb5$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $f8fd3b4e5f17ffb5$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $f8fd3b4e5f17ffb5$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $f8fd3b4e5f17ffb5$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $f8fd3b4e5f17ffb5$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $f8fd3b4e5f17ffb5$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $f8fd3b4e5f17ffb5$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $f8fd3b4e5f17ffb5$var$suspenseyCommitFlag = 8192;
function $f8fd3b4e5f17ffb5$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $f8fd3b4e5f17ffb5$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$f8fd3b4e5f17ffb5$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $f8fd3b4e5f17ffb5$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $f8fd3b4e5f17ffb5$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $f8fd3b4e5f17ffb5$var$suspenseyCommitFlag && null !== fiber.memoizedState && $f8fd3b4e5f17ffb5$var$suspendResource($f8fd3b4e5f17ffb5$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $f8fd3b4e5f17ffb5$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $f8fd3b4e5f17ffb5$var$currentHoistableRoot;
            $f8fd3b4e5f17ffb5$var$currentHoistableRoot = $f8fd3b4e5f17ffb5$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $f8fd3b4e5f17ffb5$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $f8fd3b4e5f17ffb5$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $f8fd3b4e5f17ffb5$var$suspenseyCommitFlag, $f8fd3b4e5f17ffb5$var$suspenseyCommitFlag = 16777216, $f8fd3b4e5f17ffb5$var$recursivelyAccumulateSuspenseyCommit(fiber), $f8fd3b4e5f17ffb5$var$suspenseyCommitFlag = previousHoistableRoot) : $f8fd3b4e5f17ffb5$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $f8fd3b4e5f17ffb5$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $f8fd3b4e5f17ffb5$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $f8fd3b4e5f17ffb5$var$nextEffect = childToDelete;
            $f8fd3b4e5f17ffb5$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $f8fd3b4e5f17ffb5$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$f8fd3b4e5f17ffb5$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $f8fd3b4e5f17ffb5$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $f8fd3b4e5f17ffb5$var$nextEffect = childToDelete;
            $f8fd3b4e5f17ffb5$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $f8fd3b4e5f17ffb5$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f8fd3b4e5f17ffb5$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $f8fd3b4e5f17ffb5$var$nextEffect;){
        var fiber = $f8fd3b4e5f17ffb5$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $f8fd3b4e5f17ffb5$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $f8fd3b4e5f17ffb5$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $f8fd3b4e5f17ffb5$var$nextEffect;){
            cache = $f8fd3b4e5f17ffb5$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $f8fd3b4e5f17ffb5$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $f8fd3b4e5f17ffb5$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $f8fd3b4e5f17ffb5$var$nextEffect = sibling;
                break a;
            }
            $f8fd3b4e5f17ffb5$var$nextEffect = returnFiber;
        }
    }
}
var $f8fd3b4e5f17ffb5$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $f8fd3b4e5f17ffb5$var$readContext($f8fd3b4e5f17ffb5$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $f8fd3b4e5f17ffb5$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $f8fd3b4e5f17ffb5$var$executionContext = 0, $f8fd3b4e5f17ffb5$var$workInProgressRoot = null, $f8fd3b4e5f17ffb5$var$workInProgress = null, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes = 0, $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0, $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null, $f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings = !1, $f8fd3b4e5f17ffb5$var$workInProgressRootIsPrerendering = !1, $f8fd3b4e5f17ffb5$var$workInProgressRootDidAttachPingListener = !1, $f8fd3b4e5f17ffb5$var$entangledRenderLanes = 0, $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 0, $f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes = 0, $f8fd3b4e5f17ffb5$var$workInProgressRootInterleavedUpdatedLanes = 0, $f8fd3b4e5f17ffb5$var$workInProgressRootPingedLanes = 0, $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane = 0, $f8fd3b4e5f17ffb5$var$workInProgressSuspendedRetryLanes = 0, $f8fd3b4e5f17ffb5$var$workInProgressRootConcurrentErrors = null, $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors = null, $f8fd3b4e5f17ffb5$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $f8fd3b4e5f17ffb5$var$globalMostRecentFallbackTime = 0, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderTargetTime = Infinity, $f8fd3b4e5f17ffb5$var$workInProgressTransitions = null, $f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed = null, $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 0, $f8fd3b4e5f17ffb5$var$pendingEffectsRoot = null, $f8fd3b4e5f17ffb5$var$pendingFinishedWork = null, $f8fd3b4e5f17ffb5$var$pendingEffectsLanes = 0, $f8fd3b4e5f17ffb5$var$pendingEffectsRemainingLanes = 0, $f8fd3b4e5f17ffb5$var$pendingPassiveTransitions = null, $f8fd3b4e5f17ffb5$var$pendingRecoverableErrors = null, $f8fd3b4e5f17ffb5$var$nestedUpdateCount = 0, $f8fd3b4e5f17ffb5$var$rootWithNestedUpdates = null;
function $f8fd3b4e5f17ffb5$var$requestUpdateLane() {
    if (0 !== ($f8fd3b4e5f17ffb5$var$executionContext & 2) && 0 !== $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes) return $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & -$f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes;
    if (null !== $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T) {
        var actionScopeLane = $f8fd3b4e5f17ffb5$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $f8fd3b4e5f17ffb5$var$requestTransitionLane();
    }
    return $f8fd3b4e5f17ffb5$var$resolveUpdatePriority();
}
function $f8fd3b4e5f17ffb5$var$requestDeferredLane() {
    0 === $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane && ($f8fd3b4e5f17ffb5$var$workInProgressDeferredLane = 0 === ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & 536870912) || $f8fd3b4e5f17ffb5$var$isHydrating ? $f8fd3b4e5f17ffb5$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane;
}
function $f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $f8fd3b4e5f17ffb5$var$workInProgressRoot && (2 === $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason || 9 === $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $f8fd3b4e5f17ffb5$var$prepareFreshStack(root, 0), $f8fd3b4e5f17ffb5$var$markRootSuspended(root, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes, $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane, !1);
    $f8fd3b4e5f17ffb5$var$markRootUpdated$1(root, lane);
    if (0 === ($f8fd3b4e5f17ffb5$var$executionContext & 2) || root !== $f8fd3b4e5f17ffb5$var$workInProgressRoot) root === $f8fd3b4e5f17ffb5$var$workInProgressRoot && (0 === ($f8fd3b4e5f17ffb5$var$executionContext & 2) && ($f8fd3b4e5f17ffb5$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus && $f8fd3b4e5f17ffb5$var$markRootSuspended(root, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes, $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane, !1)), $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(root);
}
function $f8fd3b4e5f17ffb5$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($f8fd3b4e5f17ffb5$var$executionContext & 6)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $f8fd3b4e5f17ffb5$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $f8fd3b4e5f17ffb5$var$renderRootConcurrent(root$jscomp$0, lanes) : $f8fd3b4e5f17ffb5$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $f8fd3b4e5f17ffb5$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $f8fd3b4e5f17ffb5$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$f8fd3b4e5f17ffb5$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $f8fd3b4e5f17ffb5$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $f8fd3b4e5f17ffb5$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($f8fd3b4e5f17ffb5$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($f8fd3b4e5f17ffb5$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $f8fd3b4e5f17ffb5$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors;
                            $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors ? $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors.push.apply($f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $f8fd3b4e5f17ffb5$var$prepareFreshStack(root$jscomp$0, 0);
                $f8fd3b4e5f17ffb5$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $f8fd3b4e5f17ffb5$var$markRootSuspended(shouldTimeSlice, lanes, $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane, !$f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $f8fd3b4e5f17ffb5$var$globalMostRecentFallbackTime + 300 - $f8fd3b4e5f17ffb5$var$now(), 10 < exitStatus)) {
                    $f8fd3b4e5f17ffb5$var$markRootSuspended(shouldTimeSlice, lanes, $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane, !$f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $f8fd3b4e5f17ffb5$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $f8fd3b4e5f17ffb5$var$scheduleTimeout($f8fd3b4e5f17ffb5$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors, $f8fd3b4e5f17ffb5$var$workInProgressTransitions, $f8fd3b4e5f17ffb5$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane, $f8fd3b4e5f17ffb5$var$workInProgressRootInterleavedUpdatedLanes, $f8fd3b4e5f17ffb5$var$workInProgressSuspendedRetryLanes, $f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $f8fd3b4e5f17ffb5$var$commitRootWhenReady(shouldTimeSlice, forceSync, $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors, $f8fd3b4e5f17ffb5$var$workInProgressTransitions, $f8fd3b4e5f17ffb5$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane, $f8fd3b4e5f17ffb5$var$workInProgressRootInterleavedUpdatedLanes, $f8fd3b4e5f17ffb5$var$workInProgressSuspendedRetryLanes, $f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(root$jscomp$0);
}
function $f8fd3b4e5f17ffb5$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($f8fd3b4e5f17ffb5$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $f8fd3b4e5f17ffb5$var$noop
        }, $f8fd3b4e5f17ffb5$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $f8fd3b4e5f17ffb5$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($f8fd3b4e5f17ffb5$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $f8fd3b4e5f17ffb5$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $f8fd3b4e5f17ffb5$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $f8fd3b4e5f17ffb5$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$f8fd3b4e5f17ffb5$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $f8fd3b4e5f17ffb5$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$f8fd3b4e5f17ffb5$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$f8fd3b4e5f17ffb5$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $f8fd3b4e5f17ffb5$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $f8fd3b4e5f17ffb5$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $f8fd3b4e5f17ffb5$var$flushSyncWork$1() {
    return 0 === ($f8fd3b4e5f17ffb5$var$executionContext & 6) ? ($f8fd3b4e5f17ffb5$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $f8fd3b4e5f17ffb5$var$resetWorkInProgressStack() {
    if (null !== $f8fd3b4e5f17ffb5$var$workInProgress) {
        if (0 === $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason) var interruptedWork = $f8fd3b4e5f17ffb5$var$workInProgress.return;
        else interruptedWork = $f8fd3b4e5f17ffb5$var$workInProgress, $f8fd3b4e5f17ffb5$var$lastContextDependency = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber$1 = null, $f8fd3b4e5f17ffb5$var$resetHooksOnUnwind(interruptedWork), $f8fd3b4e5f17ffb5$var$thenableState = null, $f8fd3b4e5f17ffb5$var$thenableIndexCounter = 0, interruptedWork = $f8fd3b4e5f17ffb5$var$workInProgress;
        for(; null !== interruptedWork;)$f8fd3b4e5f17ffb5$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $f8fd3b4e5f17ffb5$var$workInProgress = null;
    }
}
function $f8fd3b4e5f17ffb5$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $f8fd3b4e5f17ffb5$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $f8fd3b4e5f17ffb5$var$resetWorkInProgressStack();
    $f8fd3b4e5f17ffb5$var$workInProgressRoot = root;
    $f8fd3b4e5f17ffb5$var$workInProgress = timeoutHandle = $f8fd3b4e5f17ffb5$var$createWorkInProgress(root.current, null);
    $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes = lanes;
    $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0;
    $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null;
    $f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $f8fd3b4e5f17ffb5$var$workInProgressRootIsPrerendering = $f8fd3b4e5f17ffb5$var$checkIfRootIsPrerendering(root, lanes);
    $f8fd3b4e5f17ffb5$var$workInProgressRootDidAttachPingListener = !1;
    $f8fd3b4e5f17ffb5$var$workInProgressSuspendedRetryLanes = $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane = $f8fd3b4e5f17ffb5$var$workInProgressRootPingedLanes = $f8fd3b4e5f17ffb5$var$workInProgressRootInterleavedUpdatedLanes = $f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes = $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 0;
    $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors = $f8fd3b4e5f17ffb5$var$workInProgressRootConcurrentErrors = null;
    $f8fd3b4e5f17ffb5$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $f8fd3b4e5f17ffb5$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $f8fd3b4e5f17ffb5$var$entangledRenderLanes = lanes;
    $f8fd3b4e5f17ffb5$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $f8fd3b4e5f17ffb5$var$handleThrow(root, thrownValue) {
    $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber = null;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H = $f8fd3b4e5f17ffb5$var$ContextOnlyDispatcher;
    thrownValue === $f8fd3b4e5f17ffb5$var$SuspenseException || thrownValue === $f8fd3b4e5f17ffb5$var$SuspenseActionException ? (thrownValue = $f8fd3b4e5f17ffb5$var$getSuspendedThenable(), $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 3) : thrownValue === $f8fd3b4e5f17ffb5$var$SuspenseyCommitException ? (thrownValue = $f8fd3b4e5f17ffb5$var$getSuspendedThenable(), $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 4) : $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = thrownValue === $f8fd3b4e5f17ffb5$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = thrownValue;
    null === $f8fd3b4e5f17ffb5$var$workInProgress && ($f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 1, $f8fd3b4e5f17ffb5$var$logUncaughtError(root, $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $f8fd3b4e5f17ffb5$var$pushDispatcher() {
    var prevDispatcher = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H = $f8fd3b4e5f17ffb5$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $f8fd3b4e5f17ffb5$var$ContextOnlyDispatcher : prevDispatcher;
}
function $f8fd3b4e5f17ffb5$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.A;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.A = $f8fd3b4e5f17ffb5$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $f8fd3b4e5f17ffb5$var$renderDidSuspendDelayIfPossible() {
    $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 4;
    $f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings || ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & 4194048) !== $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes && null !== $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor.current || ($f8fd3b4e5f17ffb5$var$workInProgressRootIsPrerendering = !0);
    0 === ($f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($f8fd3b4e5f17ffb5$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $f8fd3b4e5f17ffb5$var$workInProgressRoot || $f8fd3b4e5f17ffb5$var$markRootSuspended($f8fd3b4e5f17ffb5$var$workInProgressRoot, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes, $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane, !1);
}
function $f8fd3b4e5f17ffb5$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $f8fd3b4e5f17ffb5$var$executionContext;
    $f8fd3b4e5f17ffb5$var$executionContext |= 2;
    var prevDispatcher = $f8fd3b4e5f17ffb5$var$pushDispatcher(), prevAsyncDispatcher = $f8fd3b4e5f17ffb5$var$pushAsyncDispatcher();
    if ($f8fd3b4e5f17ffb5$var$workInProgressRoot !== root || $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes !== lanes) $f8fd3b4e5f17ffb5$var$workInProgressTransitions = null, $f8fd3b4e5f17ffb5$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason && null !== $f8fd3b4e5f17ffb5$var$workInProgress) {
            var unitOfWork = $f8fd3b4e5f17ffb5$var$workInProgress, thrownValue = $f8fd3b4e5f17ffb5$var$workInProgressThrownValue;
            switch($f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason){
                case 8:
                    $f8fd3b4e5f17ffb5$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason;
                    $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0;
                    $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null;
                    $f8fd3b4e5f17ffb5$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $f8fd3b4e5f17ffb5$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason, $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0, $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null, $f8fd3b4e5f17ffb5$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $f8fd3b4e5f17ffb5$var$workLoopSync();
        exitStatus = $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $f8fd3b4e5f17ffb5$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $f8fd3b4e5f17ffb5$var$lastContextDependency = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber$1 = null;
    $f8fd3b4e5f17ffb5$var$executionContext = prevExecutionContext;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H = prevDispatcher;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $f8fd3b4e5f17ffb5$var$workInProgress && ($f8fd3b4e5f17ffb5$var$workInProgressRoot = null, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes = 0, $f8fd3b4e5f17ffb5$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $f8fd3b4e5f17ffb5$var$workLoopSync() {
    for(; null !== $f8fd3b4e5f17ffb5$var$workInProgress;)$f8fd3b4e5f17ffb5$var$performUnitOfWork($f8fd3b4e5f17ffb5$var$workInProgress);
}
function $f8fd3b4e5f17ffb5$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $f8fd3b4e5f17ffb5$var$executionContext;
    $f8fd3b4e5f17ffb5$var$executionContext |= 2;
    var prevDispatcher = $f8fd3b4e5f17ffb5$var$pushDispatcher(), prevAsyncDispatcher = $f8fd3b4e5f17ffb5$var$pushAsyncDispatcher();
    $f8fd3b4e5f17ffb5$var$workInProgressRoot !== root || $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes !== lanes ? ($f8fd3b4e5f17ffb5$var$workInProgressTransitions = null, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderTargetTime = $f8fd3b4e5f17ffb5$var$now() + 500, $f8fd3b4e5f17ffb5$var$prepareFreshStack(root, lanes)) : $f8fd3b4e5f17ffb5$var$workInProgressRootIsPrerendering = $f8fd3b4e5f17ffb5$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason && null !== $f8fd3b4e5f17ffb5$var$workInProgress) {
            lanes = $f8fd3b4e5f17ffb5$var$workInProgress;
            var thrownValue = $f8fd3b4e5f17ffb5$var$workInProgressThrownValue;
            b: switch($f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason){
                case 1:
                    $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0;
                    $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null;
                    $f8fd3b4e5f17ffb5$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($f8fd3b4e5f17ffb5$var$isThenableResolved(thrownValue)) {
                        $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0;
                        $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null;
                        $f8fd3b4e5f17ffb5$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason && 9 !== $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason || $f8fd3b4e5f17ffb5$var$workInProgressRoot !== root || ($f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 7);
                        $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $f8fd3b4e5f17ffb5$var$isThenableResolved(thrownValue) ? ($f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0, $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null, $f8fd3b4e5f17ffb5$var$replaySuspendedUnitOfWork(lanes)) : ($f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0, $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null, $f8fd3b4e5f17ffb5$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($f8fd3b4e5f17ffb5$var$workInProgress.tag){
                        case 26:
                            resource = $f8fd3b4e5f17ffb5$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $f8fd3b4e5f17ffb5$var$workInProgress;
                            if (resource ? $f8fd3b4e5f17ffb5$var$preloadResource(resource) : 1) {
                                $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0;
                                $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $f8fd3b4e5f17ffb5$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($f8fd3b4e5f17ffb5$var$workInProgress = returnFiber, $f8fd3b4e5f17ffb5$var$completeUnitOfWork(returnFiber)) : $f8fd3b4e5f17ffb5$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0;
                    $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null;
                    $f8fd3b4e5f17ffb5$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0;
                    $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null;
                    $f8fd3b4e5f17ffb5$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $f8fd3b4e5f17ffb5$var$resetWorkInProgressStack();
                    $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(462));
            }
        }
        $f8fd3b4e5f17ffb5$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $f8fd3b4e5f17ffb5$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $f8fd3b4e5f17ffb5$var$lastContextDependency = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber$1 = null;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H = prevDispatcher;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $f8fd3b4e5f17ffb5$var$executionContext = prevExecutionContext;
    if (null !== $f8fd3b4e5f17ffb5$var$workInProgress) return 0;
    $f8fd3b4e5f17ffb5$var$workInProgressRoot = null;
    $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes = 0;
    $f8fd3b4e5f17ffb5$var$finishQueueingConcurrentUpdates();
    return $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus;
}
function $f8fd3b4e5f17ffb5$var$workLoopConcurrentByScheduler() {
    for(; null !== $f8fd3b4e5f17ffb5$var$workInProgress && !$f8fd3b4e5f17ffb5$var$shouldYield();)$f8fd3b4e5f17ffb5$var$performUnitOfWork($f8fd3b4e5f17ffb5$var$workInProgress);
}
function $f8fd3b4e5f17ffb5$var$performUnitOfWork(unitOfWork) {
    var next = $f8fd3b4e5f17ffb5$var$beginWork(unitOfWork.alternate, unitOfWork, $f8fd3b4e5f17ffb5$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $f8fd3b4e5f17ffb5$var$completeUnitOfWork(unitOfWork) : $f8fd3b4e5f17ffb5$var$workInProgress = next;
}
function $f8fd3b4e5f17ffb5$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $f8fd3b4e5f17ffb5$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $f8fd3b4e5f17ffb5$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $f8fd3b4e5f17ffb5$var$resetHooksOnUnwind(next);
        default:
            $f8fd3b4e5f17ffb5$var$unwindInterruptedWork(current, next), next = $f8fd3b4e5f17ffb5$var$workInProgress = $f8fd3b4e5f17ffb5$var$resetWorkInProgress(next, $f8fd3b4e5f17ffb5$var$entangledRenderLanes), next = $f8fd3b4e5f17ffb5$var$beginWork(current, next, $f8fd3b4e5f17ffb5$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $f8fd3b4e5f17ffb5$var$completeUnitOfWork(unitOfWork) : $f8fd3b4e5f17ffb5$var$workInProgress = next;
}
function $f8fd3b4e5f17ffb5$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $f8fd3b4e5f17ffb5$var$lastContextDependency = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber$1 = null;
    $f8fd3b4e5f17ffb5$var$resetHooksOnUnwind(unitOfWork);
    $f8fd3b4e5f17ffb5$var$thenableState = null;
    $f8fd3b4e5f17ffb5$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($f8fd3b4e5f17ffb5$var$throwException(root, returnFiber, unitOfWork, thrownValue, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes)) {
            $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 1;
            $f8fd3b4e5f17ffb5$var$logUncaughtError(root, $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(thrownValue, root.current));
            $f8fd3b4e5f17ffb5$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $f8fd3b4e5f17ffb5$var$workInProgress = returnFiber, error;
        $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 1;
        $f8fd3b4e5f17ffb5$var$logUncaughtError(root, $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(thrownValue, root.current));
        $f8fd3b4e5f17ffb5$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($f8fd3b4e5f17ffb5$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($f8fd3b4e5f17ffb5$var$workInProgressRootIsPrerendering || 0 !== ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $f8fd3b4e5f17ffb5$var$unwindUnitOfWork(unitOfWork, root);
    } else $f8fd3b4e5f17ffb5$var$completeUnitOfWork(unitOfWork);
}
function $f8fd3b4e5f17ffb5$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $f8fd3b4e5f17ffb5$var$unwindUnitOfWork(completedWork, $f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $f8fd3b4e5f17ffb5$var$completeWork(completedWork.alternate, completedWork, $f8fd3b4e5f17ffb5$var$entangledRenderLanes);
        if (null !== next) {
            $f8fd3b4e5f17ffb5$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $f8fd3b4e5f17ffb5$var$workInProgress = completedWork;
            return;
        }
        $f8fd3b4e5f17ffb5$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus && ($f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 5);
}
function $f8fd3b4e5f17ffb5$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $f8fd3b4e5f17ffb5$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $f8fd3b4e5f17ffb5$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $f8fd3b4e5f17ffb5$var$workInProgress = unitOfWork;
            return;
        }
        $f8fd3b4e5f17ffb5$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 6;
    $f8fd3b4e5f17ffb5$var$workInProgress = null;
}
function $f8fd3b4e5f17ffb5$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $f8fd3b4e5f17ffb5$var$flushPendingEffects();
    while (0 !== $f8fd3b4e5f17ffb5$var$pendingEffectsStatus);
    if (0 !== ($f8fd3b4e5f17ffb5$var$executionContext & 6)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $f8fd3b4e5f17ffb5$var$concurrentlyUpdatedLanes;
        $f8fd3b4e5f17ffb5$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $f8fd3b4e5f17ffb5$var$workInProgressRoot && ($f8fd3b4e5f17ffb5$var$workInProgress = $f8fd3b4e5f17ffb5$var$workInProgressRoot = null, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes = 0);
        $f8fd3b4e5f17ffb5$var$pendingFinishedWork = finishedWork;
        $f8fd3b4e5f17ffb5$var$pendingEffectsRoot = root;
        $f8fd3b4e5f17ffb5$var$pendingEffectsLanes = lanes;
        $f8fd3b4e5f17ffb5$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $f8fd3b4e5f17ffb5$var$pendingPassiveTransitions = transitions;
        $f8fd3b4e5f17ffb5$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $f8fd3b4e5f17ffb5$var$scheduleCallback$1($f8fd3b4e5f17ffb5$var$NormalPriority$1, function() {
            $f8fd3b4e5f17ffb5$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T;
            $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = null;
            transitions = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
            $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $f8fd3b4e5f17ffb5$var$executionContext;
            $f8fd3b4e5f17ffb5$var$executionContext |= 4;
            try {
                $f8fd3b4e5f17ffb5$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $f8fd3b4e5f17ffb5$var$executionContext = spawnedLane, $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = transitions, $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 1;
        $f8fd3b4e5f17ffb5$var$flushMutationEffects();
        $f8fd3b4e5f17ffb5$var$flushLayoutEffects();
        $f8fd3b4e5f17ffb5$var$flushSpawnedWork();
    }
}
function $f8fd3b4e5f17ffb5$var$flushMutationEffects() {
    if (1 === $f8fd3b4e5f17ffb5$var$pendingEffectsStatus) {
        $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 0;
        var root = $f8fd3b4e5f17ffb5$var$pendingEffectsRoot, finishedWork = $f8fd3b4e5f17ffb5$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T;
            $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = null;
            var previousPriority = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
            $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $f8fd3b4e5f17ffb5$var$executionContext;
            $f8fd3b4e5f17ffb5$var$executionContext |= 4;
            try {
                $f8fd3b4e5f17ffb5$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $f8fd3b4e5f17ffb5$var$selectionInformation, curFocusedElem = $f8fd3b4e5f17ffb5$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $f8fd3b4e5f17ffb5$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $f8fd3b4e5f17ffb5$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $f8fd3b4e5f17ffb5$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $f8fd3b4e5f17ffb5$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $f8fd3b4e5f17ffb5$var$_enabled = !!$f8fd3b4e5f17ffb5$var$eventsEnabled;
                $f8fd3b4e5f17ffb5$var$selectionInformation = $f8fd3b4e5f17ffb5$var$eventsEnabled = null;
            } finally{
                $f8fd3b4e5f17ffb5$var$executionContext = prevExecutionContext, $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = previousPriority, $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 2;
    }
}
function $f8fd3b4e5f17ffb5$var$flushLayoutEffects() {
    if (2 === $f8fd3b4e5f17ffb5$var$pendingEffectsStatus) {
        $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 0;
        var root = $f8fd3b4e5f17ffb5$var$pendingEffectsRoot, finishedWork = $f8fd3b4e5f17ffb5$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T;
            $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = null;
            var previousPriority = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
            $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $f8fd3b4e5f17ffb5$var$executionContext;
            $f8fd3b4e5f17ffb5$var$executionContext |= 4;
            try {
                $f8fd3b4e5f17ffb5$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $f8fd3b4e5f17ffb5$var$executionContext = prevExecutionContext, $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = previousPriority, $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 3;
    }
}
function $f8fd3b4e5f17ffb5$var$flushSpawnedWork() {
    if (4 === $f8fd3b4e5f17ffb5$var$pendingEffectsStatus || 3 === $f8fd3b4e5f17ffb5$var$pendingEffectsStatus) {
        $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 0;
        $f8fd3b4e5f17ffb5$var$requestPaint();
        var root = $f8fd3b4e5f17ffb5$var$pendingEffectsRoot, finishedWork = $f8fd3b4e5f17ffb5$var$pendingFinishedWork, lanes = $f8fd3b4e5f17ffb5$var$pendingEffectsLanes, recoverableErrors = $f8fd3b4e5f17ffb5$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 5 : ($f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 0, $f8fd3b4e5f17ffb5$var$pendingFinishedWork = $f8fd3b4e5f17ffb5$var$pendingEffectsRoot = null, $f8fd3b4e5f17ffb5$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $f8fd3b4e5f17ffb5$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($f8fd3b4e5f17ffb5$var$injectedHook && "function" === typeof $f8fd3b4e5f17ffb5$var$injectedHook.onCommitFiberRoot) try {
            $f8fd3b4e5f17ffb5$var$injectedHook.onCommitFiberRoot($f8fd3b4e5f17ffb5$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T;
            remainingLanes = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
            $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = 2;
            $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = finishedWork, $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($f8fd3b4e5f17ffb5$var$pendingEffectsLanes & 3) && $f8fd3b4e5f17ffb5$var$flushPendingEffects();
        $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $f8fd3b4e5f17ffb5$var$rootWithNestedUpdates ? $f8fd3b4e5f17ffb5$var$nestedUpdateCount++ : ($f8fd3b4e5f17ffb5$var$nestedUpdateCount = 0, $f8fd3b4e5f17ffb5$var$rootWithNestedUpdates = root) : $f8fd3b4e5f17ffb5$var$nestedUpdateCount = 0;
        $f8fd3b4e5f17ffb5$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $f8fd3b4e5f17ffb5$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $f8fd3b4e5f17ffb5$var$releaseCache(remainingLanes)));
}
function $f8fd3b4e5f17ffb5$var$flushPendingEffects(wasDelayedCommit) {
    $f8fd3b4e5f17ffb5$var$flushMutationEffects();
    $f8fd3b4e5f17ffb5$var$flushLayoutEffects();
    $f8fd3b4e5f17ffb5$var$flushSpawnedWork();
    return $f8fd3b4e5f17ffb5$var$flushPassiveEffects(wasDelayedCommit);
}
function $f8fd3b4e5f17ffb5$var$flushPassiveEffects() {
    if (5 !== $f8fd3b4e5f17ffb5$var$pendingEffectsStatus) return !1;
    var root = $f8fd3b4e5f17ffb5$var$pendingEffectsRoot, remainingLanes = $f8fd3b4e5f17ffb5$var$pendingEffectsRemainingLanes;
    $f8fd3b4e5f17ffb5$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $f8fd3b4e5f17ffb5$var$lanesToEventPriority($f8fd3b4e5f17ffb5$var$pendingEffectsLanes), prevTransition = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T, previousPriority = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
    try {
        $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = null;
        renderPriority = $f8fd3b4e5f17ffb5$var$pendingPassiveTransitions;
        $f8fd3b4e5f17ffb5$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $f8fd3b4e5f17ffb5$var$pendingEffectsRoot, lanes = $f8fd3b4e5f17ffb5$var$pendingEffectsLanes;
        $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 0;
        $f8fd3b4e5f17ffb5$var$pendingFinishedWork = $f8fd3b4e5f17ffb5$var$pendingEffectsRoot = null;
        $f8fd3b4e5f17ffb5$var$pendingEffectsLanes = 0;
        if (0 !== ($f8fd3b4e5f17ffb5$var$executionContext & 6)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(331));
        var prevExecutionContext = $f8fd3b4e5f17ffb5$var$executionContext;
        $f8fd3b4e5f17ffb5$var$executionContext |= 4;
        $f8fd3b4e5f17ffb5$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $f8fd3b4e5f17ffb5$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $f8fd3b4e5f17ffb5$var$executionContext = prevExecutionContext;
        $f8fd3b4e5f17ffb5$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($f8fd3b4e5f17ffb5$var$injectedHook && "function" === typeof $f8fd3b4e5f17ffb5$var$injectedHook.onPostCommitFiberRoot) try {
            $f8fd3b4e5f17ffb5$var$injectedHook.onPostCommitFiberRoot($f8fd3b4e5f17ffb5$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = previousPriority, $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = prevTransition, $f8fd3b4e5f17ffb5$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $f8fd3b4e5f17ffb5$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $f8fd3b4e5f17ffb5$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $f8fd3b4e5f17ffb5$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($f8fd3b4e5f17ffb5$var$markRootUpdated$1(rootFiber, 2), $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(rootFiber));
}
function $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $f8fd3b4e5f17ffb5$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $f8fd3b4e5f17ffb5$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed || !$f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $f8fd3b4e5f17ffb5$var$createClassErrorUpdate(2);
                instance = $f8fd3b4e5f17ffb5$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($f8fd3b4e5f17ffb5$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $f8fd3b4e5f17ffb5$var$markRootUpdated$1(instance, 2), $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $f8fd3b4e5f17ffb5$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $f8fd3b4e5f17ffb5$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($f8fd3b4e5f17ffb5$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $f8fd3b4e5f17ffb5$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $f8fd3b4e5f17ffb5$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $f8fd3b4e5f17ffb5$var$workInProgressRoot === root && ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus || 3 === $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus && ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & 62914560) === $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes && 300 > $f8fd3b4e5f17ffb5$var$now() - $f8fd3b4e5f17ffb5$var$globalMostRecentFallbackTime ? 0 === ($f8fd3b4e5f17ffb5$var$executionContext & 2) && $f8fd3b4e5f17ffb5$var$prepareFreshStack(root, 0) : $f8fd3b4e5f17ffb5$var$workInProgressRootPingedLanes |= pingedLanes, $f8fd3b4e5f17ffb5$var$workInProgressSuspendedRetryLanes === $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes && ($f8fd3b4e5f17ffb5$var$workInProgressSuspendedRetryLanes = 0));
    $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(root);
}
function $f8fd3b4e5f17ffb5$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $f8fd3b4e5f17ffb5$var$claimNextRetryLane());
    boundaryFiber = $f8fd3b4e5f17ffb5$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($f8fd3b4e5f17ffb5$var$markRootUpdated$1(boundaryFiber, retryLane), $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(boundaryFiber));
}
function $f8fd3b4e5f17ffb5$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $f8fd3b4e5f17ffb5$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $f8fd3b4e5f17ffb5$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $f8fd3b4e5f17ffb5$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $f8fd3b4e5f17ffb5$var$scheduleCallback$1(priorityLevel, callback) {
    return $f8fd3b4e5f17ffb5$var$scheduleCallback$3(priorityLevel, callback);
}
var $f8fd3b4e5f17ffb5$var$firstScheduledRoot = null, $f8fd3b4e5f17ffb5$var$lastScheduledRoot = null, $f8fd3b4e5f17ffb5$var$didScheduleMicrotask = !1, $f8fd3b4e5f17ffb5$var$mightHavePendingSyncWork = !1, $f8fd3b4e5f17ffb5$var$isFlushingWork = !1, $f8fd3b4e5f17ffb5$var$currentEventTransitionLane = 0;
function $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(root) {
    root !== $f8fd3b4e5f17ffb5$var$lastScheduledRoot && null === root.next && (null === $f8fd3b4e5f17ffb5$var$lastScheduledRoot ? $f8fd3b4e5f17ffb5$var$firstScheduledRoot = $f8fd3b4e5f17ffb5$var$lastScheduledRoot = root : $f8fd3b4e5f17ffb5$var$lastScheduledRoot = $f8fd3b4e5f17ffb5$var$lastScheduledRoot.next = root);
    $f8fd3b4e5f17ffb5$var$mightHavePendingSyncWork = !0;
    $f8fd3b4e5f17ffb5$var$didScheduleMicrotask || ($f8fd3b4e5f17ffb5$var$didScheduleMicrotask = !0, $f8fd3b4e5f17ffb5$var$scheduleImmediateRootScheduleTask());
}
function $f8fd3b4e5f17ffb5$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$f8fd3b4e5f17ffb5$var$isFlushingWork && $f8fd3b4e5f17ffb5$var$mightHavePendingSyncWork) {
        $f8fd3b4e5f17ffb5$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $f8fd3b4e5f17ffb5$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $f8fd3b4e5f17ffb5$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $f8fd3b4e5f17ffb5$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$getNextLanes(root$174, root$174 === $f8fd3b4e5f17ffb5$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $f8fd3b4e5f17ffb5$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $f8fd3b4e5f17ffb5$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $f8fd3b4e5f17ffb5$var$isFlushingWork = !1;
    }
}
function $f8fd3b4e5f17ffb5$var$processRootScheduleInImmediateTask() {
    $f8fd3b4e5f17ffb5$var$processRootScheduleInMicrotask();
}
function $f8fd3b4e5f17ffb5$var$processRootScheduleInMicrotask() {
    $f8fd3b4e5f17ffb5$var$mightHavePendingSyncWork = $f8fd3b4e5f17ffb5$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $f8fd3b4e5f17ffb5$var$currentEventTransitionLane && ($f8fd3b4e5f17ffb5$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $f8fd3b4e5f17ffb5$var$currentEventTransitionLane), $f8fd3b4e5f17ffb5$var$currentEventTransitionLane = 0);
    for(var currentTime = $f8fd3b4e5f17ffb5$var$now(), prev = null, root = $f8fd3b4e5f17ffb5$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $f8fd3b4e5f17ffb5$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $f8fd3b4e5f17ffb5$var$firstScheduledRoot = next : prev.next = next, null === next && ($f8fd3b4e5f17ffb5$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $f8fd3b4e5f17ffb5$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $f8fd3b4e5f17ffb5$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $f8fd3b4e5f17ffb5$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $f8fd3b4e5f17ffb5$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $f8fd3b4e5f17ffb5$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $f8fd3b4e5f17ffb5$var$workInProgressRoot;
    suspendedLanes = $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes;
    suspendedLanes = $f8fd3b4e5f17ffb5$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason || 9 === $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $f8fd3b4e5f17ffb5$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $f8fd3b4e5f17ffb5$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $f8fd3b4e5f17ffb5$var$cancelCallback$1(pingedLanes);
        switch($f8fd3b4e5f17ffb5$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $f8fd3b4e5f17ffb5$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $f8fd3b4e5f17ffb5$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $f8fd3b4e5f17ffb5$var$IdlePriority;
                break;
            default:
                suspendedLanes = $f8fd3b4e5f17ffb5$var$NormalPriority$1;
        }
        pingedLanes = $f8fd3b4e5f17ffb5$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $f8fd3b4e5f17ffb5$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $f8fd3b4e5f17ffb5$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $f8fd3b4e5f17ffb5$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $f8fd3b4e5f17ffb5$var$pendingEffectsStatus && 5 !== $f8fd3b4e5f17ffb5$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($f8fd3b4e5f17ffb5$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $f8fd3b4e5f17ffb5$var$getNextLanes(root, root === $f8fd3b4e5f17ffb5$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $f8fd3b4e5f17ffb5$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $f8fd3b4e5f17ffb5$var$scheduleTaskForRootDuringMicrotask(root, $f8fd3b4e5f17ffb5$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $f8fd3b4e5f17ffb5$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $f8fd3b4e5f17ffb5$var$performSyncWorkOnRoot(root, lanes) {
    if ($f8fd3b4e5f17ffb5$var$flushPendingEffects()) return null;
    $f8fd3b4e5f17ffb5$var$performWorkOnRoot(root, lanes, !0);
}
function $f8fd3b4e5f17ffb5$var$scheduleImmediateRootScheduleTask() {
    $f8fd3b4e5f17ffb5$var$scheduleMicrotask(function() {
        0 !== ($f8fd3b4e5f17ffb5$var$executionContext & 6) ? $f8fd3b4e5f17ffb5$var$scheduleCallback$3($f8fd3b4e5f17ffb5$var$ImmediatePriority, $f8fd3b4e5f17ffb5$var$processRootScheduleInImmediateTask) : $f8fd3b4e5f17ffb5$var$processRootScheduleInMicrotask();
    });
}
function $f8fd3b4e5f17ffb5$var$requestTransitionLane() {
    0 === $f8fd3b4e5f17ffb5$var$currentEventTransitionLane && ($f8fd3b4e5f17ffb5$var$currentEventTransitionLane = $f8fd3b4e5f17ffb5$var$claimNextTransitionLane());
    return $f8fd3b4e5f17ffb5$var$currentEventTransitionLane;
}
function $f8fd3b4e5f17ffb5$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $f8fd3b4e5f17ffb5$var$sanitizeURL("" + actionProp);
}
function $f8fd3b4e5f17ffb5$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $f8fd3b4e5f17ffb5$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $f8fd3b4e5f17ffb5$var$coerceFormActionProp((nativeEventTarget[$f8fd3b4e5f17ffb5$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$f8fd3b4e5f17ffb5$var$internalPropsKey] || null) ? $f8fd3b4e5f17ffb5$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $f8fd3b4e5f17ffb5$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $f8fd3b4e5f17ffb5$var$currentEventTransitionLane) {
                                var formData = submitter ? $f8fd3b4e5f17ffb5$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $f8fd3b4e5f17ffb5$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $f8fd3b4e5f17ffb5$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $f8fd3b4e5f17ffb5$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $f8fd3b4e5f17ffb5$var$i$jscomp$inline_1528 = 0; $f8fd3b4e5f17ffb5$var$i$jscomp$inline_1528 < $f8fd3b4e5f17ffb5$var$simpleEventPluginEvents.length; $f8fd3b4e5f17ffb5$var$i$jscomp$inline_1528++){
    var $f8fd3b4e5f17ffb5$var$eventName$jscomp$inline_1529 = $f8fd3b4e5f17ffb5$var$simpleEventPluginEvents[$f8fd3b4e5f17ffb5$var$i$jscomp$inline_1528], $f8fd3b4e5f17ffb5$var$domEventName$jscomp$inline_1530 = $f8fd3b4e5f17ffb5$var$eventName$jscomp$inline_1529.toLowerCase(), $f8fd3b4e5f17ffb5$var$capitalizedEvent$jscomp$inline_1531 = $f8fd3b4e5f17ffb5$var$eventName$jscomp$inline_1529[0].toUpperCase() + $f8fd3b4e5f17ffb5$var$eventName$jscomp$inline_1529.slice(1);
    $f8fd3b4e5f17ffb5$var$registerSimpleEvent($f8fd3b4e5f17ffb5$var$domEventName$jscomp$inline_1530, "on" + $f8fd3b4e5f17ffb5$var$capitalizedEvent$jscomp$inline_1531);
}
$f8fd3b4e5f17ffb5$var$registerSimpleEvent($f8fd3b4e5f17ffb5$var$ANIMATION_END, "onAnimationEnd");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent($f8fd3b4e5f17ffb5$var$ANIMATION_ITERATION, "onAnimationIteration");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent($f8fd3b4e5f17ffb5$var$ANIMATION_START, "onAnimationStart");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent("dblclick", "onDoubleClick");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent("focusin", "onFocus");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent("focusout", "onBlur");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent($f8fd3b4e5f17ffb5$var$TRANSITION_RUN, "onTransitionRun");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent($f8fd3b4e5f17ffb5$var$TRANSITION_START, "onTransitionStart");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent($f8fd3b4e5f17ffb5$var$TRANSITION_CANCEL, "onTransitionCancel");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent($f8fd3b4e5f17ffb5$var$TRANSITION_END, "onTransitionEnd");
$f8fd3b4e5f17ffb5$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f8fd3b4e5f17ffb5$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f8fd3b4e5f17ffb5$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f8fd3b4e5f17ffb5$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f8fd3b4e5f17ffb5$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f8fd3b4e5f17ffb5$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f8fd3b4e5f17ffb5$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f8fd3b4e5f17ffb5$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f8fd3b4e5f17ffb5$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f8fd3b4e5f17ffb5$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f8fd3b4e5f17ffb5$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f8fd3b4e5f17ffb5$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($f8fd3b4e5f17ffb5$var$mediaEventTypes));
function $f8fd3b4e5f17ffb5$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$f8fd3b4e5f17ffb5$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$f8fd3b4e5f17ffb5$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($f8fd3b4e5f17ffb5$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $f8fd3b4e5f17ffb5$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $f8fd3b4e5f17ffb5$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $f8fd3b4e5f17ffb5$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $f8fd3b4e5f17ffb5$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$f8fd3b4e5f17ffb5$var$listeningMarker]) {
        rootContainerElement[$f8fd3b4e5f17ffb5$var$listeningMarker] = !0;
        $f8fd3b4e5f17ffb5$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($f8fd3b4e5f17ffb5$var$nonDelegatedEvents.has(domEventName) || $f8fd3b4e5f17ffb5$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $f8fd3b4e5f17ffb5$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$f8fd3b4e5f17ffb5$var$listeningMarker] || (ownerDocument[$f8fd3b4e5f17ffb5$var$listeningMarker] = !0, $f8fd3b4e5f17ffb5$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $f8fd3b4e5f17ffb5$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($f8fd3b4e5f17ffb5$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $f8fd3b4e5f17ffb5$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $f8fd3b4e5f17ffb5$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $f8fd3b4e5f17ffb5$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$f8fd3b4e5f17ffb5$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $f8fd3b4e5f17ffb5$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $f8fd3b4e5f17ffb5$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $f8fd3b4e5f17ffb5$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $f8fd3b4e5f17ffb5$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $f8fd3b4e5f17ffb5$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $f8fd3b4e5f17ffb5$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticTouchEvent;
                        break;
                    case $f8fd3b4e5f17ffb5$var$ANIMATION_END:
                    case $f8fd3b4e5f17ffb5$var$ANIMATION_ITERATION:
                    case $f8fd3b4e5f17ffb5$var$ANIMATION_START:
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticAnimationEvent;
                        break;
                    case $f8fd3b4e5f17ffb5$var$TRANSITION_END:
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $f8fd3b4e5f17ffb5$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($f8fd3b4e5f17ffb5$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $f8fd3b4e5f17ffb5$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($f8fd3b4e5f17ffb5$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$f8fd3b4e5f17ffb5$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $f8fd3b4e5f17ffb5$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $f8fd3b4e5f17ffb5$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $f8fd3b4e5f17ffb5$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $f8fd3b4e5f17ffb5$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $f8fd3b4e5f17ffb5$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $f8fd3b4e5f17ffb5$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $f8fd3b4e5f17ffb5$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $f8fd3b4e5f17ffb5$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $f8fd3b4e5f17ffb5$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $f8fd3b4e5f17ffb5$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $f8fd3b4e5f17ffb5$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $f8fd3b4e5f17ffb5$var$getParent(inCapturePhase);
                                reactEventName = $f8fd3b4e5f17ffb5$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $f8fd3b4e5f17ffb5$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $f8fd3b4e5f17ffb5$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $f8fd3b4e5f17ffb5$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $f8fd3b4e5f17ffb5$var$getTargetInstForChangeEvent;
                else if ($f8fd3b4e5f17ffb5$var$isTextInputElement(reactName)) {
                    if ($f8fd3b4e5f17ffb5$var$isInputEventSupported) getTargetInstFunc = $f8fd3b4e5f17ffb5$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $f8fd3b4e5f17ffb5$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $f8fd3b4e5f17ffb5$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $f8fd3b4e5f17ffb5$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $f8fd3b4e5f17ffb5$var$getTargetInstForChangeEvent) : getTargetInstFunc = $f8fd3b4e5f17ffb5$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $f8fd3b4e5f17ffb5$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $f8fd3b4e5f17ffb5$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $f8fd3b4e5f17ffb5$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($f8fd3b4e5f17ffb5$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $f8fd3b4e5f17ffb5$var$activeElement = handleEventFunc, $f8fd3b4e5f17ffb5$var$activeElementInst = targetInst, $f8fd3b4e5f17ffb5$var$lastSelection = null;
                    break;
                case "focusout":
                    $f8fd3b4e5f17ffb5$var$lastSelection = $f8fd3b4e5f17ffb5$var$activeElementInst = $f8fd3b4e5f17ffb5$var$activeElement = null;
                    break;
                case "mousedown":
                    $f8fd3b4e5f17ffb5$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f8fd3b4e5f17ffb5$var$mouseDown = !1;
                    $f8fd3b4e5f17ffb5$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($f8fd3b4e5f17ffb5$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $f8fd3b4e5f17ffb5$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($f8fd3b4e5f17ffb5$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $f8fd3b4e5f17ffb5$var$isComposing ? $f8fd3b4e5f17ffb5$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($f8fd3b4e5f17ffb5$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($f8fd3b4e5f17ffb5$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $f8fd3b4e5f17ffb5$var$isComposing && (fallbackData = $f8fd3b4e5f17ffb5$var$getData()) : ($f8fd3b4e5f17ffb5$var$root = nativeEventTarget, $f8fd3b4e5f17ffb5$var$startText = "value" in $f8fd3b4e5f17ffb5$var$root ? $f8fd3b4e5f17ffb5$var$root.value : $f8fd3b4e5f17ffb5$var$root.textContent, $f8fd3b4e5f17ffb5$var$isComposing = !0)), handleEventFunc = $f8fd3b4e5f17ffb5$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $f8fd3b4e5f17ffb5$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $f8fd3b4e5f17ffb5$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $f8fd3b4e5f17ffb5$var$canUseTextInputEvent ? $f8fd3b4e5f17ffb5$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $f8fd3b4e5f17ffb5$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $f8fd3b4e5f17ffb5$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $f8fd3b4e5f17ffb5$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $f8fd3b4e5f17ffb5$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $f8fd3b4e5f17ffb5$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $f8fd3b4e5f17ffb5$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $f8fd3b4e5f17ffb5$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $f8fd3b4e5f17ffb5$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($f8fd3b4e5f17ffb5$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $f8fd3b4e5f17ffb5$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($f8fd3b4e5f17ffb5$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $f8fd3b4e5f17ffb5$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $f8fd3b4e5f17ffb5$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $f8fd3b4e5f17ffb5$var$getListener(target, registrationName), null != stateNode && listeners.unshift($f8fd3b4e5f17ffb5$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $f8fd3b4e5f17ffb5$var$getListener(target, registrationName), null != stateNode && listeners.push($f8fd3b4e5f17ffb5$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $f8fd3b4e5f17ffb5$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $f8fd3b4e5f17ffb5$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $f8fd3b4e5f17ffb5$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($f8fd3b4e5f17ffb5$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($f8fd3b4e5f17ffb5$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $f8fd3b4e5f17ffb5$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $f8fd3b4e5f17ffb5$var$normalizeMarkupForTextOrAttribute(clientText);
    return $f8fd3b4e5f17ffb5$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $f8fd3b4e5f17ffb5$var$noop$1() {}
function $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $f8fd3b4e5f17ffb5$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $f8fd3b4e5f17ffb5$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $f8fd3b4e5f17ffb5$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $f8fd3b4e5f17ffb5$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $f8fd3b4e5f17ffb5$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $f8fd3b4e5f17ffb5$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $f8fd3b4e5f17ffb5$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $f8fd3b4e5f17ffb5$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "name", props.name, props, null), $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "encType", props.encType, props, null), $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "method", props.method, props, null), $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $f8fd3b4e5f17ffb5$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $f8fd3b4e5f17ffb5$var$noop$1);
            break;
        case "onScroll":
            null != value && $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $f8fd3b4e5f17ffb5$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("toggle", domElement);
            $f8fd3b4e5f17ffb5$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $f8fd3b4e5f17ffb5$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $f8fd3b4e5f17ffb5$var$aliases.get(key) || key, $f8fd3b4e5f17ffb5$var$setValueForAttribute(domElement, key, value);
    }
}
function $f8fd3b4e5f17ffb5$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $f8fd3b4e5f17ffb5$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $f8fd3b4e5f17ffb5$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $f8fd3b4e5f17ffb5$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $f8fd3b4e5f17ffb5$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$f8fd3b4e5f17ffb5$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$f8fd3b4e5f17ffb5$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $f8fd3b4e5f17ffb5$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $f8fd3b4e5f17ffb5$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("error", domElement);
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(137, tag));
                    default:
                        $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $f8fd3b4e5f17ffb5$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $f8fd3b4e5f17ffb5$var$track(domElement);
            return;
        case "select":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $f8fd3b4e5f17ffb5$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $f8fd3b4e5f17ffb5$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(91));
                    break;
                default:
                    $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $f8fd3b4e5f17ffb5$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $f8fd3b4e5f17ffb5$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("toggle", domElement);
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("cancel", domElement);
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $f8fd3b4e5f17ffb5$var$mediaEventTypes.length; hasSrc++)$f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent($f8fd3b4e5f17ffb5$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("error", domElement);
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("error", domElement), $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(137, tag));
                default:
                    $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($f8fd3b4e5f17ffb5$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $f8fd3b4e5f17ffb5$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $f8fd3b4e5f17ffb5$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $f8fd3b4e5f17ffb5$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $f8fd3b4e5f17ffb5$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $f8fd3b4e5f17ffb5$var$updateOptions(domElement, !!lastProps, tag, !0) : $f8fd3b4e5f17ffb5$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $f8fd3b4e5f17ffb5$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($f8fd3b4e5f17ffb5$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $f8fd3b4e5f17ffb5$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $f8fd3b4e5f17ffb5$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $f8fd3b4e5f17ffb5$var$eventsEnabled = null, $f8fd3b4e5f17ffb5$var$selectionInformation = null;
function $f8fd3b4e5f17ffb5$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $f8fd3b4e5f17ffb5$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $f8fd3b4e5f17ffb5$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $f8fd3b4e5f17ffb5$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $f8fd3b4e5f17ffb5$var$currentPopstateTransitionEvent = null;
function $f8fd3b4e5f17ffb5$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $f8fd3b4e5f17ffb5$var$currentPopstateTransitionEvent) return !1;
        $f8fd3b4e5f17ffb5$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $f8fd3b4e5f17ffb5$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $f8fd3b4e5f17ffb5$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $f8fd3b4e5f17ffb5$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $f8fd3b4e5f17ffb5$var$localPromise = "function" === typeof Promise ? Promise : void 0, $f8fd3b4e5f17ffb5$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f8fd3b4e5f17ffb5$var$localPromise ? function(callback) {
    return $f8fd3b4e5f17ffb5$var$localPromise.resolve(null).then(callback).catch($f8fd3b4e5f17ffb5$var$handleErrorInNextTick);
} : $f8fd3b4e5f17ffb5$var$scheduleTimeout;
function $f8fd3b4e5f17ffb5$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $f8fd3b4e5f17ffb5$var$isSingletonScope(type) {
    return "head" === type;
}
function $f8fd3b4e5f17ffb5$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $f8fd3b4e5f17ffb5$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $f8fd3b4e5f17ffb5$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $f8fd3b4e5f17ffb5$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$f8fd3b4e5f17ffb5$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $f8fd3b4e5f17ffb5$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $f8fd3b4e5f17ffb5$var$retryIfBlockedOn(suspenseInstance);
}
function $f8fd3b4e5f17ffb5$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $f8fd3b4e5f17ffb5$var$clearContainerSparingly(node);
                $f8fd3b4e5f17ffb5$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $f8fd3b4e5f17ffb5$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$f8fd3b4e5f17ffb5$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $f8fd3b4e5f17ffb5$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $f8fd3b4e5f17ffb5$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $f8fd3b4e5f17ffb5$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $f8fd3b4e5f17ffb5$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $f8fd3b4e5f17ffb5$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $f8fd3b4e5f17ffb5$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $f8fd3b4e5f17ffb5$var$previousHydratableOnEnteringScopedSingleton = null;
function $f8fd3b4e5f17ffb5$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $f8fd3b4e5f17ffb5$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $f8fd3b4e5f17ffb5$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(451));
    }
}
function $f8fd3b4e5f17ffb5$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $f8fd3b4e5f17ffb5$var$detachDeletedInstance(instance);
}
var $f8fd3b4e5f17ffb5$var$preloadPropsMap = new Map(), $f8fd3b4e5f17ffb5$var$preconnectsSet = new Set();
function $f8fd3b4e5f17ffb5$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $f8fd3b4e5f17ffb5$var$previousDispatcher = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.d;
$f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.d = {
    f: $f8fd3b4e5f17ffb5$var$flushSyncWork,
    r: $f8fd3b4e5f17ffb5$var$requestFormReset,
    D: $f8fd3b4e5f17ffb5$var$prefetchDNS,
    C: $f8fd3b4e5f17ffb5$var$preconnect,
    L: $f8fd3b4e5f17ffb5$var$preload,
    m: $f8fd3b4e5f17ffb5$var$preloadModule,
    X: $f8fd3b4e5f17ffb5$var$preinitScript,
    S: $f8fd3b4e5f17ffb5$var$preinitStyle,
    M: $f8fd3b4e5f17ffb5$var$preinitModuleScript
};
function $f8fd3b4e5f17ffb5$var$flushSyncWork() {
    var previousWasRendering = $f8fd3b4e5f17ffb5$var$previousDispatcher.f(), wasRendering = $f8fd3b4e5f17ffb5$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $f8fd3b4e5f17ffb5$var$requestFormReset(form) {
    var formInst = $f8fd3b4e5f17ffb5$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $f8fd3b4e5f17ffb5$var$requestFormReset$1(formInst) : $f8fd3b4e5f17ffb5$var$previousDispatcher.r(form);
}
var $f8fd3b4e5f17ffb5$var$globalDocument = "undefined" === typeof document ? null : document;
function $f8fd3b4e5f17ffb5$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $f8fd3b4e5f17ffb5$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $f8fd3b4e5f17ffb5$var$preconnectsSet.has(limitedEscapedHref) || ($f8fd3b4e5f17ffb5$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $f8fd3b4e5f17ffb5$var$setInitialProperties(href, "link", rel), $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $f8fd3b4e5f17ffb5$var$prefetchDNS(href) {
    $f8fd3b4e5f17ffb5$var$previousDispatcher.D(href);
    $f8fd3b4e5f17ffb5$var$preconnectAs("dns-prefetch", href, null);
}
function $f8fd3b4e5f17ffb5$var$preconnect(href, crossOrigin) {
    $f8fd3b4e5f17ffb5$var$previousDispatcher.C(href, crossOrigin);
    $f8fd3b4e5f17ffb5$var$preconnectAs("preconnect", href, crossOrigin);
}
function $f8fd3b4e5f17ffb5$var$preload(href, as, options) {
    $f8fd3b4e5f17ffb5$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $f8fd3b4e5f17ffb5$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $f8fd3b4e5f17ffb5$var$getStyleKey(href);
                break;
            case "script":
                key = $f8fd3b4e5f17ffb5$var$getScriptKey(href);
        }
        $f8fd3b4e5f17ffb5$var$preloadPropsMap.has(key) || (href = $f8fd3b4e5f17ffb5$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $f8fd3b4e5f17ffb5$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($f8fd3b4e5f17ffb5$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($f8fd3b4e5f17ffb5$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $f8fd3b4e5f17ffb5$var$setInitialProperties(as, "link", href), $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $f8fd3b4e5f17ffb5$var$preloadModule(href, options) {
    $f8fd3b4e5f17ffb5$var$previousDispatcher.m(href, options);
    var ownerDocument = $f8fd3b4e5f17ffb5$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $f8fd3b4e5f17ffb5$var$getScriptKey(href);
        }
        if (!$f8fd3b4e5f17ffb5$var$preloadPropsMap.has(key) && (href = $f8fd3b4e5f17ffb5$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $f8fd3b4e5f17ffb5$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($f8fd3b4e5f17ffb5$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $f8fd3b4e5f17ffb5$var$setInitialProperties(as, "link", href);
            $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $f8fd3b4e5f17ffb5$var$preinitStyle(href, precedence, options) {
    $f8fd3b4e5f17ffb5$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $f8fd3b4e5f17ffb5$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $f8fd3b4e5f17ffb5$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $f8fd3b4e5f17ffb5$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($f8fd3b4e5f17ffb5$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $f8fd3b4e5f17ffb5$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $f8fd3b4e5f17ffb5$var$preloadPropsMap.get(key)) && $f8fd3b4e5f17ffb5$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(link);
                $f8fd3b4e5f17ffb5$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $f8fd3b4e5f17ffb5$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $f8fd3b4e5f17ffb5$var$preinitScript(src, options) {
    $f8fd3b4e5f17ffb5$var$previousDispatcher.X(src, options);
    var ownerDocument = $f8fd3b4e5f17ffb5$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $f8fd3b4e5f17ffb5$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $f8fd3b4e5f17ffb5$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($f8fd3b4e5f17ffb5$var$getScriptSelectorFromKey(key)), resource || (src = $f8fd3b4e5f17ffb5$var$assign({
            src: src,
            async: !0
        }, options), (options = $f8fd3b4e5f17ffb5$var$preloadPropsMap.get(key)) && $f8fd3b4e5f17ffb5$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(resource), $f8fd3b4e5f17ffb5$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $f8fd3b4e5f17ffb5$var$preinitModuleScript(src, options) {
    $f8fd3b4e5f17ffb5$var$previousDispatcher.M(src, options);
    var ownerDocument = $f8fd3b4e5f17ffb5$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $f8fd3b4e5f17ffb5$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $f8fd3b4e5f17ffb5$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($f8fd3b4e5f17ffb5$var$getScriptSelectorFromKey(key)), resource || (src = $f8fd3b4e5f17ffb5$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $f8fd3b4e5f17ffb5$var$preloadPropsMap.get(key)) && $f8fd3b4e5f17ffb5$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(resource), $f8fd3b4e5f17ffb5$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $f8fd3b4e5f17ffb5$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$rootInstanceStackCursor.current) ? $f8fd3b4e5f17ffb5$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $f8fd3b4e5f17ffb5$var$getStyleKey(pendingProps.href), pendingProps = $f8fd3b4e5f17ffb5$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $f8fd3b4e5f17ffb5$var$getStyleKey(pendingProps.href);
                var styles$244 = $f8fd3b4e5f17ffb5$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($f8fd3b4e5f17ffb5$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $f8fd3b4e5f17ffb5$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $f8fd3b4e5f17ffb5$var$preloadPropsMap.set(type, pendingProps), styles$244 || $f8fd3b4e5f17ffb5$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $f8fd3b4e5f17ffb5$var$getScriptKey(pendingProps), pendingProps = $f8fd3b4e5f17ffb5$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(444, type));
    }
}
function $f8fd3b4e5f17ffb5$var$getStyleKey(href) {
    return 'href="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $f8fd3b4e5f17ffb5$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $f8fd3b4e5f17ffb5$var$stylesheetPropsFromRawProps(rawProps) {
    return $f8fd3b4e5f17ffb5$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $f8fd3b4e5f17ffb5$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $f8fd3b4e5f17ffb5$var$setInitialProperties(key, "link", preloadProps), $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $f8fd3b4e5f17ffb5$var$getScriptKey(src) {
    return '[src="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $f8fd3b4e5f17ffb5$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $f8fd3b4e5f17ffb5$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(instance), instance;
            var styleProps = $f8fd3b4e5f17ffb5$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(instance);
            $f8fd3b4e5f17ffb5$var$setInitialProperties(instance, "style", styleProps);
            $f8fd3b4e5f17ffb5$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $f8fd3b4e5f17ffb5$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($f8fd3b4e5f17ffb5$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $f8fd3b4e5f17ffb5$var$stylesheetPropsFromRawProps(props);
            (styleProps = $f8fd3b4e5f17ffb5$var$preloadPropsMap.get(styleProps)) && $f8fd3b4e5f17ffb5$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $f8fd3b4e5f17ffb5$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $f8fd3b4e5f17ffb5$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $f8fd3b4e5f17ffb5$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($f8fd3b4e5f17ffb5$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $f8fd3b4e5f17ffb5$var$preloadPropsMap.get(instance$250)) instance = $f8fd3b4e5f17ffb5$var$assign({}, props), $f8fd3b4e5f17ffb5$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(styleProps);
            $f8fd3b4e5f17ffb5$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $f8fd3b4e5f17ffb5$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $f8fd3b4e5f17ffb5$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $f8fd3b4e5f17ffb5$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $f8fd3b4e5f17ffb5$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $f8fd3b4e5f17ffb5$var$tagCaches = null;
function $f8fd3b4e5f17ffb5$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $f8fd3b4e5f17ffb5$var$tagCaches) {
        var cache = new Map();
        var caches = $f8fd3b4e5f17ffb5$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $f8fd3b4e5f17ffb5$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$f8fd3b4e5f17ffb5$var$internalHoistableMarker] || node[$f8fd3b4e5f17ffb5$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $f8fd3b4e5f17ffb5$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $f8fd3b4e5f17ffb5$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $f8fd3b4e5f17ffb5$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $f8fd3b4e5f17ffb5$var$suspendedState = null;
function $f8fd3b4e5f17ffb5$var$noop() {}
function $f8fd3b4e5f17ffb5$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $f8fd3b4e5f17ffb5$var$suspendedState) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(475));
    var state = $f8fd3b4e5f17ffb5$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $f8fd3b4e5f17ffb5$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($f8fd3b4e5f17ffb5$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $f8fd3b4e5f17ffb5$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $f8fd3b4e5f17ffb5$var$stylesheetPropsFromRawProps(props);
            (key = $f8fd3b4e5f17ffb5$var$preloadPropsMap.get(key)) && $f8fd3b4e5f17ffb5$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $f8fd3b4e5f17ffb5$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $f8fd3b4e5f17ffb5$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $f8fd3b4e5f17ffb5$var$waitForCommitToBeReady() {
    if (null === $f8fd3b4e5f17ffb5$var$suspendedState) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(475));
    var state = $f8fd3b4e5f17ffb5$var$suspendedState;
    state.stylesheets && 0 === state.count && $f8fd3b4e5f17ffb5$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $f8fd3b4e5f17ffb5$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $f8fd3b4e5f17ffb5$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $f8fd3b4e5f17ffb5$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $f8fd3b4e5f17ffb5$var$precedencesByRoot = null;
function $f8fd3b4e5f17ffb5$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $f8fd3b4e5f17ffb5$var$precedencesByRoot = new Map(), resources.forEach($f8fd3b4e5f17ffb5$var$insertStylesheetIntoRoot, state), $f8fd3b4e5f17ffb5$var$precedencesByRoot = null, $f8fd3b4e5f17ffb5$var$onUnsuspend.call(state));
}
function $f8fd3b4e5f17ffb5$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $f8fd3b4e5f17ffb5$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $f8fd3b4e5f17ffb5$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $f8fd3b4e5f17ffb5$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $f8fd3b4e5f17ffb5$var$HostTransitionContext = {
    $$typeof: $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $f8fd3b4e5f17ffb5$var$sharedNotPendingObject,
    _currentValue2: $f8fd3b4e5f17ffb5$var$sharedNotPendingObject,
    _threadCount: 0
};
function $f8fd3b4e5f17ffb5$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $f8fd3b4e5f17ffb5$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f8fd3b4e5f17ffb5$var$createLaneMap(0);
    this.hiddenUpdates = $f8fd3b4e5f17ffb5$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $f8fd3b4e5f17ffb5$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $f8fd3b4e5f17ffb5$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $f8fd3b4e5f17ffb5$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $f8fd3b4e5f17ffb5$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $f8fd3b4e5f17ffb5$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $f8fd3b4e5f17ffb5$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $f8fd3b4e5f17ffb5$var$emptyContextObject;
    parentComponent = $f8fd3b4e5f17ffb5$var$emptyContextObject;
    return parentComponent;
}
function $f8fd3b4e5f17ffb5$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $f8fd3b4e5f17ffb5$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $f8fd3b4e5f17ffb5$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $f8fd3b4e5f17ffb5$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(element, rootFiber, lane), $f8fd3b4e5f17ffb5$var$entangleTransitions(element, rootFiber, lane));
}
function $f8fd3b4e5f17ffb5$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $f8fd3b4e5f17ffb5$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $f8fd3b4e5f17ffb5$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $f8fd3b4e5f17ffb5$var$markRetryLaneImpl(fiber, retryLane);
}
function $f8fd3b4e5f17ffb5$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $f8fd3b4e5f17ffb5$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $f8fd3b4e5f17ffb5$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $f8fd3b4e5f17ffb5$var$_enabled = !0;
function $f8fd3b4e5f17ffb5$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = null;
    var previousPriority = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
    try {
        $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = 2, $f8fd3b4e5f17ffb5$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = previousPriority, $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f8fd3b4e5f17ffb5$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = null;
    var previousPriority = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
    try {
        $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = 8, $f8fd3b4e5f17ffb5$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = previousPriority, $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f8fd3b4e5f17ffb5$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($f8fd3b4e5f17ffb5$var$_enabled) {
        var blockedOn = $f8fd3b4e5f17ffb5$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $f8fd3b4e5f17ffb5$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $f8fd3b4e5f17ffb5$var$return_targetInst, targetContainer), $f8fd3b4e5f17ffb5$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($f8fd3b4e5f17ffb5$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($f8fd3b4e5f17ffb5$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $f8fd3b4e5f17ffb5$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $f8fd3b4e5f17ffb5$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $f8fd3b4e5f17ffb5$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $f8fd3b4e5f17ffb5$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(fiber);
                                0 === ($f8fd3b4e5f17ffb5$var$executionContext & 6) && ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderTargetTime = $f8fd3b4e5f17ffb5$var$now() + 500, $f8fd3b4e5f17ffb5$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $f8fd3b4e5f17ffb5$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(root, fiber, 2), $f8fd3b4e5f17ffb5$var$flushSyncWork$1(), $f8fd3b4e5f17ffb5$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $f8fd3b4e5f17ffb5$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $f8fd3b4e5f17ffb5$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $f8fd3b4e5f17ffb5$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $f8fd3b4e5f17ffb5$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $f8fd3b4e5f17ffb5$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $f8fd3b4e5f17ffb5$var$getEventTarget(nativeEvent);
    return $f8fd3b4e5f17ffb5$var$findInstanceBlockingTarget(nativeEvent);
}
var $f8fd3b4e5f17ffb5$var$return_targetInst = null;
function $f8fd3b4e5f17ffb5$var$findInstanceBlockingTarget(targetNode) {
    $f8fd3b4e5f17ffb5$var$return_targetInst = null;
    targetNode = $f8fd3b4e5f17ffb5$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $f8fd3b4e5f17ffb5$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $f8fd3b4e5f17ffb5$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $f8fd3b4e5f17ffb5$var$return_targetInst = targetNode;
    return null;
}
function $f8fd3b4e5f17ffb5$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($f8fd3b4e5f17ffb5$var$getCurrentPriorityLevel()){
                case $f8fd3b4e5f17ffb5$var$ImmediatePriority:
                    return 2;
                case $f8fd3b4e5f17ffb5$var$UserBlockingPriority:
                    return 8;
                case $f8fd3b4e5f17ffb5$var$NormalPriority$1:
                case $f8fd3b4e5f17ffb5$var$LowPriority:
                    return 32;
                case $f8fd3b4e5f17ffb5$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $f8fd3b4e5f17ffb5$var$hasScheduledReplayAttempt = !1, $f8fd3b4e5f17ffb5$var$queuedFocus = null, $f8fd3b4e5f17ffb5$var$queuedDrag = null, $f8fd3b4e5f17ffb5$var$queuedMouse = null, $f8fd3b4e5f17ffb5$var$queuedPointers = new Map(), $f8fd3b4e5f17ffb5$var$queuedPointerCaptures = new Map(), $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets = [], $f8fd3b4e5f17ffb5$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $f8fd3b4e5f17ffb5$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $f8fd3b4e5f17ffb5$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $f8fd3b4e5f17ffb5$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $f8fd3b4e5f17ffb5$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $f8fd3b4e5f17ffb5$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f8fd3b4e5f17ffb5$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $f8fd3b4e5f17ffb5$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $f8fd3b4e5f17ffb5$var$getInstanceFromNode(blockedOn), null !== blockedOn && $f8fd3b4e5f17ffb5$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $f8fd3b4e5f17ffb5$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $f8fd3b4e5f17ffb5$var$queuedFocus = $f8fd3b4e5f17ffb5$var$accumulateOrCreateContinuousQueuedReplayableEvent($f8fd3b4e5f17ffb5$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $f8fd3b4e5f17ffb5$var$queuedDrag = $f8fd3b4e5f17ffb5$var$accumulateOrCreateContinuousQueuedReplayableEvent($f8fd3b4e5f17ffb5$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $f8fd3b4e5f17ffb5$var$queuedMouse = $f8fd3b4e5f17ffb5$var$accumulateOrCreateContinuousQueuedReplayableEvent($f8fd3b4e5f17ffb5$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $f8fd3b4e5f17ffb5$var$queuedPointers.set(pointerId, $f8fd3b4e5f17ffb5$var$accumulateOrCreateContinuousQueuedReplayableEvent($f8fd3b4e5f17ffb5$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $f8fd3b4e5f17ffb5$var$queuedPointerCaptures.set(pointerId, $f8fd3b4e5f17ffb5$var$accumulateOrCreateContinuousQueuedReplayableEvent($f8fd3b4e5f17ffb5$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $f8fd3b4e5f17ffb5$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $f8fd3b4e5f17ffb5$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $f8fd3b4e5f17ffb5$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $f8fd3b4e5f17ffb5$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $f8fd3b4e5f17ffb5$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $f8fd3b4e5f17ffb5$var$requestUpdateLane();
                            lane = $f8fd3b4e5f17ffb5$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $f8fd3b4e5f17ffb5$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $f8fd3b4e5f17ffb5$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $f8fd3b4e5f17ffb5$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $f8fd3b4e5f17ffb5$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $f8fd3b4e5f17ffb5$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $f8fd3b4e5f17ffb5$var$currentReplayingEvent = null;
        } else return targetContainers = $f8fd3b4e5f17ffb5$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $f8fd3b4e5f17ffb5$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $f8fd3b4e5f17ffb5$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $f8fd3b4e5f17ffb5$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $f8fd3b4e5f17ffb5$var$replayUnblockedEvents() {
    $f8fd3b4e5f17ffb5$var$hasScheduledReplayAttempt = !1;
    null !== $f8fd3b4e5f17ffb5$var$queuedFocus && $f8fd3b4e5f17ffb5$var$attemptReplayContinuousQueuedEvent($f8fd3b4e5f17ffb5$var$queuedFocus) && ($f8fd3b4e5f17ffb5$var$queuedFocus = null);
    null !== $f8fd3b4e5f17ffb5$var$queuedDrag && $f8fd3b4e5f17ffb5$var$attemptReplayContinuousQueuedEvent($f8fd3b4e5f17ffb5$var$queuedDrag) && ($f8fd3b4e5f17ffb5$var$queuedDrag = null);
    null !== $f8fd3b4e5f17ffb5$var$queuedMouse && $f8fd3b4e5f17ffb5$var$attemptReplayContinuousQueuedEvent($f8fd3b4e5f17ffb5$var$queuedMouse) && ($f8fd3b4e5f17ffb5$var$queuedMouse = null);
    $f8fd3b4e5f17ffb5$var$queuedPointers.forEach($f8fd3b4e5f17ffb5$var$attemptReplayContinuousQueuedEventInMap);
    $f8fd3b4e5f17ffb5$var$queuedPointerCaptures.forEach($f8fd3b4e5f17ffb5$var$attemptReplayContinuousQueuedEventInMap);
}
function $f8fd3b4e5f17ffb5$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $f8fd3b4e5f17ffb5$var$hasScheduledReplayAttempt || ($f8fd3b4e5f17ffb5$var$hasScheduledReplayAttempt = !0, $hNfVH.unstable_scheduleCallback($hNfVH.unstable_NormalPriority, $f8fd3b4e5f17ffb5$var$replayUnblockedEvents)));
}
var $f8fd3b4e5f17ffb5$var$lastScheduledReplayQueue = null;
function $f8fd3b4e5f17ffb5$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $f8fd3b4e5f17ffb5$var$lastScheduledReplayQueue !== formReplayingQueue && ($f8fd3b4e5f17ffb5$var$lastScheduledReplayQueue = formReplayingQueue, $hNfVH.unstable_scheduleCallback($hNfVH.unstable_NormalPriority, function() {
        $f8fd3b4e5f17ffb5$var$lastScheduledReplayQueue === formReplayingQueue && ($f8fd3b4e5f17ffb5$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $f8fd3b4e5f17ffb5$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $f8fd3b4e5f17ffb5$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $f8fd3b4e5f17ffb5$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $f8fd3b4e5f17ffb5$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $f8fd3b4e5f17ffb5$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $f8fd3b4e5f17ffb5$var$queuedFocus && $f8fd3b4e5f17ffb5$var$scheduleCallbackIfUnblocked($f8fd3b4e5f17ffb5$var$queuedFocus, unblocked);
    null !== $f8fd3b4e5f17ffb5$var$queuedDrag && $f8fd3b4e5f17ffb5$var$scheduleCallbackIfUnblocked($f8fd3b4e5f17ffb5$var$queuedDrag, unblocked);
    null !== $f8fd3b4e5f17ffb5$var$queuedMouse && $f8fd3b4e5f17ffb5$var$scheduleCallbackIfUnblocked($f8fd3b4e5f17ffb5$var$queuedMouse, unblocked);
    $f8fd3b4e5f17ffb5$var$queuedPointers.forEach(unblock);
    $f8fd3b4e5f17ffb5$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets.length && (i = $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$f8fd3b4e5f17ffb5$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$f8fd3b4e5f17ffb5$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $f8fd3b4e5f17ffb5$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$f8fd3b4e5f17ffb5$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $f8fd3b4e5f17ffb5$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $f8fd3b4e5f17ffb5$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $f8fd3b4e5f17ffb5$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$f8fd3b4e5f17ffb5$var$ReactDOMHydrationRoot.prototype.render = $f8fd3b4e5f17ffb5$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(409));
    var current = root.current, lane = $f8fd3b4e5f17ffb5$var$requestUpdateLane();
    $f8fd3b4e5f17ffb5$var$updateContainerImpl(current, lane, children, root, null, null);
};
$f8fd3b4e5f17ffb5$var$ReactDOMHydrationRoot.prototype.unmount = $f8fd3b4e5f17ffb5$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $f8fd3b4e5f17ffb5$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $f8fd3b4e5f17ffb5$var$flushSyncWork$1();
        container[$f8fd3b4e5f17ffb5$var$internalContainerInstanceKey] = null;
    }
};
function $f8fd3b4e5f17ffb5$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$f8fd3b4e5f17ffb5$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $f8fd3b4e5f17ffb5$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets[i].priority; i++);
        $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $f8fd3b4e5f17ffb5$var$attemptExplicitHydrationTarget(target);
    }
};
var $f8fd3b4e5f17ffb5$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $dNU7X.version;
if ("19.1.1" !== $f8fd3b4e5f17ffb5$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(527, $f8fd3b4e5f17ffb5$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.1"));
$f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $f8fd3b4e5f17ffb5$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $f8fd3b4e5f17ffb5$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $f8fd3b4e5f17ffb5$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $f8fd3b4e5f17ffb5$var$ReactSharedInternals,
    reconcilerVersion: "19.1.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f8fd3b4e5f17ffb5$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f8fd3b4e5f17ffb5$var$hook$jscomp$inline_2257.isDisabled && $f8fd3b4e5f17ffb5$var$hook$jscomp$inline_2257.supportsFiber) try {
        $f8fd3b4e5f17ffb5$var$rendererID = $f8fd3b4e5f17ffb5$var$hook$jscomp$inline_2257.inject($f8fd3b4e5f17ffb5$var$internals$jscomp$inline_2256), $f8fd3b4e5f17ffb5$var$injectedHook = $f8fd3b4e5f17ffb5$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$f8fd3b4e5f17ffb5$export$882461b6382ed46c = function(container, options) {
    if (!$f8fd3b4e5f17ffb5$var$isValidContainer(container)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $f8fd3b4e5f17ffb5$var$defaultOnUncaughtError, onCaughtError = $f8fd3b4e5f17ffb5$var$defaultOnCaughtError, onRecoverableError = $f8fd3b4e5f17ffb5$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $f8fd3b4e5f17ffb5$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$f8fd3b4e5f17ffb5$var$internalContainerInstanceKey] = options.current;
    $f8fd3b4e5f17ffb5$var$listenToAllSupportedEvents(container);
    return new $f8fd3b4e5f17ffb5$var$ReactDOMRoot(options);
};
$f8fd3b4e5f17ffb5$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$f8fd3b4e5f17ffb5$var$isValidContainer(container)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $f8fd3b4e5f17ffb5$var$defaultOnUncaughtError, onCaughtError = $f8fd3b4e5f17ffb5$var$defaultOnCaughtError, onRecoverableError = $f8fd3b4e5f17ffb5$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $f8fd3b4e5f17ffb5$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $f8fd3b4e5f17ffb5$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $f8fd3b4e5f17ffb5$var$requestUpdateLane();
    isStrictMode = $f8fd3b4e5f17ffb5$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $f8fd3b4e5f17ffb5$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $f8fd3b4e5f17ffb5$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $f8fd3b4e5f17ffb5$var$markRootUpdated$1(initialChildren, options);
    $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(initialChildren);
    container[$f8fd3b4e5f17ffb5$var$internalContainerInstanceKey] = initialChildren.current;
    $f8fd3b4e5f17ffb5$var$listenToAllSupportedEvents(container);
    return new $f8fd3b4e5f17ffb5$var$ReactDOMHydrationRoot(initialChildren);
};
$f8fd3b4e5f17ffb5$export$83d89fbfd8236492 = "19.1.1";

});
parcelRegister("hNfVH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("k8s7f"));

});
parcelRegister("k8s7f", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $ea8a5d3bfd1fa17f$export$c4744153514ff05d, (v) => $ea8a5d3bfd1fa17f$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $ea8a5d3bfd1fa17f$export$3e506c1ccc9cc1a7, (v) => $ea8a5d3bfd1fa17f$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $ea8a5d3bfd1fa17f$export$e26fe2ed2fa76875, (v) => $ea8a5d3bfd1fa17f$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $ea8a5d3bfd1fa17f$export$502329bbf4b505b1, (v) => $ea8a5d3bfd1fa17f$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $ea8a5d3bfd1fa17f$export$6e3807111c4874c4, (v) => $ea8a5d3bfd1fa17f$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $ea8a5d3bfd1fa17f$export$c27134553091fb3a, (v) => $ea8a5d3bfd1fa17f$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $ea8a5d3bfd1fa17f$export$33ee1acdc04fd2a2, (v) => $ea8a5d3bfd1fa17f$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $ea8a5d3bfd1fa17f$export$b00a404bbd5edef2, (v) => $ea8a5d3bfd1fa17f$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $ea8a5d3bfd1fa17f$export$d66a1c1c77bd778b, (v) => $ea8a5d3bfd1fa17f$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $ea8a5d3bfd1fa17f$export$d3dfb8e4810cb555, (v) => $ea8a5d3bfd1fa17f$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $ea8a5d3bfd1fa17f$export$72fdf0e06517287b, (v) => $ea8a5d3bfd1fa17f$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $ea8a5d3bfd1fa17f$export$816d2913ae6b83b1, (v) => $ea8a5d3bfd1fa17f$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $ea8a5d3bfd1fa17f$export$61bcfe829111a1d0, (v) => $ea8a5d3bfd1fa17f$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $ea8a5d3bfd1fa17f$export$7ee8c9beb337bc3f, (v) => $ea8a5d3bfd1fa17f$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $ea8a5d3bfd1fa17f$export$b5836b71941fa3ed, (v) => $ea8a5d3bfd1fa17f$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $ea8a5d3bfd1fa17f$export$cf845f2c119da08a, (v) => $ea8a5d3bfd1fa17f$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ea8a5d3bfd1fa17f$export$c4744153514ff05d;
var $ea8a5d3bfd1fa17f$export$3e506c1ccc9cc1a7;
var $ea8a5d3bfd1fa17f$export$e26fe2ed2fa76875;
var $ea8a5d3bfd1fa17f$export$502329bbf4b505b1;
var $ea8a5d3bfd1fa17f$export$6e3807111c4874c4;
var $ea8a5d3bfd1fa17f$export$c27134553091fb3a;
var $ea8a5d3bfd1fa17f$export$33ee1acdc04fd2a2;
var $ea8a5d3bfd1fa17f$export$b00a404bbd5edef2;
var $ea8a5d3bfd1fa17f$export$d66a1c1c77bd778b;
var $ea8a5d3bfd1fa17f$export$d3dfb8e4810cb555;
var $ea8a5d3bfd1fa17f$export$72fdf0e06517287b;
var $ea8a5d3bfd1fa17f$export$816d2913ae6b83b1;
var $ea8a5d3bfd1fa17f$export$61bcfe829111a1d0;
var $ea8a5d3bfd1fa17f$export$7ee8c9beb337bc3f;
var $ea8a5d3bfd1fa17f$export$b5836b71941fa3ed;
var $ea8a5d3bfd1fa17f$export$cf845f2c119da08a;
"use strict";
function $ea8a5d3bfd1fa17f$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $ea8a5d3bfd1fa17f$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $ea8a5d3bfd1fa17f$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $ea8a5d3bfd1fa17f$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $ea8a5d3bfd1fa17f$var$compare(left, last)) rightIndex < length && 0 > $ea8a5d3bfd1fa17f$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $ea8a5d3bfd1fa17f$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $ea8a5d3bfd1fa17f$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$ea8a5d3bfd1fa17f$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ea8a5d3bfd1fa17f$var$localPerformance = performance;
    $ea8a5d3bfd1fa17f$export$c4744153514ff05d = function() {
        return $ea8a5d3bfd1fa17f$var$localPerformance.now();
    };
} else {
    var $ea8a5d3bfd1fa17f$var$localDate = Date, $ea8a5d3bfd1fa17f$var$initialTime = $ea8a5d3bfd1fa17f$var$localDate.now();
    $ea8a5d3bfd1fa17f$export$c4744153514ff05d = function() {
        return $ea8a5d3bfd1fa17f$var$localDate.now() - $ea8a5d3bfd1fa17f$var$initialTime;
    };
}
var $ea8a5d3bfd1fa17f$var$taskQueue = [], $ea8a5d3bfd1fa17f$var$timerQueue = [], $ea8a5d3bfd1fa17f$var$taskIdCounter = 1, $ea8a5d3bfd1fa17f$var$currentTask = null, $ea8a5d3bfd1fa17f$var$currentPriorityLevel = 3, $ea8a5d3bfd1fa17f$var$isPerformingWork = !1, $ea8a5d3bfd1fa17f$var$isHostCallbackScheduled = !1, $ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled = !1, $ea8a5d3bfd1fa17f$var$needsPaint = !1, $ea8a5d3bfd1fa17f$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $ea8a5d3bfd1fa17f$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $ea8a5d3bfd1fa17f$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime) {
    for(var timer = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue); null !== timer;){
        if (null === timer.callback) $ea8a5d3bfd1fa17f$var$pop($ea8a5d3bfd1fa17f$var$timerQueue);
        else if (timer.startTime <= currentTime) $ea8a5d3bfd1fa17f$var$pop($ea8a5d3bfd1fa17f$var$timerQueue), timer.sortIndex = timer.expirationTime, $ea8a5d3bfd1fa17f$var$push($ea8a5d3bfd1fa17f$var$taskQueue, timer);
        else break;
        timer = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue);
    }
}
function $ea8a5d3bfd1fa17f$var$handleTimeout(currentTime) {
    $ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled = !1;
    $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime);
    if (!$ea8a5d3bfd1fa17f$var$isHostCallbackScheduled) {
        if (null !== $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue)) $ea8a5d3bfd1fa17f$var$isHostCallbackScheduled = !0, $ea8a5d3bfd1fa17f$var$isMessageLoopRunning || ($ea8a5d3bfd1fa17f$var$isMessageLoopRunning = !0, $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue);
            null !== firstTimer && $ea8a5d3bfd1fa17f$var$requestHostTimeout($ea8a5d3bfd1fa17f$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $ea8a5d3bfd1fa17f$var$isMessageLoopRunning = !1, $ea8a5d3bfd1fa17f$var$taskTimeoutID = -1, $ea8a5d3bfd1fa17f$var$frameInterval = 5, $ea8a5d3bfd1fa17f$var$startTime = -1;
function $ea8a5d3bfd1fa17f$var$shouldYieldToHost() {
    return $ea8a5d3bfd1fa17f$var$needsPaint ? !0 : $ea8a5d3bfd1fa17f$export$c4744153514ff05d() - $ea8a5d3bfd1fa17f$var$startTime < $ea8a5d3bfd1fa17f$var$frameInterval ? !1 : !0;
}
function $ea8a5d3bfd1fa17f$var$performWorkUntilDeadline() {
    $ea8a5d3bfd1fa17f$var$needsPaint = !1;
    if ($ea8a5d3bfd1fa17f$var$isMessageLoopRunning) {
        var currentTime = $ea8a5d3bfd1fa17f$export$c4744153514ff05d();
        $ea8a5d3bfd1fa17f$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $ea8a5d3bfd1fa17f$var$isHostCallbackScheduled = !1;
                $ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled && ($ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled = !1, $ea8a5d3bfd1fa17f$var$localClearTimeout($ea8a5d3bfd1fa17f$var$taskTimeoutID), $ea8a5d3bfd1fa17f$var$taskTimeoutID = -1);
                $ea8a5d3bfd1fa17f$var$isPerformingWork = !0;
                var previousPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
                try {
                    b: {
                        $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime);
                        for($ea8a5d3bfd1fa17f$var$currentTask = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue); null !== $ea8a5d3bfd1fa17f$var$currentTask && !($ea8a5d3bfd1fa17f$var$currentTask.expirationTime > currentTime && $ea8a5d3bfd1fa17f$var$shouldYieldToHost());){
                            var callback = $ea8a5d3bfd1fa17f$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $ea8a5d3bfd1fa17f$var$currentTask.callback = null;
                                $ea8a5d3bfd1fa17f$var$currentPriorityLevel = $ea8a5d3bfd1fa17f$var$currentTask.priorityLevel;
                                var continuationCallback = callback($ea8a5d3bfd1fa17f$var$currentTask.expirationTime <= currentTime);
                                currentTime = $ea8a5d3bfd1fa17f$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $ea8a5d3bfd1fa17f$var$currentTask.callback = continuationCallback;
                                    $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $ea8a5d3bfd1fa17f$var$currentTask === $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue) && $ea8a5d3bfd1fa17f$var$pop($ea8a5d3bfd1fa17f$var$taskQueue);
                                $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime);
                            } else $ea8a5d3bfd1fa17f$var$pop($ea8a5d3bfd1fa17f$var$taskQueue);
                            $ea8a5d3bfd1fa17f$var$currentTask = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue);
                        }
                        if (null !== $ea8a5d3bfd1fa17f$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue);
                            null !== firstTimer && $ea8a5d3bfd1fa17f$var$requestHostTimeout($ea8a5d3bfd1fa17f$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $ea8a5d3bfd1fa17f$var$currentTask = null, $ea8a5d3bfd1fa17f$var$currentPriorityLevel = previousPriorityLevel, $ea8a5d3bfd1fa17f$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline() : $ea8a5d3bfd1fa17f$var$isMessageLoopRunning = !1;
        }
    }
}
var $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $ea8a5d3bfd1fa17f$var$localSetImmediate) $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline = function() {
    $ea8a5d3bfd1fa17f$var$localSetImmediate($ea8a5d3bfd1fa17f$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ea8a5d3bfd1fa17f$var$channel = new MessageChannel(), $ea8a5d3bfd1fa17f$var$port = $ea8a5d3bfd1fa17f$var$channel.port2;
    $ea8a5d3bfd1fa17f$var$channel.port1.onmessage = $ea8a5d3bfd1fa17f$var$performWorkUntilDeadline;
    $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline = function() {
        $ea8a5d3bfd1fa17f$var$port.postMessage(null);
    };
} else $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline = function() {
    $ea8a5d3bfd1fa17f$var$localSetTimeout($ea8a5d3bfd1fa17f$var$performWorkUntilDeadline, 0);
};
function $ea8a5d3bfd1fa17f$var$requestHostTimeout(callback, ms) {
    $ea8a5d3bfd1fa17f$var$taskTimeoutID = $ea8a5d3bfd1fa17f$var$localSetTimeout(function() {
        callback($ea8a5d3bfd1fa17f$export$c4744153514ff05d());
    }, ms);
}
$ea8a5d3bfd1fa17f$export$3e506c1ccc9cc1a7 = 5;
$ea8a5d3bfd1fa17f$export$e26fe2ed2fa76875 = 1;
$ea8a5d3bfd1fa17f$export$502329bbf4b505b1 = 4;
$ea8a5d3bfd1fa17f$export$6e3807111c4874c4 = 3;
$ea8a5d3bfd1fa17f$export$c27134553091fb3a = null;
$ea8a5d3bfd1fa17f$export$33ee1acdc04fd2a2 = 2;
$ea8a5d3bfd1fa17f$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$ea8a5d3bfd1fa17f$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ea8a5d3bfd1fa17f$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$ea8a5d3bfd1fa17f$export$d3dfb8e4810cb555 = function() {
    return $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
};
$ea8a5d3bfd1fa17f$export$72fdf0e06517287b = function(eventHandler) {
    switch($ea8a5d3bfd1fa17f$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
    $ea8a5d3bfd1fa17f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $ea8a5d3bfd1fa17f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$ea8a5d3bfd1fa17f$export$816d2913ae6b83b1 = function() {
    $ea8a5d3bfd1fa17f$var$needsPaint = !0;
};
$ea8a5d3bfd1fa17f$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
    $ea8a5d3bfd1fa17f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $ea8a5d3bfd1fa17f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$ea8a5d3bfd1fa17f$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $ea8a5d3bfd1fa17f$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $ea8a5d3bfd1fa17f$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $ea8a5d3bfd1fa17f$var$push($ea8a5d3bfd1fa17f$var$timerQueue, priorityLevel), null === $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue) && priorityLevel === $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue) && ($ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled ? ($ea8a5d3bfd1fa17f$var$localClearTimeout($ea8a5d3bfd1fa17f$var$taskTimeoutID), $ea8a5d3bfd1fa17f$var$taskTimeoutID = -1) : $ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled = !0, $ea8a5d3bfd1fa17f$var$requestHostTimeout($ea8a5d3bfd1fa17f$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $ea8a5d3bfd1fa17f$var$push($ea8a5d3bfd1fa17f$var$taskQueue, priorityLevel), $ea8a5d3bfd1fa17f$var$isHostCallbackScheduled || $ea8a5d3bfd1fa17f$var$isPerformingWork || ($ea8a5d3bfd1fa17f$var$isHostCallbackScheduled = !0, $ea8a5d3bfd1fa17f$var$isMessageLoopRunning || ($ea8a5d3bfd1fa17f$var$isMessageLoopRunning = !0, $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$ea8a5d3bfd1fa17f$export$b5836b71941fa3ed = $ea8a5d3bfd1fa17f$var$shouldYieldToHost;
$ea8a5d3bfd1fa17f$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
        $ea8a5d3bfd1fa17f$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $ea8a5d3bfd1fa17f$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("dNU7X", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9x51g"));

});

parcelRegister("boCrV", function(module, exports) {
'use strict';
function $84bfc2d503de3ab8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($84bfc2d503de3ab8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$84bfc2d503de3ab8$var$checkDCE();

module.exports = (parcelRequire("7oYVV"));

});
parcelRegister("7oYVV", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $563a0a6108185525$export$69ce8ef3fe5cead0, (v) => $563a0a6108185525$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $563a0a6108185525$export$d39a5bbd09211389, (v) => $563a0a6108185525$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $563a0a6108185525$export$cd75ccfd720a3cd4, (v) => $563a0a6108185525$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $563a0a6108185525$export$a0816fa17a9e79be, (v) => $563a0a6108185525$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $563a0a6108185525$export$7292efcadded39f3, (v) => $563a0a6108185525$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $563a0a6108185525$export$da407abadb9b8f86, (v) => $563a0a6108185525$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $563a0a6108185525$export$314cfea32580671c, (v) => $563a0a6108185525$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $563a0a6108185525$export$513ccb98c53b8039, (v) => $563a0a6108185525$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $563a0a6108185525$export$dbca993bc2d264a, (v) => $563a0a6108185525$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $563a0a6108185525$export$4797a8006f0655d0, (v) => $563a0a6108185525$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $563a0a6108185525$export$c78a37762a8d58e1, (v) => $563a0a6108185525$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $563a0a6108185525$export$606f11b2eb45ecc6, (v) => $563a0a6108185525$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $563a0a6108185525$export$f7e8a0bf92324b1e, (v) => $563a0a6108185525$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $563a0a6108185525$export$83d89fbfd8236492, (v) => $563a0a6108185525$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $563a0a6108185525$export$69ce8ef3fe5cead0;
var $563a0a6108185525$export$d39a5bbd09211389;
var $563a0a6108185525$export$cd75ccfd720a3cd4;
var $563a0a6108185525$export$a0816fa17a9e79be;
var $563a0a6108185525$export$7292efcadded39f3;
var $563a0a6108185525$export$da407abadb9b8f86;
var $563a0a6108185525$export$314cfea32580671c;
var $563a0a6108185525$export$513ccb98c53b8039;
var $563a0a6108185525$export$dbca993bc2d264a;
var $563a0a6108185525$export$4797a8006f0655d0;
var $563a0a6108185525$export$c78a37762a8d58e1;
var $563a0a6108185525$export$606f11b2eb45ecc6;
var $563a0a6108185525$export$f7e8a0bf92324b1e;
var $563a0a6108185525$export$83d89fbfd8236492;
"use strict";

var $dNU7X = parcelRequire("dNU7X");
function $563a0a6108185525$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $563a0a6108185525$var$noop() {}
var $563a0a6108185525$var$Internals = {
    d: {
        f: $563a0a6108185525$var$noop,
        r: function() {
            throw Error($563a0a6108185525$var$formatProdErrorMessage(522));
        },
        D: $563a0a6108185525$var$noop,
        C: $563a0a6108185525$var$noop,
        L: $563a0a6108185525$var$noop,
        m: $563a0a6108185525$var$noop,
        X: $563a0a6108185525$var$noop,
        S: $563a0a6108185525$var$noop,
        M: $563a0a6108185525$var$noop
    },
    p: 0,
    findDOMNode: null
}, $563a0a6108185525$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $563a0a6108185525$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $563a0a6108185525$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $563a0a6108185525$var$ReactSharedInternals = $dNU7X.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $563a0a6108185525$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$563a0a6108185525$export$69ce8ef3fe5cead0 = $563a0a6108185525$var$Internals;
$563a0a6108185525$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($563a0a6108185525$var$formatProdErrorMessage(299));
    return $563a0a6108185525$var$createPortal$1(children, container, null, key);
};
$563a0a6108185525$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $563a0a6108185525$var$ReactSharedInternals.T, previousUpdatePriority = $563a0a6108185525$var$Internals.p;
    try {
        if ($563a0a6108185525$var$ReactSharedInternals.T = null, $563a0a6108185525$var$Internals.p = 2, fn) return fn();
    } finally{
        $563a0a6108185525$var$ReactSharedInternals.T = previousTransition, $563a0a6108185525$var$Internals.p = previousUpdatePriority, $563a0a6108185525$var$Internals.d.f();
    }
};
$563a0a6108185525$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $563a0a6108185525$var$Internals.d.C(href, options));
};
$563a0a6108185525$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $563a0a6108185525$var$Internals.d.D(href);
};
$563a0a6108185525$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $563a0a6108185525$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $563a0a6108185525$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $563a0a6108185525$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$563a0a6108185525$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $563a0a6108185525$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $563a0a6108185525$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $563a0a6108185525$var$Internals.d.M(href);
    }
};
$563a0a6108185525$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $563a0a6108185525$var$getCrossOriginStringAs(as, options.crossOrigin);
        $563a0a6108185525$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$563a0a6108185525$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $563a0a6108185525$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $563a0a6108185525$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $563a0a6108185525$var$Internals.d.m(href);
    }
};
$563a0a6108185525$export$4797a8006f0655d0 = function(form) {
    $563a0a6108185525$var$Internals.d.r(form);
};
$563a0a6108185525$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$563a0a6108185525$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $563a0a6108185525$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$563a0a6108185525$export$f7e8a0bf92324b1e = function() {
    return $563a0a6108185525$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$563a0a6108185525$export$83d89fbfd8236492 = "19.1.1";

});



var $2111e08a92d70add$exports = {};
'use strict';

$2111e08a92d70add$exports = (parcelRequire("jpaef"));




var $dNU7X = parcelRequire("dNU7X");
var $3d2450ff1707eb5a$exports = {};
'use strict';
function $3d2450ff1707eb5a$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($3d2450ff1707eb5a$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$3d2450ff1707eb5a$var$checkDCE();

$3d2450ff1707eb5a$exports = (parcelRequire("lnmxF"));





var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");
"use client";
const $f18ef7be44492bd1$export$a3579ca508007a95 = (0, $dNU7X.createContext)({});



var $dNU7X = parcelRequire("dNU7X");
"use client";
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $f3900207c0f36c9c$export$fe4300aa8eebea86(init) {
    const ref = (0, $dNU7X.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $dNU7X = parcelRequire("dNU7X");
const $dad1068478789ff3$export$4e09c449d6c407f7 = typeof window !== "undefined";


"use client";
const $294ba76ab9b08b31$export$700979bc83e7db82 = (0, $dad1068478789ff3$export$4e09c449d6c407f7) ? (0, $dNU7X.useLayoutEffect) : (0, $dNU7X.useEffect);




var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");
"use client";
/**
 * @public
 */ const $c4613d9a2b461869$export$f224e4635b6f8ce2 = /* @__PURE__ */ (0, $dNU7X.createContext)(null);




function $7954d01aff4b2ddf$export$a6cdc56e425d0d0a(value) {
    return typeof value === "object" && value !== null;
}


/**
 * Checks if an element is an HTML element in a way
 * that works across iframes
 */ function $79a29f44bb63ed43$export$1b3bfaa9684536aa(element) {
    return (0, $7954d01aff4b2ddf$export$a6cdc56e425d0d0a)(element) && "offsetHeight" in element;
}



var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");
"use client";
/**
 * @public
 */ const $3d6503ac3b793412$export$22a697fb29aac98d = (0, $dNU7X.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $dNU7X = parcelRequire("dNU7X");
/**
 * Taken from https://github.com/radix-ui/primitives/blob/main/packages/react/compose-refs/src/compose-refs.tsx
 */ /**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $532d3303a61becd3$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $532d3303a61becd3$var$composeRefs(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $532d3303a61becd3$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup === "function") hasCleanup = true;
            return cleanup;
        });
        // React <19 will log an error to the console if a callback ref returns a
        // value. We don't use ref cleanups internally so this will only happen if a
        // user's ref callback returns a value, which we only expect if they are
        // using the cleanup functionality added in React 19.
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup === "function") cleanup();
                else $532d3303a61becd3$var$setRef(refs[i], null);
            }
        };
    };
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $532d3303a61becd3$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return $dNU7X.useCallback($532d3303a61becd3$var$composeRefs(...refs), refs);
}


"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $ffadae27235316fc$var$PopChildMeasure extends $dNU7X.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const parent = element.offsetParent;
            const parentWidth = (0, $79a29f44bb63ed43$export$1b3bfaa9684536aa)(parent) ? parent.offsetWidth || 0 : 0;
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
            size.right = parentWidth - size.width - size.left;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $ffadae27235316fc$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent, anchorX: anchorX, root: root }) {
    const id = (0, $dNU7X.useId)();
    const ref = (0, $dNU7X.useRef)(null);
    const size = (0, $dNU7X.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0
    });
    const { nonce: nonce } = (0, $dNU7X.useContext)((0, $3d6503ac3b793412$export$22a697fb29aac98d));
    const composedRef = (0, $532d3303a61becd3$export$c7b2cbe3552a0d05)(ref, children?.ref);
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $dNU7X.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left, right: right } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        const x = anchorX === "left" ? `left: ${left}` : `right: ${right}`;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        const parent = root ?? document.head;
        parent.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            ${x}px !important;
            top: ${top}px !important;
          }
        `);
        return ()=>{
            if (parent.contains(style)) parent.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $2111e08a92d70add$exports.jsx)($ffadae27235316fc$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $dNU7X.cloneElement(children, {
            ref: composedRef
        })
    });
}


"use client";
const $43eb533642115c0a$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode, anchorX: anchorX, root: root })=>{
    const presenceChildren = (0, $f3900207c0f36c9c$export$fe4300aa8eebea86)($43eb533642115c0a$var$newChildrenMap);
    const id = (0, $dNU7X.useId)();
    let isReusedContext = true;
    let context = (0, $dNU7X.useMemo)(()=>{
        isReusedContext = false;
        return {
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        };
    }, [
        isPresent,
        presenceChildren,
        onExitComplete
    ]);
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ if (presenceAffectsLayout && isReusedContext) context = {
        ...context
    };
    (0, $dNU7X.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $dNU7X.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $2111e08a92d70add$exports.jsx)((0, $ffadae27235316fc$export$1d6cdde0c6816c6d), {
        isPresent: isPresent,
        anchorX: anchorX,
        root: root,
        children: children
    });
    return (0, $2111e08a92d70add$exports.jsx)((0, $c4613d9a2b461869$export$f224e4635b6f8ce2).Provider, {
        value: context,
        children: children
    });
};
function $43eb533642115c0a$var$newChildrenMap() {
    return new Map();
}



var $dNU7X = parcelRequire("dNU7X");

"use client";
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $e785341539d45a4b$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $dNU7X.useContext)((0, $c4613d9a2b461869$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $dNU7X.useId)();
    (0, $dNU7X.useEffect)(()=>{
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $dNU7X.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $e785341539d45a4b$export$8249053f690ea39a() {
    return $e785341539d45a4b$export$ee27c052bca048fb((0, $dNU7X.useContext)((0, $c4613d9a2b461869$export$f224e4635b6f8ce2)));
}
function $e785341539d45a4b$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}



var $dNU7X = parcelRequire("dNU7X");
const $393679a5611aba75$export$10e61aed958678dd = (child)=>child.key || "";
function $393679a5611aba75$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $dNU7X.Children).forEach(children, (child)=>{
        if ((0, $dNU7X.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}


"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $a685fed0b5e274f8$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync", propagate: propagate = false, anchorX: anchorX = "left", root: root })=>{
    const [isParentPresent, safeToRemove] = (0, $e785341539d45a4b$export$2a8c16d82a0a0e26)(propagate);
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $dNU7X.useMemo)(()=>(0, $393679a5611aba75$export$872a3a1281f4b357)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = propagate && !isParentPresent ? [] : presentChildren.map((0, $393679a5611aba75$export$10e61aed958678dd));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $dNU7X.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $dNU7X.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $f3900207c0f36c9c$export$fe4300aa8eebea86)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $dNU7X.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $dNU7X.useState)(presentChildren);
    (0, $294ba76ab9b08b31$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $393679a5611aba75$export$10e61aed958678dd)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $393679a5611aba75$export$10e61aed958678dd)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $393679a5611aba75$export$872a3a1281f4b357)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return null;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $dNU7X.useContext)((0, $f18ef7be44492bd1$export$a3579ca508007a95));
    return (0, $2111e08a92d70add$exports.jsx)((0, $2111e08a92d70add$exports.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $393679a5611aba75$export$10e61aed958678dd)(child);
            const isPresent = propagate && !isParentPresent ? false : presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender?.();
                    setRenderedChildren(pendingPresentChildren.current);
                    propagate && safeToRemove?.();
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $2111e08a92d70add$exports.jsx)((0, $43eb533642115c0a$export$979daf65881a382a), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                root: root,
                onExitComplete: isPresent ? undefined : onExit,
                anchorX: anchorX,
                children: child
            }, key);
        })
    });
};


var $dNU7X = parcelRequire("dNU7X");
const $ffce05c154280e28$var$radToDeg = (rad)=>rad * 180 / Math.PI;
const $ffce05c154280e28$var$rotate = (v)=>{
    const angle = $ffce05c154280e28$var$radToDeg(Math.atan2(v[1], v[0]));
    return $ffce05c154280e28$var$rebaseAngle(angle);
};
const $ffce05c154280e28$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate: $ffce05c154280e28$var$rotate,
    rotateZ: $ffce05c154280e28$var$rotate,
    skewX: (v)=>$ffce05c154280e28$var$radToDeg(Math.atan(v[1])),
    skewY: (v)=>$ffce05c154280e28$var$radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const $ffce05c154280e28$var$rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const $ffce05c154280e28$var$rotateZ = $ffce05c154280e28$var$rotate;
const $ffce05c154280e28$var$scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const $ffce05c154280e28$var$scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const $ffce05c154280e28$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $ffce05c154280e28$var$scaleX,
    scaleY: $ffce05c154280e28$var$scaleY,
    scale: (v)=>($ffce05c154280e28$var$scaleX(v) + $ffce05c154280e28$var$scaleY(v)) / 2,
    rotateX: (v)=>$ffce05c154280e28$var$rebaseAngle($ffce05c154280e28$var$radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>$ffce05c154280e28$var$rebaseAngle($ffce05c154280e28$var$radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ: $ffce05c154280e28$var$rotateZ,
    rotate: $ffce05c154280e28$var$rotateZ,
    skewX: (v)=>$ffce05c154280e28$var$radToDeg(Math.atan(v[4])),
    skewY: (v)=>$ffce05c154280e28$var$radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function $ffce05c154280e28$export$1f10c01143b9f089(name) {
    return name.includes("scale") ? 1 : 0;
}
function $ffce05c154280e28$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $ffce05c154280e28$export$1f10c01143b9f089(name);
    const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = $ffce05c154280e28$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
        parsers = $ffce05c154280e28$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $ffce05c154280e28$export$1f10c01143b9f089(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map($ffce05c154280e28$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const $ffce05c154280e28$export$bcd97e0e03ba17f6 = (instance, name)=>{
    const { transform: transform = "none" } = getComputedStyle(instance);
    return $ffce05c154280e28$export$f9111f9e16b73a26(transform, name);
};
function $ffce05c154280e28$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}

const $cb58381eaa053471$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $cb58381eaa053471$export$9de1236619d9e756 = /*@__PURE__*/ $cb58381eaa053471$var$checkStringStartsWith("--");
const $cb58381eaa053471$var$startsAsVariableToken = /*@__PURE__*/ $cb58381eaa053471$var$checkStringStartsWith("var(--");
const $cb58381eaa053471$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $cb58381eaa053471$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $cb58381eaa053471$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $cb58381eaa053471$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

/**
 * Generate a list of every possible transform key.
 */ const $76901b26fa5d5fe6$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $76901b26fa5d5fe6$export$7b42a0094fb00b6e = /*@__PURE__*/ (()=>new Set($76901b26fa5d5fe6$export$280dc01950909d86))();


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $d651b1e4da920e6b$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $d651b1e4da920e6b$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $d651b1e4da920e6b$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}


/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $3b971a33074d84fb$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};


function $cbff5fc74401a324$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $cbff5fc74401a324$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$cbff5fc74401a324$var$isIdentityScale(scale) || !$cbff5fc74401a324$var$isIdentityScale(scaleX) || !$cbff5fc74401a324$var$isIdentityScale(scaleY);
}
function $cbff5fc74401a324$export$a545127cf1fbb600(values) {
    return $cbff5fc74401a324$export$bdf30dca883ea463(values) || $cbff5fc74401a324$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $cbff5fc74401a324$export$bf80f5f8f4dc327f(values) {
    return $cbff5fc74401a324$var$is2DTranslate(values.x) || $cbff5fc74401a324$var$is2DTranslate(values.y);
}
function $cbff5fc74401a324$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $fa00eed79ea4bee6$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $fa00eed79ea4bee6$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $fa00eed79ea4bee6$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $fa00eed79ea4bee6$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $fa00eed79ea4bee6$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $fa00eed79ea4bee6$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $fa00eed79ea4bee6$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $fa00eed79ea4bee6$export$d80074982803af5c(box, { x: x, y: y }) {
    $fa00eed79ea4bee6$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $fa00eed79ea4bee6$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $fa00eed79ea4bee6$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $fa00eed79ea4bee6$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $fa00eed79ea4bee6$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $fa00eed79ea4bee6$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $fa00eed79ea4bee6$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $cbff5fc74401a324$export$a545127cf1fbb600)(node.latestValues)) $fa00eed79ea4bee6$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $fa00eed79ea4bee6$var$TREE_SCALE_SNAP_MAX && treeScale.x > $fa00eed79ea4bee6$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $fa00eed79ea4bee6$var$TREE_SCALE_SNAP_MAX && treeScale.y > $fa00eed79ea4bee6$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $fa00eed79ea4bee6$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $fa00eed79ea4bee6$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $fa00eed79ea4bee6$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $fa00eed79ea4bee6$export$58b16271041fbfb(box, transform) {
    $fa00eed79ea4bee6$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $fa00eed79ea4bee6$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $e3c6479a4e864f1b$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $d651b1e4da920e6b$export$d3955c6a8f65a36b)((0, $d651b1e4da920e6b$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $e3c6479a4e864f1b$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $e3c6479a4e864f1b$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $fa00eed79ea4bee6$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $fa00eed79ea4bee6$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}



const $5976c8ad8c36f7e6$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $76901b26fa5d5fe6$export$280dc01950909d86)
]);


/**
 * ValueType for "auto"
 */ const $734f22282ca6f438$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


const $aafb21eef928513a$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $537be50b9d5e4d5e$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $537be50b9d5e4d5e$export$58f0f39f63f3cf42 = {
    ...$537be50b9d5e4d5e$export$98e628dec113755e,
    transform: (v)=>(0, $aafb21eef928513a$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $537be50b9d5e4d5e$export$dcdf75081b88279d = {
    ...$537be50b9d5e4d5e$export$98e628dec113755e,
    default: 1
};


/*#__NO_SIDE_EFFECTS__*/ const $0e96f9492cc5e780$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $0e96f9492cc5e780$export$41fc368e1a942b97 = /*@__PURE__*/ $0e96f9492cc5e780$var$createUnitType("deg");
const $0e96f9492cc5e780$export$626336c2cd4b14de = /*@__PURE__*/ $0e96f9492cc5e780$var$createUnitType("%");
const $0e96f9492cc5e780$export$91c0eda1d06bf008 = /*@__PURE__*/ $0e96f9492cc5e780$var$createUnitType("px");
const $0e96f9492cc5e780$export$f91e8c45a95a32f2 = /*@__PURE__*/ $0e96f9492cc5e780$var$createUnitType("vh");
const $0e96f9492cc5e780$export$aed3d7b7d206c196 = /*@__PURE__*/ $0e96f9492cc5e780$var$createUnitType("vw");
const $0e96f9492cc5e780$export$44e2e1705876d7ed = /*@__PURE__*/ (()=>({
        ...$0e96f9492cc5e780$export$626336c2cd4b14de,
        parse: (v)=>$0e96f9492cc5e780$export$626336c2cd4b14de.parse(v) / 100,
        transform: (v)=>$0e96f9492cc5e780$export$626336c2cd4b14de.transform(v * 100)
    }))();


/**
 * Tests a provided value against a ValueType
 */ const $ce525ef09c228797$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * A list of value types commonly used for dimensions
 */ const $71aedec508f2c4ca$export$d176691c1998a1f5 = [
    (0, $537be50b9d5e4d5e$export$98e628dec113755e),
    (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    (0, $0e96f9492cc5e780$export$626336c2cd4b14de),
    (0, $0e96f9492cc5e780$export$41fc368e1a942b97),
    (0, $0e96f9492cc5e780$export$aed3d7b7d206c196),
    (0, $0e96f9492cc5e780$export$f91e8c45a95a32f2),
    (0, $734f22282ca6f438$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $71aedec508f2c4ca$export$eefdd52e3ccae428 = (v)=>$71aedec508f2c4ca$export$d176691c1998a1f5.find((0, $ce525ef09c228797$export$6eae4d0a6a7ca7cd)(v));



let $80ee25e76ad65aaa$export$491112666e282270 = ()=>{};
let $80ee25e76ad65aaa$export$f5708dca728d7177 = ()=>{};
var $80ee25e76ad65aaa$var$check, $80ee25e76ad65aaa$var$message, $80ee25e76ad65aaa$var$errorCode, $80ee25e76ad65aaa$var$check1, $80ee25e76ad65aaa$var$message1, $80ee25e76ad65aaa$var$errorCode1;

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $9ce1d76bd644ac7b$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);



/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $853c13d2c312cc33$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $853c13d2c312cc33$export$b9f0c1f373aee2b0(current) {
    const match = $853c13d2c312cc33$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 ?? token2}`,
        fallback
    ];
}
const $853c13d2c312cc33$var$maxDepth = 4;
function $853c13d2c312cc33$export$289398774300c991(current, element, depth = 1) {
    (0, $80ee25e76ad65aaa$export$f5708dca728d7177)(depth <= $853c13d2c312cc33$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
    const [token, fallback] = $853c13d2c312cc33$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $9ce1d76bd644ac7b$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $cb58381eaa053471$export$31f9caa2600b5723)(fallback) ? $853c13d2c312cc33$export$289398774300c991(fallback, element, depth + 1) : fallback;
}



function $95834331a4ac5b78$export$5a98a90409277f5a(keyframes) {
    for(let i = 1; i < keyframes.length; i++)keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
}






const $172405d9db2363b2$export$8e5250d1aa9bf370 = (v)=>v === (0, $537be50b9d5e4d5e$export$98e628dec113755e) || v === (0, $0e96f9492cc5e780$export$91c0eda1d06bf008);
const $172405d9db2363b2$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $172405d9db2363b2$var$nonTranslationalTransformKeys = (0, $76901b26fa5d5fe6$export$280dc01950909d86).filter((key)=>!$172405d9db2363b2$var$transformKeys.has(key));
function $172405d9db2363b2$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $172405d9db2363b2$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $172405d9db2363b2$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform: transform })=>(0, $ffce05c154280e28$export$f9111f9e16b73a26)(transform, "x"),
    y: (_bbox, { transform: transform })=>(0, $ffce05c154280e28$export$f9111f9e16b73a26)(transform, "y")
};
// Alias translate longform names
$172405d9db2363b2$export$781d46a8aa670d52.translateX = $172405d9db2363b2$export$781d46a8aa670d52.x;
$172405d9db2363b2$export$781d46a8aa670d52.translateY = $172405d9db2363b2$export$781d46a8aa670d52.y;


/*#__NO_SIDE_EFFECTS__*/ const $8627ddaf329d4de9$export$8793edee2d425525 = (any)=>any;


const $58b144feeed2312d$export$dd826089e3c5e502 = {};


const $40793c110400510b$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];


const $911834144665c26d$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};


function $f36be00d148c3149$export$b995e5e85f5c8289(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    let numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, $911834144665c26d$export$84ce9a476f53d110).value) (0, $911834144665c26d$export$84ce9a476f53d110).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $9537ba4c51d45100$var$maxElapsed = 40;
function $9537ba4c51d45100$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, $40793c110400510b$export$71ecace0a033b35a).reduce((acc, key)=>{
        acc[key] = (0, $f36be00d148c3149$export$b995e5e85f5c8289)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    const { setup: setup, read: read, resolveKeyframes: resolveKeyframes, preUpdate: preUpdate, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $58b144feeed2312d$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!(0, $58b144feeed2312d$export$dd826089e3c5e502).useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $9537ba4c51d45100$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, $40793c110400510b$export$71ecace0a033b35a).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, $40793c110400510b$export$71ecace0a033b35a).length; i++)steps[(0, $40793c110400510b$export$71ecace0a033b35a)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $d1447ba151973c89$export$2cef06c20297c17d, cancel: $d1447ba151973c89$export$ec99c0ef4978dccb, state: $d1447ba151973c89$export$fff89137e9e818ce, steps: $d1447ba151973c89$export$1811c3a7e3af92f0 } = /* @__PURE__ */ (0, $9537ba4c51d45100$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $8627ddaf329d4de9$export$8793edee2d425525), true);


const $5893df20395e66d3$var$toResolve = new Set();
let $5893df20395e66d3$var$isScheduled = false;
let $5893df20395e66d3$var$anyNeedsMeasurement = false;
let $5893df20395e66d3$var$isForced = false;
function $5893df20395e66d3$var$measureAllKeyframes() {
    if ($5893df20395e66d3$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($5893df20395e66d3$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $172405d9db2363b2$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                element.getValue(key)?.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $5893df20395e66d3$var$anyNeedsMeasurement = false;
    $5893df20395e66d3$var$isScheduled = false;
    $5893df20395e66d3$var$toResolve.forEach((resolver)=>resolver.complete($5893df20395e66d3$var$isForced));
    $5893df20395e66d3$var$toResolve.clear();
}
function $5893df20395e66d3$var$readAllKeyframes() {
    $5893df20395e66d3$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $5893df20395e66d3$var$anyNeedsMeasurement = true;
    });
}
function $5893df20395e66d3$export$78b96d2a12593b05() {
    $5893df20395e66d3$var$isForced = true;
    $5893df20395e66d3$var$readAllKeyframes();
    $5893df20395e66d3$var$measureAllKeyframes();
    $5893df20395e66d3$var$isForced = false;
}
class $5893df20395e66d3$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.state = "scheduled";
        if (this.isAsync) {
            $5893df20395e66d3$var$toResolve.add(this);
            if (!$5893df20395e66d3$var$isScheduled) {
                $5893df20395e66d3$var$isScheduled = true;
                (0, $d1447ba151973c89$export$2cef06c20297c17d).read($5893df20395e66d3$var$readAllKeyframes);
                (0, $d1447ba151973c89$export$2cef06c20297c17d).resolveKeyframes($5893df20395e66d3$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        // If initial keyframe is null we need to read it from the DOM
        if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue?.get();
            // TODO: This doesn't work if the final keyframe is a wildcard
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
            else if (element && name) {
                const valueAsRead = element.readValue(name, finalKeyframe);
                if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
            }
            if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
            if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
        }
        (0, $95834331a4ac5b78$export$5a98a90409277f5a)(unresolvedKeyframes);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(isForcedComplete = false) {
        this.state = "complete";
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
        $5893df20395e66d3$var$toResolve.delete(this);
    }
    cancel() {
        if (this.state === "scheduled") {
            $5893df20395e66d3$var$toResolve.delete(this);
            this.state = "pending";
        }
    }
    resume() {
        if (this.state === "pending") this.scheduleResolve();
    }
}


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $7785621dd47c1599$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $24ded9a41c9a3d49$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $7785621dd47c1599$export$ade84c85e44a6cb1)(value);
    else return true;
}




// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $319e45483c659837$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $a7737c620d342bbd$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $3ca7671078c198f1$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $f49be501251a7391$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $e6d26254b0c2a89d$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $f49be501251a7391$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $3ca7671078c198f1$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $e6d26254b0c2a89d$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $a7737c620d342bbd$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $b35f0704081fa00b$var$clampRgbUnit = (v)=>(0, $aafb21eef928513a$export$7d15b64cf5a3a4c4)(0, 255, v);
const $b35f0704081fa00b$export$7a99c86b5b1f4c9e = {
    ...(0, $537be50b9d5e4d5e$export$98e628dec113755e),
    transform: (v)=>Math.round($b35f0704081fa00b$var$clampRgbUnit(v))
};
const $b35f0704081fa00b$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $e6d26254b0c2a89d$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $e6d26254b0c2a89d$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $b35f0704081fa00b$export$7a99c86b5b1f4c9e.transform(red) + ", " + $b35f0704081fa00b$export$7a99c86b5b1f4c9e.transform(green) + ", " + $b35f0704081fa00b$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $319e45483c659837$export$83d2e9e3e4ee39ed)((0, $537be50b9d5e4d5e$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $2347a98eddfdb8cd$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $2347a98eddfdb8cd$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $e6d26254b0c2a89d$export$2c8400d58aca05e)("#"),
    parse: $2347a98eddfdb8cd$var$parseHex,
    transform: (0, $b35f0704081fa00b$export$4e46ac54fc82cf3b).transform
};






const $391fa0f1ffdc0f8d$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $e6d26254b0c2a89d$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $e6d26254b0c2a89d$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $0e96f9492cc5e780$export$626336c2cd4b14de).transform((0, $319e45483c659837$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $0e96f9492cc5e780$export$626336c2cd4b14de).transform((0, $319e45483c659837$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $319e45483c659837$export$83d2e9e3e4ee39ed)((0, $537be50b9d5e4d5e$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $f65424d413933229$export$35e9368ef982300f = {
    test: (v)=>(0, $b35f0704081fa00b$export$4e46ac54fc82cf3b).test(v) || (0, $2347a98eddfdb8cd$export$834dfc94dde4b3d8).test(v) || (0, $391fa0f1ffdc0f8d$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $b35f0704081fa00b$export$4e46ac54fc82cf3b).test(v)) return (0, $b35f0704081fa00b$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $391fa0f1ffdc0f8d$export$810b04175080204c).test(v)) return (0, $391fa0f1ffdc0f8d$export$810b04175080204c).parse(v);
        else return (0, $2347a98eddfdb8cd$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $b35f0704081fa00b$export$4e46ac54fc82cf3b).transform(v) : (0, $391fa0f1ffdc0f8d$export$810b04175080204c).transform(v);
    },
    getAnimatableNone: (v)=>{
        const parsed = $f65424d413933229$export$35e9368ef982300f.parse(v);
        parsed.alpha = 0;
        return $f65424d413933229$export$35e9368ef982300f.transform(parsed);
    }
};


const $2085000a26bee501$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $7d7af56b5778707d$var$test(v) {
    return isNaN(v) && typeof v === "string" && (v.match((0, $a7737c620d342bbd$export$2444ca58c08448e4))?.length || 0) + (v.match((0, $2085000a26bee501$export$740b69c5fad25dba))?.length || 0) > 0;
}
const $7d7af56b5778707d$var$NUMBER_TOKEN = "number";
const $7d7af56b5778707d$var$COLOR_TOKEN = "color";
const $7d7af56b5778707d$var$VAR_TOKEN = "var";
const $7d7af56b5778707d$var$VAR_FUNCTION_TOKEN = "var(";
const $7d7af56b5778707d$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $7d7af56b5778707d$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $7d7af56b5778707d$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($7d7af56b5778707d$var$complexRegex, (parsedValue)=>{
        if ((0, $f65424d413933229$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($7d7af56b5778707d$var$COLOR_TOKEN);
            values.push((0, $f65424d413933229$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($7d7af56b5778707d$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($7d7af56b5778707d$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($7d7af56b5778707d$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $7d7af56b5778707d$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($7d7af56b5778707d$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $7d7af56b5778707d$var$parseComplexValue(v) {
    return $7d7af56b5778707d$export$b61fc7c44bf646d5(v).values;
}
function $7d7af56b5778707d$var$createTransformer(source) {
    const { split: split, types: types } = $7d7af56b5778707d$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $7d7af56b5778707d$var$NUMBER_TOKEN) output += (0, $319e45483c659837$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $7d7af56b5778707d$var$COLOR_TOKEN) output += (0, $f65424d413933229$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $7d7af56b5778707d$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : (0, $f65424d413933229$export$35e9368ef982300f).test(v) ? (0, $f65424d413933229$export$35e9368ef982300f).getAnimatableNone(v) : v;
function $7d7af56b5778707d$var$getAnimatableNone(v) {
    const parsed = $7d7af56b5778707d$var$parseComplexValue(v);
    const transformer = $7d7af56b5778707d$var$createTransformer(v);
    return transformer(parsed.map($7d7af56b5778707d$var$convertNumbersToZero));
}
const $7d7af56b5778707d$export$83a0e34f1302825b = {
    test: $7d7af56b5778707d$var$test,
    parse: $7d7af56b5778707d$var$parseComplexValue,
    createTransformer: $7d7af56b5778707d$var$createTransformer,
    getAnimatableNone: $7d7af56b5778707d$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $990db8d961337d87$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $990db8d961337d87$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $a7737c620d342bbd$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $990db8d961337d87$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $990db8d961337d87$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $990db8d961337d87$export$3dea766d36a8935f = {
    ...(0, $7d7af56b5778707d$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($990db8d961337d87$var$functionRegex);
        return functions ? functions.map($990db8d961337d87$var$applyDefaultFilter).join(" ") : v;
    }
};





const $4325d04a0a7f6543$export$7d260a2a5f8bc19e = {
    ...(0, $537be50b9d5e4d5e$export$98e628dec113755e),
    transform: Math.round
};






const $5d0eb08997874bc4$export$f2e4285fee37e26 = {
    rotate: (0, $0e96f9492cc5e780$export$41fc368e1a942b97),
    rotateX: (0, $0e96f9492cc5e780$export$41fc368e1a942b97),
    rotateY: (0, $0e96f9492cc5e780$export$41fc368e1a942b97),
    rotateZ: (0, $0e96f9492cc5e780$export$41fc368e1a942b97),
    scale: $537be50b9d5e4d5e$export$dcdf75081b88279d,
    scaleX: (0, $537be50b9d5e4d5e$export$dcdf75081b88279d),
    scaleY: (0, $537be50b9d5e4d5e$export$dcdf75081b88279d),
    scaleZ: (0, $537be50b9d5e4d5e$export$dcdf75081b88279d),
    skew: (0, $0e96f9492cc5e780$export$41fc368e1a942b97),
    skewX: (0, $0e96f9492cc5e780$export$41fc368e1a942b97),
    skewY: (0, $0e96f9492cc5e780$export$41fc368e1a942b97),
    distance: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    translateX: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    translateY: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    translateZ: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    x: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    y: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    z: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    perspective: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    transformPerspective: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    opacity: (0, $537be50b9d5e4d5e$export$58f0f39f63f3cf42),
    originX: (0, $0e96f9492cc5e780$export$44e2e1705876d7ed),
    originY: (0, $0e96f9492cc5e780$export$44e2e1705876d7ed),
    originZ: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008)
};


const $dec0b9f9c1310c3a$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    borderTopWidth: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    borderRightWidth: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    borderRadius: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    radius: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    maxWidth: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    height: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    maxHeight: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    top: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    right: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    bottom: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    left: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    paddingTop: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    paddingRight: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    paddingBottom: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    paddingLeft: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    margin: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    marginTop: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    marginRight: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    marginBottom: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    marginLeft: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $0e96f9492cc5e780$export$91c0eda1d06bf008),
    ...(0, $5d0eb08997874bc4$export$f2e4285fee37e26),
    zIndex: (0, $4325d04a0a7f6543$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $537be50b9d5e4d5e$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $537be50b9d5e4d5e$export$58f0f39f63f3cf42),
    numOctaves: (0, $4325d04a0a7f6543$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $5e10b287bbabbcae$export$98cd7c72c5a731fb = {
    ...(0, $dec0b9f9c1310c3a$export$eec14432cd1cb67b),
    color: // Color props
    $f65424d413933229$export$35e9368ef982300f,
    backgroundColor: (0, $f65424d413933229$export$35e9368ef982300f),
    outlineColor: (0, $f65424d413933229$export$35e9368ef982300f),
    fill: (0, $f65424d413933229$export$35e9368ef982300f),
    stroke: (0, $f65424d413933229$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $f65424d413933229$export$35e9368ef982300f),
    borderTopColor: (0, $f65424d413933229$export$35e9368ef982300f),
    borderRightColor: (0, $f65424d413933229$export$35e9368ef982300f),
    borderBottomColor: (0, $f65424d413933229$export$35e9368ef982300f),
    borderLeftColor: (0, $f65424d413933229$export$35e9368ef982300f),
    filter: $990db8d961337d87$export$3dea766d36a8935f,
    WebkitFilter: (0, $990db8d961337d87$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $5e10b287bbabbcae$export$67d1babe0338d23b = (key)=>$5e10b287bbabbcae$export$98cd7c72c5a731fb[key];


function $469413a6e970aec8$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $5e10b287bbabbcae$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $990db8d961337d87$export$3dea766d36a8935f)) defaultValueType = (0, $7d7af56b5778707d$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $174434e5df1a07d0$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $174434e5df1a07d0$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$174434e5df1a07d0$var$invalidTemplates.has(keyframe) && (0, $7d7af56b5778707d$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $469413a6e970aec8$export$cea0cedcb94873b5)(name, animatableTemplate);
}



class $c50b5d932cc1df71$export$4983792d11b61017 extends (0, $5893df20395e66d3$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $cb58381eaa053471$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $853c13d2c312cc33$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $5976c8ad8c36f7e6$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $71aedec508f2c4ca$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $71aedec508f2c4ca$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $172405d9db2363b2$export$8e5250d1aa9bf370)(originType) && (0, $172405d9db2363b2$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else if ((0, $172405d9db2363b2$export$781d46a8aa670d52)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $24ded9a41c9a3d49$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $174434e5df1a07d0$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $172405d9db2363b2$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $172405d9db2363b2$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if (this.removedTransforms?.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}

const $79da92e230ca0803$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);






/**
 * A list of all ValueTypes
 */ const $02ef4f2e49d5353e$var$valueTypes = [
    ...(0, $71aedec508f2c4ca$export$d176691c1998a1f5),
    (0, $f65424d413933229$export$35e9368ef982300f),
    (0, $7d7af56b5778707d$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $02ef4f2e49d5353e$export$950e7e59ea1ffed7 = (v)=>$02ef4f2e49d5353e$var$valueTypes.find((0, $ce525ef09c228797$export$6eae4d0a6a7ca7cd)(v));


const { schedule: $7e3455ea5039691b$export$bb76eed83315504c, cancel: $7e3455ea5039691b$export$3252729004b8456e } = /* @__PURE__ */ (0, $9537ba4c51d45100$export$510b0596a933801a)(queueMicrotask, false);

function $653b9df1170831fe$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $653b9df1170831fe$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $653b9df1170831fe$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $eb440515b4613129$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $653b9df1170831fe$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $653b9df1170831fe$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $6779748396cb3e46$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}




let $1ca16a2cd98ee355$var$now;
function $1ca16a2cd98ee355$var$clearTime() {
    $1ca16a2cd98ee355$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $1ca16a2cd98ee355$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($1ca16a2cd98ee355$var$now === undefined) $1ca16a2cd98ee355$export$2da9be4cfdb689b1.set((0, $d1447ba151973c89$export$fff89137e9e818ce).isProcessing || (0, $58b144feeed2312d$export$dd826089e3c5e502).useManualTiming ? (0, $d1447ba151973c89$export$fff89137e9e818ce).timestamp : performance.now());
        return $1ca16a2cd98ee355$var$now;
    },
    set: (newTime)=>{
        $1ca16a2cd98ee355$var$now = newTime;
        queueMicrotask($1ca16a2cd98ee355$var$clearTime);
    }
};



/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $158c82181da7b3e7$var$MAX_VELOCITY_DELTA = 30;
const $158c82181da7b3e7$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $158c82181da7b3e7$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $158c82181da7b3e7$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v)=>{
            const currentTime = (0, $1ca16a2cd98ee355$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev) {
                this.events.change?.notify(this.current);
                if (this.dependents) for (const dependent of this.dependents)dependent.dirty();
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $1ca16a2cd98ee355$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $158c82181da7b3e7$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $eb440515b4613129$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $d1447ba151973c89$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v) {
        if (!this.passiveEffect) this.updateAndNotify(v);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    dirty() {
        this.events.change?.notify(this.current);
    }
    addDependent(dependent) {
        if (!this.dependents) this.dependents = new Set();
        this.dependents.add(dependent);
    }
    removeDependent(dependent) {
        if (this.dependents) this.dependents.delete(dependent);
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($158c82181da7b3e7$export$67fcd818a264039d.current) $158c82181da7b3e7$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $1ca16a2cd98ee355$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $158c82181da7b3e7$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $158c82181da7b3e7$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $6779748396cb3e46$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.dependents?.clear();
        this.events.destroy?.notify();
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $158c82181da7b3e7$export$ce8bdc721e76545f(init, options) {
    return new $158c82181da7b3e7$export$8cea36d14ee64562(init, options);
}



const $11a1928e58371a59$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $11a1928e58371a59$export$65570e08d843624d = {};
for(const key in $11a1928e58371a59$var$featureProps)$11a1928e58371a59$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$11a1928e58371a59$var$featureProps[key].some((name)=>!!props[name])
};


const $5896390693a21a91$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $5896390693a21a91$export$3d227df54007d73a = ()=>({
        x: $5896390693a21a91$export$ff25708b37f72782(),
        y: $5896390693a21a91$export$ff25708b37f72782()
    });
const $5896390693a21a91$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $5896390693a21a91$export$6459fc9e86be362e = ()=>({
        x: $5896390693a21a91$export$6db76765312617ac(),
        y: $5896390693a21a91$export$6db76765312617ac()
    });



// Does this device prefer reduced motion? Returns `null` server-side.
const $43d8fe695ba0f568$export$ff7706047246b98b = {
    current: null
};
const $43d8fe695ba0f568$export$6476d16e2fd2d0db = {
    current: false
};


function $e409256cb1664625$export$ca9f41fb23dded3d() {
    (0, $43d8fe695ba0f568$export$6476d16e2fd2d0db).current = true;
    if (!(0, $dad1068478789ff3$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $43d8fe695ba0f568$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $43d8fe695ba0f568$export$ff7706047246b98b).current = false;
}



const $b6ca70c97d02d458$export$bc2a978a17abfdde = new WeakMap();


function $e7a49398a967dd85$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}


/**
 * Decides if the supplied variable is variant label
 */ function $ca0f8c6df749e90b$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


const $80c62fcd2eb50351$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $80c62fcd2eb50351$export$1405a65085f40b9 = [
    "initial",
    ...$80c62fcd2eb50351$export$16e45afcc206d3a8
];


function $ac8636e0b8252682$export$4b3c3bd8d910d78d(props) {
    return (0, $e7a49398a967dd85$export$aa71198ceeaf53ce)(props.animate) || (0, $80c62fcd2eb50351$export$1405a65085f40b9).some((name)=>(0, $ca0f8c6df749e90b$export$720b90e312cea233)(props[name]));
}
function $ac8636e0b8252682$export$ce46fa4165cdec40(props) {
    return Boolean($ac8636e0b8252682$export$4b3c3bd8d910d78d(props) || props.variants);
}



function $9bdfdaa98ee49c73$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $79da92e230ca0803$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $79da92e230ca0803$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $158c82181da7b3e7$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $158c82181da7b3e7$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}


function $e4d50330964e9dfb$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement?.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $e4d50330964e9dfb$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $e4d50330964e9dfb$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $e4d50330964e9dfb$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


const $0c333d728745b9b7$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $0c333d728745b9b7$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $5893df20395e66d3$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $1ca16a2cd98ee355$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $d1447ba151973c89$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $ac8636e0b8252682$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $ac8636e0b8252682$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $79da92e230ca0803$export$605d60a2578142d3)(value)) value.set(latestValues[key]);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $b6ca70c97d02d458$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $43d8fe695ba0f568$export$6476d16e2fd2d0db).current) (0, $e409256cb1664625$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $43d8fe695ba0f568$export$ff7706047246b98b).current;
        this.parent?.addChild(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, $d1447ba151973c89$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $d1447ba151973c89$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent?.removeChild(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    addChild(child) {
        this.children.add(child);
        this.enteringChildren ?? (this.enteringChildren = new Set());
        this.enteringChildren.add(child);
    }
    removeChild(child) {
        this.children.delete(child);
        this.enteringChildren && this.enteringChildren.delete(child);
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $76901b26fa5d5fe6$export$7b42a0094fb00b6e).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $d1447ba151973c89$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
            this.scheduleRender();
        });
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $11a1928e58371a59$export$65570e08d843624d){
            const featureDefinition = (0, $11a1928e58371a59$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $5896390693a21a91$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $0c333d728745b9b7$var$propEventHandlers.length; i++){
            const key = $0c333d728745b9b7$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $9bdfdaa98ee49c73$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $158c82181da7b3e7$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.getBaseTargetFromProps(this.props, key) ?? this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $9ce1d76bd644ac7b$export$65583ed5a868f2d9)(value) || (0, $7785621dd47c1599$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $02ef4f2e49d5353e$export$950e7e59ea1ffed7)(value) && (0, $7d7af56b5778707d$export$83a0e34f1302825b).test(target)) value = (0, $469413a6e970aec8$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $79da92e230ca0803$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $79da92e230ca0803$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $e4d50330964e9dfb$export$d68f140c4d9b48bc)(this.props, initial, this.presenceContext?.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $79da92e230ca0803$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $eb440515b4613129$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    scheduleRenderMicrotask() {
        (0, $7e3455ea5039691b$export$bb76eed83315504c).render(this.render);
    }
}


class $f63c4d1541eda581$export$e49735c2a366bdc7 extends (0, $0c333d728745b9b7$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $c50b5d932cc1df71$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $79da92e230ca0803$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}


/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $3419e8a249cad0e1$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



const $d4fbd88cc8bd14ae$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $d4fbd88cc8bd14ae$var$numTransforms = (0, $76901b26fa5d5fe6$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $d4fbd88cc8bd14ae$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $d4fbd88cc8bd14ae$var$numTransforms; i++){
        const key = (0, $76901b26fa5d5fe6$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $3419e8a249cad0e1$export$453ef540a9a1bd6b)(value, (0, $dec0b9f9c1310c3a$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $d4fbd88cc8bd14ae$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}


function $0e894a915a937550$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $76901b26fa5d5fe6$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $cb58381eaa053471$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $3419e8a249cad0e1$export$453ef540a9a1bd6b)(value, (0, $dec0b9f9c1310c3a$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $d4fbd88cc8bd14ae$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


function $1630cdb0e18b80ec$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    const elementStyle = element.style;
    let key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection?.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}





const $067884b677a42124$export$91ddd985b97788d1 = {};
function $067884b677a42124$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $067884b677a42124$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $cb58381eaa053471$export$9de1236619d9e756)(key)) $067884b677a42124$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}


function $75ec738e0b9a677c$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $76901b26fa5d5fe6$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $067884b677a42124$export$91ddd985b97788d1)[key] || key === "opacity");
}


function $85f5284540c3920e$export$16da615486abaa45(props, prevProps, visualElement) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $79da92e230ca0803$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $79da92e230ca0803$export$605d60a2578142d3)(prevProps.style[key]) || (0, $75ec738e0b9a677c$export$6d27ce8e3de1c3cf)(key, props) || visualElement?.getValue(key)?.liveStyle !== undefined) newValues[key] = style[key];
    return newValues;
}


function $e7012b03ad324f2a$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $e7012b03ad324f2a$export$23fea75b03ac16b3 extends (0, $f63c4d1541eda581$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $1630cdb0e18b80ec$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $76901b26fa5d5fe6$export$7b42a0094fb00b6e).has(key)) return this.projection?.isProjecting ? (0, $ffce05c154280e28$export$1f10c01143b9f089)(key) : (0, $ffce05c154280e28$export$bcd97e0e03ba17f6)(instance, key);
        else {
            const computedStyle = $e7012b03ad324f2a$export$3735103072e4a80(instance);
            const value = ((0, $cb58381eaa053471$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $e3c6479a4e864f1b$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $0e894a915a937550$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $85f5284540c3920e$export$16da615486abaa45)(props, prevProps, visualElement);
    }
}





/**
 * Convert camelCase to dash-case properties.
 */ const $0f114a66a15173b1$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();




const $e956bd2c777864d5$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $e956bd2c777864d5$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $e956bd2c777864d5$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $e956bd2c777864d5$var$dashKeys : $e956bd2c777864d5$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $0e96f9492cc5e780$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $0e96f9492cc5e780$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $0e96f9492cc5e780$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attributes, like cx and style.transform
 */ function $35df77f2c0de9a92$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate, styleProp) {
    (0, $0e894a915a937550$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style } = state;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        style.transformOrigin = attrs.transformOrigin ?? "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = styleProp?.transformBox ?? "fill-box";
        delete attrs.transformBox;
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $e956bd2c777864d5$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $14db436db6a2825b$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


const $4ef9b8c38cf7f229$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";





function $01c6945f76b75740$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $1630cdb0e18b80ec$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $14db436db6a2825b$export$28931db5d57958e5).has(key) ? (0, $0f114a66a15173b1$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}




function $04aee5ae9607f26f$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $85f5284540c3920e$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $79da92e230ca0803$export$605d60a2578142d3)(props[key]) || (0, $79da92e230ca0803$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $76901b26fa5d5fe6$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}


class $6bff6456522de76f$export$86bcdffbaf733d84 extends (0, $f63c4d1541eda581$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $5896390693a21a91$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $76901b26fa5d5fe6$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $5e10b287bbabbcae$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $14db436db6a2825b$export$28931db5d57958e5).has(key) ? (0, $0f114a66a15173b1$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $04aee5ae9607f26f$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $35df77f2c0de9a92$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $01c6945f76b75740$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $4ef9b8c38cf7f229$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $728d8fc1aaa5e410$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $a4ff4b2c9835eed9$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $728d8fc1aaa5e410$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}


const $b7bceff059e333d0$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $a4ff4b2c9835eed9$export$88f3fc2fd3766989)(Component) ? new (0, $6bff6456522de76f$export$86bcdffbaf733d84)(options) : new (0, $e7012b03ad324f2a$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $dNU7X.Fragment)
    });
};






var $dNU7X = parcelRequire("dNU7X");


var $dNU7X = parcelRequire("dNU7X");
"use client";
const $bceeea8eabf147a7$export$40f10139ecf1f171 = (0, $dNU7X.createContext)({
    strict: false
});




var $dNU7X = parcelRequire("dNU7X");
"use client";
const $6d760815973a6180$export$2285bbca2c666415 = /* @__PURE__ */ (0, $dNU7X.createContext)({});



var $dNU7X = parcelRequire("dNU7X");



function $028eed08bc1780ce$export$12fc32fc096a04a3(props, context) {
    if ((0, $ac8636e0b8252682$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $ca0f8c6df749e90b$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $ca0f8c6df749e90b$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


"use client";
function $ec3e80d50780adb6$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $028eed08bc1780ce$export$12fc32fc096a04a3)(props, (0, $dNU7X.useContext)((0, $6d760815973a6180$export$2285bbca2c666415)));
    return (0, $dNU7X.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $ec3e80d50780adb6$var$variantLabelsAsDependency(initial),
        $ec3e80d50780adb6$var$variantLabelsAsDependency(animate)
    ]);
}
function $ec3e80d50780adb6$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}




var $dNU7X = parcelRequire("dNU7X");


var $dNU7X = parcelRequire("dNU7X");


const $31980b31c72f903f$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


"use client";
function $285b4e6b9d45a4b0$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $79da92e230ca0803$export$605d60a2578142d3)(source[key]) && !(0, $75ec738e0b9a677c$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $285b4e6b9d45a4b0$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $dNU7X.useMemo)(()=>{
        const state = (0, $31980b31c72f903f$export$8940b483cf52eeda)();
        (0, $0e894a915a937550$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $285b4e6b9d45a4b0$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $285b4e6b9d45a4b0$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $285b4e6b9d45a4b0$var$useInitialMotionValues(props, visualState));
    return style;
}
function $285b4e6b9d45a4b0$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $285b4e6b9d45a4b0$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}



var $dNU7X = parcelRequire("dNU7X");



const $158d062d91892bc4$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $31980b31c72f903f$export$8940b483cf52eeda)(),
        attrs: {}
    });



"use client";
function $75f1498eae7af762$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $dNU7X.useMemo)(()=>{
        const state = (0, $158d062d91892bc4$export$41be8b43e1c4d4f9)();
        (0, $35df77f2c0de9a92$export$5475d24f125d7053)(state, visualState, (0, $4ef9b8c38cf7f229$export$6328ce7565ea1049)(Component), props.transformTemplate, props.style);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $285b4e6b9d45a4b0$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $a16007375bdc9c81$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $a16007375bdc9c81$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $a16007375bdc9c81$var$validMotionProps.has(key);
}


let $07d4bae53d29ab9c$var$shouldForward = (key)=>!(0, $a16007375bdc9c81$export$2f9c46555243bf04)(key);
function $07d4bae53d29ab9c$export$59d6962c470509a5(isValidProp) {
    if (typeof isValidProp !== "function") return;
    // Explicitly filter our events
    $07d4bae53d29ab9c$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $a16007375bdc9c81$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $07d4bae53d29ab9c$export$59d6962c470509a5($07d4bae53d29ab9c$import$c13ab922a8265d09$2e2bcd8739ae039);
} catch  {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $07d4bae53d29ab9c$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($07d4bae53d29ab9c$var$shouldForward(key) || forwardMotionProps === true && (0, $a16007375bdc9c81$export$2f9c46555243bf04)(key) || !isDom && !(0, $a16007375bdc9c81$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}



"use client";
function $d4b678fa83abd483$export$e25bb1e5b53cbdff(Component, props, ref, { latestValues: latestValues }, isStatic, forwardMotionProps = false) {
    const useVisualProps = (0, $a4ff4b2c9835eed9$export$88f3fc2fd3766989)(Component) ? (0, $75f1498eae7af762$export$84309c4f53cb1bd5) : (0, $285b4e6b9d45a4b0$export$57be0a314572d87d);
    const visualProps = useVisualProps(props, latestValues, isStatic, Component);
    const filteredProps = (0, $07d4bae53d29ab9c$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
    const elementProps = Component !== (0, $dNU7X.Fragment) ? {
        ...filteredProps,
        ...visualProps,
        ref: ref
    } : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */ const { children: children } = props;
    const renderedChildren = (0, $dNU7X.useMemo)(()=>(0, $79da92e230ca0803$export$605d60a2578142d3)(children) ? children.get() : children, [
        children
    ]);
    return (0, $dNU7X.createElement)(Component, {
        ...elementProps,
        children: renderedChildren
    });
}




var $dNU7X = parcelRequire("dNU7X");







/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $5bda3a3458e4e1d8$export$fcc2206ecb6d74b(value) {
    return (0, $79da92e230ca0803$export$605d60a2578142d3)(value) ? value.get() : value;
}


"use client";
function $a7876dda059c3a6e$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState }, props, context, presenceContext) {
    const state = {
        latestValues: $a7876dda059c3a6e$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    return state;
}
function $a7876dda059c3a6e$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $5bda3a3458e4e1d8$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $ac8636e0b8252682$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $ac8636e0b8252682$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $e7a49398a967dd85$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $e4d50330964e9dfb$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}
const $a7876dda059c3a6e$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $dNU7X.useContext)((0, $6d760815973a6180$export$2285bbca2c666415));
        const presenceContext = (0, $dNU7X.useContext)((0, $c4613d9a2b461869$export$f224e4635b6f8ce2));
        const make = ()=>$a7876dda059c3a6e$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $f3900207c0f36c9c$export$fe4300aa8eebea86)(make);
    };




"use client";
const $ae611974504e6247$export$851cf1f78cb3feac = /*@__PURE__*/ (0, $a7876dda059c3a6e$export$e91e107bc6d03a8e)({
    scrapeMotionValuesFromProps: $85f5284540c3920e$export$16da615486abaa45,
    createRenderState: (0, $31980b31c72f903f$export$8940b483cf52eeda)
});





"use client";
const $b3c477f34555a2d6$export$9922240e40b88c48 = /*@__PURE__*/ (0, $a7876dda059c3a6e$export$e91e107bc6d03a8e)({
    scrapeMotionValuesFromProps: (0, $04aee5ae9607f26f$export$16da615486abaa45),
    createRenderState: (0, $158d062d91892bc4$export$41be8b43e1c4d4f9)
});





function $b0a649ba5c72f682$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $11a1928e58371a59$export$65570e08d843624d)[key] = {
        ...(0, $11a1928e58371a59$export$65570e08d843624d)[key],
        ...features[key]
    };
}


const $cf3c10373fc4be8e$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");



var $dNU7X = parcelRequire("dNU7X");
function $47fdaa874812c1f9$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


"use client";
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $2e67adbe06d585bc$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $dNU7X.useCallback)((instance)=>{
        if (instance) visualState.onMount && visualState.onMount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $47fdaa874812c1f9$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Include externalRef in dependencies to ensure the callback updates
     * when the ref changes, allowing proper ref forwarding.
     */ [
        visualElement
    ]);
}



var $dNU7X = parcelRequire("dNU7X");

const $73707bc84e6b6a17$export$ed7b8fa9dbf0105d = "framerAppearId";
const $73707bc84e6b6a17$export$8592e1c077c890a6 = "data-" + (0, $0f114a66a15173b1$export$9fd24a634729c672)($73707bc84e6b6a17$export$ed7b8fa9dbf0105d);







var $dNU7X = parcelRequire("dNU7X");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $ecec3af7ca46deba$export$da5f7b802957459a = (0, $dNU7X.createContext)({});




"use client";
function $e0bdec89ac95ba83$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    const { visualElement: parent } = (0, $dNU7X.useContext)((0, $6d760815973a6180$export$2285bbca2c666415));
    const lazyContext = (0, $dNU7X.useContext)((0, $bceeea8eabf147a7$export$40f10139ecf1f171));
    const presenceContext = (0, $dNU7X.useContext)((0, $c4613d9a2b461869$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $dNU7X.useContext)((0, $3d6503ac3b793412$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $dNU7X.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $dNU7X.useContext)((0, $ecec3af7ca46deba$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $e0bdec89ac95ba83$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $dNU7X.useRef)(false);
    (0, $dNU7X.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $73707bc84e6b6a17$export$8592e1c077c890a6];
    const wantsHandoff = (0, $dNU7X.useRef)(Boolean(optimisedAppearId) && !window.MotionHandoffIsComplete?.(optimisedAppearId) && window.MotionHasOptimisedAnimation?.(optimisedAppearId));
    (0, $294ba76ab9b08b31$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        visualElement.scheduleRenderMicrotask();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $dNU7X.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                window.MotionHandoffMarkAsComplete?.(optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
        /**
         * Now we've finished triggering animations for this element we
         * can wipe the enteringChildren set for the next render.
         */ visualElement.enteringChildren = undefined;
    });
    return visualElement;
}
function $e0bdec89ac95ba83$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot, layoutCrossfade: layoutCrossfade } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $e0bdec89ac95ba83$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $47fdaa874812c1f9$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        crossfade: layoutCrossfade,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $e0bdec89ac95ba83$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $e0bdec89ac95ba83$var$getClosestProjectingNode(visualElement.parent);
}


"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $df5115c18c1c875c$export$46b7e4b9dc6110c3(Component, { forwardMotionProps: forwardMotionProps = false } = {}, preloadedFeatures, createVisualElement) {
    preloadedFeatures && (0, $b0a649ba5c72f682$export$449561ec5703cdc8)(preloadedFeatures);
    const useVisualState = (0, $a4ff4b2c9835eed9$export$88f3fc2fd3766989)(Component) ? (0, $b3c477f34555a2d6$export$9922240e40b88c48) : (0, $ae611974504e6247$export$851cf1f78cb3feac);
    function MotionDOMComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $dNU7X.useContext)((0, $3d6503ac3b793412$export$22a697fb29aac98d)),
            ...props,
            layoutId: $df5115c18c1c875c$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $ec3e80d50780adb6$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $dad1068478789ff3$export$4e09c449d6c407f7)) {
            $df5115c18c1c875c$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $df5115c18c1c875c$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $e0bdec89ac95ba83$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $2111e08a92d70add$exports.jsxs)((0, $6d760815973a6180$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $2111e08a92d70add$exports.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                (0, $d4b678fa83abd483$export$e25bb1e5b53cbdff)(Component, props, (0, $2e67adbe06d585bc$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, forwardMotionProps)
            ]
        });
    }
    MotionDOMComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${Component.displayName ?? Component.name ?? ""})`}`;
    const ForwardRefMotionComponent = (0, $dNU7X.forwardRef)(MotionDOMComponent);
    ForwardRefMotionComponent[0, $cf3c10373fc4be8e$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $df5115c18c1c875c$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $dNU7X.useContext)((0, $f18ef7be44492bd1$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $df5115c18c1c875c$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $dNU7X.useContext)((0, $bceeea8eabf147a7$export$40f10139ecf1f171)).strict;
}
function $df5115c18c1c875c$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $11a1928e58371a59$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: drag?.isEnabled(props) || layout?.isEnabled(props) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


function $af99d916a18a85b6$export$a28d6df673050e18(preloadedFeatures, createVisualElement) {
    if (typeof Proxy === "undefined") return 0, $df5115c18c1c875c$export$46b7e4b9dc6110c3;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const factory = (Component, options)=>{
        return (0, $df5115c18c1c875c$export$46b7e4b9dc6110c3)(Component, options, preloadedFeatures, createVisualElement);
    };
    /**
     * Support for deprecated`motion(Component)` pattern
     */ const deprecatedFactoryFunction = (Component, options)=>{
        return factory(Component, options);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return factory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, (0, $df5115c18c1c875c$export$46b7e4b9dc6110c3)(key, undefined, preloadedFeatures, createVisualElement));
            return componentCache.get(key);
        }
    });
}




function $3ec73a681c32742a$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $e4d50330964e9dfb$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


function $dde277b96b9a21da$export$7c1391340308742e(transition, key) {
    return transition?.[key] ?? transition?.["default"] ?? transition;
}



const $7518ec218f811ae9$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $eb44b5b071848feb$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $158c82181da7b3e7$export$ce8bdc721e76545f)(value));
}
function $eb44b5b071848feb$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $7518ec218f811ae9$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
}
function $eb44b5b071848feb$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $3ec73a681c32742a$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = $eb44b5b071848feb$var$resolveFinalValueInKeyframes(target[key]);
        $eb44b5b071848feb$var$setMotionValue(visualElement, key, value);
    }
}




function $6c5a03958aff06d5$export$98397f3adbf6259f(value) {
    return Boolean((0, $79da92e230ca0803$export$605d60a2578142d3)(value) && value.add);
}


function $30e1dd6229f35e12$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $6c5a03958aff06d5$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $58b144feeed2312d$export$dd826089e3c5e502).WillChange) {
        const newWillChange = new (0, $58b144feeed2312d$export$dd826089e3c5e502).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}



function $c484efbbce608d94$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $73707bc84e6b6a17$export$8592e1c077c890a6];
}




/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $81cab8916775f3d6$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $81cab8916775f3d6$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $f8be08f89a83b942$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $f8be08f89a83b942$export$a4627e546088548d = (...transformers)=>transformers.reduce($f8be08f89a83b942$var$combineFunctions);



const $66911b61b9f5d672$export$d921fb2475e2900c = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};









// Adapted from https://gist.github.com/mjackson/5311256
function $10944f1620fb909c$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $10944f1620fb909c$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $10944f1620fb909c$var$hueToRgb(p, q, hue + 1 / 3);
        green = $10944f1620fb909c$var$hueToRgb(p, q, hue);
        blue = $10944f1620fb909c$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}



function $08c8d1ac61f5f54f$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}



// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $362a0d4eb173da3e$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $362a0d4eb173da3e$var$colorTypes = [
    (0, $2347a98eddfdb8cd$export$834dfc94dde4b3d8),
    (0, $b35f0704081fa00b$export$4e46ac54fc82cf3b),
    (0, $391fa0f1ffdc0f8d$export$810b04175080204c)
];
const $362a0d4eb173da3e$var$getColorType = (v)=>$362a0d4eb173da3e$var$colorTypes.find((type)=>type.test(v));
function $362a0d4eb173da3e$var$asRGBA(color) {
    const type = $362a0d4eb173da3e$var$getColorType(color);
    (0, $80ee25e76ad65aaa$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable");
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $391fa0f1ffdc0f8d$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $10944f1620fb909c$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $362a0d4eb173da3e$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $362a0d4eb173da3e$var$asRGBA(from);
    const toRGBA = $362a0d4eb173da3e$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $08c8d1ac61f5f54f$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $362a0d4eb173da3e$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $362a0d4eb173da3e$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $362a0d4eb173da3e$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $b35f0704081fa00b$export$4e46ac54fc82cf3b).transform(blended);
    };
};




const $caabf0691e64a0c1$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $caabf0691e64a0c1$export$fed62ccc3fb1a568(origin, target) {
    if ($caabf0691e64a0c1$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}


function $d45582428047f6c0$var$mixNumber(a, b) {
    return (p)=>(0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $d45582428047f6c0$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $d45582428047f6c0$var$mixNumber;
    else if (typeof a === "string") return (0, $cb58381eaa053471$export$31f9caa2600b5723)(a) ? (0, $08c8d1ac61f5f54f$export$a6f92d4bae65c0f1) : (0, $f65424d413933229$export$35e9368ef982300f).test(a) ? (0, $362a0d4eb173da3e$export$51e568cf5c039bac) : $d45582428047f6c0$export$65516310a87d8205;
    else if (Array.isArray(a)) return $d45582428047f6c0$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $f65424d413933229$export$35e9368ef982300f).test(a) ? (0, $362a0d4eb173da3e$export$51e568cf5c039bac) : $d45582428047f6c0$export$ebc23b6840c51ba1;
    return 0, $08c8d1ac61f5f54f$export$a6f92d4bae65c0f1;
}
function $d45582428047f6c0$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$d45582428047f6c0$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $d45582428047f6c0$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $d45582428047f6c0$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $d45582428047f6c0$var$matchOrder(origin, target) {
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = origin.values[originIndex] ?? 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $d45582428047f6c0$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $7d7af56b5778707d$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $7d7af56b5778707d$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $7d7af56b5778707d$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $caabf0691e64a0c1$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $caabf0691e64a0c1$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $caabf0691e64a0c1$export$fed62ccc3fb1a568)(origin, target);
        return (0, $f8be08f89a83b942$export$a4627e546088548d)($d45582428047f6c0$export$3bbefa2f402845c4($d45582428047f6c0$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $80ee25e76ad65aaa$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different");
        return (0, $08c8d1ac61f5f54f$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $f3bdd40e5efa8278$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $d45582428047f6c0$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}




const $6a506cdbba05182a$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: (keepAlive = true)=>(0, $d1447ba151973c89$export$2cef06c20297c17d).update(passTimestamp, keepAlive),
        stop: ()=>(0, $d1447ba151973c89$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $d1447ba151973c89$export$fff89137e9e818ce).isProcessing ? (0, $d1447ba151973c89$export$fff89137e9e818ce).timestamp : (0, $1ca16a2cd98ee355$export$2da9be4cfdb689b1).now()
    };
};



const $fd01a14f50750c85$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $075d0d2515f93a3f$export$f4ff70a5b4808fd8 = 20000;
function $075d0d2515f93a3f$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $075d0d2515f93a3f$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $075d0d2515f93a3f$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




/**
 * Create a progress => progress easing function from a generator.
 */ function $f8a434778c393bc0$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $075d0d2515f93a3f$export$cbdd6b3d40ea54e2)(generator), (0, $075d0d2515f93a3f$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $81cab8916775f3d6$export$f64c3bfbc58eec0f)(duration)
    };
}



const $87bf7c5a1bc3e354$var$velocitySampleDuration = 5; // ms
function $87bf7c5a1bc3e354$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $87bf7c5a1bc3e354$var$velocitySampleDuration, 0);
    return (0, $6779748396cb3e46$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


const $f8d5087169bf3b0f$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};




const $b65450fd7a92e999$var$safeMin = 0.001;
function $b65450fd7a92e999$export$b15f158dc6d6f458({ duration: duration = (0, $f8d5087169bf3b0f$export$86436497e7b05d16).duration, bounce: bounce = (0, $f8d5087169bf3b0f$export$86436497e7b05d16).bounce, velocity: velocity = (0, $f8d5087169bf3b0f$export$86436497e7b05d16).velocity, mass: mass = (0, $f8d5087169bf3b0f$export$86436497e7b05d16).mass }) {
    let envelope;
    let derivative;
    (0, $80ee25e76ad65aaa$export$491112666e282270)(duration <= (0, $81cab8916775f3d6$export$fc3e7e8557f8c8c7)((0, $f8d5087169bf3b0f$export$86436497e7b05d16).maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $aafb21eef928513a$export$7d15b64cf5a3a4c4)((0, $f8d5087169bf3b0f$export$86436497e7b05d16).minDamping, (0, $f8d5087169bf3b0f$export$86436497e7b05d16).maxDamping, dampingRatio);
    duration = (0, $aafb21eef928513a$export$7d15b64cf5a3a4c4)((0, $f8d5087169bf3b0f$export$86436497e7b05d16).minDuration, (0, $f8d5087169bf3b0f$export$86436497e7b05d16).maxDuration, (0, $81cab8916775f3d6$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $b65450fd7a92e999$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $b65450fd7a92e999$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $b65450fd7a92e999$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $b65450fd7a92e999$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$b65450fd7a92e999$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $b65450fd7a92e999$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $81cab8916775f3d6$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $f8d5087169bf3b0f$export$86436497e7b05d16).stiffness,
        damping: (0, $f8d5087169bf3b0f$export$86436497e7b05d16).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $b65450fd7a92e999$var$rootIterations = 12;
function $b65450fd7a92e999$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $b65450fd7a92e999$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $b65450fd7a92e999$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $2bf5a29499b658ea$var$durationKeys = [
    "duration",
    "bounce"
];
const $2bf5a29499b658ea$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $2bf5a29499b658ea$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $2bf5a29499b658ea$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $f8d5087169bf3b0f$export$86436497e7b05d16).velocity,
        stiffness: (0, $f8d5087169bf3b0f$export$86436497e7b05d16).stiffness,
        damping: (0, $f8d5087169bf3b0f$export$86436497e7b05d16).damping,
        mass: (0, $f8d5087169bf3b0f$export$86436497e7b05d16).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$2bf5a29499b658ea$var$isSpringType(options, $2bf5a29499b658ea$var$physicsKeys) && $2bf5a29499b658ea$var$isSpringType(options, $2bf5a29499b658ea$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $aafb21eef928513a$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $f8d5087169bf3b0f$export$86436497e7b05d16).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $b65450fd7a92e999$export$b15f158dc6d6f458)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $f8d5087169bf3b0f$export$86436497e7b05d16).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $2bf5a29499b658ea$export$b36281d89752ae66(optionsOrVisualDuration = (0, $f8d5087169bf3b0f$export$86436497e7b05d16).visualDuration, bounce = (0, $f8d5087169bf3b0f$export$86436497e7b05d16).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $2bf5a29499b658ea$var$getSpringOptions({
        ...options,
        velocity: -(0, $81cab8916775f3d6$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $81cab8916775f3d6$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $f8d5087169bf3b0f$export$86436497e7b05d16).restSpeed.granular : (0, $f8d5087169bf3b0f$export$86436497e7b05d16).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $f8d5087169bf3b0f$export$86436497e7b05d16).restDelta.granular : (0, $f8d5087169bf3b0f$export$86436497e7b05d16).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $b65450fd7a92e999$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = t === 0 ? initialVelocity : 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $81cab8916775f3d6$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $87bf7c5a1bc3e354$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $075d0d2515f93a3f$export$cbdd6b3d40ea54e2)(generator), (0, $075d0d2515f93a3f$export$f4ff70a5b4808fd8));
            const easing = (0, $fd01a14f50750c85$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: ()=>{}
    };
    return generator;
}
$2bf5a29499b658ea$export$b36281d89752ae66.applyToOptions = (options)=>{
    const generatorOptions = (0, $f8a434778c393bc0$export$7f1511d09ee75a99)(options, 100, $2bf5a29499b658ea$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $81cab8916775f3d6$export$fc3e7e8557f8c8c7)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};



function $076a82e07fbafb3a$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $2bf5a29499b658ea$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $87bf7c5a1bc3e354$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $0a4199fb49c90c1f$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $0a4199fb49c90c1f$var$subdivisionPrecision = 0.0000001;
const $0a4199fb49c90c1f$var$subdivisionMaxIterations = 12;
function $0a4199fb49c90c1f$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $0a4199fb49c90c1f$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $0a4199fb49c90c1f$var$subdivisionPrecision && ++i < $0a4199fb49c90c1f$var$subdivisionMaxIterations);
    return currentT;
}
function $0a4199fb49c90c1f$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $8627ddaf329d4de9$export$8793edee2d425525;
    const getTForX = (aX)=>$0a4199fb49c90c1f$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $0a4199fb49c90c1f$var$calcBezier(getTForX(t), mY1, mY2);
}


const $4c392417820bcf66$export$929e5a82286172a6 = /*@__PURE__*/ (0, $0a4199fb49c90c1f$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $4c392417820bcf66$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $0a4199fb49c90c1f$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $4c392417820bcf66$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $0a4199fb49c90c1f$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);




// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $8ff609d1dcedeee9$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $f89556042492d5da$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $f837c40938ca743f$export$77edfce482316a60 = /*@__PURE__*/ (0, $0a4199fb49c90c1f$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $f837c40938ca743f$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $f89556042492d5da$export$2c07eeff45156d4d)($f837c40938ca743f$export$77edfce482316a60);
const $f837c40938ca743f$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $8ff609d1dcedeee9$export$f946554fb8aeaf0d)($f837c40938ca743f$export$b01116c84cdfe1a2);


const $6c9d7d850c0a6fae$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $f837c40938ca743f$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $fec248e616eb47d7$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $fec248e616eb47d7$export$c8d67a19199d1a50 = (0, $f89556042492d5da$export$2c07eeff45156d4d)($fec248e616eb47d7$export$e444123e42d03385);
const $fec248e616eb47d7$export$30d3455eee55bed5 = (0, $8ff609d1dcedeee9$export$f946554fb8aeaf0d)($fec248e616eb47d7$export$e444123e42d03385);




const $b0421471170e35aa$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


const $d35c54cfb7dba98e$var$easingLookup = {
    linear: (0, $8627ddaf329d4de9$export$8793edee2d425525),
    easeIn: $4c392417820bcf66$export$929e5a82286172a6,
    easeInOut: $4c392417820bcf66$export$c07234257a03d5e9,
    easeOut: $4c392417820bcf66$export$57636bb43b1ccbb0,
    circIn: $fec248e616eb47d7$export$e444123e42d03385,
    circInOut: $fec248e616eb47d7$export$30d3455eee55bed5,
    circOut: $fec248e616eb47d7$export$c8d67a19199d1a50,
    backIn: $f837c40938ca743f$export$b01116c84cdfe1a2,
    backInOut: $f837c40938ca743f$export$ddc5fd596f6c71b2,
    backOut: $f837c40938ca743f$export$77edfce482316a60,
    anticipate: $6c9d7d850c0a6fae$export$6b0af63b873d419e
};
const $d35c54cfb7dba98e$var$isValidEasing = (easing)=>{
    return typeof easing === "string";
};
const $d35c54cfb7dba98e$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $b0421471170e35aa$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $80ee25e76ad65aaa$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`, "cubic-bezier-length");
        const [x1, y1, x2, y2] = definition;
        return (0, $0a4199fb49c90c1f$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if ($d35c54cfb7dba98e$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $80ee25e76ad65aaa$export$f5708dca728d7177)($d35c54cfb7dba98e$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`, "invalid-easing-type");
        return $d35c54cfb7dba98e$var$easingLookup[definition];
    }
    return definition;
};

const $6eac6d4c5988c361$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};


/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ const $5de1dbf596522ca0$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



function $e122b8fe5e5a3bef$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $58b144feeed2312d$export$dd826089e3c5e502).mix || (0, $f3bdd40e5efa8278$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $8627ddaf329d4de9$export$8793edee2d425525) : ease;
            mixer = (0, $f8be08f89a83b942$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $e122b8fe5e5a3bef$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $80ee25e76ad65aaa$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $e122b8fe5e5a3bef$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $5de1dbf596522ca0$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $aafb21eef928513a$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $39b124d03423d3f1$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $5de1dbf596522ca0$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $533ffabfabb677ba$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $39b124d03423d3f1$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $f0282569ba9810e1$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $c25523cdd7962831$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $4c392417820bcf66$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $c25523cdd7962831$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $6eac6d4c5988c361$export$216948827bbdc797)(ease) ? ease.map((0, $d35c54cfb7dba98e$export$ef97fe084f156ca4)) : (0, $d35c54cfb7dba98e$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $f0282569ba9810e1$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $533ffabfabb677ba$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $e122b8fe5e5a3bef$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $c25523cdd7962831$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



const $bff6d9e6bc26b61f$var$isNotNull = (value)=>value !== null;
function $bff6d9e6bc26b61f$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe, speed = 1) {
    const resolvedKeyframes = keyframes.filter($bff6d9e6bc26b61f$var$isNotNull);
    const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}





const $6c73e88da323ec78$var$transitionTypeMap = {
    decay: (0, $076a82e07fbafb3a$export$ee3ff3a17106998),
    inertia: $076a82e07fbafb3a$export$ee3ff3a17106998,
    tween: (0, $c25523cdd7962831$export$d25ddfdf17c3ad3e),
    keyframes: (0, $c25523cdd7962831$export$d25ddfdf17c3ad3e),
    spring: $2bf5a29499b658ea$export$b36281d89752ae66
};
function $6c73e88da323ec78$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $6c73e88da323ec78$var$transitionTypeMap[transition.type];
}


class $eb8ba5af0dea8790$export$655db786091c33e0 {
    constructor(){
        this.updateFinished();
    }
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this._finished = new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ then(onResolve, onReject) {
        return this.finished.then(onResolve, onReject);
    }
}


const $d1f5bc1f54a5e77a$var$percentToProgress = (percent)=>percent / 100;
class $d1f5bc1f54a5e77a$export$3394f837405475c7 extends (0, $eb8ba5af0dea8790$export$655db786091c33e0) {
    constructor(options){
        super();
        this.state = "idle";
        this.startTime = null;
        this.isStopped = false;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            const { motionValue: motionValue } = this.options;
            if (motionValue && motionValue.updatedAt !== (0, $1ca16a2cd98ee355$export$2da9be4cfdb689b1).now()) this.tick((0, $1ca16a2cd98ee355$export$2da9be4cfdb689b1).now());
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            this.options.onStop?.();
        };
        (0, $66911b61b9f5d672$export$d921fb2475e2900c).mainThread++;
        this.options = options;
        this.initAnimation();
        this.play();
        if (options.autoplay === false) this.pause();
    }
    initAnimation() {
        const { options: options } = this;
        (0, $6c73e88da323ec78$export$98db6ef1242dfa2)(options);
        const { type: type = (0, $c25523cdd7962831$export$d25ddfdf17c3ad3e), repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = options;
        let { keyframes: keyframes$1 } = options;
        const generatorFactory = type || (0, $c25523cdd7962831$export$d25ddfdf17c3ad3e);
        if (generatorFactory !== (0, $c25523cdd7962831$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = (0, $f8be08f89a83b942$export$a4627e546088548d)($d1f5bc1f54a5e77a$var$percentToProgress, (0, $f3bdd40e5efa8278$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory({
            ...options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $075d0d2515f93a3f$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        this.calculatedDuration = calculatedDuration;
        this.resolvedDuration = calculatedDuration + repeatDelay;
        this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
        this.generator = generator;
    }
    updateTime(timestamp) {
        const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
        // Update currentTime
        if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
    }
    tick(timestamp, sample = false) {
        const { generator: generator, totalDuration: totalDuration, mixKeyframes: mixKeyframes, mirroredGenerator: mirroredGenerator, resolvedDuration: resolvedDuration, calculatedDuration: calculatedDuration } = this;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay = 0, keyframes: keyframes, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, type: type, onUpdate: onUpdate, finalKeyframe: finalKeyframe } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        if (sample) this.currentTime = timestamp;
        else this.updateTime(timestamp);
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
        const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $aafb21eef928513a$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mixKeyframes) state.value = mixKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        // TODO: The exception for inertia could be cleaner here
        if (isAnimationFinished && type !== (0, $076a82e07fbafb3a$export$ee3ff3a17106998)) state.value = (0, $bff6d9e6bc26b61f$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.finished.then(resolve, reject);
    }
    get duration() {
        return (0, $81cab8916775f3d6$export$f64c3bfbc58eec0f)(this.calculatedDuration);
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $81cab8916775f3d6$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $81cab8916775f3d6$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $81cab8916775f3d6$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
        this.driver?.start(false);
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        this.updateTime((0, $1ca16a2cd98ee355$export$2da9be4cfdb689b1).now());
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $81cab8916775f3d6$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (this.isStopped) return;
        const { driver: driver = (0, $6a506cdbba05182a$export$c1033964b5ad7fef), startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        this.options.onPlay?.();
        const now = this.driver.now();
        if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now;
        } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime ?? now;
        if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        this.state = "paused";
        this.updateTime((0, $1ca16a2cd98ee355$export$2da9be4cfdb689b1).now());
        this.holdTime = this.currentTime;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.notifyFinished();
        this.teardown();
        this.state = "finished";
        this.options.onComplete?.();
    }
    cancel() {
        this.holdTime = null;
        this.startTime = 0;
        this.tick(0);
        this.teardown();
        this.options.onCancel?.();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.startTime = this.holdTime = null;
        (0, $66911b61b9f5d672$export$d921fb2475e2900c).mainThread--;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(sampleTime) {
        this.startTime = 0;
        return this.tick(sampleTime, true);
    }
    attachTimeline(timeline) {
        if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
        }
        this.driver?.stop();
        return timeline.observe(this);
    }
}
// Legacy function support
function $d1f5bc1f54a5e77a$export$ee9b76de7353d815(options) {
    return new $d1f5bc1f54a5e77a$export$3394f837405475c7(options);
}







const $2b13f3b4441f4a96$export$c9f584638d388483 = (name)=>name.startsWith("--");


function $fa3b2014ce1d864b$export$37a5fde709c1db82(element, name, value) {
    (0, $2b13f3b4441f4a96$export$c9f584638d388483)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}


/*#__NO_SIDE_EFFECTS__*/ function $e6217b6d4a9b8838$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


const $3126d0721221ca9d$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $e6217b6d4a9b8838$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);








/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $934fff82b61f5796$export$e3ad02c335474dee = {};


function $48dda3f50415bead$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $e6217b6d4a9b8838$export$7c73462e0d25e514)(callback);
    return ()=>(0, $934fff82b61f5796$export$e3ad02c335474dee)[supportsFlag] ?? memoized();
}


const $95bebdea3d47f5cd$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $48dda3f50415bead$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");



const $6d3b766c65f01a6f$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



const $98a0af7bcf2349bf$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $6d3b766c65f01a6f$export$2523b8f0bd8f44cb)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $6d3b766c65f01a6f$export$2523b8f0bd8f44cb)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $6d3b766c65f01a6f$export$2523b8f0bd8f44cb)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $6d3b766c65f01a6f$export$2523b8f0bd8f44cb)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};


function $61f0f1e87066fb01$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $95bebdea3d47f5cd$export$866c1d07a1ac2ab)() ? (0, $fd01a14f50750c85$export$66d3851e2b1ec912)(easing, duration) : "ease-out";
    else if ((0, $b0421471170e35aa$export$ff43f99925d7366b)(easing)) return (0, $6d3b766c65f01a6f$export$2523b8f0bd8f44cb)(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$61f0f1e87066fb01$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $98a0af7bcf2349bf$export$2cf569f5e2221176).easeOut);
    else return (0, $98a0af7bcf2349bf$export$2cf569f5e2221176)[easing];
}


function $6be37902044fd39d$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeOut", times: times } = {}, pseudoElement) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $61f0f1e87066fb01$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, $911834144665c26d$export$84ce9a476f53d110).value) (0, $66911b61b9f5d672$export$d921fb2475e2900c).waapi++;
    const options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    const animation = element.animate(keyframeOptions, options);
    if ((0, $911834144665c26d$export$84ce9a476f53d110).value) animation.finished.finally(()=>{
        (0, $66911b61b9f5d672$export$d921fb2475e2900c).waapi--;
    });
    return animation;
}



function $172d947c63c9ddaf$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}


function $cba4c9a3d7e0a0b1$export$a31269144d66b4a({ type: type, ...options }) {
    if ((0, $172d947c63c9ddaf$export$6ab7812f1bac68be)(type) && (0, $95bebdea3d47f5cd$export$866c1d07a1ac2ab)()) return type.applyToOptions(options);
    else {
        options.duration ?? (options.duration = 300);
        options.ease ?? (options.ease = "easeOut");
    }
    return options;
}


/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ class $4c8d1e64aaaf7a11$export$6c0f9803d8aa7219 extends (0, $eb8ba5af0dea8790$export$655db786091c33e0) {
    constructor(options){
        super();
        this.finishedTime = null;
        this.isStopped = false;
        if (!options) return;
        const { element: element, name: name, keyframes: keyframes, pseudoElement: pseudoElement, allowFlatten: allowFlatten = false, finalKeyframe: finalKeyframe, onComplete: onComplete } = options;
        this.isPseudoElement = Boolean(pseudoElement);
        this.allowFlatten = allowFlatten;
        this.options = options;
        (0, $80ee25e76ad65aaa$export$f5708dca728d7177)(typeof options.type !== "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
        const transition = (0, $cba4c9a3d7e0a0b1$export$a31269144d66b4a)(options);
        this.animation = (0, $6be37902044fd39d$export$d896de52f97cb615)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) this.animation.pause();
        this.animation.onfinish = ()=>{
            this.finishedTime = this.time;
            if (!pseudoElement) {
                const keyframe = (0, $bff6d9e6bc26b61f$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
                if (this.updateMotionValue) this.updateMotionValue(keyframe);
                else /**
                     * If we can, we want to commit the final style as set by the user,
                     * rather than the computed keyframe value supplied by the animation.
                     */ (0, $fa3b2014ce1d864b$export$37a5fde709c1db82)(element, name, keyframe);
                this.animation.cancel();
            }
            onComplete?.();
            this.notifyFinished();
        };
    }
    play() {
        if (this.isStopped) return;
        this.animation.play();
        if (this.state === "finished") this.updateFinished();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.finish?.();
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch (e) {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        const { state: state } = this;
        if (state === "idle" || state === "finished") return;
        if (this.updateMotionValue) this.updateMotionValue();
        else this.commitStyles();
        if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ commitStyles() {
        if (!this.isPseudoElement) this.animation.commitStyles?.();
    }
    get duration() {
        const duration = this.animation.effect?.getComputedTiming?.().duration || 0;
        return (0, $81cab8916775f3d6$export$f64c3bfbc58eec0f)(Number(duration));
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $81cab8916775f3d6$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $81cab8916775f3d6$export$f64c3bfbc58eec0f)(Number(this.animation.currentTime) || 0);
    }
    set time(newTime) {
        this.finishedTime = null;
        this.animation.currentTime = (0, $81cab8916775f3d6$export$fc3e7e8557f8c8c7)(newTime);
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ get speed() {
        return this.animation.playbackRate;
    }
    set speed(newSpeed) {
        // Allow backwards playback after finishing
        if (newSpeed < 0) this.finishedTime = null;
        this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        return Number(this.animation.startTime);
    }
    set startTime(newStartTime) {
        this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ attachTimeline({ timeline: timeline, observe: observe }) {
        if (this.allowFlatten) this.animation.effect?.updateTiming({
            easing: "linear"
        });
        this.animation.onfinish = null;
        if (timeline && (0, $3126d0721221ca9d$export$20d68f04f30763a5)()) {
            this.animation.timeline = timeline;
            return 0, $8627ddaf329d4de9$export$8793edee2d425525;
        } else return observe(this);
    }
}




const $ed6b1e1fbf279a6a$var$unsupportedEasingFunctions = {
    anticipate: $6c9d7d850c0a6fae$export$6b0af63b873d419e,
    backInOut: $f837c40938ca743f$export$ddc5fd596f6c71b2,
    circInOut: $fec248e616eb47d7$export$30d3455eee55bed5
};
function $ed6b1e1fbf279a6a$var$isUnsupportedEase(key) {
    return key in $ed6b1e1fbf279a6a$var$unsupportedEasingFunctions;
}
function $ed6b1e1fbf279a6a$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $ed6b1e1fbf279a6a$var$isUnsupportedEase(transition.ease)) transition.ease = $ed6b1e1fbf279a6a$var$unsupportedEasingFunctions[transition.ease];
}


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $ad43c6af0df4caea$var$sampleDelta = 10; //ms
class $ad43c6af0df4caea$export$bd2cd6a048093d96 extends (0, $4c8d1e64aaaf7a11$export$6c0f9803d8aa7219) {
    constructor(options){
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $ed6b1e1fbf279a6a$export$5195f232c29d1f82)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $6c73e88da323ec78$export$98db6ef1242dfa2)(options);
        super(options);
        if (options.startTime) this.startTime = options.startTime;
        this.options = options;
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read commited styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ updateMotionValue(value) {
        const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
        if (!motionValue) return;
        if (value !== undefined) {
            motionValue.set(value);
            return;
        }
        const sampleAnimation = new (0, $d1f5bc1f54a5e77a$export$3394f837405475c7)({
            ...options,
            autoplay: false
        });
        const sampleTime = (0, $81cab8916775f3d6$export$fc3e7e8557f8c8c7)(this.finishedTime ?? this.time);
        motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $ad43c6af0df4caea$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $ad43c6af0df4caea$var$sampleDelta);
        sampleAnimation.stop();
    }
}





/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $53820e59f65ef7cd$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $7d7af56b5778707d$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $a9bcd0a4550ffb4c$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $a9bcd0a4550ffb4c$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $53820e59f65ef7cd$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $53820e59f65ef7cd$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $80ee25e76ad65aaa$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". "${isOriginAnimatable ? targetKeyframe : originKeyframe}" is not an animatable value.`, "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $a9bcd0a4550ffb4c$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $172d947c63c9ddaf$export$6ab7812f1bac68be)(type)) && velocity;
}


function $f364177ad8cc94a1$export$b2585dd3c345da47(options) {
    options.duration = 0;
    options.type = "keyframes";
}




/**
 * A list of values that can be hardware-accelerated.
 */ const $2b2bfd03afbac9de$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);
const $2b2bfd03afbac9de$var$supportsWaapi = /*@__PURE__*/ (0, $e6217b6d4a9b8838$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
function $2b2bfd03afbac9de$export$ea92bde116fda821(options) {
    const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
    const subject = motionValue?.owner?.current;
    /**
     * We use this check instead of isHTMLElement() because we explicitly
     * **don't** want elements in different timing contexts (i.e. popups)
     * to be accelerated, as it's not possible to sync these animations
     * properly with those driven from the main window frameloop.
     */ if (!(subject instanceof HTMLElement)) return false;
    const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
    return $2b2bfd03afbac9de$var$supportsWaapi() && name && $2b2bfd03afbac9de$var$acceleratedValues.has(name) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}


/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $4b91bf5f58fa41fe$var$MAX_RESOLVE_DELAY = 40;
class $4b91bf5f58fa41fe$export$b9855e2a7dee3dd2 extends (0, $eb8ba5af0dea8790$export$655db786091c33e0) {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", keyframes: keyframes, name: name, motionValue: motionValue, element: element, ...options }){
        super();
        /**
         * Bound to support return animation.stop pattern
         */ this.stop = ()=>{
            if (this._animation) {
                this._animation.stop();
                this.stopTimeline?.();
            }
            this.keyframeResolver?.cancel();
        };
        this.createdAt = (0, $1ca16a2cd98ee355$export$2da9be4cfdb689b1).now();
        const optionsWithDefaults = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element,
            ...options
        };
        const KeyframeResolver$1 = element?.KeyframeResolver || (0, $5893df20395e66d3$export$74d34ca3182f1750);
        this.keyframeResolver = new KeyframeResolver$1(keyframes, (resolvedKeyframes, finalKeyframe, forced)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue, element);
        this.keyframeResolver?.scheduleResolve();
    }
    onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
        this.keyframeResolver = undefined;
        const { name: name, type: type, velocity: velocity, delay: delay, isHandoff: isHandoff, onUpdate: onUpdate } = options;
        this.resolvedAt = (0, $1ca16a2cd98ee355$export$2da9be4cfdb689b1).now();
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!(0, $a9bcd0a4550ffb4c$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            if ((0, $58b144feeed2312d$export$dd826089e3c5e502).instantAnimations || !delay) onUpdate?.((0, $bff6d9e6bc26b61f$export$14de59408fad90b)(keyframes, options, finalKeyframe));
            keyframes[0] = keyframes[keyframes.length - 1];
            (0, $f364177ad8cc94a1$export$b2585dd3c345da47)(options);
            options.repeat = 0;
        }
        /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first commited frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $4b91bf5f58fa41fe$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
        const resolvedOptions = {
            startTime: startTime,
            finalKeyframe: finalKeyframe,
            ...options,
            keyframes: keyframes
        };
        /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         */ const animation = !isHandoff && (0, $2b2bfd03afbac9de$export$ea92bde116fda821)(resolvedOptions) ? new (0, $ad43c6af0df4caea$export$bd2cd6a048093d96)({
            ...resolvedOptions,
            element: resolvedOptions.motionValue.owner.current
        }) : new (0, $d1f5bc1f54a5e77a$export$3394f837405475c7)(resolvedOptions);
        animation.finished.then(()=>this.notifyFinished()).catch((0, $8627ddaf329d4de9$export$8793edee2d425525));
        if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        this._animation = animation;
    }
    get finished() {
        if (!this._animation) return this._finished;
        else return this.animation.finished;
    }
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
    get animation() {
        if (!this._animation) {
            this.keyframeResolver?.resume();
            (0, $5893df20395e66d3$export$78b96d2a12593b05)();
        }
        return this._animation;
    }
    get duration() {
        return this.animation.duration;
    }
    get iterationDuration() {
        return this.animation.iterationDuration;
    }
    get time() {
        return this.animation.time;
    }
    set time(newTime) {
        this.animation.time = newTime;
    }
    get speed() {
        return this.animation.speed;
    }
    get state() {
        return this.animation.state;
    }
    set speed(newSpeed) {
        this.animation.speed = newSpeed;
    }
    get startTime() {
        return this.animation.startTime;
    }
    attachTimeline(timeline) {
        if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
        else this.pendingTimeline = timeline;
        return ()=>this.stop();
    }
    play() {
        this.animation.play();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.complete();
    }
    cancel() {
        if (this._animation) this.animation.cancel();
        this.keyframeResolver?.cancel();
    }
}



const $85f4d27b2e1a247f$var$isNotNull = (value)=>value !== null;
function $85f4d27b2e1a247f$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($85f4d27b2e1a247f$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}



const $9c0b4f2a8497e915$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $9c0b4f2a8497e915$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $9c0b4f2a8497e915$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $9c0b4f2a8497e915$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $9c0b4f2a8497e915$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $9c0b4f2a8497e915$var$keyframesTransition;
    else if ((0, $76901b26fa5d5fe6$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $9c0b4f2a8497e915$var$criticallyDampedSpring(keyframes[1]) : $9c0b4f2a8497e915$var$underDampedSpring;
    return $9c0b4f2a8497e915$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $e7bbdae8221c6432$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}


const $16c2ab2aef2568e2$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $dde277b96b9a21da$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $81cab8916775f3d6$export$fc3e7e8557f8c8c7)(delay);
        const options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $e7bbdae8221c6432$export$ca8e47dc8ed5a9d7)(valueTransition)) Object.assign(options, (0, $9c0b4f2a8497e915$export$262124b154b9f1c0)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $81cab8916775f3d6$export$fc3e7e8557f8c8c7)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $81cab8916775f3d6$export$fc3e7e8557f8c8c7)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, $f364177ad8cc94a1$export$b2585dd3c345da47)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $58b144feeed2312d$export$dd826089e3c5e502).instantAnimations || (0, $58b144feeed2312d$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            (0, $f364177ad8cc94a1$export$b2585dd3c345da47)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $85f4d27b2e1a247f$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $d1447ba151973c89$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, $d1f5bc1f54a5e77a$export$3394f837405475c7)(options) : new (0, $4b91bf5f58fa41fe$export$b9855e2a7dee3dd2)(options);
    };


/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $90a2e299a1f33d53$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $90a2e299a1f33d53$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $90a2e299a1f33d53$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $dde277b96b9a21da$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If the value is already at the defined target, skip the animation.
         */ const currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) continue;
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $c484efbbce608d94$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $d1447ba151973c89$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $30e1dd6229f35e12$export$3ac5aed310be0bee)(visualElement, key);
        value.start((0, $16c2ab2aef2568e2$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $5976c8ad8c36f7e6$export$c66c0d5db2a205d).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $d1447ba151973c89$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $eb44b5b071848feb$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}



function $0cc08af4a759000d$export$6e01cb2cb232d79b(children, child, delayChildren, staggerChildren = 0, staggerDirection = 1) {
    const index = Array.from(children).sort((a, b)=>a.sortNodePosition(b)).indexOf(child);
    const numChildren = children.size;
    const maxStaggerDuration = (numChildren - 1) * staggerChildren;
    const delayIsFunction = typeof delayChildren === "function";
    return delayIsFunction ? delayChildren(index, numChildren) : staggerDirection === 1 ? index * staggerChildren : maxStaggerDuration - index * staggerChildren;
}



function $f00afe1d7c1f69d3$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $3ec73a681c32742a$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? visualElement.presenceContext?.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $90a2e299a1f33d53$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $f00afe1d7c1f69d3$var$animateChildren(visualElement, variant, forwardDelay, delayChildren, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $f00afe1d7c1f69d3$var$animateChildren(visualElement, variant, delay = 0, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    for (const child of visualElement.variantChildren){
        child.notify("AnimationStart", variant);
        animations.push($f00afe1d7c1f69d3$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delay + (typeof delayChildren === "function" ? 0 : delayChildren) + (0, $0cc08af4a759000d$export$6e01cb2cb232d79b)(visualElement.variantChildren, child, delayChildren, staggerChildren, staggerDirection)
        }).then(()=>child.notify("AnimationComplete", variant)));
    }
    return Promise.all(animations);
}


function $8537809ab4f6b8a5$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $f00afe1d7c1f69d3$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $f00afe1d7c1f69d3$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $3ec73a681c32742a$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $90a2e299a1f33d53$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}





function $42131f7a370c9e34$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




const $b7975df47f92527e$var$numVariantProps = (0, $80c62fcd2eb50351$export$1405a65085f40b9).length;
function $b7975df47f92527e$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $b7975df47f92527e$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $b7975df47f92527e$var$numVariantProps; i++){
        const name = (0, $80c62fcd2eb50351$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $ca0f8c6df749e90b$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}





const $242290cc144dbb6b$var$reversePriorityOrder = [
    ...(0, $80c62fcd2eb50351$export$16e45afcc206d3a8)
].reverse();
const $242290cc144dbb6b$var$numAnimationTypes = (0, $80c62fcd2eb50351$export$16e45afcc206d3a8).length;
function $242290cc144dbb6b$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $8537809ab4f6b8a5$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $242290cc144dbb6b$export$bb53502b7a672aa8(visualElement) {
    let animate = $242290cc144dbb6b$var$animateList(visualElement);
    let state = $242290cc144dbb6b$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            const resolved = (0, $3ec73a681c32742a$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? visualElement.presenceContext?.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $b7975df47f92527e$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $242290cc144dbb6b$var$numAnimationTypes; i++){
            const type = $242290cc144dbb6b$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $ca0f8c6df749e90b$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $e7a49398a967dd85$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $242290cc144dbb6b$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $7518ec218f811ae9$export$9153ad4c4999f4a0)(next) && (0, $7518ec218f811ae9$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $42131f7a370c9e34$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>{
                const options = {
                    type: type
                };
                /**
                     * If we're performing the initial animation, but we're not
                     * rendering at the same time as the variant-controlling parent,
                     * we want to use the parent's transition to calculate the stagger.
                     */ if (typeof animation === "string" && isInitialRender && !willAnimateViaParent && visualElement.manuallyAnimateOnMount && visualElement.parent) {
                    const { parent: parent } = visualElement;
                    const parentVariant = (0, $3ec73a681c32742a$export$7b1b1c981f4f0558)(parent, animation);
                    if (parent.enteringChildren && parentVariant) {
                        const { delayChildren: delayChildren } = parentVariant.transition || {};
                        options.delay = (0, $0cc08af4a759000d$export$6e01cb2cb232d79b)(parent.enteringChildren, visualElement, delayChildren);
                    }
                }
                return {
                    animation: animation,
                    options: options
                };
            }));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                const initialTransition = (0, $3ec73a681c32742a$export$7b1b1c981f4f0558)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget ?? null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        visualElement.variantChildren?.forEach((child)=>child.animationState?.setActive(type, isActive));
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $242290cc144dbb6b$var$createState();
            isInitialRender = true;
        }
    };
}
function $242290cc144dbb6b$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $42131f7a370c9e34$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $242290cc144dbb6b$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $242290cc144dbb6b$var$createState() {
    return {
        animate: $242290cc144dbb6b$var$createTypeState(true),
        whileInView: $242290cc144dbb6b$var$createTypeState(),
        whileHover: $242290cc144dbb6b$var$createTypeState(),
        whileTap: $242290cc144dbb6b$var$createTypeState(),
        whileDrag: $242290cc144dbb6b$var$createTypeState(),
        whileFocus: $242290cc144dbb6b$var$createTypeState(),
        exit: $242290cc144dbb6b$var$createTypeState()
    };
}


class $a244c61b38edd17b$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


class $f5e2227db93f7b34$export$b45b3fe5caabdca extends (0, $a244c61b38edd17b$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $242290cc144dbb6b$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $e7a49398a967dd85$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        this.node.animationState.reset();
        this.unmountControls?.();
    }
}



let $5a6c1699349308f9$var$id = 0;
class $5a6c1699349308f9$export$4989d1eb6104cc6c extends (0, $a244c61b38edd17b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $5a6c1699349308f9$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>{
            onExitComplete(this.id);
        });
    }
    mount() {
        const { register: register, onExitComplete: onExitComplete } = this.node.presenceContext || {};
        if (onExitComplete) onExitComplete(this.id);
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $bc8211d8ecdec13a$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $f5e2227db93f7b34$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $5a6c1699349308f9$export$4989d1eb6104cc6c)
    }
};




const $506b2f80258b4681$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $506b2f80258b4681$export$1b3dd616664938e4() {
    return $506b2f80258b4681$export$9e9bc3c487fccc00.x || $506b2f80258b4681$export$9e9bc3c487fccc00.y;
}


function $214b015126f9c3f6$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $506b2f80258b4681$export$9e9bc3c487fccc00)[axis]) return null;
        else {
            (0, $506b2f80258b4681$export$9e9bc3c487fccc00)[axis] = true;
            return ()=>{
                (0, $506b2f80258b4681$export$9e9bc3c487fccc00)[axis] = false;
            };
        }
    } else {
        if ((0, $506b2f80258b4681$export$9e9bc3c487fccc00).x || (0, $506b2f80258b4681$export$9e9bc3c487fccc00).y) return null;
        else {
            (0, $506b2f80258b4681$export$9e9bc3c487fccc00).x = (0, $506b2f80258b4681$export$9e9bc3c487fccc00).y = true;
            return ()=>{
                (0, $506b2f80258b4681$export$9e9bc3c487fccc00).x = (0, $506b2f80258b4681$export$9e9bc3c487fccc00).y = false;
            };
        }
    }
}




function $7918bb0cf98b4c96$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}



const $c029f34bfc12f89b$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $17b739d7228a9ca5$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $17b739d7228a9ca5$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $c029f34bfc12f89b$export$a4cf9c8a4b063a6e)(event) && handler(event, $17b739d7228a9ca5$export$12f84bb882d06e1a(event));
};


function $c001941294158545$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $7918bb0cf98b4c96$export$b1d829ddf82884aa)(target, eventName, (0, $17b739d7228a9ca5$export$c404e80f92c98d29)(handler), options);
}





const $533437274413027b$var$SCALE_PRECISION = 0.0001;
const $533437274413027b$var$SCALE_MIN = 1 - $533437274413027b$var$SCALE_PRECISION;
const $533437274413027b$var$SCALE_MAX = 1 + $533437274413027b$var$SCALE_PRECISION;
const $533437274413027b$var$TRANSLATE_PRECISION = 0.01;
const $533437274413027b$var$TRANSLATE_MIN = 0 - $533437274413027b$var$TRANSLATE_PRECISION;
const $533437274413027b$var$TRANSLATE_MAX = 0 + $533437274413027b$var$TRANSLATE_PRECISION;
function $533437274413027b$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $533437274413027b$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $533437274413027b$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $533437274413027b$export$c1c127004b72a37(target) / $533437274413027b$export$c1c127004b72a37(source);
    delta.translate = (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $533437274413027b$var$SCALE_MIN && delta.scale <= $533437274413027b$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $533437274413027b$var$TRANSLATE_MIN && delta.translate <= $533437274413027b$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $533437274413027b$export$c0d25e96fc67d310(delta, source, target, origin) {
    $533437274413027b$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $533437274413027b$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $533437274413027b$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $533437274413027b$export$c1c127004b72a37(relative);
}
function $533437274413027b$export$426154f9d100f99(target, relative, parent) {
    $533437274413027b$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $533437274413027b$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $533437274413027b$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $533437274413027b$export$c1c127004b72a37(layout);
}
function $533437274413027b$export$2785bfcc929c5650(target, layout, parent) {
    $533437274413027b$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $533437274413027b$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}



function $73503c7090005507$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}



// Fixes https://github.com/motiondivision/motion/issues/2270
const $6d0b3645874bea96$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};








const $8596a9e9151d7036$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $8596a9e9151d7036$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $8596a9e9151d7036$export$9f17032d917177de(a.x, b.x);
    const yDelta = $8596a9e9151d7036$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}


/**
 * @internal
 */ class $957447cdb911cc46$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow = window, dragSnapToOrigin: dragSnapToOrigin = false, distanceThreshold: distanceThreshold = 3 } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $957447cdb911cc46$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursor.
            const isDistancePastThreshold = (0, $8596a9e9151d7036$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= this.distanceThreshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $d1447ba151973c89$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $957447cdb911cc46$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $d1447ba151973c89$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $957447cdb911cc46$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $957447cdb911cc46$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $c029f34bfc12f89b$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.distanceThreshold = distanceThreshold;
        this.contextWindow = contextWindow || window;
        const info = (0, $17b739d7228a9ca5$export$12f84bb882d06e1a)(event);
        const initialInfo = $957447cdb911cc46$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $d1447ba151973c89$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $957447cdb911cc46$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $f8be08f89a83b942$export$a4627e546088548d)((0, $c001941294158545$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $c001941294158545$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $c001941294158545$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $d1447ba151973c89$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $957447cdb911cc46$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $957447cdb911cc46$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $957447cdb911cc46$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $957447cdb911cc46$var$subtractPoint(point, $957447cdb911cc46$var$lastDevicePoint(history)),
        offset: $957447cdb911cc46$var$subtractPoint(point, $957447cdb911cc46$var$startDevicePoint(history)),
        velocity: $957447cdb911cc46$var$getVelocity(history, 0.1)
    };
}
function $957447cdb911cc46$var$startDevicePoint(history) {
    return history[0];
}
function $957447cdb911cc46$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $957447cdb911cc46$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $957447cdb911cc46$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $81cab8916775f3d6$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $81cab8916775f3d6$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}





/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $36903b3edb1fbfa8$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $36903b3edb1fbfa8$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $36903b3edb1fbfa8$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $36903b3edb1fbfa8$export$690c180aa5775042(layoutBox.x, left, right),
        y: $36903b3edb1fbfa8$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $36903b3edb1fbfa8$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $36903b3edb1fbfa8$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $36903b3edb1fbfa8$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $36903b3edb1fbfa8$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $36903b3edb1fbfa8$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $533437274413027b$export$c1c127004b72a37)(source);
    const targetLength = (0, $533437274413027b$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $5de1dbf596522ca0$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $5de1dbf596522ca0$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $aafb21eef928513a$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $36903b3edb1fbfa8$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $36903b3edb1fbfa8$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $36903b3edb1fbfa8$export$7c5eaef8f4723d22(dragElastic = $36903b3edb1fbfa8$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $36903b3edb1fbfa8$export$a3366d3bac43a742;
    return {
        x: $36903b3edb1fbfa8$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $36903b3edb1fbfa8$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $36903b3edb1fbfa8$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $36903b3edb1fbfa8$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $36903b3edb1fbfa8$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $36903b3edb1fbfa8$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $3b3682cf200825b3$export$f0a15892c27dc07c = new WeakMap();
class $3b3682cf200825b3$export$86bff71f18910307 {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $5896390693a21a91$export$6459fc9e86be362e)();
        /**
         * The latest pointer event. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPointerEvent = null;
        /**
         * The latest pan info. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPanInfo = null;
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false, distanceThreshold: distanceThreshold } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $17b739d7228a9ca5$export$12f84bb882d06e1a)(event).point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $214b015126f9c3f6$export$64d8a3fd7eb621d5)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $73503c7090005507$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $0e96f9492cc5e780$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $533437274413027b$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $d1447ba151973c89$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (0, $30e1dd6229f35e12$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $3b3682cf200825b3$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.stop(event, info);
            this.latestPointerEvent = null;
            this.latestPanInfo = null;
        };
        const resumeAnimation = ()=>(0, $73503c7090005507$export$b789de563eb43b1)((axis)=>this.getAnimationState(axis) === "paused" && this.getAxisMotionValue(axis).animation?.play());
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $957447cdb911cc46$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            distanceThreshold: distanceThreshold,
            contextWindow: (0, $6d0b3645874bea96$export$d533d84f9871c879)(this.visualElement)
        });
    }
    /**
     * @internal
     */ stop(event, panInfo) {
        const finalEvent = event || this.latestPointerEvent;
        const finalPanInfo = panInfo || this.latestPanInfo;
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging || !finalPanInfo || !finalEvent) return;
        const { velocity: velocity } = finalPanInfo;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $d1447ba151973c89$export$2cef06c20297c17d).postRender(()=>onDragEnd(finalEvent, finalPanInfo));
    }
    /**
     * @internal
     */ cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$3b3682cf200825b3$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $36903b3edb1fbfa8$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : this.visualElement.projection?.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $47fdaa874812c1f9$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $36903b3edb1fbfa8$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $36903b3edb1fbfa8$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $73503c7090005507$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $36903b3edb1fbfa8$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $47fdaa874812c1f9$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $80ee25e76ad65aaa$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $e3c6479a4e864f1b$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $36903b3edb1fbfa8$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $d651b1e4da920e6b$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $d651b1e4da920e6b$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $73503c7090005507$export$b789de563eb43b1)((axis)=>{
            if (!$3b3682cf200825b3$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $30e1dd6229f35e12$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $16c2ab2aef2568e2$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $73503c7090005507$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $73503c7090005507$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).animation?.pause());
    }
    getAnimationState(axis) {
        return this.getAxisMotionValue(axis).animation?.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $73503c7090005507$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$3b3682cf200825b3$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $47fdaa874812c1f9$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $73503c7090005507$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $36903b3edb1fbfa8$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $73503c7090005507$export$b789de563eb43b1)((axis)=>{
            if (!$3b3682cf200825b3$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $3b3682cf200825b3$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $c001941294158545$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $47fdaa874812c1f9$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $d1447ba151973c89$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $7918bb0cf98b4c96$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $73503c7090005507$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $36903b3edb1fbfa8$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $3b3682cf200825b3$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $3b3682cf200825b3$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $7354e866fea60932$export$5d97dc2872682820 extends (0, $a244c61b38edd17b$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $8627ddaf329d4de9$export$8793edee2d425525);
        this.removeListeners = (0, $8627ddaf329d4de9$export$8793edee2d425525);
        this.controls = new (0, $3b3682cf200825b3$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $8627ddaf329d4de9$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $c0b33af73602509d$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $d1447ba151973c89$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $c0b33af73602509d$export$b4f8f1ee75ce5859 extends (0, $a244c61b38edd17b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $8627ddaf329d4de9$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $957447cdb911cc46$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $6d0b3645874bea96$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $c0b33af73602509d$var$asyncHandler(onPanSessionStart),
            onStart: $c0b33af73602509d$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $d1447ba151973c89$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $c001941294158545$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}





var $dNU7X = parcelRequire("dNU7X");



/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $2c21c5e8f0c04986$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $b80b5953fb866653$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $b80b5953fb866653$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $0e96f9492cc5e780$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $b80b5953fb866653$export$fafff692be55225d(latest, node.target.x);
        const y = $b80b5953fb866653$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};



const $a160c4ba9f49eafe$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $7d7af56b5778707d$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $7d7af56b5778707d$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};



"use client";
/**
 * Track whether we've taken any snapshots yet. If not,
 * we can safely skip notification of didUpdate.
 *
 * Difficult to capture in a test but to prevent flickering
 * we must set this to true either on update or unmount.
 * Running `next-env/layout-id` in Safari will show this behaviour if broken.
 */ let $65f2108c11f1f596$var$hasTakenAnySnapshot = false;
class $65f2108c11f1f596$var$MeasureLayoutWithContext extends (0, $dNU7X.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $067884b677a42124$export$de9e7791c71225fd)($65f2108c11f1f596$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            if ($65f2108c11f1f596$var$hasTakenAnySnapshot) projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $2c21c5e8f0c04986$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const { projection: projection } = visualElement;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        $65f2108c11f1f596$var$hasTakenAnySnapshot = true;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $d1447ba151973c89$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $7e3455ea5039691b$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        $65f2108c11f1f596$var$hasTakenAnySnapshot = true;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $65f2108c11f1f596$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $e785341539d45a4b$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $dNU7X.useContext)((0, $f18ef7be44492bd1$export$a3579ca508007a95));
    return (0, $2111e08a92d70add$exports.jsx)($65f2108c11f1f596$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $dNU7X.useContext)((0, $ecec3af7ca46deba$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $65f2108c11f1f596$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $b80b5953fb866653$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $b80b5953fb866653$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $b80b5953fb866653$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $b80b5953fb866653$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $b80b5953fb866653$export$5eafb6257a5844c),
    boxShadow: (0, $a160c4ba9f49eafe$export$eb0bc629e74dcf8)
};



/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function $01460aa926351bcb$export$17eda790a720ec57(element) {
    return (0, $7954d01aff4b2ddf$export$a6cdc56e425d0d0a)(element) && "ownerSVGElement" in element;
}


/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function $af0c407d4c5ec410$export$66957ea77182581d(element) {
    return (0, $01460aa926351bcb$export$17eda790a720ec57)(element) && element.tagName === "svg";
}





function $8f3199f6768855c4$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $79da92e230ca0803$export$605d60a2578142d3)(value) ? value : (0, $158c82181da7b3e7$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $16c2ab2aef2568e2$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}




const $c80aa79306a45c1f$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $fe383d20befd627e$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $653b9df1170831fe$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $653b9df1170831fe$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $c80aa79306a45c1f$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}




/**
 * Timeout defined in ms
 */ function $d1ee437a6a35a8f3$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $1ca16a2cd98ee355$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $d1447ba151973c89$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $d1447ba151973c89$export$2cef06c20297c17d).setup(checkElapsed, true);
    return ()=>(0, $d1447ba151973c89$export$ec99c0ef4978dccb)(checkElapsed);
}
function $d1ee437a6a35a8f3$export$fcd451ca460f8a2a(callback, timeout) {
    return $d1ee437a6a35a8f3$export$1391212d75b2ee65(callback, (0, $81cab8916775f3d6$export$fc3e7e8557f8c8c7)(timeout));
}





const $2e6a1d75cf0231e5$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $2e6a1d75cf0231e5$var$numBorders = $2e6a1d75cf0231e5$var$borders.length;
const $2e6a1d75cf0231e5$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $2e6a1d75cf0231e5$var$isPx = (value)=>typeof value === "number" || (0, $0e96f9492cc5e780$export$91c0eda1d06bf008).test(value);
function $2e6a1d75cf0231e5$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(0, lead.opacity ?? 1, $2e6a1d75cf0231e5$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(follow.opacity ?? 1, 0, $2e6a1d75cf0231e5$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(follow.opacity ?? 1, lead.opacity ?? 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $2e6a1d75cf0231e5$var$numBorders; i++){
        const borderLabel = `border${$2e6a1d75cf0231e5$var$borders[i]}Radius`;
        let followRadius = $2e6a1d75cf0231e5$var$getRadius(follow, borderLabel);
        let leadRadius = $2e6a1d75cf0231e5$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $2e6a1d75cf0231e5$var$isPx(followRadius) === $2e6a1d75cf0231e5$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)($2e6a1d75cf0231e5$var$asNumber(followRadius), $2e6a1d75cf0231e5$var$asNumber(leadRadius), progress), 0);
            if ((0, $0e96f9492cc5e780$export$626336c2cd4b14de).test(leadRadius) || (0, $0e96f9492cc5e780$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $2e6a1d75cf0231e5$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $2e6a1d75cf0231e5$var$easeCrossfadeIn = /*@__PURE__*/ $2e6a1d75cf0231e5$var$compress(0, 0.5, (0, $fec248e616eb47d7$export$c8d67a19199d1a50));
const $2e6a1d75cf0231e5$var$easeCrossfadeOut = /*@__PURE__*/ $2e6a1d75cf0231e5$var$compress(0.5, 0.95, (0, $8627ddaf329d4de9$export$8793edee2d425525));
function $2e6a1d75cf0231e5$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $5de1dbf596522ca0$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $fd4ebf0e07d2486c$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $fd4ebf0e07d2486c$export$c53fd88f45d77e4b(box, originBox) {
    $fd4ebf0e07d2486c$export$a0230ae482601ae8(box.x, originBox.x);
    $fd4ebf0e07d2486c$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $fd4ebf0e07d2486c$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}






/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $5a59ef8eb7f81390$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $fa00eed79ea4bee6$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $fa00eed79ea4bee6$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $5a59ef8eb7f81390$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $0e96f9492cc5e780$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $5a59ef8eb7f81390$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $5a59ef8eb7f81390$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $5a59ef8eb7f81390$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $5a59ef8eb7f81390$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $5a59ef8eb7f81390$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $5a59ef8eb7f81390$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $5a59ef8eb7f81390$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $5a59ef8eb7f81390$export$42b76f1d0d16d5b(box.x, transforms, $5a59ef8eb7f81390$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $5a59ef8eb7f81390$export$42b76f1d0d16d5b(box.y, transforms, $5a59ef8eb7f81390$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $2ac520920f092e67$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $2ac520920f092e67$export$a7ec7642fe550fb6(delta) {
    return $2ac520920f092e67$var$isAxisDeltaZero(delta.x) && $2ac520920f092e67$var$isAxisDeltaZero(delta.y);
}
function $2ac520920f092e67$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $2ac520920f092e67$export$8d5cf76bb7daff09(a, b) {
    return $2ac520920f092e67$export$7a9a6f114ddd0fdb(a.x, b.x) && $2ac520920f092e67$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $2ac520920f092e67$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $2ac520920f092e67$export$ef641b782d85522(a, b) {
    return $2ac520920f092e67$export$22adf28bfca1c186(a.x, b.x) && $2ac520920f092e67$export$22adf28bfca1c186(a.y, b.y);
}
function $2ac520920f092e67$export$c5706146bc63213(box) {
    return (0, $533437274413027b$export$c1c127004b72a37)(box.x) / (0, $533437274413027b$export$c1c127004b72a37)(box.y);
}
function $2ac520920f092e67$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $c5c73899515e530f$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $653b9df1170831fe$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $653b9df1170831fe$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $0cb56395abdb6ac1$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = latestTransform?.z || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $e0ea8413ad6f253f$var$metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
const $e0ea8413ad6f253f$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $e0ea8413ad6f253f$var$animationTarget = 1000;
let $e0ea8413ad6f253f$var$id = 0;
function $e0ea8413ad6f253f$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $e0ea8413ad6f253f$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $c484efbbce608d94$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $d1447ba151973c89$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $e0ea8413ad6f253f$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $e0ea8413ad6f253f$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent?.()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $e0ea8413ad6f253f$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            this.animationCommitId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, $911834144665c26d$export$84ce9a476f53d110).value) $e0ea8413ad6f253f$var$metrics.nodes = $e0ea8413ad6f253f$var$metrics.calculatedTargetDeltas = $e0ea8413ad6f253f$var$metrics.calculatedProjections = 0;
                this.nodes.forEach($e0ea8413ad6f253f$export$131f2f0cc5fe9609);
                this.nodes.forEach($e0ea8413ad6f253f$var$resolveTargetDelta);
                this.nodes.forEach($e0ea8413ad6f253f$var$calcProjection);
                this.nodes.forEach($e0ea8413ad6f253f$export$c2664f37bc951031);
                if ((0, $911834144665c26d$export$84ce9a476f53d110).addProjectionMetrics) (0, $911834144665c26d$export$84ce9a476f53d110).addProjectionMetrics($e0ea8413ad6f253f$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $fe383d20befd627e$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $eb440515b4613129$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance) {
            if (this.instance) return;
            this.isSVG = (0, $01460aa926351bcb$export$17eda790a720ec57)(instance) && !(0, $af0c407d4c5ec410$export$66957ea77182581d)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (this.root.hasTreeAnimated && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                let innerWidth = 0;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                // Set initial innerWidth in a frame.read callback to batch the read
                (0, $d1447ba151973c89$export$2cef06c20297c17d).read(()=>{
                    innerWidth = window.innerWidth;
                });
                attachResizeListener(instance, ()=>{
                    const newInnerWidth = window.innerWidth;
                    if (newInnerWidth === innerWidth) return;
                    innerWidth = newInnerWidth;
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $d1ee437a6a35a8f3$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $2c21c5e8f0c04986$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $2c21c5e8f0c04986$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($e0ea8413ad6f253f$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeLayoutChanged: hasRelativeLayoutChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $e0ea8413ad6f253f$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const hasTargetChanged = !this.targetLayout || !(0, $2ac520920f092e67$export$ef641b782d85522)(this.targetLayout, newLayout);
                /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                if (this.options.layoutRoot || this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    const animationOptions = {
                        ...(0, $dde277b96b9a21da$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                    /**
                         * Set animation origin after starting animation to avoid layout jump
                         * caused by stopping previous layout animation
                         */ this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $e0ea8413ad6f253f$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            this.eventHandlers.clear();
            (0, $d1447ba151973c89$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($e0ea8413ad6f253f$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $e0ea8413ad6f253f$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($e0ea8413ad6f253f$var$clearMeasurements);
                return;
            }
            /**
             * If this is a repeat of didUpdate then ignore the animation.
             */ if (this.animationId <= this.animationCommitId) {
                this.nodes.forEach($e0ea8413ad6f253f$var$clearIsLayoutDirty);
                return;
            }
            this.animationCommitId = this.animationId;
            if (!this.isUpdating) this.nodes.forEach($e0ea8413ad6f253f$var$clearIsLayoutDirty);
            else {
                this.isUpdating = false;
                /**
                 * Write
                 */ this.nodes.forEach($e0ea8413ad6f253f$var$resetTransformStyle);
                /**
                 * Read ==================
                 */ // Update layout measurements of updated children
                this.nodes.forEach($e0ea8413ad6f253f$var$updateLayout);
                /**
                 * Write
                 */ // Notify listeners that the layout is updated
                this.nodes.forEach($e0ea8413ad6f253f$var$notifyLayoutUpdate);
            }
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $1ca16a2cd98ee355$export$2da9be4cfdb689b1).now();
            (0, $d1447ba151973c89$export$fff89137e9e818ce).delta = (0, $aafb21eef928513a$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $d1447ba151973c89$export$fff89137e9e818ce).timestamp);
            (0, $d1447ba151973c89$export$fff89137e9e818ce).timestamp = now;
            (0, $d1447ba151973c89$export$fff89137e9e818ce).isProcessing = true;
            (0, $d1447ba151973c89$export$1811c3a7e3af92f0).update.process((0, $d1447ba151973c89$export$fff89137e9e818ce));
            (0, $d1447ba151973c89$export$1811c3a7e3af92f0).preRender.process((0, $d1447ba151973c89$export$fff89137e9e818ce));
            (0, $d1447ba151973c89$export$1811c3a7e3af92f0).render.process((0, $d1447ba151973c89$export$fff89137e9e818ce));
            (0, $d1447ba151973c89$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $7e3455ea5039691b$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($e0ea8413ad6f253f$var$clearSnapshot);
            this.sharedNodes.forEach($e0ea8413ad6f253f$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $d1447ba151973c89$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $d1447ba151973c89$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
            if (this.snapshot && !(0, $533437274413027b$export$c1c127004b72a37)(this.snapshot.measuredBox.x) && !(0, $533437274413027b$export$c1c127004b72a37)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
        }
        updateLayout() {
            if (!this.instance) return;
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $5896390693a21a91$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement && this.instance) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $2ac520920f092e67$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && this.instance && (hasProjection || (0, $cbff5fc74401a324$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $e0ea8413ad6f253f$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $5896390693a21a91$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = this.scroll?.wasRoot || this.path.some($e0ea8413ad6f253f$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $fa00eed79ea4bee6$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $fa00eed79ea4bee6$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $5896390693a21a91$export$6459fc9e86be362e)();
            (0, $fd4ebf0e07d2486c$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if (this.scroll?.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $fd4ebf0e07d2486c$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $fa00eed79ea4bee6$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $fa00eed79ea4bee6$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $5896390693a21a91$export$6459fc9e86be362e)();
            (0, $fd4ebf0e07d2486c$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $fa00eed79ea4bee6$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $cbff5fc74401a324$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $fa00eed79ea4bee6$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $cbff5fc74401a324$export$a545127cf1fbb600)(this.latestValues)) (0, $fa00eed79ea4bee6$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $5896390693a21a91$export$6459fc9e86be362e)();
            (0, $fd4ebf0e07d2486c$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $cbff5fc74401a324$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $cbff5fc74401a324$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $5896390693a21a91$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $fd4ebf0e07d2486c$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $5a59ef8eb7f81390$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $cbff5fc74401a324$export$a545127cf1fbb600)(this.latestValues)) (0, $5a59ef8eb7f81390$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $d1447ba151973c89$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $d1447ba151973c89$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $5896390693a21a91$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $5896390693a21a91$export$6459fc9e86be362e)();
                    (0, $533437274413027b$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $fd4ebf0e07d2486c$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $5896390693a21a91$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $5896390693a21a91$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $533437274413027b$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $fd4ebf0e07d2486c$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $fa00eed79ea4bee6$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $fd4ebf0e07d2486c$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $5896390693a21a91$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $5896390693a21a91$export$6459fc9e86be362e)();
                    (0, $533437274413027b$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $fd4ebf0e07d2486c$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ((0, $911834144665c26d$export$84ce9a476f53d110).value) $e0ea8413ad6f253f$var$metrics.calculatedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $cbff5fc74401a324$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $cbff5fc74401a324$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || this.parent?.isProjectionDirty) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $d1447ba151973c89$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $fd4ebf0e07d2486c$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $fa00eed79ea4bee6$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $5896390693a21a91$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $fd4ebf0e07d2486c$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $fd4ebf0e07d2486c$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $533437274413027b$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $2ac520920f092e67$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $2ac520920f092e67$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ((0, $911834144665c26d$export$84ce9a476f53d110).value) $e0ea8413ad6f253f$var$metrics.calculatedProjections++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.visualElement?.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $5896390693a21a91$export$3d227df54007d73a)();
            this.projectionDelta = (0, $5896390693a21a91$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $5896390693a21a91$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $5896390693a21a91$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $5896390693a21a91$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($e0ea8413ad6f253f$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $e0ea8413ad6f253f$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $e0ea8413ad6f253f$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $533437274413027b$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $e0ea8413ad6f253f$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $2ac520920f092e67$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $5896390693a21a91$export$6459fc9e86be362e)();
                    (0, $fd4ebf0e07d2486c$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $2e6a1d75cf0231e5$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation?.stop();
            this.resumingFrom?.currentAnimation?.stop();
            if (this.pendingAnimation) {
                (0, $d1447ba151973c89$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $d1447ba151973c89$export$2cef06c20297c17d).update(()=>{
                (0, $2c21c5e8f0c04986$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                (0, $66911b61b9f5d672$export$d921fb2475e2900c).layout++;
                this.motionValue || (this.motionValue = (0, $158c82181da7b3e7$export$ce8bdc721e76545f)(0));
                this.currentAnimation = (0, $8f3199f6768855c4$export$335a17c977067b99)(this.motionValue, [
                    0,
                    1000
                ], {
                    ...options,
                    velocity: 0,
                    isSync: true,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onStop: ()=>{
                        (0, $66911b61b9f5d672$export$d921fb2475e2900c).layout--;
                    },
                    onComplete: ()=>{
                        (0, $66911b61b9f5d672$export$d921fb2475e2900c).layout--;
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($e0ea8413ad6f253f$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $e0ea8413ad6f253f$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $5896390693a21a91$export$6459fc9e86be362e)();
                const xLength = (0, $533437274413027b$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $533437274413027b$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $fd4ebf0e07d2486c$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $fa00eed79ea4bee6$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $533437274413027b$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $c5c73899515e530f$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.lead || this : this;
        }
        getPrevLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $e0ea8413ad6f253f$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $e0ea8413ad6f253f$var$transformAxes.length; i++){
                $e0ea8413ad6f253f$var$resetDistortingTransform(`rotate${$e0ea8413ad6f253f$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $e0ea8413ad6f253f$var$resetDistortingTransform(`skew${$e0ea8413ad6f253f$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        applyProjectionStyles(targetStyle, styleProp) {
            if (!this.instance || this.isSVG) return;
            if (!this.isVisible) {
                targetStyle.visibility = "hidden";
                return;
            }
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                targetStyle.visibility = "";
                targetStyle.opacity = "";
                targetStyle.pointerEvents = (0, $5bda3a3458e4e1d8$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "";
                targetStyle.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                if (this.options.layoutId) {
                    targetStyle.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    targetStyle.pointerEvents = (0, $5bda3a3458e4e1d8$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $cbff5fc74401a324$export$a545127cf1fbb600)(this.latestValues)) {
                    targetStyle.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return;
            }
            targetStyle.visibility = "";
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            let transform = (0, $0cb56395abdb6ac1$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) transform = transformTemplate(valuesToRender, transform);
            targetStyle.transform = transform;
            const { x: x, y: y } = this.projectionDelta;
            targetStyle.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $067884b677a42124$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo, isCSSVariable: isCSSVariable } = (0, $067884b677a42124$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)targetStyle[applyTo[i]] = corrected;
                } else // If this is a CSS variable, set it directly on the instance.
                // Replacing this function from creating styles to setting them
                // would be a good place to remove per frame object creation
                if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                else targetStyle[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) targetStyle.pointerEvents = lead === this ? (0, $5bda3a3458e4e1d8$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "" : "none";
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>node.currentAnimation?.stop());
            this.root.nodes.forEach($e0ea8413ad6f253f$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $e0ea8413ad6f253f$var$updateLayout(node) {
    node.updateLayout();
}
function $e0ea8413ad6f253f$var$notifyLayoutUpdate(node) {
    const snapshot = node.resumeFrom?.snapshot || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $73503c7090005507$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $533437274413027b$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($e0ea8413ad6f253f$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $73503c7090005507$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $533437274413027b$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $5896390693a21a91$export$3d227df54007d73a)();
        (0, $533437274413027b$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $5896390693a21a91$export$3d227df54007d73a)();
        if (isShared) (0, $533437274413027b$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $533437274413027b$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $2ac520920f092e67$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $5896390693a21a91$export$6459fc9e86be362e)();
                    (0, $533437274413027b$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $5896390693a21a91$export$6459fc9e86be362e)();
                    (0, $533437274413027b$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $2ac520920f092e67$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $e0ea8413ad6f253f$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, $911834144665c26d$export$84ce9a476f53d110).value) $e0ea8413ad6f253f$var$metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $e0ea8413ad6f253f$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $e0ea8413ad6f253f$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $e0ea8413ad6f253f$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $e0ea8413ad6f253f$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $e0ea8413ad6f253f$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $e0ea8413ad6f253f$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $e0ea8413ad6f253f$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $e0ea8413ad6f253f$var$calcProjection(node) {
    node.calcProjection();
}
function $e0ea8413ad6f253f$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $e0ea8413ad6f253f$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $e0ea8413ad6f253f$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $e0ea8413ad6f253f$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $3b971a33074d84fb$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $e0ea8413ad6f253f$export$6ffd3e6ae339a132(output, from, to, p) {
    $e0ea8413ad6f253f$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $e0ea8413ad6f253f$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $e0ea8413ad6f253f$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $e0ea8413ad6f253f$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $e0ea8413ad6f253f$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $e0ea8413ad6f253f$var$roundPoint = $e0ea8413ad6f253f$var$userAgentContains("applewebkit/") && !$e0ea8413ad6f253f$var$userAgentContains("chrome/") ? Math.round : (0, $8627ddaf329d4de9$export$8793edee2d425525);
function $e0ea8413ad6f253f$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $e0ea8413ad6f253f$var$roundPoint(axis.min);
    axis.max = $e0ea8413ad6f253f$var$roundPoint(axis.max);
}
function $e0ea8413ad6f253f$var$roundBox(box) {
    $e0ea8413ad6f253f$var$roundAxis(box.x);
    $e0ea8413ad6f253f$var$roundAxis(box.y);
}
function $e0ea8413ad6f253f$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $533437274413027b$export$28d0384c4b79bde2)((0, $2ac520920f092e67$export$c5706146bc63213)(snapshot), (0, $2ac520920f092e67$export$c5706146bc63213)(layout), 0.2);
}
function $e0ea8413ad6f253f$var$checkNodeWasScrollRoot(node) {
    return node !== node.root && node.scroll?.wasRoot;
}




const $4eaf0ed0e3500e4a$export$2d029a49a09b6177 = (0, $e0ea8413ad6f253f$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $7918bb0cf98b4c96$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $1d6a3f10763b4a21$export$b91509fcf893b648 = {
    current: undefined
};
const $1d6a3f10763b4a21$export$b61a9eb3dbde8858 = (0, $e0ea8413ad6f253f$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$1d6a3f10763b4a21$export$b91509fcf893b648.current) {
            const documentNode = new (0, $4eaf0ed0e3500e4a$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $1d6a3f10763b4a21$export$b91509fcf893b648.current = documentNode;
        }
        return $1d6a3f10763b4a21$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $ade3aac5f86b36f1$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $c0b33af73602509d$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $7354e866fea60932$export$5d97dc2872682820),
        ProjectionNode: (0, $1d6a3f10763b4a21$export$b61a9eb3dbde8858),
        MeasureLayout: $65f2108c11f1f596$export$779f5fb01ad751cd
    }
};



function $13add2d6478d87ac$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) root = scope.current;
        const elements = selectorCache?.[elementOrSelector] ?? root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}


function $d21e1551b179b2a5$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $13add2d6478d87ac$export$90ceba2564a894f8)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}


function $3386765c6aceac05$var$isValidHover(event) {
    return !(event.pointerType === "touch" || (0, $506b2f80258b4681$export$1b3dd616664938e4)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $3386765c6aceac05$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $d21e1551b179b2a5$export$edc0ace9d5e7e842)(elementOrSelector, options);
    const onPointerEnter = (enterEvent)=>{
        if (!$3386765c6aceac05$var$isValidHover(enterEvent)) return;
        const { target: target } = enterEvent;
        const onHoverEnd = onHoverStart(target, enterEvent);
        if (typeof onHoverEnd !== "function" || !target) return;
        const onPointerLeave = (leaveEvent)=>{
            if (!$3386765c6aceac05$var$isValidHover(leaveEvent)) return;
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        };
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    };
    elements.forEach((element)=>{
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}




function $9dfda607c3147ef9$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $d1447ba151973c89$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $17b739d7228a9ca5$export$12f84bb882d06e1a)(event)));
}
class $9dfda607c3147ef9$export$93a81ea037eac456 extends (0, $a244c61b38edd17b$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $3386765c6aceac05$export$3f60957f5dbf3876)(current, (_element, startEvent)=>{
            $9dfda607c3147ef9$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$9dfda607c3147ef9$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}





class $14336df7919c5d4d$export$d4826db40d47595b extends (0, $a244c61b38edd17b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $f8be08f89a83b942$export$a4627e546088548d)((0, $7918bb0cf98b4c96$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $7918bb0cf98b4c96$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}




/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $df66a748ed057824$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $df66a748ed057824$export$e841ada32ff745b(parent, child.parentElement);
};




const $9c0553a9a8de739f$var$focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function $9c0553a9a8de739f$export$5f6976e2f961e8b7(element) {
    return $9c0553a9a8de739f$var$focusableElements.has(element.tagName) || element.tabIndex !== -1;
}


const $9867e03173a36242$export$7987404a4e35b84b = new WeakSet();


/**
 * Filter out events that are not "Enter" keys.
 */ function $52567f12798efc4d$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $52567f12798efc4d$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $52567f12798efc4d$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $52567f12798efc4d$var$filterEvents(()=>{
        if ((0, $9867e03173a36242$export$7987404a4e35b84b).has(element)) return;
        $52567f12798efc4d$var$firePointerEvent(element, "down");
        const handleKeyup = $52567f12798efc4d$var$filterEvents(()=>{
            $52567f12798efc4d$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$52567f12798efc4d$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};



/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $be9322e77b43074e$var$isValidPressEvent(event) {
    return (0, $c029f34bfc12f89b$export$a4cf9c8a4b063a6e)(event) && !(0, $506b2f80258b4681$export$1b3dd616664938e4)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $be9322e77b43074e$export$dbe9198142dace0c(targetOrSelector, onPressStart, options = {}) {
    const [targets, eventOptions, cancelEvents] = (0, $d21e1551b179b2a5$export$edc0ace9d5e7e842)(targetOrSelector, options);
    const startPress = (startEvent)=>{
        const target = startEvent.currentTarget;
        if (!$be9322e77b43074e$var$isValidPressEvent(startEvent)) return;
        (0, $9867e03173a36242$export$7987404a4e35b84b).add(target);
        const onPressEnd = onPressStart(target, startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if ((0, $9867e03173a36242$export$7987404a4e35b84b).has(target)) (0, $9867e03173a36242$export$7987404a4e35b84b).delete(target);
            if (!$be9322e77b43074e$var$isValidPressEvent(endEvent)) return;
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, target === window || target === document || options.useGlobalTarget || (0, $df66a748ed057824$export$e841ada32ff745b)(target, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    targets.forEach((target)=>{
        const pointerDownTarget = options.useGlobalTarget ? window : target;
        pointerDownTarget.addEventListener("pointerdown", startPress, eventOptions);
        if ((0, $79a29f44bb63ed43$export$1b3bfaa9684536aa)(target)) {
            target.addEventListener("focus", (event)=>(0, $52567f12798efc4d$export$4b5790288fe12a79)(event, eventOptions));
            if (!(0, $9c0553a9a8de739f$export$5f6976e2f961e8b7)(target) && !target.hasAttribute("tabindex")) target.tabIndex = 0;
        }
    });
    return cancelEvents;
}




function $05a9a21080c95b56$var$handlePressEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $d1447ba151973c89$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $17b739d7228a9ca5$export$12f84bb882d06e1a)(event)));
}
class $05a9a21080c95b56$export$f026abdbba7f0c9e extends (0, $a244c61b38edd17b$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $be9322e77b43074e$export$dbe9198142dace0c)(current, (_element, startEvent)=>{
            $05a9a21080c95b56$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success })=>$05a9a21080c95b56$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: this.node.props.globalTapTarget
        });
    }
    unmount() {}
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $8c488f47c0522dd4$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $8c488f47c0522dd4$var$observers = new WeakMap();
const $8c488f47c0522dd4$var$fireObserverCallback = (entry)=>{
    const callback = $8c488f47c0522dd4$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $8c488f47c0522dd4$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($8c488f47c0522dd4$var$fireObserverCallback);
};
function $8c488f47c0522dd4$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$8c488f47c0522dd4$var$observers.has(lookupRoot)) $8c488f47c0522dd4$var$observers.set(lookupRoot, {});
    const rootObservers = $8c488f47c0522dd4$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($8c488f47c0522dd4$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $8c488f47c0522dd4$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $8c488f47c0522dd4$var$initIntersectionObserver(options);
    $8c488f47c0522dd4$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $8c488f47c0522dd4$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $8c476473a5d38ace$var$thresholdNames = {
    some: 0,
    all: 1
};
class $8c476473a5d38ace$export$150851c8cc2f0c72 extends (0, $a244c61b38edd17b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $8c476473a5d38ace$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $8c488f47c0522dd4$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($8c476473a5d38ace$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $8c476473a5d38ace$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $8f7837541f3569d8$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $8c476473a5d38ace$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $05a9a21080c95b56$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $14336df7919c5d4d$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $9dfda607c3147ef9$export$93a81ea037eac456)
    }
};




const $7478e826ded0edd7$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $1d6a3f10763b4a21$export$b61a9eb3dbde8858),
        MeasureLayout: $65f2108c11f1f596$export$779f5fb01ad751cd
    }
};


const $17e505fad9bb5b8e$export$d596cd8841d25433 = {
    ...(0, $bc8211d8ecdec13a$export$7f9953c70dacfd7f),
    ...(0, $8f7837541f3569d8$export$e5b72898e5a201f1),
    ...(0, $ade3aac5f86b36f1$export$d7d5d435647ed5a0),
    ...(0, $7478e826ded0edd7$export$b3219800bda33a1f)
};


const $0c64644bb077db98$export$e25e478948902b8b = /*@__PURE__*/ (0, $af99d916a18a85b6$export$a28d6df673050e18)((0, $17e505fad9bb5b8e$export$d596cd8841d25433), (0, $b7bceff059e333d0$export$56ba0183203348f5));



var $dNU7X = parcelRequire("dNU7X");
var $ff02e2ed73a890ae$exports = {};

$parcel$export($ff02e2ed73a890ae$exports, "slide1", () => $30cf294374ec4e56$export$2e2bcd8739ae039);
$parcel$export($ff02e2ed73a890ae$exports, "slide2", () => $65155c66dc392d60$export$2e2bcd8739ae039);
$parcel$export($ff02e2ed73a890ae$exports, "slide3", () => $d949d33b1bf992c9$export$2e2bcd8739ae039);
$parcel$export($ff02e2ed73a890ae$exports, "slide4", () => $2ecb8b052377e834$export$2e2bcd8739ae039);
$parcel$export($ff02e2ed73a890ae$exports, "slide5", () => $e9acee785946148a$export$2e2bcd8739ae039);
$parcel$export($ff02e2ed73a890ae$exports, "slide6", () => $72e659c7b6fa709e$export$2e2bcd8739ae039);
$parcel$export($ff02e2ed73a890ae$exports, "slide7", () => $2389534f34c83ec6$export$2e2bcd8739ae039);
$parcel$export($ff02e2ed73a890ae$exports, "slide8", () => $50dc2cb52e8f79a5$export$2e2bcd8739ae039);
$parcel$export($ff02e2ed73a890ae$exports, "slide9", () => $33e6cff83f63f526$export$2e2bcd8739ae039);
$parcel$export($ff02e2ed73a890ae$exports, "slide10", () => $3bd4776cbaa3734c$export$2e2bcd8739ae039);
$parcel$export($ff02e2ed73a890ae$exports, "slide11", () => $2a3e0b413187d13b$export$2e2bcd8739ae039);
/*#__PURE__*/ 
var $35ad621bc2207b51$exports = {};
$35ad621bc2207b51$exports = import.meta.resolve("cVfK5");


const $30cf294374ec4e56$export$531496150fdbf74d = new URL($35ad621bc2207b51$exports);
function $30cf294374ec4e56$export$8c710bf21b20072d() {
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("img", {
        src: $30cf294374ec4e56$export$531496150fdbf74d,
        alt: "LM Studio screenshot",
        className: "w-auto max-h-100 mb-8 self-center rounded-lg shadow-xl"
    });
}
var $af80fc315c83f642$exports = {};
$af80fc315c83f642$exports = "https://opencode.ai/";


var $17a958b253385abd$exports = {};
$17a958b253385abd$exports = "https://llms-demo.holden.xyz/";


function $30cf294374ec4e56$var$_createMdxContent(props) {
    const _components = Object.assign({
        h1: "h1",
        div: "div",
        p: "p",
        a: "a"
    }, props.components);
    return (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.h1, {
                children: "Running Local LLMs: Fast, Free, and Private"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("div", {
                className: "text-xl text-gray-400",
                children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)(_components.p, {
                    children: [
                        "Built with Qwen3-Coder-30B-A3B-Instruct + ",
                        /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("a", {
                            href: $af80fc315c83f642$exports,
                            className: "text-blue-400 hover:text-blue-300 underline",
                            children: "opencode CLI"
                        })
                    ]
                })
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)(_components.p, {
                children: [
                    "Link to slides: ",
                    /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("a", {
                        href: $17a958b253385abd$exports,
                        className: "hover:text-blue-300 underline mb-4",
                        children: "https://llms-demo.holden.xyz"
                    })
                ]
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)($30cf294374ec4e56$export$8c710bf21b20072d, {}),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("div", {
                className: "text-gray-300 text-lg mt-auto mb-2",
                children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                    children: "Jesse Holden | October 2, 2025"
                })
            })
        ]
    });
}
function $30cf294374ec4e56$var$MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)($30cf294374ec4e56$var$_createMdxContent, {
            ...props
        })
    }) : $30cf294374ec4e56$var$_createMdxContent(props);
}
var $30cf294374ec4e56$export$2e2bcd8739ae039 = $30cf294374ec4e56$var$MDXContent;


/*#__PURE__*/ 
function $65155c66dc392d60$var$_createMdxContent(props) {
    const _components = Object.assign({
        h1: "h1",
        p: "p",
        hr: "hr",
        strong: "strong"
    }, props.components);
    return (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
        children: [
            (0, $2111e08a92d70add$exports.jsx)(_components.h1, {
                children: "Why Run Local?"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Most devs either rely entirely on cloud AI or avoid it altogether"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Local models offer a compelling middle ground:"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.hr, {}),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)(_components.p, {
                children: [
                    (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                        children: "Zero recurring costs"
                    }),
                    " \u2014 no API bills, unlimited tokens"
                ]
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)(_components.p, {
                children: [
                    (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                        children: "Privacy by default"
                    }),
                    " \u2014 proprietary code never leaves your machine"
                ]
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)(_components.p, {
                children: [
                    (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                        children: "Always available"
                    }),
                    " \u2014 no rate limits, no outages, works offline"
                ]
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)(_components.p, {
                children: [
                    (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                        children: "Full control"
                    }),
                    " \u2014 customize, fine-tune, experiment freely"
                ]
            })
        ]
    });
}
function $65155c66dc392d60$var$MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)($65155c66dc392d60$var$_createMdxContent, {
            ...props
        })
    }) : $65155c66dc392d60$var$_createMdxContent(props);
}
var $65155c66dc392d60$export$2e2bcd8739ae039 = $65155c66dc392d60$var$MDXContent;


/*#__PURE__*/ 
function $d949d33b1bf992c9$var$_createMdxContent(props) {
    const _components = Object.assign({
        h1: "h1",
        p: "p",
        strong: "strong",
        h2: "h2",
        ul: "ul",
        li: "li"
    }, props.components);
    return (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
        children: [
            (0, $2111e08a92d70add$exports.jsx)(_components.h1, {
                children: "Is It Actually Good Enough?"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)(_components.p, {
                children: [
                    (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                        children: "Reality check:"
                    }),
                    " 7B models \u2260 GPT-5 or Claude, but that's okay"
                ]
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.h2, {
                children: "The Sweet Spot"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Code completion, refactoring, boilerplate generation, code explanations, documentation writing"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.h2, {
                children: "Our Hardware Advantage"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "M1 with 32GB RAM is perfect for 7B models"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)(_components.ul, {
                children: [
                    "\n",
                    (0, $2111e08a92d70add$exports.jsx)(_components.li, {
                        children: "Models use ~4-6GB VRAM"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.li, {
                        children: "Fast inference: 20-40 tokens/second"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.li, {
                        children: "Runs smoothly alongside your regular development work"
                    }),
                    "\n"
                ]
            })
        ]
    });
}
function $d949d33b1bf992c9$var$MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)($d949d33b1bf992c9$var$_createMdxContent, {
            ...props
        })
    }) : $d949d33b1bf992c9$var$_createMdxContent(props);
}
var $d949d33b1bf992c9$export$2e2bcd8739ae039 = $d949d33b1bf992c9$var$MDXContent;


/*#__PURE__*/ 
function $2ecb8b052377e834$var$_createMdxContent(props) {
    const _components = Object.assign({
        h1: "h1",
        h2: "h2",
        p: "p",
        strong: "strong",
        ol: "ol",
        li: "li"
    }, props.components);
    return (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
        children: [
            (0, $2111e08a92d70add$exports.jsx)(_components.h1, {
                children: "Getting Started is Trivially Easy"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.h2, {
                children: "Two Main Tools"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)(_components.p, {
                children: [
                    (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                        children: "LM Studio"
                    }),
                    " \u2014 GUI-based, beginner-friendly, great for exploring models"
                ]
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)(_components.p, {
                children: [
                    (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                        children: "Ollama"
                    }),
                    " \u2014 CLI-based, dev-friendly, perfect for workflows and automation"
                ]
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.h2, {
                children: "Setup Time"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Less than 5 minutes from download to running your first model"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)(_components.ol, {
                children: [
                    "\n",
                    (0, $2111e08a92d70add$exports.jsx)(_components.li, {
                        children: "Download and install LM Studio (https://lmstudio.ai/)"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.li, {
                        children: "Download Gemma 3n E4B"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.li, {
                        children: "Start using it!"
                    }),
                    "\n"
                ]
            })
        ]
    });
}
function $2ecb8b052377e834$var$MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)($2ecb8b052377e834$var$_createMdxContent, {
            ...props
        })
    }) : $2ecb8b052377e834$var$_createMdxContent(props);
}
var $2ecb8b052377e834$export$2e2bcd8739ae039 = $2ecb8b052377e834$var$MDXContent;


/*#__PURE__*/ 
var $31b2caea9f2c569b$exports = {};
$31b2caea9f2c569b$exports = import.meta.resolve("gbxxx");


const $e9acee785946148a$export$531496150fdbf74d = new URL($31b2caea9f2c569b$exports);
function $e9acee785946148a$export$da1896a261122d17() {
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("img", {
        src: $e9acee785946148a$export$531496150fdbf74d,
        className: "h-auto mb-8 self-center rounded-lg shadow-xl"
    });
}
function $e9acee785946148a$var$_createMdxContent(props) {
    const _components = Object.assign({
        h1: "h1",
        p: "p"
    }, props.components);
    return (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.h1, {
                children: "Quick Demo"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Using context7 mcp with LM Studio and Gemma (~30 tokens/second)"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)($e9acee785946148a$export$da1896a261122d17, {})
        ]
    });
}
function $e9acee785946148a$var$MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)($e9acee785946148a$var$_createMdxContent, {
            ...props
        })
    }) : $e9acee785946148a$var$_createMdxContent(props);
}
var $e9acee785946148a$export$2e2bcd8739ae039 = $e9acee785946148a$var$MDXContent;


/*#__PURE__*/ 
var $c881b22c655ea824$exports = {};
$c881b22c655ea824$exports = import.meta.resolve("8RHSQ");


const $72e659c7b6fa709e$export$531496150fdbf74d = new URL($c881b22c655ea824$exports);
function $72e659c7b6fa709e$export$fdd7ffc6d2f6f8b9() {
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("img", {
        src: $72e659c7b6fa709e$export$531496150fdbf74d,
        className: "h-auto mb-8 self-center rounded-lg shadow-xl"
    });
}
function $72e659c7b6fa709e$var$_createMdxContent(props) {
    const _components = Object.assign({
        h1: "h1"
    }, props.components);
    return (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.h1, {
                children: "Quick Demo"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)($72e659c7b6fa709e$export$fdd7ffc6d2f6f8b9, {})
        ]
    });
}
function $72e659c7b6fa709e$var$MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)($72e659c7b6fa709e$var$_createMdxContent, {
            ...props
        })
    }) : $72e659c7b6fa709e$var$_createMdxContent(props);
}
var $72e659c7b6fa709e$export$2e2bcd8739ae039 = $72e659c7b6fa709e$var$MDXContent;


/*#__PURE__*/ 
function $2389534f34c83ec6$var$_createMdxContent(props) {
    const _components = Object.assign({
        h1: "h1",
        p: "p",
        strong: "strong"
    }, props.components);
    return (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
        children: [
            (0, $2111e08a92d70add$exports.jsx)(_components.h1, {
                children: "Models Worth Trying"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                    children: "DeepSeek R1-0528-Qwen3-8B"
                })
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Distilled reasoning model with chain-of-thought capabilities \u2014 achieves state-of-the-art performance on AIME 2024, matching Qwen3-235B"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                    children: "Gemma 3n E4B"
                })
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Google's efficient 4B parameter model with multimodal support \u2014 runs with only ~4GB memory footprint using selective parameter activation"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                    children: "Devstral Small 2507"
                })
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Mistral's 24B parameter coding agent specialist \u2014 #1 open-source model on SWE-Bench Verified (53.6%), excels at multi-file editing"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                    children: "Qwen3-4B-Instruct-2507"
                })
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Alibaba's 4B parameter model with 256K context window \u2014 strong multilingual support (100+ languages), excellent instruction-following"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "All run smoothly on M1 Macs with 32GB RAM"
            })
        ]
    });
}
function $2389534f34c83ec6$var$MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)($2389534f34c83ec6$var$_createMdxContent, {
            ...props
        })
    }) : $2389534f34c83ec6$var$_createMdxContent(props);
}
var $2389534f34c83ec6$export$2e2bcd8739ae039 = $2389534f34c83ec6$var$MDXContent;


/*#__PURE__*/ 
function $50dc2cb52e8f79a5$var$_createMdxContent(props) {
    const _components = Object.assign({
        h1: "h1",
        h2: "h2",
        p: "p"
    }, props.components);
    return (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
        children: [
            (0, $2111e08a92d70add$exports.jsx)(_components.h1, {
                children: "Real Use Cases for Our Work"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.h2, {
                children: "Privacy-Sensitive Personal Automation"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Email triage and inbox management without exposing messages to cloud services"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Smart home rule generation for Home Assistant using natural language"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Document processing for receipts, medical records, and family photos"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.h2, {
                children: "Development Workflows"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Code review and refactoring for proprietary codebases"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Generate test cases and documentation without API costs"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Explore unfamiliar legacy systems and new frameworks"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.h2, {
                children: "Homelab & Self-Hosting"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Network activity reports from firewall logs in plain English"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Media library organization and personalized recommendations"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Server alert translation into actionable, prioritized notifications"
            })
        ]
    });
}
function $50dc2cb52e8f79a5$var$MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)($50dc2cb52e8f79a5$var$_createMdxContent, {
            ...props
        })
    }) : $50dc2cb52e8f79a5$var$_createMdxContent(props);
}
var $50dc2cb52e8f79a5$export$2e2bcd8739ae039 = $50dc2cb52e8f79a5$var$MDXContent;


/*#__PURE__*/ 
function $33e6cff83f63f526$var$_createMdxContent(props) {
    const _components = Object.assign({
        h1: "h1",
        h2: "h2",
        p: "p"
    }, props.components);
    return (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
        children: [
            (0, $2111e08a92d70add$exports.jsx)(_components.h1, {
                children: "Practical Tips & Workflows"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.h2, {
                children: "Getting Started"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Start with Ollama or LM Studio w/ running server + your editor integration (Continue.dev, Cline, Cursor) or terminal UI (opencode)"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Use specific models for specific tasks \u2014 coding vs general vs reasoning"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.h2, {
                children: "Best Practices"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Keep cloud AI for complex tasks, use local for iteration and experimentation"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Context is king \u2014 paste relevant code, be specific in your prompts"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.h2, {
                children: "Integration & Automation"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Schedule background tasks with cron for overnight processing"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Use n8n for visual workflow automation with local LLM nodes"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Connect via APIs to Home Assistant, Nextcloud, or your local services"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Use local vector databases (ChromaDB, Qdrant) for semantic search"
            })
        ]
    });
}
function $33e6cff83f63f526$var$MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)($33e6cff83f63f526$var$_createMdxContent, {
            ...props
        })
    }) : $33e6cff83f63f526$var$_createMdxContent(props);
}
var $33e6cff83f63f526$export$2e2bcd8739ae039 = $33e6cff83f63f526$var$MDXContent;


/*#__PURE__*/ 
function $3bd4776cbaa3734c$var$_createMdxContent(props) {
    const _components = Object.assign({
        h1: "h1",
        p: "p",
        strong: "strong"
    }, props.components);
    return (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
        children: [
            (0, $2111e08a92d70add$exports.jsx)(_components.h1, {
                children: "Common Questions"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                    children: '"Isn\'t it slow?"'
                })
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "20-40 tokens/second on M1 \u2014 faster than you read"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                    children: '"What about quality?"'
                })
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Great for 80% of daily tasks \u2014 refactoring, documentation, learning. Use cloud AI when you need the absolute best"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                    children: '"How much storage?"'
                })
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "4-8GB per model \u2014 store 5-10 models comfortably on a 256GB machine"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                    children: '"Does it replace cloud AI?"'
                })
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Complements, not replaces. Local for privacy and cost-free iteration, cloud for maximum capability"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                    children: '"Is setup hard?"'
                })
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Install Ollama or LM Studio \u2192 Download model \u2192 Start using. Under 5 minutes total"
            })
        ]
    });
}
function $3bd4776cbaa3734c$var$MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)($3bd4776cbaa3734c$var$_createMdxContent, {
            ...props
        })
    }) : $3bd4776cbaa3734c$var$_createMdxContent(props);
}
var $3bd4776cbaa3734c$export$2e2bcd8739ae039 = $3bd4776cbaa3734c$var$MDXContent;


/*#__PURE__*/ 
function $2a3e0b413187d13b$var$_createMdxContent(props) {
    const _components = Object.assign({
        h1: "h1",
        p: "p",
        strong: "strong",
        ol: "ol",
        li: "li",
        code: "code",
        hr: "hr",
        ul: "ul"
    }, props.components);
    return (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
        children: [
            (0, $2111e08a92d70add$exports.jsx)(_components.h1, {
                children: "Try It This Week"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                    children: "The 3-Day Challenge"
                })
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)(_components.ol, {
                children: [
                    "\n",
                    (0, $2111e08a92d70add$exports.jsxs)(_components.li, {
                        children: [
                            "Install Ollama (",
                            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.code, {
                                children: "brew install ollama"
                            }),
                            ") or LM Studio"
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)(_components.li, {
                        children: [
                            "Download one model: ",
                            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.code, {
                                children: "ollama pull qwen3:4b"
                            }),
                            " or ",
                            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.code, {
                                children: "ollama pull gemma3n:e4b"
                            })
                        ]
                    }),
                    "\n",
                    /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.li, {
                        children: "Use it for real work \u2014 code review, docs, or exploration"
                    }),
                    "\n"
                ]
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.hr, {}),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                    children: "Share & Learn"
                })
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: "Post your experience in #guild-ai \u2014 wins, surprises, questions, gotchas"
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                    children: "Resources"
                })
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)(_components.ul, {
                children: [
                    "\n",
                    (0, $2111e08a92d70add$exports.jsx)(_components.li, {
                        children: "lmstudio.ai \u2014 Easy GUI for beginners"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.li, {
                        children: "ollama.com \u2014 CLI tool for power users"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.li, {
                        children: "huggingface.co \u2014 Browse models and benchmarks"
                    }),
                    "\n",
                    /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.li, {
                        children: "youtube.com/@Fireship \u2014 Great tech explainers and tutorials"
                    }),
                    "\n"
                ]
            }),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.hr, {}),
            "\n",
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(_components.p, {
                children: (0, $2111e08a92d70add$exports.jsx)(_components.strong, {
                    children: "Questions?"
                })
            })
        ]
    });
}
function $2a3e0b413187d13b$var$MDXContent(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)($2a3e0b413187d13b$var$_createMdxContent, {
            ...props
        })
    }) : $2a3e0b413187d13b$var$_createMdxContent(props);
}
var $2a3e0b413187d13b$export$2e2bcd8739ae039 = $2a3e0b413187d13b$var$MDXContent;





const $cd93687958c8007e$var$slides = Object.values($ff02e2ed73a890ae$exports);
function $cd93687958c8007e$export$86fbec116b87613f() {
    const [currentSlide, setCurrentSlide] = (0, $dNU7X.useState)(0);
    const nextSlide = (0, $dNU7X.useCallback)(()=>{
        setCurrentSlide((prev)=>(prev + 1) % $cd93687958c8007e$var$slides.length);
    }, []);
    const prevSlide = (0, $dNU7X.useCallback)(()=>{
        setCurrentSlide((prev)=>(prev - 1 + $cd93687958c8007e$var$slides.length) % $cd93687958c8007e$var$slides.length);
    }, []);
    // Handle keyboard navigation
    (0, $dNU7X.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === 'ArrowRight') nextSlide();
            else if (event.key === 'ArrowLeft') prevSlide();
        };
        window.addEventListener('keydown', handleKeyDown);
        return ()=>window.removeEventListener('keydown', handleKeyDown);
    }, [
        nextSlide,
        prevSlide
    ]);
    const CurrentSlideComponent = $cd93687958c8007e$var$slides[currentSlide];
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)("div", {
        className: "min-h-screen bg-gradient-to-br from-gray-900 to-black text-white flex flex-col items-center justify-center p-4",
        children: [
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)("div", {
                className: "w-full max-w-4xl h-[80vh] relative overflow-hidden rounded-2xl border border-gray-700 shadow-2xl",
                children: [
                    /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $a685fed0b5e274f8$export$3ae376d12526dd6f), {
                        mode: "wait",
                        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $0c64644bb077db98$export$e25e478948902b8b).div, {
                            initial: {
                                opacity: 0,
                                x: 100
                            },
                            animate: {
                                opacity: 1,
                                x: 0
                            },
                            exit: {
                                opacity: 0,
                                x: -100
                            },
                            transition: {
                                duration: 0.5,
                                ease: 'easeInOut'
                            },
                            className: "absolute inset-0 flex flex-col px-16 py-4",
                            children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(CurrentSlideComponent, {})
                        }, currentSlide)
                    }),
                    /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("div", {
                        className: "absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2",
                        children: $cd93687958c8007e$var$slides.map((_, index)=>/*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setCurrentSlide(index),
                                className: `w-3 h-3 rounded-full transition-all ${currentSlide === index ? 'bg-blue-500' : 'bg-gray-600'}`,
                                "aria-label": `Go to slide ${index + 1}`
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("button", {
                        type: "button",
                        onClick: prevSlide,
                        className: "absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 rounded-full p-3 transition-colors",
                        "aria-label": "Previous slide",
                        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "h-6 w-6",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            children: [
                                /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("title", {
                                    children: "Previous slide"
                                }),
                                /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M15 19l-7-7 7-7"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("button", {
                        type: "button",
                        onClick: nextSlide,
                        className: "absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 rounded-full p-3 transition-colors",
                        "aria-label": "Next slide",
                        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "h-6 w-6",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            children: [
                                /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("title", {
                                    children: "Next slide"
                                }),
                                /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M9 5l7 7-7 7"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("div", {
                className: "mt-8 text-center text-gray-400",
                children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)("p", {
                    children: [
                        "Slide ",
                        currentSlide + 1,
                        " of ",
                        $cd93687958c8007e$var$slides.length
                    ]
                })
            })
        ]
    });
}


const $70fc9a727fa662ae$var$container = document.getElementById('app');
const $70fc9a727fa662ae$var$root = (0, $3d2450ff1707eb5a$exports.createRoot)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $dNU7X.StrictMode), {
    children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=parcel-slide-llms.f026c1fa.js.map
